!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react"), require("mobx"), require("mobx-react"), require("@miriamtech/if2-js-model"), require("leaflet"), require("@fortawesome/react-fontawesome"), require("@fortawesome/free-solid-svg-icons"), require("@miriamtech/if2-ui"), require("react-dom"), require("js-quantities"), require("lodash"), require("mobx-utils"), require("react-interval"), require("@miriamtech/if2-core"), require("@turf/destination"), require("@fortawesome/free-regular-svg-icons"), require("react-transition-group"), require("jquery"), require("uuid"), require("@turf/helpers"), require("react-tooltip"), require("i18next-browser-languagedetector"), require("@turf/center"), require("@turf/bbox"), require("@turf/area"), require("@turf/rewind"), require("crc-32"), require("d3-scale"), require("d3-color"), require("@turf/nearest-point"), require("@turf/meta"), require("react-virtuoso"), require("react-copy-to-clipboard")) : "function" == typeof define && define.amd ? define(["react", "mobx", "mobx-react", "@miriamtech/if2-js-model", "leaflet", "@fortawesome/react-fontawesome", "@fortawesome/free-solid-svg-icons", "@miriamtech/if2-ui", "react-dom", "js-quantities", "lodash", "mobx-utils", "react-interval", "@miriamtech/if2-core", "@turf/destination", "@fortawesome/free-regular-svg-icons", "react-transition-group", "jquery", "uuid", "@turf/helpers", "react-tooltip", "i18next-browser-languagedetector", "@turf/center", "@turf/bbox", "@turf/area", "@turf/rewind", "crc-32", "d3-scale", "d3-color", "@turf/nearest-point", "@turf/meta", "react-virtuoso", "react-copy-to-clipboard"], t) : "object" == typeof exports ? exports.if2_fields = t(require("react"), require("mobx"), require("mobx-react"), require("@miriamtech/if2-js-model"), require("leaflet"), require("@fortawesome/react-fontawesome"), require("@fortawesome/free-solid-svg-icons"), require("@miriamtech/if2-ui"), require("react-dom"), require("js-quantities"), require("lodash"), require("mobx-utils"), require("react-interval"), require("@miriamtech/if2-core"), require("@turf/destination"), require("@fortawesome/free-regular-svg-icons"), require("react-transition-group"), require("jquery"), require("uuid"), require("@turf/helpers"), require("react-tooltip"), require("i18next-browser-languagedetector"), require("@turf/center"), require("@turf/bbox"), require("@turf/area"), require("@turf/rewind"), require("crc-32"), require("d3-scale"), require("d3-color"), require("@turf/nearest-point"), require("@turf/meta"), require("react-virtuoso"), require("react-copy-to-clipboard")) : e.if2_fields = t(e.react, e.mobx, e["mobx-react"], e["@miriamtech/if2-js-model"], e.leaflet, e["@fortawesome/react-fontawesome"], e["@fortawesome/free-solid-svg-icons"], e["@miriamtech/if2-ui"], e["react-dom"], e["js-quantities"], e.lodash, e["mobx-utils"], e["react-interval"], e["@miriamtech/if2-core"], e["@turf/destination"], e["@fortawesome/free-regular-svg-icons"], e["react-transition-group"], e.jquery, e.uuid, e["@turf/helpers"], e["react-tooltip"], e["i18next-browser-languagedetector"], e["@turf/center"], e["@turf/bbox"], e["@turf/area"], e["@turf/rewind"], e["crc-32"], e["d3-scale"], e["d3-color"], e["@turf/nearest-point"], e["@turf/meta"], e["react-virtuoso"], e["react-copy-to-clipboard"]);
}(window, function (e, t, r, n, o, i, a, c, l, u, s, p, f, d, y, b, h, m, v, g, w, O, _, j, P, E, k, x, S, C, R, N, z) {
  return function (e) {
    var t = {};
    function r(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
    }
    return r.m = e, r.c = t, r.d = function (e, t, n) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (r.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
      return n;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 181);
  }([function (t, r) {
    t.exports = e;
  }, function (e, r) {
    e.exports = t;
  }, function (e, t) {
    e.exports = r;
  }, function (e, t, r) {
    e.exports = r(99)();
  }, function (e, t) {
    e.exports = n;
  }, function (e, t) {
    e.exports = o;
  }, function (e, t, r) {
    var n;
    /*!
      Copyright (c) 2018 Jed Watson.
      Licensed under the MIT License (MIT), see
      http://jedwatson.github.io/classnames
    */
    !function () {
      "use strict";

      var r = {}.hasOwnProperty;
      function o() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var n = arguments[t];
          if (n) {
            var i = typeof n;
            if ("string" === i || "number" === i) e.push(n);else if (Array.isArray(n)) {
              if (n.length) {
                var a = o.apply(null, n);
                a && e.push(a);
              }
            } else if ("object" === i) if (n.toString === Object.prototype.toString) for (var c in n) r.call(n, c) && n[c] && e.push(c);else e.push(n.toString());
          }
        }
        return e.join(" ");
      }
      e.exports ? (o.default = o, e.exports = o) : void 0 === (n = function () {
        return o;
      }.apply(t, [])) || (e.exports = n);
    }();
  }, function (e, t) {
    e.exports = i;
  },, function (e, t) {
    e.exports = a;
  }, function (e, t) {
    e.exports = c;
  }, function (e, t) {
    e.exports = l;
  }, function (e, t) {
    e.exports = u;
  }, function (e, t, r) {
    var n = r(58),
      o = "object" == typeof self && self && self.Object === Object && self,
      i = n || o || Function("return this")();
    e.exports = i;
  }, function (e, t) {
    e.exports = s;
  }, function (e, t, r) {
    "use strict";

    var n,
      o = "object" == typeof Reflect ? Reflect : null,
      i = o && "function" == typeof o.apply ? o.apply : function (e, t, r) {
        return Function.prototype.apply.call(e, t, r);
      };
    n = o && "function" == typeof o.ownKeys ? o.ownKeys : Object.getOwnPropertySymbols ? function (e) {
      return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
    } : function (e) {
      return Object.getOwnPropertyNames(e);
    };
    var a = Number.isNaN || function (e) {
      return e != e;
    };
    function c() {
      c.init.call(this);
    }
    e.exports = c, e.exports.once = function (e, t) {
      return new Promise(function (r, n) {
        function o(r) {
          e.removeListener(t, i), n(r);
        }
        function i() {
          "function" == typeof e.removeListener && e.removeListener("error", o), r([].slice.call(arguments));
        }
        m(e, t, i, {
          once: !0
        }), "error" !== t && function (e, t, r) {
          "function" == typeof e.on && m(e, "error", t, r);
        }(e, o, {
          once: !0
        });
      });
    }, c.EventEmitter = c, c.prototype._events = void 0, c.prototype._eventsCount = 0, c.prototype._maxListeners = void 0;
    var l = 10;
    function u(e) {
      if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
    }
    function s(e) {
      return void 0 === e._maxListeners ? c.defaultMaxListeners : e._maxListeners;
    }
    function p(e, t, r, n) {
      var o, i, a, c;
      if (u(r), void 0 === (i = e._events) ? (i = e._events = Object.create(null), e._eventsCount = 0) : (void 0 !== i.newListener && (e.emit("newListener", t, r.listener ? r.listener : r), i = e._events), a = i[t]), void 0 === a) a = i[t] = r, ++e._eventsCount;else if ("function" == typeof a ? a = i[t] = n ? [r, a] : [a, r] : n ? a.unshift(r) : a.push(r), (o = s(e)) > 0 && a.length > o && !a.warned) {
        a.warned = !0;
        var l = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
        l.name = "MaxListenersExceededWarning", l.emitter = e, l.type = t, l.count = a.length, c = l, console && console.warn && console.warn(c);
      }
      return e;
    }
    function f() {
      if (!this.fired) return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, 0 === arguments.length ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
    }
    function d(e, t, r) {
      var n = {
          fired: !1,
          wrapFn: void 0,
          target: e,
          type: t,
          listener: r
        },
        o = f.bind(n);
      return o.listener = r, n.wrapFn = o, o;
    }
    function y(e, t, r) {
      var n = e._events;
      if (void 0 === n) return [];
      var o = n[t];
      return void 0 === o ? [] : "function" == typeof o ? r ? [o.listener || o] : [o] : r ? function (e) {
        for (var t = new Array(e.length), r = 0; r < t.length; ++r) t[r] = e[r].listener || e[r];
        return t;
      }(o) : h(o, o.length);
    }
    function b(e) {
      var t = this._events;
      if (void 0 !== t) {
        var r = t[e];
        if ("function" == typeof r) return 1;
        if (void 0 !== r) return r.length;
      }
      return 0;
    }
    function h(e, t) {
      for (var r = new Array(t), n = 0; n < t; ++n) r[n] = e[n];
      return r;
    }
    function m(e, t, r, n) {
      if ("function" == typeof e.on) n.once ? e.once(t, r) : e.on(t, r);else {
        if ("function" != typeof e.addEventListener) throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
        e.addEventListener(t, function o(i) {
          n.once && e.removeEventListener(t, o), r(i);
        });
      }
    }
    Object.defineProperty(c, "defaultMaxListeners", {
      enumerable: !0,
      get: function () {
        return l;
      },
      set: function (e) {
        if ("number" != typeof e || e < 0 || a(e)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
        l = e;
      }
    }), c.init = function () {
      void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
    }, c.prototype.setMaxListeners = function (e) {
      if ("number" != typeof e || e < 0 || a(e)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
      return this._maxListeners = e, this;
    }, c.prototype.getMaxListeners = function () {
      return s(this);
    }, c.prototype.emit = function (e) {
      for (var t = [], r = 1; r < arguments.length; r++) t.push(arguments[r]);
      var n = "error" === e,
        o = this._events;
      if (void 0 !== o) n = n && void 0 === o.error;else if (!n) return !1;
      if (n) {
        var a;
        if (t.length > 0 && (a = t[0]), a instanceof Error) throw a;
        var c = new Error("Unhandled error." + (a ? " (" + a.message + ")" : ""));
        throw c.context = a, c;
      }
      var l = o[e];
      if (void 0 === l) return !1;
      if ("function" == typeof l) i(l, this, t);else {
        var u = l.length,
          s = h(l, u);
        for (r = 0; r < u; ++r) i(s[r], this, t);
      }
      return !0;
    }, c.prototype.addListener = function (e, t) {
      return p(this, e, t, !1);
    }, c.prototype.on = c.prototype.addListener, c.prototype.prependListener = function (e, t) {
      return p(this, e, t, !0);
    }, c.prototype.once = function (e, t) {
      return u(t), this.on(e, d(this, e, t)), this;
    }, c.prototype.prependOnceListener = function (e, t) {
      return u(t), this.prependListener(e, d(this, e, t)), this;
    }, c.prototype.removeListener = function (e, t) {
      var r, n, o, i, a;
      if (u(t), void 0 === (n = this._events)) return this;
      if (void 0 === (r = n[e])) return this;
      if (r === t || r.listener === t) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete n[e], n.removeListener && this.emit("removeListener", e, r.listener || t));else if ("function" != typeof r) {
        for (o = -1, i = r.length - 1; i >= 0; i--) if (r[i] === t || r[i].listener === t) {
          a = r[i].listener, o = i;
          break;
        }
        if (o < 0) return this;
        0 === o ? r.shift() : function (e, t) {
          for (; t + 1 < e.length; t++) e[t] = e[t + 1];
          e.pop();
        }(r, o), 1 === r.length && (n[e] = r[0]), void 0 !== n.removeListener && this.emit("removeListener", e, a || t);
      }
      return this;
    }, c.prototype.off = c.prototype.removeListener, c.prototype.removeAllListeners = function (e) {
      var t, r, n;
      if (void 0 === (r = this._events)) return this;
      if (void 0 === r.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== r[e] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete r[e]), this;
      if (0 === arguments.length) {
        var o,
          i = Object.keys(r);
        for (n = 0; n < i.length; ++n) "removeListener" !== (o = i[n]) && this.removeAllListeners(o);
        return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
      }
      if ("function" == typeof (t = r[e])) this.removeListener(e, t);else if (void 0 !== t) for (n = t.length - 1; n >= 0; n--) this.removeListener(e, t[n]);
      return this;
    }, c.prototype.listeners = function (e) {
      return y(this, e, !0);
    }, c.prototype.rawListeners = function (e) {
      return y(this, e, !1);
    }, c.listenerCount = function (e, t) {
      return "function" == typeof e.listenerCount ? e.listenerCount(t) : b.call(e, t);
    }, c.prototype.listenerCount = b, c.prototype.eventNames = function () {
      return this._eventsCount > 0 ? n(this._events) : [];
    };
  }, function (e, t, r) {
    var n = r(119),
      o = r(125);
    e.exports = function (e, t) {
      var r = o(e, t);
      return n(r) ? r : void 0;
    };
  }, function (e, t) {
    e.exports = p;
  }, function (e, t, r) {
    var n = r(53);
    e.exports = function (e, t, r) {
      return (t = n(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = f;
  }, function (e, t) {
    e.exports = d;
  }, function (e, t) {
    e.exports = y;
  }, function (e, t) {
    e.exports = function (e) {
      var t = typeof e;
      return null != e && ("object" == t || "function" == t);
    };
  }, function (e, t) {
    e.exports = function (e) {
      return null != e && "object" == typeof e;
    };
  }, function (e, t, r) {
    "use strict";

    var n = function () {};
    e.exports = n;
  }, function (e, t, r) {
    "use strict";

    e.exports = function (e, t, r, n, o, i, a, c) {
      if (!e) {
        var l;
        if (void 0 === t) l = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
          var u = [r, n, o, i, a, c],
            s = 0;
          (l = new Error(t.replace(/%s/g, function () {
            return u[s++];
          }))).name = "Invariant Violation";
        }
        throw l.framesToPop = 1, l;
      }
    };
  }, function (e, t) {
    e.exports = b;
  }, function (e, t) {
    e.exports = h;
  }, function (e, t, r) {
    var n = r(109),
      o = r(110),
      i = r(111),
      a = r(112),
      c = r(113);
    function l(e) {
      var t = -1,
        r = null == e ? 0 : e.length;
      for (this.clear(); ++t < r;) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }
    l.prototype.clear = n, l.prototype.delete = o, l.prototype.get = i, l.prototype.has = a, l.prototype.set = c, e.exports = l;
  }, function (e, t, r) {
    var n = r(56);
    e.exports = function (e, t) {
      for (var r = e.length; r--;) if (n(e[r][0], t)) return r;
      return -1;
    };
  }, function (e, t, r) {
    var n = r(39),
      o = r(121),
      i = r(122),
      a = n ? n.toStringTag : void 0;
    e.exports = function (e) {
      return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : a && a in Object(e) ? o(e) : i(e);
    };
  }, function (e, t, r) {
    var n = r(16)(Object, "create");
    e.exports = n;
  }, function (e, t, r) {
    var n = r(135);
    e.exports = function (e, t) {
      var r = e.__data__;
      return n(t) ? r["string" == typeof t ? "string" : "hash"] : r.map;
    };
  }, function (e, t, r) {
    var n = r(60),
      o = r(61);
    e.exports = function (e, t, r, i) {
      var a = !r;
      r || (r = {});
      for (var c = -1, l = t.length; ++c < l;) {
        var u = t[c],
          s = i ? i(r[u], e[u], u, r, e) : void 0;
        void 0 === s && (s = e[u]), a ? o(r, u, s) : n(r, u, s);
      }
      return r;
    };
  }, function (e, t, r) {
    var n = r(93),
      o = r(94),
      i = r(95),
      a = r(97);
    e.exports = function (e, t) {
      return n(e) || o(e, t) || i(e, t) || a();
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = m;
  }, function (e, t) {
    e.exports = v;
  }, function (e, t) {
    e.exports = g;
  }, function (e, t, r) {
    var n = r(16)(r(13), "Map");
    e.exports = n;
  }, function (e, t, r) {
    var n = r(13).Symbol;
    e.exports = n;
  }, function (e, t, r) {
    var n = r(62),
      o = r(149),
      i = r(66);
    e.exports = function (e) {
      return i(e) ? n(e) : o(e);
    };
  }, function (e, t) {
    var r = Array.isArray;
    e.exports = r;
  }, function (e, t) {
    e.exports = function (e) {
      return e.webpackPolyfill || (e.deprecate = function () {}, e.paths = [], e.children || (e.children = []), Object.defineProperty(e, "loaded", {
        enumerable: !0,
        get: function () {
          return e.l;
        }
      }), Object.defineProperty(e, "id", {
        enumerable: !0,
        get: function () {
          return e.i;
        }
      }), e.webpackPolyfill = 1), e;
    };
  }, function (e, t) {
    e.exports = function (e) {
      return function (t) {
        return e(t);
      };
    };
  }, function (e, t, r) {
    (function (e) {
      var n = r(58),
        o = t && !t.nodeType && t,
        i = o && "object" == typeof e && e && !e.nodeType && e,
        a = i && i.exports === o && n.process,
        c = function () {
          try {
            var e = i && i.require && i.require("util").types;
            return e || a && a.binding && a.binding("util");
          } catch (e) {}
        }();
      e.exports = c;
    }).call(this, r(42)(e));
  }, function (e, t) {
    var r = Object.prototype;
    e.exports = function (e) {
      var t = e && e.constructor;
      return e === ("function" == typeof t && t.prototype || r);
    };
  }, function (e, t, r) {
    var n = r(62),
      o = r(152),
      i = r(66);
    e.exports = function (e) {
      return i(e) ? n(e, !0) : o(e);
    };
  }, function (e, t, r) {
    var n = r(157),
      o = r(67),
      i = Object.prototype.propertyIsEnumerable,
      a = Object.getOwnPropertySymbols,
      c = a ? function (e) {
        return null == e ? [] : (e = Object(e), n(a(e), function (t) {
          return i.call(e, t);
        }));
      } : o;
    e.exports = c;
  }, function (e, t, r) {
    var n = r(161),
      o = r(38),
      i = r(162),
      a = r(163),
      c = r(164),
      l = r(30),
      u = r(59),
      s = u(n),
      p = u(o),
      f = u(i),
      d = u(a),
      y = u(c),
      b = l;
    (n && "[object DataView]" != b(new n(new ArrayBuffer(1))) || o && "[object Map]" != b(new o()) || i && "[object Promise]" != b(i.resolve()) || a && "[object Set]" != b(new a()) || c && "[object WeakMap]" != b(new c())) && (b = function (e) {
      var t = l(e),
        r = "[object Object]" == t ? e.constructor : void 0,
        n = r ? u(r) : "";
      if (n) switch (n) {
        case s:
          return "[object DataView]";
        case p:
          return "[object Map]";
        case f:
          return "[object Promise]";
        case d:
          return "[object Set]";
        case y:
          return "[object WeakMap]";
      }
      return t;
    }), e.exports = b;
  }, function (e, t, r) {
    var n = r(167);
    e.exports = function (e) {
      var t = new e.constructor(e.byteLength);
      return new n(t).set(new n(e)), t;
    };
  }, function (e, t, r) {
    var n = r(101),
      o = r(102);
    e.exports = function (e, t, r) {
      var i = t && r || 0;
      "string" == typeof e && (t = "binary" === e ? new Array(16) : null, e = null);
      var a = (e = e || {}).random || (e.rng || n)();
      if (a[6] = 15 & a[6] | 64, a[8] = 63 & a[8] | 128, t) for (var c = 0; c < 16; ++c) t[i + c] = a[c];
      return t || o(a);
    };
  }, function (e, t, r) {
    e.exports = r(180);
  }, function (e, t) {
    e.exports = w;
  }, function (e, t, r) {
    var n = r(54).default,
      o = r(92);
    e.exports = function (e) {
      var t = o(e, "string");
      return "symbol" == n(t) ? t : t + "";
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    function r(t) {
      return e.exports = r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, r(t);
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = function (e) {
      return function (t, r, n, o, i) {
        var a = n || "<<anonymous>>",
          c = i || r;
        if (null == t[r]) return new Error("The " + o + " `" + c + "` is required to make `" + a + "` accessible for users of assistive technologies such as screen readers.");
        for (var l = arguments.length, u = Array(l > 5 ? l - 5 : 0), s = 5; s < l; s++) u[s - 5] = arguments[s];
        return e.apply(void 0, [t, r, n, o, i].concat(u));
      };
    }, e.exports = t.default;
  }, function (e, t) {
    e.exports = function (e, t) {
      return e === t || e != e && t != t;
    };
  }, function (e, t, r) {
    var n = r(30),
      o = r(22);
    e.exports = function (e) {
      if (!o(e)) return !1;
      var t = n(e);
      return "[object Function]" == t || "[object GeneratorFunction]" == t || "[object AsyncFunction]" == t || "[object Proxy]" == t;
    };
  }, function (e, t, r) {
    (function (t) {
      var r = "object" == typeof t && t && t.Object === Object && t;
      e.exports = r;
    }).call(this, r(120));
  }, function (e, t) {
    var r = Function.prototype.toString;
    e.exports = function (e) {
      if (null != e) {
        try {
          return r.call(e);
        } catch (e) {}
        try {
          return e + "";
        } catch (e) {}
      }
      return "";
    };
  }, function (e, t, r) {
    var n = r(61),
      o = r(56),
      i = Object.prototype.hasOwnProperty;
    e.exports = function (e, t, r) {
      var a = e[t];
      i.call(e, t) && o(a, r) && (void 0 !== r || t in e) || n(e, t, r);
    };
  }, function (e, t, r) {
    var n = r(140);
    e.exports = function (e, t, r) {
      "__proto__" == t && n ? n(e, t, {
        configurable: !0,
        enumerable: !0,
        value: r,
        writable: !0
      }) : e[t] = r;
    };
  }, function (e, t, r) {
    var n = r(142),
      o = r(143),
      i = r(41),
      a = r(63),
      c = r(146),
      l = r(147),
      u = Object.prototype.hasOwnProperty;
    e.exports = function (e, t) {
      var r = i(e),
        s = !r && o(e),
        p = !r && !s && a(e),
        f = !r && !s && !p && l(e),
        d = r || s || p || f,
        y = d ? n(e.length, String) : [],
        b = y.length;
      for (var h in e) !t && !u.call(e, h) || d && ("length" == h || p && ("offset" == h || "parent" == h) || f && ("buffer" == h || "byteLength" == h || "byteOffset" == h) || c(h, b)) || y.push(h);
      return y;
    };
  }, function (e, t, r) {
    (function (e) {
      var n = r(13),
        o = r(145),
        i = t && !t.nodeType && t,
        a = i && "object" == typeof e && e && !e.nodeType && e,
        c = a && a.exports === i ? n.Buffer : void 0,
        l = (c ? c.isBuffer : void 0) || o;
      e.exports = l;
    }).call(this, r(42)(e));
  }, function (e, t) {
    e.exports = function (e) {
      return "number" == typeof e && e > -1 && e % 1 == 0 && e <= 9007199254740991;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      return function (r) {
        return e(t(r));
      };
    };
  }, function (e, t, r) {
    var n = r(57),
      o = r(64);
    e.exports = function (e) {
      return null != e && o(e.length) && !n(e);
    };
  }, function (e, t) {
    e.exports = function () {
      return [];
    };
  }, function (e, t, r) {
    var n = r(69),
      o = r(70),
      i = r(47),
      a = r(67),
      c = Object.getOwnPropertySymbols ? function (e) {
        for (var t = []; e;) n(t, i(e)), e = o(e);
        return t;
      } : a;
    e.exports = c;
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var r = -1, n = t.length, o = e.length; ++r < n;) e[o + r] = t[r];
      return e;
    };
  }, function (e, t, r) {
    var n = r(65)(Object.getPrototypeOf, Object);
    e.exports = n;
  }, function (e, t, r) {
    var n = r(69),
      o = r(41);
    e.exports = function (e, t, r) {
      var i = t(e);
      return o(e) ? i : n(i, r(e));
    };
  }, function (e, t) {
    function r(t) {
      return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? (e.exports = r = function (e) {
        return typeof e;
      }, e.exports.default = e.exports, e.exports.__esModule = !0) : (e.exports = r = function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, e.exports.default = e.exports, e.exports.__esModule = !0), r(t);
    }
    e.exports = r, e.exports.default = e.exports, e.exports.__esModule = !0;
  }, function (e, t) {
    e.exports = O;
  }, function (e) {
    e.exports = JSON.parse('{"en":{"activerecord":{"attributes":{"grafts":{"base":"Grafts"}},"errors":{"messages":{"blank":"can\'t be blank","must_be_valid_year":"must be a valid year","required":"must exist"}}},"if2_fields":{"account_not_found":"Account not found","accounting_reference":"Accounting Reference","acid_water_treatment":"Acid Water Treatment","acres":"Acres","activate":"Activate","add_graft":"add graft","affirmative":"Yes","apply":"Apply","began_organic_transition_on":"Began Organic Transition On","blocks":"Blocks","both":"Both","brand":"Brand","cancel":"Cancel","choose_field_from_map":"Choose a field from the map or list below.","choose_fields_spreadsheet":"Choose a spreadsheet of fields","close":"Close","confirm_delete_field":"Are you sure you want to delete this field?","conventional":"Conventional","cooling_type":"Cooling Type","copied_to_clipboard":"Copied!","copy_to_clipboard":"Copy to clipboard","county":"County","crop":"Crop","crop_and_variety":"Crop/Variety","crop_filter":"Crop Filter","crops":"Crops","cultivar":"Cultivar","cultivars":"Cultivars","date":"Date","date_began_organic_transition":"Date when this field began its transition to organic","date_completed_organic_transition":"Date when this field completed its transition to organic","date_or_year_required":"You must include either a date or year","date_year_or_variety_required":"You must include either a date, year or variety","deactivate":"Deactivate","declaration_date":"Declaration Date","declaration_date_label":"Organic Declaration Date","declared_organic_on":"Declared Organic On","delete":"Delete","edit":"Edit","edit_field":"Edit: %{field}","elevation":"Elevation","export":{"fields":"Export Fields","to_kml":"Export to KML"},"field_block_name":"Field/Block Name","field_form":{"add_label":"-Add %{label}-","field_has_multiple_cultivars":"Field has multiple cultivars","field_has_multiple_root_stocks":"Field has multiple root stocks","field_has_multiple_use_types":"Field has multiple use types","field_has_multiple_varieties":"Field has multiple varieties","not_specified":"-Not Specified-","organic_state":{"not_organic":"No","organic":"Yes","transitioning":"Transitioning"},"root_stocks_accounted_for":"Root stocks accounted for:","varieties_accounted_for":"Varieties accounted for:"},"field_visual_editor":{"acreage":"Acreage","computed_acreage":"Computed Acreage","field_block_acreage":"Field/Block Acreage","field_block_irrigation_rate":"Field/Block Irrigation Rate","field_block_plant_spacing":"Field/Block Plant Spacing","field_block_row_spacing":"Field/Block Row Spacing","field_block_tree_density":"Field/Block Tree Density"},"fields":"Fields","graft_date":"Graft date","graft_information":"Specify the graft date and interstem variety","grafted_onto":"Grafted onto","grafts":"Grafts","harvest_lot":"Harvest Lot","import_enqueued":"Import enqueued","import_fields":"Import Fields","import_file_format":{"columns":{"acid_water_treatment":"Whether or not the field\'s water supply is being treated with acid.","area":"Total area of the field. Note that area units are required.","area_default":"Total area of the field. Area units are supported, with the default\\nbeing \'%{unit}\'.\\n","cooling_types":"Type of cooling employed in the field. Note that multiple types are supported\\nseparated by forward slashes.\\n","county":"The county containing the field.","crop":"Name of the crop in the field.","cultivars":"Cultivars in the field. Note that multiple cultivars are supported\\nseparated by forward slashes.\\n","elevation":"Elevation of the field. Note that linear units are required.","elevation_default":"Elevation of the field. Linear units are supported, with the default being \'%{unit}\'.","grafts":"Grafts that have occurred in the field. Note that multiple interstem\\nvarieties are supported separated by forward slashes.\\n","harvest_lot":"The harvest lot for the field.","inactive":"Whether or not the field is inactive.","irrigation_management_types":"Type of irrigation management employed in the field. Note that multiple\\ntypes are supported separated by forward slashes.\\n","irrigation_monitoring_types":"Type of irrigation monitoring employed in the field. Note that multiple\\ntypes are supported separated by forward slashes.\\n","irrigation_rate":"Rate of irrigation of the field. Note that volumetric flow rate\\nunits are required.\\n","irrigation_rate_default":"Rate of irrigation of the field. Volumetric flow rate units are\\nsupported, with the default being \'%{unit}\'.\\n","irrigation_types":"Type of irrigation employed for the field. Note that multiple types\\nare supported separated by forward slashes.\\n","latitude":"Latitude of the field.","longitude":"Longitude of the field.","name":"Name of the field.","nearest_region":"The region or town nearest to the field.","non_bearing":"Whether or not the field is non-bearing.","notes":"Freehand notes about the field.","organic":"Whether or not the field is organic.","plant_spacing":"Spacing between plants in a row. Note that linear units are required.","plant_spacing_default":"Spacing between plants in a row. Linear units are supported, with the\\ndefault being \'%{unit}\'.\\n","previous_crop":"Crop previously in the field.","root_stocks":"Root stocks in the field. Note that multiple root stocks are supported\\nseparated by forward slashes.\\n","row_spacing":"Spacing between rows in the field. Note that linear units are required.","row_spacing_default":"Spacing between rows in the field. Linear units are supported, with\\nthe default being \'%{unit}\'.\\n","soil_classification":"Soil classification of the field. A mixture of soil types can be\\nspecified separated by forward slashes.\\n","support_system":"Support system used in the field.","transitional":"Whether or not the field has started the transition to organic.","tree_density":"Density of the tree plantings in the field. Note that reciprocal area\\nunits are required.\\n","tree_density_default":"Density of the tree plantings in the field. Reciprocal area units are\\nsupported, with the default being \'%{unit}\'.\\n","use_types":"Use types supported by the field. Note that multiple use types are\\nsupported separated by forward slashes.\\n","varieties":"Varieties in the field. Note that multiple varieties are supported\\nseparated by forward slashes.\\n","water_source":"Water source for the field.","year_planted":"Year the field was planted."},"description":"Description","download_csv":"Download CSV","example":"Example","header":"Header","introduction":"The import file follows a particular format. It must be a CSV file\\n(comma-separated values), which is probably not the format exported by\\ndefault by your spreadsheet program. The first row of the file must be a\\nset of column headers. Finally, while order and case are not important,\\nall of the following headers are required (although most values are\\noptional). Also note that only English headers and values are supported.\\n","title":"Field Import File Format","valid_values":"The following values are supported","value_required":"Value required?","you_can_download_csv":"You can download a pre-formatted CSV by clicking the button above."},"import_file_must_follow":"This file must follow a","imports":"Imports","inactive":"Inactive","irrigation_management_type":"Irrigation Management Type","irrigation_monitoring_type":"Irrigation Monitoring Type","irrigation_rate":"Irrigation Rate","irrigation_type":"Irrigation Type","max_import_size_exceeded":"This file exceeds the maximum allowed size of %{max}","name":"Name","nearest_town_region":"Nearest Town/Region","negative":"No","new_field":"New Field","no_fields_created_for":"No fields have been created for","no_fields_match":"No fields match the search/filter criteria","non_bearing":"Nonbearing","notes":"Notes","organic":"Organic","plant_spacing":"Plant Spacing","previous_crop":"Previous Crop","processing":"Processing","rate":"Rate","root_stock":"Root Stock","root_stocks":"Root stocks","row_spacing":"Row Spacing","save":"Save","search_by_name_crop_variety":"Search by name, crop type, variety, etc.","select_interstem_variety":"Select interstem variety","shade_color":"Shade Color","soil_classification":"Soil Classification","specific_format":"specific format","successfully_imported_following":"Successfully imported the following:","support_system":"Support System","that_account":"that account","transitional_date":"Transitional Date","tree_density":"Tree Density","uploaded":"Uploaded","uploading":"Uploading","use_the_form_to_create_new_field":"Use the form below to create a new field.","use_the_form_to_edit_field":"Use the form below to edit this field.","use_type":"Use Type","use_types":"Use types","varieties":"Varieties","variety":"Variety","variety_filter":"Variety Filter","view":"View","water_source":"Water Source","year":"Year","year_planted":"Year Planted","you_do_not_have_permission":"You do not have permission to move fields into"}}}');
  }, function (e) {
    e.exports = JSON.parse('{"es":{"activerecord":{"attributes":{"grafts":{"base":"Injertos"}},"errors":{"messages":{"blank":"No puede estar en blanco","must_be_valid_year":"Debe ser un año válido","required":"Se requiere"}}},"if2_fields":{"account_not_found":"No se encontró la cuenta","accounting_reference":"Referencia de contabilidad","acid_water_treatment":"Agua tratada con ácido","acres":"Acres","activate":"Activar","add_graft":"añadir injerto","affirmative":"Sí","apply":"Aplicar","began_organic_transition_on":"Comenzó la Transición Orgánica En","blocks":"Bloques","both":"Ambos","brand":"Marca","cancel":"Cancelar","choose_field_from_map":"Seleccione un campo del mapa o de la lista de abajo.","choose_fields_spreadsheet":"Elija una hoja de cálculo de campos","close":"Cerrar","confirm_delete_field":"¿Está seguro de que quiere eliminar este campo?","conventional":"Convencional","cooling_type":"Tipo de enfriamiento","copied_to_clipboard":"¡Copiado!","copy_to_clipboard":"Copiar al portapapeles","county":"Condado","crop":"Cultivo","crop_and_variety":"Cultivo/Variedad","crop_filter":"Filtro por cultivo","crops":"Cultivos","cultivar":"Cultivar","cultivars":"Cultivares","date":"Fecha","date_began_organic_transition":"Fecha en que este campo inició su transición a orgánico","date_completed_organic_transition":"Fecha en la que este campo completó su transición a orgánico","date_or_year_required":"Se requiere o una fecha o un año","date_year_or_variety_required":"Se requiere una fecha, un año o una variedad","deactivate":"Desactivar","declaration_date":"Fecha de Declaración","declaration_date_label":"Fecha de Declaración Orgánica","declared_organic_on":"Declarado Orgánico","delete":"Eliminar","edit":"Editar","edit_field":"Edit: %{field}","elevation":"Altura","export":{"fields":"Exportar campos","to_kml":"Exportar a KML"},"field_block_name":"Nombre de campo/bloque","field_form":{"add_label":"-Añadir %{label}-","field_has_multiple_cultivars":"El campo tiene más de un cultivar","field_has_multiple_root_stocks":"El campo tiene más de un rizoma","field_has_multiple_use_types":"El campo tiene más de una utilización","field_has_multiple_varieties":"El campo tiene más de una variedad","not_specified":"-No especificado-","organic_state":{"not_organic":"No","organic":"Sí","transitioning":"Transición"},"root_stocks_accounted_for":"Rizomas ya contadas:","varieties_accounted_for":"Variedades ya contadas:"},"field_visual_editor":{"acreage":"Superficie","computed_acreage":"Superficie Calculada","field_block_acreage":"Superficie de Campo/Bloque","field_block_irrigation_rate":"Ritmo de irrigación del campo/bloque","field_block_plant_spacing":"Espaciado de plantas del campo/bloque","field_block_row_spacing":"Espaciado de la hilera del Campo/Bloque","field_block_tree_density":"Densidad de árboles del campo/bloque"},"fields":"Campos","graft_date":"Fecha de injerto","graft_information":"Especifica la fecha y variedad de intertallo","grafted_onto":"Injertado en","grafts":"Injertos","harvest_lot":"Lote de cosecha","import_enqueued":"Importación encolada","import_fields":"Importar Campos","import_file_format":{"columns":{"acid_water_treatment":"Si el suministro de agua de este campo está siendo tratado con ácido o no.","area":"Área total del campo. Tenga en cuenta que las unidades de área son obligatorias.","area_default":"Área total del campo. Las unidades de área son compatibles, siendo el\\nvalor predeterminado \'%{unit}\'.\\n","cooling_types":"Tipos de refrigeración utilizados en el campo. Tenga en cuenta que se\\nadmiten varios tipos separados por barras diagonales.\\n","county":"El condado que contiene el campo.","crop":"Nombre del cultivo en el campo.","cultivars":"Cultivares en el campo. Tenga en cuenta que se admiten varios\\ncultivares separados por barras diagonales.\\n","elevation":"Elevación del campo. Tenga en cuenta que se requieren unidades lineales.","elevation_default":"Elevación del campo. Se admiten unidades lineales, siendo el valor\\npredeterminado \'%{unit}\'.\\n","grafts":"Injertos que se han producido en el campo. Tenga en cuenta que se\\nadmiten varias variedades entre tallos separadas por barras diagonales.\\n","harvest_lot":"El lote de cosecha para este campo.","inactive":"Si el campo está inactivo o no.","irrigation_management_types":"Tipo de manejo del riego empleado en el campo. Tenga en cuenta que se\\nadmiten varios tipos separados por barras diagonales.\\n","irrigation_monitoring_types":"Tipo de seguimiento del riego empleado en el campo. Tenga en cuenta\\nque se admiten varios tipos separados por barras diagonales.\\n","irrigation_rate":"Tasa de riego de este campo. Tenga en cuenta que se requieren\\nunidades de caudal volumétrico.\\n","irrigation_rate_default":"Tasa de riego de este campo. Se admiten las unidades de caudal\\nvolumétrico, siendo el valor predeterminado \'%{unit}\'.\\n","irrigation_types":"Tipo de riego empleado para el campo. Tenga en cuenta que se admiten\\nvarios tipos separados por barras diagonales.\\n","latitude":"Latitud del campo.","longitude":"Longitud del campo.","name":"Nombre del campo.","nearest_region":"La región o localidad más cercana al campo.","non_bearing":"Si este campo es o no no portador.","notes":"Notas a mano alzada sobre este campo.","organic":"Si este campo es orgánico o no.","plant_spacing":"Espaciado entre plantas en una fila. Tenga en cuenta que se requieren\\nunidades lineales.\\n","plant_spacing_default":"Espaciado entre plantas en una fila. Se admiten unidades lineales,\\nsiendo el valor predeterminado \'%{unit}\'.\\n","previous_crop":"Recortar previamente en este campo.","root_stocks":"Raíces en el campo. Tenga en cuenta que se admiten múltiples raíces\\nseparadas por barras diagonales.\\n","row_spacing":"Espaciamiento entre filas en el campo. Tenga en cuenta que se\\nrequieren unidades lineales.\\n","row_spacing_default":"Espaciamiento entre filas en el campo. Se admiten unidades lineales,\\nsiendo el valor predeterminado \'%{unit}\'.\\n","soil_classification":"Clasificación de suelos del campo. Se puede especificar una mezcla de\\ntipos de suelo separados por barras diagonales.\\n","support_system":"Sistema de apoyo utilizado en el campo.","transitional":"Si este campo ha iniciado o no la transición a lo orgánico.","tree_density":"Densidad de las plantaciones de árboles en el campo. Tenga en cuenta\\nque se requieren unidades de área recíprocas.\\n","tree_density_default":"Densidad de las plantaciones de árboles en el campo. Se admiten\\nunidades de área recíprocas, siendo el valor predeterminado \'%{unit}\'.\\n","use_types":"Utilice tipos admitidos por el campo. Tenga en cuenta que se admiten\\nvarios tipos de uso separados por barras diagonales.\\n","varieties":"Variedades en el campo. Tenga en cuenta que se admiten varias variedades\\nseparadas por barras diagonales.\\n","water_source":"Fuente de agua para el campo.","year_planted":"Año en que se plantó el campo."},"description":"Descripción","download_csv":"Descargar CSV","example":"Ejemplo","header":"Encabezamiento","introduction":"El archivo de importación sigue un formato particular. Debe ser un\\narchivo CSV (valores separados por comas), que probablemente no sea\\nel formato exportado de manera predeterminada por su programa de hoja\\nde cálculo. La primera fila del archivo debe ser un conjunto de\\nencabezados de columna. Finalmente, aunque el orden y el caso no son\\nimportantes, todos los siguientes encabezados son obligatorios (aunque\\nla mayoría de los valores son opcionales). También tenga en cuenta que\\nsolo se admiten encabezados y valores en inglés.\\n","title":"Formato de archivo de la importación del campo","valid_values":"Se admiten los siguientes valores","value_required":"Valor requerido?","you_can_download_csv":"Puede descargar un CSV preformateado haciendo clic en el botón de arriba."},"import_file_must_follow":"Este archivo debe seguir un","imports":"Importaciones","inactive":"Desactivado","irrigation_management_type":"Tipo de gestión de riego","irrigation_monitoring_type":"Tipo de monitoreo de riego","irrigation_rate":"Ritmo de irrigación","irrigation_type":"Tipo de riego","max_import_size_exceeded":"Este archivo supera el tamaño máximo permitido de %{max}","name":"Nombre","nearest_town_region":"Pueblo/región más cerca","negative":"No","new_field":"Nuevo Campo","no_fields_created_for":"No se ha creado ningún campo para","no_fields_match":"Ningún campo coincide con los criterios de búsqueda/filtro","non_bearing":"Que no rinde frutos","notes":"Apuntes","organic":"Orgánico","plant_spacing":"Espaciado de plantas","previous_crop":"Cultivo anterior","processing":"Procesando","rate":"Ritmo de irrigación","root_stock":"Rizoma","root_stocks":"Rizomas","row_spacing":"Espaciado de la hilera","save":"Guardar","search_by_name_crop_variety":"Buscar por nombre, cultivo, variedad, etc.","select_interstem_variety":"Seleccione variedad de intertallo","shade_color":"Color de sombra","soil_classification":"Clasificación del suelo","specific_format":"formato en específico","successfully_imported_following":"Los siguientes se han importado exitosamente:","support_system":"Sistema de Apoyo","that_account":"esa cuenta","transitional_date":"Fecha \'de transición\'","tree_density":"Densidad de árboles","uploaded":"Se ha cargado","uploading":"Cargando","use_the_form_to_create_new_field":"Use el siguiente formulario para crear un nuevo campo.","use_the_form_to_edit_field":"Use el siguiente formulario para editar este campo.","use_type":"Utilización","use_types":"Utilizaciones","varieties":"Variedades","variety":"Variedad","variety_filter":"Filtro por variedad","view":"Ver","water_source":"Fuente de agua","year":"Año","year_planted":"Año sembrado","you_do_not_have_permission":"Usted no tiene permiso mover campos a"}}}');
  }, function (e, t) {
    e.exports = function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, r) {
    var n = r(53);
    function o(e, t) {
      for (var r = 0; r < t.length; r++) {
        var o = t[r];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, n(o.key), o);
      }
    }
    e.exports = function (e, t, r) {
      return t && o(e.prototype, t), r && o(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
      }), e;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = _;
  }, function (e, t, r) {
    var n = r(98);
    e.exports = function (e, t) {
      if (null == e) return {};
      var r,
        o,
        i = n(e, t);
      if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        for (o = 0; o < a.length; o++) r = a[o], t.includes(r) || {}.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
      }
      return i;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = j;
  }, function (e, t) {
    e.exports = P;
  }, function (e, t) {
    e.exports = E;
  }, function (e, t) {
    e.exports = k;
  }, function (e, t, r) {
    var n = r(107);
    e.exports = function (e) {
      return n(e, 5);
    };
  }, function (e, t) {
    e.exports = x;
  }, function (e, t) {
    e.exports = S;
  }, function (e, t) {
    e.exports = C;
  }, function (e, t) {
    e.exports = R;
  }, function (e, t, r) {
    "use strict";

    e.exports = r(178);
  }, function (e, t) {
    e.exports = N;
  }, function (e, t) {
    e.exports = z;
  }, function (e, t, r) {
    var n = r(54).default;
    e.exports = function (e, t) {
      if ("object" != n(e) || !e) return e;
      var r = e[Symbol.toPrimitive];
      if (void 0 !== r) {
        var o = r.call(e, t || "default");
        if ("object" != n(o)) return o;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === t ? String : Number)(e);
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = function (e) {
      if (Array.isArray(e)) return e;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = function (e, t) {
      var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
      if (null != r) {
        var n,
          o,
          i,
          a,
          c = [],
          l = !0,
          u = !1;
        try {
          if (i = (r = r.call(e)).next, 0 === t) {
            if (Object(r) !== r) return;
            l = !1;
          } else for (; !(l = (n = i.call(r)).done) && (c.push(n.value), c.length !== t); l = !0);
        } catch (e) {
          u = !0, o = e;
        } finally {
          try {
            if (!l && null != r.return && (a = r.return(), Object(a) !== a)) return;
          } finally {
            if (u) throw o;
          }
        }
        return c;
      }
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, r) {
    var n = r(96);
    e.exports = function (e, t) {
      if (e) {
        if ("string" == typeof e) return n(e, t);
        var r = {}.toString.call(e).slice(8, -1);
        return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(e) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? n(e, t) : void 0;
      }
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = function (e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = Array(t); r < t; r++) n[r] = e[r];
      return n;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t) {
    e.exports = function (e, t) {
      if (null == e) return {};
      var r = {};
      for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
        if (t.includes(n)) continue;
        r[n] = e[n];
      }
      return r;
    }, e.exports.__esModule = !0, e.exports.default = e.exports;
  }, function (e, t, r) {
    "use strict";

    var n = r(100);
    function o() {}
    function i() {}
    i.resetWarningCache = o, e.exports = function () {
      function e(e, t, r, o, i, a) {
        if (a !== n) {
          var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw c.name = "Invariant Violation", c;
        }
      }
      function t() {
        return e;
      }
      e.isRequired = e;
      var r = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: i,
        resetWarningCache: o
      };
      return r.PropTypes = r, r;
    };
  }, function (e, t, r) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t) {
    var r = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto);
    if (r) {
      var n = new Uint8Array(16);
      e.exports = function () {
        return r(n), n;
      };
    } else {
      var o = new Array(16);
      e.exports = function () {
        for (var e, t = 0; t < 16; t++) 0 == (3 & t) && (e = 4294967296 * Math.random()), o[t] = e >>> ((3 & t) << 3) & 255;
        return o;
      };
    }
  }, function (e, t) {
    for (var r = [], n = 0; n < 256; ++n) r[n] = (n + 256).toString(16).substr(1);
    e.exports = function (e, t) {
      var n = t || 0,
        o = r;
      return [o[e[n++]], o[e[n++]], o[e[n++]], o[e[n++]], "-", o[e[n++]], o[e[n++]], "-", o[e[n++]], o[e[n++]], "-", o[e[n++]], o[e[n++]], "-", o[e[n++]], o[e[n++]], o[e[n++]], o[e[n++]], o[e[n++]], o[e[n++]]].join("");
    };
  }, function (e, t, r) {
    var n = {
      "./field-import.json": 104,
      "./field.json": 105,
      "./geo-json.json": 106
    };
    function o(e) {
      var t = i(e);
      return r(t);
    }
    function i(e) {
      if (!r.o(n, e)) {
        var t = new Error("Cannot find module '" + e + "'");
        throw t.code = "MODULE_NOT_FOUND", t;
      }
      return n[e];
    }
    o.keys = function () {
      return Object.keys(n);
    }, o.resolve = i, e.exports = o, o.id = 103;
  }, function (e) {
    e.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/fields/field-import","type":"object","properties":{"type":{"type":"string","enum":["IF2::Fields::FieldImport"]},"serial":{"type":"integer"},"account_id":{"type":["integer"]},"created_at":{"type":"string"},"updated_at":{"type":"string"},"status":{"type":"string","enum":["enqueued","running","complete","failed"]},"message":{"type":"string"},"file_name":{"type":"string"},"total":{"type":"integer"},"processed":{"type":"integer"},"fields_created":{"type":"integer"},"crops_created":{"type":"integer"},"varieties_created":{"type":["integer","null"]},"cultivars_created":{"type":["integer","null"]},"root_stocks_created":{"type":["integer","null"]},"use_types_created":{"type":["integer","null"]}},"required":["type","serial","account_id","created_at","updated_at","status","message","file_name","total","processed","fields_created","crops_created","varieties_created","cultivars_created","root_stocks_created","use_types_created"],"additionalProperties":false}');
  }, function (e) {
    e.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/fields/field","type":"object","properties":{"type":{"type":"string"},"id":{"type":["integer","string"]},"serial":{"type":"integer"},"created_at":{"type":"string"},"updated_at":{"type":"string"},"name":{"type":"string"},"area":{"type":"string"},"row_spacing":{"type":["string","null"]},"plant_spacing":{"type":["string","null"]},"tree_density":{"type":["string","null"]},"irrigation_rate":{"type":["string","null"]},"elevation":{"type":["string","null"]},"county":{"type":["string","null"]},"notes":{"type":["string","null"]},"accounting_reference":{"type":["string","null"]},"nearest_region":{"type":["string","null"]},"harvest_lot":{"type":["string","null"]},"previous_crop":{"type":["string","null"]},"year_planted":{"type":["integer","null"]},"latitude":{"type":["string","null"]},"longitude":{"type":["string","null"]},"geo_json":{"$ref":"https://schemas.miriamtech.com/if2/fields/field/geo-json"},"inactive":{"type":"boolean"},"non_bearing":{"type":"boolean"},"acid_water_treatment":{"type":"boolean"},"organic":{"type":"boolean"},"transitional":{"type":"boolean"},"organic_date":{"type":["string","null"]},"transitional_date":{"type":["string","null"]},"account":{"$ref":"#/$defs/object_reference"},"crop":{"$ref":"#/$defs/object_reference"},"varieties":{"type":"array","items":{"$ref":"#/$defs/presentation_percentage_reference"}},"root_stocks":{"type":"array","items":{"$ref":"#/$defs/presentation_percentage_reference"}},"cultivars":{"type":"array","items":{"$ref":"#/$defs/presentation_reference"}},"use_types":{"type":"array","items":{"$ref":"#/$defs/presentation_reference"}}},"required":["type","id","serial","created_at","updated_at","name","area","row_spacing","plant_spacing","tree_density","irrigation_rate","elevation","county","notes","accounting_reference","nearest_region","harvest_lot","previous_crop","year_planted","latitude","longitude","geo_json","inactive","non_bearing","acid_water_treatment","organic","transitional","organic_date","transitional_date","account","crop"],"additionalProperties":false,"$defs":{"object_reference":{"type":"object","properties":{"id":{"type":["integer","string"]},"serial":{"type":"integer"},"name":{"type":"string"}},"required":["id","serial","name"],"additionalProperties":false},"presentation_percentage_reference":{"type":"object","properties":{"name":{"type":"string"},"percentage":{"oneOf":[{"type":"number","minimum":0,"maximum":1},{"type":"string"},{"type":"null"}]}},"required":["name","percentage"],"additionalProperties":false},"presentation_reference":{"type":"object","properties":{"name":{"type":"string"}},"required":["name"],"additionalProperties":false}}}');
  }, function (e) {
    e.exports = JSON.parse('{"$id":"https://schemas.miriamtech.com/if2/fields/field/geo-json","anyOf":[{"type":"null"},{"type":"object","properties":{"type":{"type":"string"}},"required":["type"]}]}');
  }, function (e, t, r) {
    var n = r(108),
      o = r(139),
      i = r(60),
      a = r(141),
      c = r(151),
      l = r(154),
      u = r(155),
      s = r(156),
      p = r(158),
      f = r(159),
      d = r(160),
      y = r(48),
      b = r(165),
      h = r(166),
      m = r(172),
      v = r(41),
      g = r(63),
      w = r(174),
      O = r(22),
      _ = r(176),
      j = r(40),
      P = r(46),
      E = {};
    E["[object Arguments]"] = E["[object Array]"] = E["[object ArrayBuffer]"] = E["[object DataView]"] = E["[object Boolean]"] = E["[object Date]"] = E["[object Float32Array]"] = E["[object Float64Array]"] = E["[object Int8Array]"] = E["[object Int16Array]"] = E["[object Int32Array]"] = E["[object Map]"] = E["[object Number]"] = E["[object Object]"] = E["[object RegExp]"] = E["[object Set]"] = E["[object String]"] = E["[object Symbol]"] = E["[object Uint8Array]"] = E["[object Uint8ClampedArray]"] = E["[object Uint16Array]"] = E["[object Uint32Array]"] = !0, E["[object Error]"] = E["[object Function]"] = E["[object WeakMap]"] = !1, e.exports = function e(t, r, k, x, S, C) {
      var R,
        N = 1 & r,
        z = 2 & r,
        D = 4 & r;
      if (k && (R = S ? k(t, x, S, C) : k(t)), void 0 !== R) return R;
      if (!O(t)) return t;
      var T = v(t);
      if (T) {
        if (R = b(t), !N) return u(t, R);
      } else {
        var M = y(t),
          F = "[object Function]" == M || "[object GeneratorFunction]" == M;
        if (g(t)) return l(t, N);
        if ("[object Object]" == M || "[object Arguments]" == M || F && !S) {
          if (R = z || F ? {} : m(t), !N) return z ? p(t, c(R, t)) : s(t, a(R, t));
        } else {
          if (!E[M]) return S ? t : {};
          R = h(t, M, N);
        }
      }
      C || (C = new n());
      var I = C.get(t);
      if (I) return I;
      C.set(t, R), _(t) ? t.forEach(function (n) {
        R.add(e(n, r, k, n, t, C));
      }) : w(t) && t.forEach(function (n, o) {
        R.set(o, e(n, r, k, o, t, C));
      });
      var A = T ? void 0 : (D ? z ? d : f : z ? P : j)(t);
      return o(A || t, function (n, o) {
        A && (n = t[o = n]), i(R, o, e(n, r, k, o, t, C));
      }), R;
    };
  }, function (e, t, r) {
    var n = r(28),
      o = r(114),
      i = r(115),
      a = r(116),
      c = r(117),
      l = r(118);
    function u(e) {
      var t = this.__data__ = new n(e);
      this.size = t.size;
    }
    u.prototype.clear = o, u.prototype.delete = i, u.prototype.get = a, u.prototype.has = c, u.prototype.set = l, e.exports = u;
  }, function (e, t) {
    e.exports = function () {
      this.__data__ = [], this.size = 0;
    };
  }, function (e, t, r) {
    var n = r(29),
      o = Array.prototype.splice;
    e.exports = function (e) {
      var t = this.__data__,
        r = n(t, e);
      return !(r < 0) && (r == t.length - 1 ? t.pop() : o.call(t, r, 1), --this.size, !0);
    };
  }, function (e, t, r) {
    var n = r(29);
    e.exports = function (e) {
      var t = this.__data__,
        r = n(t, e);
      return r < 0 ? void 0 : t[r][1];
    };
  }, function (e, t, r) {
    var n = r(29);
    e.exports = function (e) {
      return n(this.__data__, e) > -1;
    };
  }, function (e, t, r) {
    var n = r(29);
    e.exports = function (e, t) {
      var r = this.__data__,
        o = n(r, e);
      return o < 0 ? (++this.size, r.push([e, t])) : r[o][1] = t, this;
    };
  }, function (e, t, r) {
    var n = r(28);
    e.exports = function () {
      this.__data__ = new n(), this.size = 0;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = this.__data__,
        r = t.delete(e);
      return this.size = t.size, r;
    };
  }, function (e, t) {
    e.exports = function (e) {
      return this.__data__.get(e);
    };
  }, function (e, t) {
    e.exports = function (e) {
      return this.__data__.has(e);
    };
  }, function (e, t, r) {
    var n = r(28),
      o = r(38),
      i = r(126);
    e.exports = function (e, t) {
      var r = this.__data__;
      if (r instanceof n) {
        var a = r.__data__;
        if (!o || a.length < 199) return a.push([e, t]), this.size = ++r.size, this;
        r = this.__data__ = new i(a);
      }
      return r.set(e, t), this.size = r.size, this;
    };
  }, function (e, t, r) {
    var n = r(57),
      o = r(123),
      i = r(22),
      a = r(59),
      c = /^\[object .+?Constructor\]$/,
      l = Function.prototype,
      u = Object.prototype,
      s = l.toString,
      p = u.hasOwnProperty,
      f = RegExp("^" + s.call(p).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    e.exports = function (e) {
      return !(!i(e) || o(e)) && (n(e) ? f : c).test(a(e));
    };
  }, function (e, t) {
    var r;
    r = function () {
      return this;
    }();
    try {
      r = r || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (r = window);
    }
    e.exports = r;
  }, function (e, t, r) {
    var n = r(39),
      o = Object.prototype,
      i = o.hasOwnProperty,
      a = o.toString,
      c = n ? n.toStringTag : void 0;
    e.exports = function (e) {
      var t = i.call(e, c),
        r = e[c];
      try {
        e[c] = void 0;
        var n = !0;
      } catch (e) {}
      var o = a.call(e);
      return n && (t ? e[c] = r : delete e[c]), o;
    };
  }, function (e, t) {
    var r = Object.prototype.toString;
    e.exports = function (e) {
      return r.call(e);
    };
  }, function (e, t, r) {
    var n,
      o = r(124),
      i = (n = /[^.]+$/.exec(o && o.keys && o.keys.IE_PROTO || "")) ? "Symbol(src)_1." + n : "";
    e.exports = function (e) {
      return !!i && i in e;
    };
  }, function (e, t, r) {
    var n = r(13)["__core-js_shared__"];
    e.exports = n;
  }, function (e, t) {
    e.exports = function (e, t) {
      return null == e ? void 0 : e[t];
    };
  }, function (e, t, r) {
    var n = r(127),
      o = r(134),
      i = r(136),
      a = r(137),
      c = r(138);
    function l(e) {
      var t = -1,
        r = null == e ? 0 : e.length;
      for (this.clear(); ++t < r;) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }
    l.prototype.clear = n, l.prototype.delete = o, l.prototype.get = i, l.prototype.has = a, l.prototype.set = c, e.exports = l;
  }, function (e, t, r) {
    var n = r(128),
      o = r(28),
      i = r(38);
    e.exports = function () {
      this.size = 0, this.__data__ = {
        hash: new n(),
        map: new (i || o)(),
        string: new n()
      };
    };
  }, function (e, t, r) {
    var n = r(129),
      o = r(130),
      i = r(131),
      a = r(132),
      c = r(133);
    function l(e) {
      var t = -1,
        r = null == e ? 0 : e.length;
      for (this.clear(); ++t < r;) {
        var n = e[t];
        this.set(n[0], n[1]);
      }
    }
    l.prototype.clear = n, l.prototype.delete = o, l.prototype.get = i, l.prototype.has = a, l.prototype.set = c, e.exports = l;
  }, function (e, t, r) {
    var n = r(31);
    e.exports = function () {
      this.__data__ = n ? n(null) : {}, this.size = 0;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = this.has(e) && delete this.__data__[e];
      return this.size -= t ? 1 : 0, t;
    };
  }, function (e, t, r) {
    var n = r(31),
      o = Object.prototype.hasOwnProperty;
    e.exports = function (e) {
      var t = this.__data__;
      if (n) {
        var r = t[e];
        return "__lodash_hash_undefined__" === r ? void 0 : r;
      }
      return o.call(t, e) ? t[e] : void 0;
    };
  }, function (e, t, r) {
    var n = r(31),
      o = Object.prototype.hasOwnProperty;
    e.exports = function (e) {
      var t = this.__data__;
      return n ? void 0 !== t[e] : o.call(t, e);
    };
  }, function (e, t, r) {
    var n = r(31);
    e.exports = function (e, t) {
      var r = this.__data__;
      return this.size += this.has(e) ? 0 : 1, r[e] = n && void 0 === t ? "__lodash_hash_undefined__" : t, this;
    };
  }, function (e, t, r) {
    var n = r(32);
    e.exports = function (e) {
      var t = n(this, e).delete(e);
      return this.size -= t ? 1 : 0, t;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = typeof e;
      return "string" == t || "number" == t || "symbol" == t || "boolean" == t ? "__proto__" !== e : null === e;
    };
  }, function (e, t, r) {
    var n = r(32);
    e.exports = function (e) {
      return n(this, e).get(e);
    };
  }, function (e, t, r) {
    var n = r(32);
    e.exports = function (e) {
      return n(this, e).has(e);
    };
  }, function (e, t, r) {
    var n = r(32);
    e.exports = function (e, t) {
      var r = n(this, e),
        o = r.size;
      return r.set(e, t), this.size += r.size == o ? 0 : 1, this;
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var r = -1, n = null == e ? 0 : e.length; ++r < n && !1 !== t(e[r], r, e););
      return e;
    };
  }, function (e, t, r) {
    var n = r(16),
      o = function () {
        try {
          var e = n(Object, "defineProperty");
          return e({}, "", {}), e;
        } catch (e) {}
      }();
    e.exports = o;
  }, function (e, t, r) {
    var n = r(33),
      o = r(40);
    e.exports = function (e, t) {
      return e && n(t, o(t), e);
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var r = -1, n = Array(e); ++r < e;) n[r] = t(r);
      return n;
    };
  }, function (e, t, r) {
    var n = r(144),
      o = r(23),
      i = Object.prototype,
      a = i.hasOwnProperty,
      c = i.propertyIsEnumerable,
      l = n(function () {
        return arguments;
      }()) ? n : function (e) {
        return o(e) && a.call(e, "callee") && !c.call(e, "callee");
      };
    e.exports = l;
  }, function (e, t, r) {
    var n = r(30),
      o = r(23);
    e.exports = function (e) {
      return o(e) && "[object Arguments]" == n(e);
    };
  }, function (e, t) {
    e.exports = function () {
      return !1;
    };
  }, function (e, t) {
    var r = /^(?:0|[1-9]\d*)$/;
    e.exports = function (e, t) {
      var n = typeof e;
      return !!(t = null == t ? 9007199254740991 : t) && ("number" == n || "symbol" != n && r.test(e)) && e > -1 && e % 1 == 0 && e < t;
    };
  }, function (e, t, r) {
    var n = r(148),
      o = r(43),
      i = r(44),
      a = i && i.isTypedArray,
      c = a ? o(a) : n;
    e.exports = c;
  }, function (e, t, r) {
    var n = r(30),
      o = r(64),
      i = r(23),
      a = {};
    a["[object Float32Array]"] = a["[object Float64Array]"] = a["[object Int8Array]"] = a["[object Int16Array]"] = a["[object Int32Array]"] = a["[object Uint8Array]"] = a["[object Uint8ClampedArray]"] = a["[object Uint16Array]"] = a["[object Uint32Array]"] = !0, a["[object Arguments]"] = a["[object Array]"] = a["[object ArrayBuffer]"] = a["[object Boolean]"] = a["[object DataView]"] = a["[object Date]"] = a["[object Error]"] = a["[object Function]"] = a["[object Map]"] = a["[object Number]"] = a["[object Object]"] = a["[object RegExp]"] = a["[object Set]"] = a["[object String]"] = a["[object WeakMap]"] = !1, e.exports = function (e) {
      return i(e) && o(e.length) && !!a[n(e)];
    };
  }, function (e, t, r) {
    var n = r(45),
      o = r(150),
      i = Object.prototype.hasOwnProperty;
    e.exports = function (e) {
      if (!n(e)) return o(e);
      var t = [];
      for (var r in Object(e)) i.call(e, r) && "constructor" != r && t.push(r);
      return t;
    };
  }, function (e, t, r) {
    var n = r(65)(Object.keys, Object);
    e.exports = n;
  }, function (e, t, r) {
    var n = r(33),
      o = r(46);
    e.exports = function (e, t) {
      return e && n(t, o(t), e);
    };
  }, function (e, t, r) {
    var n = r(22),
      o = r(45),
      i = r(153),
      a = Object.prototype.hasOwnProperty;
    e.exports = function (e) {
      if (!n(e)) return i(e);
      var t = o(e),
        r = [];
      for (var c in e) ("constructor" != c || !t && a.call(e, c)) && r.push(c);
      return r;
    };
  }, function (e, t) {
    e.exports = function (e) {
      var t = [];
      if (null != e) for (var r in Object(e)) t.push(r);
      return t;
    };
  }, function (e, t, r) {
    (function (e) {
      var n = r(13),
        o = t && !t.nodeType && t,
        i = o && "object" == typeof e && e && !e.nodeType && e,
        a = i && i.exports === o ? n.Buffer : void 0,
        c = a ? a.allocUnsafe : void 0;
      e.exports = function (e, t) {
        if (t) return e.slice();
        var r = e.length,
          n = c ? c(r) : new e.constructor(r);
        return e.copy(n), n;
      };
    }).call(this, r(42)(e));
  }, function (e, t) {
    e.exports = function (e, t) {
      var r = -1,
        n = e.length;
      for (t || (t = Array(n)); ++r < n;) t[r] = e[r];
      return t;
    };
  }, function (e, t, r) {
    var n = r(33),
      o = r(47);
    e.exports = function (e, t) {
      return n(e, o(e), t);
    };
  }, function (e, t) {
    e.exports = function (e, t) {
      for (var r = -1, n = null == e ? 0 : e.length, o = 0, i = []; ++r < n;) {
        var a = e[r];
        t(a, r, e) && (i[o++] = a);
      }
      return i;
    };
  }, function (e, t, r) {
    var n = r(33),
      o = r(68);
    e.exports = function (e, t) {
      return n(e, o(e), t);
    };
  }, function (e, t, r) {
    var n = r(71),
      o = r(47),
      i = r(40);
    e.exports = function (e) {
      return n(e, i, o);
    };
  }, function (e, t, r) {
    var n = r(71),
      o = r(68),
      i = r(46);
    e.exports = function (e) {
      return n(e, i, o);
    };
  }, function (e, t, r) {
    var n = r(16)(r(13), "DataView");
    e.exports = n;
  }, function (e, t, r) {
    var n = r(16)(r(13), "Promise");
    e.exports = n;
  }, function (e, t, r) {
    var n = r(16)(r(13), "Set");
    e.exports = n;
  }, function (e, t, r) {
    var n = r(16)(r(13), "WeakMap");
    e.exports = n;
  }, function (e, t) {
    var r = Object.prototype.hasOwnProperty;
    e.exports = function (e) {
      var t = e.length,
        n = new e.constructor(t);
      return t && "string" == typeof e[0] && r.call(e, "index") && (n.index = e.index, n.input = e.input), n;
    };
  }, function (e, t, r) {
    var n = r(49),
      o = r(168),
      i = r(169),
      a = r(170),
      c = r(171);
    e.exports = function (e, t, r) {
      var l = e.constructor;
      switch (t) {
        case "[object ArrayBuffer]":
          return n(e);
        case "[object Boolean]":
        case "[object Date]":
          return new l(+e);
        case "[object DataView]":
          return o(e, r);
        case "[object Float32Array]":
        case "[object Float64Array]":
        case "[object Int8Array]":
        case "[object Int16Array]":
        case "[object Int32Array]":
        case "[object Uint8Array]":
        case "[object Uint8ClampedArray]":
        case "[object Uint16Array]":
        case "[object Uint32Array]":
          return c(e, r);
        case "[object Map]":
          return new l();
        case "[object Number]":
        case "[object String]":
          return new l(e);
        case "[object RegExp]":
          return i(e);
        case "[object Set]":
          return new l();
        case "[object Symbol]":
          return a(e);
      }
    };
  }, function (e, t, r) {
    var n = r(13).Uint8Array;
    e.exports = n;
  }, function (e, t, r) {
    var n = r(49);
    e.exports = function (e, t) {
      var r = t ? n(e.buffer) : e.buffer;
      return new e.constructor(r, e.byteOffset, e.byteLength);
    };
  }, function (e, t) {
    var r = /\w*$/;
    e.exports = function (e) {
      var t = new e.constructor(e.source, r.exec(e));
      return t.lastIndex = e.lastIndex, t;
    };
  }, function (e, t, r) {
    var n = r(39),
      o = n ? n.prototype : void 0,
      i = o ? o.valueOf : void 0;
    e.exports = function (e) {
      return i ? Object(i.call(e)) : {};
    };
  }, function (e, t, r) {
    var n = r(49);
    e.exports = function (e, t) {
      var r = t ? n(e.buffer) : e.buffer;
      return new e.constructor(r, e.byteOffset, e.length);
    };
  }, function (e, t, r) {
    var n = r(173),
      o = r(70),
      i = r(45);
    e.exports = function (e) {
      return "function" != typeof e.constructor || i(e) ? {} : n(o(e));
    };
  }, function (e, t, r) {
    var n = r(22),
      o = Object.create,
      i = function () {
        function e() {}
        return function (t) {
          if (!n(t)) return {};
          if (o) return o(t);
          e.prototype = t;
          var r = new e();
          return e.prototype = void 0, r;
        };
      }();
    e.exports = i;
  }, function (e, t, r) {
    var n = r(175),
      o = r(43),
      i = r(44),
      a = i && i.isMap,
      c = a ? o(a) : n;
    e.exports = c;
  }, function (e, t, r) {
    var n = r(48),
      o = r(23);
    e.exports = function (e) {
      return o(e) && "[object Map]" == n(e);
    };
  }, function (e, t, r) {
    var n = r(177),
      o = r(43),
      i = r(44),
      a = i && i.isSet,
      c = a ? o(a) : n;
    e.exports = c;
  }, function (e, t, r) {
    var n = r(48),
      o = r(23);
    e.exports = function (e) {
      return o(e) && "[object Set]" == n(e);
    };
  }, function (e, t, r) {
    "use strict";

    /** @license React v16.14.0
     * react-dom-server.browser.production.min.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    var n = r(179),
      o = r(0);
    function i(e) {
      for (var t = "https://reactjs.org/docs/error-decoder.html?invariant=" + e, r = 1; r < arguments.length; r++) t += "&args[]=" + encodeURIComponent(arguments[r]);
      return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var a = "function" == typeof Symbol && Symbol.for,
      c = a ? Symbol.for("react.portal") : 60106,
      l = a ? Symbol.for("react.fragment") : 60107,
      u = a ? Symbol.for("react.strict_mode") : 60108,
      s = a ? Symbol.for("react.profiler") : 60114,
      p = a ? Symbol.for("react.provider") : 60109,
      f = a ? Symbol.for("react.context") : 60110,
      d = a ? Symbol.for("react.concurrent_mode") : 60111,
      y = a ? Symbol.for("react.forward_ref") : 60112,
      b = a ? Symbol.for("react.suspense") : 60113,
      h = a ? Symbol.for("react.suspense_list") : 60120,
      m = a ? Symbol.for("react.memo") : 60115,
      v = a ? Symbol.for("react.lazy") : 60116,
      g = a ? Symbol.for("react.block") : 60121,
      w = a ? Symbol.for("react.fundamental") : 60117,
      O = a ? Symbol.for("react.scope") : 60119;
    function _(e) {
      if (null == e) return null;
      if ("function" == typeof e) return e.displayName || e.name || null;
      if ("string" == typeof e) return e;
      switch (e) {
        case l:
          return "Fragment";
        case c:
          return "Portal";
        case s:
          return "Profiler";
        case u:
          return "StrictMode";
        case b:
          return "Suspense";
        case h:
          return "SuspenseList";
      }
      if ("object" == typeof e) switch (e.$$typeof) {
        case f:
          return "Context.Consumer";
        case p:
          return "Context.Provider";
        case y:
          var t = e.render;
          return t = t.displayName || t.name || "", e.displayName || ("" !== t ? "ForwardRef(" + t + ")" : "ForwardRef");
        case m:
          return _(e.type);
        case g:
          return _(e.render);
        case v:
          if (e = 1 === e._status ? e._result : null) return _(e);
      }
      return null;
    }
    var j = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    j.hasOwnProperty("ReactCurrentDispatcher") || (j.ReactCurrentDispatcher = {
      current: null
    }), j.hasOwnProperty("ReactCurrentBatchConfig") || (j.ReactCurrentBatchConfig = {
      suspense: null
    });
    var P = {};
    function E(e, t) {
      for (var r = 0 | e._threadCount; r <= t; r++) e[r] = e._currentValue2, e._threadCount = r + 1;
    }
    for (var k = new Uint16Array(16), x = 0; 15 > x; x++) k[x] = x + 1;
    k[15] = 0;
    var S = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
      C = Object.prototype.hasOwnProperty,
      R = {},
      N = {};
    function z(e) {
      return !!C.call(N, e) || !C.call(R, e) && (S.test(e) ? N[e] = !0 : (R[e] = !0, !1));
    }
    function D(e, t, r, n, o, i) {
      this.acceptsBooleans = 2 === t || 3 === t || 4 === t, this.attributeName = n, this.attributeNamespace = o, this.mustUseProperty = r, this.propertyName = e, this.type = t, this.sanitizeURL = i;
    }
    var T = {};
    "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (e) {
      T[e] = new D(e, 0, !1, e, null, !1);
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (e) {
      var t = e[0];
      T[t] = new D(t, 1, !1, e[1], null, !1);
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (e) {
      T[e] = new D(e, 2, !1, e.toLowerCase(), null, !1);
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function (e) {
      T[e] = new D(e, 2, !1, e, null, !1);
    }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (e) {
      T[e] = new D(e, 3, !1, e.toLowerCase(), null, !1);
    }), ["checked", "multiple", "muted", "selected"].forEach(function (e) {
      T[e] = new D(e, 3, !0, e, null, !1);
    }), ["capture", "download"].forEach(function (e) {
      T[e] = new D(e, 4, !1, e, null, !1);
    }), ["cols", "rows", "size", "span"].forEach(function (e) {
      T[e] = new D(e, 6, !1, e, null, !1);
    }), ["rowSpan", "start"].forEach(function (e) {
      T[e] = new D(e, 5, !1, e.toLowerCase(), null, !1);
    });
    var M = /[\-:]([a-z])/g;
    function F(e) {
      return e[1].toUpperCase();
    }
    "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (e) {
      var t = e.replace(M, F);
      T[t] = new D(t, 1, !1, e, null, !1);
    }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (e) {
      var t = e.replace(M, F);
      T[t] = new D(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1);
    }), ["xml:base", "xml:lang", "xml:space"].forEach(function (e) {
      var t = e.replace(M, F);
      T[t] = new D(t, 1, !1, e, "http://www.w3.org/XML/1998/namespace", !1);
    }), ["tabIndex", "crossOrigin"].forEach(function (e) {
      T[e] = new D(e, 1, !1, e.toLowerCase(), null, !1);
    }), T.xlinkHref = new D("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0), ["src", "href", "action", "formAction"].forEach(function (e) {
      T[e] = new D(e, 1, !1, e.toLowerCase(), null, !0);
    });
    var I = /["'&<>]/;
    function A(e) {
      if ("boolean" == typeof e || "number" == typeof e) return "" + e;
      e = "" + e;
      var t = I.exec(e);
      if (t) {
        var r,
          n = "",
          o = 0;
        for (r = t.index; r < e.length; r++) {
          switch (e.charCodeAt(r)) {
            case 34:
              t = "&quot;";
              break;
            case 38:
              t = "&amp;";
              break;
            case 39:
              t = "&#x27;";
              break;
            case 60:
              t = "&lt;";
              break;
            case 62:
              t = "&gt;";
              break;
            default:
              continue;
          }
          o !== r && (n += e.substring(o, r)), o = r + 1, n += t;
        }
        e = o !== r ? n + e.substring(o, r) : n;
      }
      return e;
    }
    function L(e, t) {
      var r,
        n = T.hasOwnProperty(e) ? T[e] : null;
      return (r = "style" !== e) && (r = null !== n ? 0 === n.type : 2 < e.length && ("o" === e[0] || "O" === e[0]) && ("n" === e[1] || "N" === e[1])), r || function (e, t, r, n) {
        if (null == t || function (e, t, r, n) {
          if (null !== r && 0 === r.type) return !1;
          switch (typeof t) {
            case "function":
            case "symbol":
              return !0;
            case "boolean":
              return !n && (null !== r ? !r.acceptsBooleans : "data-" !== (e = e.toLowerCase().slice(0, 5)) && "aria-" !== e);
            default:
              return !1;
          }
        }(e, t, r, n)) return !0;
        if (n) return !1;
        if (null !== r) switch (r.type) {
          case 3:
            return !t;
          case 4:
            return !1 === t;
          case 5:
            return isNaN(t);
          case 6:
            return isNaN(t) || 1 > t;
        }
        return !1;
      }(e, t, n, !1) ? "" : null !== n ? (e = n.attributeName, 3 === (r = n.type) || 4 === r && !0 === t ? e + '=""' : (n.sanitizeURL && (t = "" + t), e + '="' + A(t) + '"')) : z(e) ? e + '="' + A(t) + '"' : "";
    }
    var U = "function" == typeof Object.is ? Object.is : function (e, t) {
        return e === t && (0 !== e || 1 / e == 1 / t) || e != e && t != t;
      },
      V = null,
      B = null,
      q = null,
      W = !1,
      H = !1,
      G = null,
      J = 0;
    function $() {
      if (null === V) throw Error(i(321));
      return V;
    }
    function K() {
      if (0 < J) throw Error(i(312));
      return {
        memoizedState: null,
        queue: null,
        next: null
      };
    }
    function Z() {
      return null === q ? null === B ? (W = !1, B = q = K()) : (W = !0, q = B) : null === q.next ? (W = !1, q = q.next = K()) : (W = !0, q = q.next), q;
    }
    function Y(e, t, r, n) {
      for (; H;) H = !1, J += 1, q = null, r = e(t, n);
      return B = V = null, J = 0, q = G = null, r;
    }
    function Q(e, t) {
      return "function" == typeof t ? t(e) : t;
    }
    function X(e, t, r) {
      if (V = $(), q = Z(), W) {
        var n = q.queue;
        if (t = n.dispatch, null !== G && void 0 !== (r = G.get(n))) {
          G.delete(n), n = q.memoizedState;
          do {
            n = e(n, r.action), r = r.next;
          } while (null !== r);
          return q.memoizedState = n, [n, t];
        }
        return [q.memoizedState, t];
      }
      return e = e === Q ? "function" == typeof t ? t() : t : void 0 !== r ? r(t) : t, q.memoizedState = e, e = (e = q.queue = {
        last: null,
        dispatch: null
      }).dispatch = ee.bind(null, V, e), [q.memoizedState, e];
    }
    function ee(e, t, r) {
      if (!(25 > J)) throw Error(i(301));
      if (e === V) if (H = !0, e = {
        action: r,
        next: null
      }, null === G && (G = new Map()), void 0 === (r = G.get(t))) G.set(t, e);else {
        for (t = r; null !== t.next;) t = t.next;
        t.next = e;
      }
    }
    function te() {}
    var re = 0,
      ne = {
        readContext: function (e) {
          var t = re;
          return E(e, t), e[t];
        },
        useContext: function (e) {
          $();
          var t = re;
          return E(e, t), e[t];
        },
        useMemo: function (e, t) {
          if (V = $(), t = void 0 === t ? null : t, null !== (q = Z())) {
            var r = q.memoizedState;
            if (null !== r && null !== t) {
              e: {
                var n = r[1];
                if (null === n) n = !1;else {
                  for (var o = 0; o < n.length && o < t.length; o++) if (!U(t[o], n[o])) {
                    n = !1;
                    break e;
                  }
                  n = !0;
                }
              }
              if (n) return r[0];
            }
          }
          return e = e(), q.memoizedState = [e, t], e;
        },
        useReducer: X,
        useRef: function (e) {
          V = $();
          var t = (q = Z()).memoizedState;
          return null === t ? (e = {
            current: e
          }, q.memoizedState = e) : t;
        },
        useState: function (e) {
          return X(Q, e);
        },
        useLayoutEffect: function () {},
        useCallback: function (e) {
          return e;
        },
        useImperativeHandle: te,
        useEffect: te,
        useDebugValue: te,
        useResponder: function (e, t) {
          return {
            props: t,
            responder: e
          };
        },
        useDeferredValue: function (e) {
          return $(), e;
        },
        useTransition: function () {
          return $(), [function (e) {
            e();
          }, !1];
        }
      },
      oe = "http://www.w3.org/1999/xhtml";
    function ie(e) {
      switch (e) {
        case "svg":
          return "http://www.w3.org/2000/svg";
        case "math":
          return "http://www.w3.org/1998/Math/MathML";
        default:
          return "http://www.w3.org/1999/xhtml";
      }
    }
    var ae = {
        area: !0,
        base: !0,
        br: !0,
        col: !0,
        embed: !0,
        hr: !0,
        img: !0,
        input: !0,
        keygen: !0,
        link: !0,
        meta: !0,
        param: !0,
        source: !0,
        track: !0,
        wbr: !0
      },
      ce = n({
        menuitem: !0
      }, ae),
      le = {
        animationIterationCount: !0,
        borderImageOutset: !0,
        borderImageSlice: !0,
        borderImageWidth: !0,
        boxFlex: !0,
        boxFlexGroup: !0,
        boxOrdinalGroup: !0,
        columnCount: !0,
        columns: !0,
        flex: !0,
        flexGrow: !0,
        flexPositive: !0,
        flexShrink: !0,
        flexNegative: !0,
        flexOrder: !0,
        gridArea: !0,
        gridRow: !0,
        gridRowEnd: !0,
        gridRowSpan: !0,
        gridRowStart: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnSpan: !0,
        gridColumnStart: !0,
        fontWeight: !0,
        lineClamp: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        tabSize: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
        fillOpacity: !0,
        floodOpacity: !0,
        stopOpacity: !0,
        strokeDasharray: !0,
        strokeDashoffset: !0,
        strokeMiterlimit: !0,
        strokeOpacity: !0,
        strokeWidth: !0
      },
      ue = ["Webkit", "ms", "Moz", "O"];
    Object.keys(le).forEach(function (e) {
      ue.forEach(function (t) {
        t = t + e.charAt(0).toUpperCase() + e.substring(1), le[t] = le[e];
      });
    });
    var se = /([A-Z])/g,
      pe = /^ms-/,
      fe = o.Children.toArray,
      de = j.ReactCurrentDispatcher,
      ye = {
        listing: !0,
        pre: !0,
        textarea: !0
      },
      be = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,
      he = {},
      me = {};
    var ve = Object.prototype.hasOwnProperty,
      ge = {
        children: null,
        dangerouslySetInnerHTML: null,
        suppressContentEditableWarning: null,
        suppressHydrationWarning: null
      };
    function we(e, t) {
      if (void 0 === e) throw Error(i(152, _(t) || "Component"));
    }
    function Oe(e, t, r) {
      function a(o, a) {
        var c = a.prototype && a.prototype.isReactComponent,
          l = function (e, t, r, n) {
            if (n && "object" == typeof (n = e.contextType) && null !== n) return E(n, r), n[r];
            if (e = e.contextTypes) {
              for (var o in r = {}, e) r[o] = t[o];
              t = r;
            } else t = P;
            return t;
          }(a, t, r, c),
          u = [],
          s = !1,
          p = {
            isMounted: function () {
              return !1;
            },
            enqueueForceUpdate: function () {
              if (null === u) return null;
            },
            enqueueReplaceState: function (e, t) {
              s = !0, u = [t];
            },
            enqueueSetState: function (e, t) {
              if (null === u) return null;
              u.push(t);
            }
          };
        if (c) {
          if (c = new a(o.props, l, p), "function" == typeof a.getDerivedStateFromProps) {
            var f = a.getDerivedStateFromProps.call(null, o.props, c.state);
            null != f && (c.state = n({}, c.state, f));
          }
        } else if (V = {}, c = a(o.props, l, p), null == (c = Y(a, o.props, c, l)) || null == c.render) return void we(e = c, a);
        if (c.props = o.props, c.context = l, c.updater = p, void 0 === (p = c.state) && (c.state = p = null), "function" == typeof c.UNSAFE_componentWillMount || "function" == typeof c.componentWillMount) if ("function" == typeof c.componentWillMount && "function" != typeof a.getDerivedStateFromProps && c.componentWillMount(), "function" == typeof c.UNSAFE_componentWillMount && "function" != typeof a.getDerivedStateFromProps && c.UNSAFE_componentWillMount(), u.length) {
          p = u;
          var d = s;
          if (u = null, s = !1, d && 1 === p.length) c.state = p[0];else {
            f = d ? p[0] : c.state;
            var y = !0;
            for (d = d ? 1 : 0; d < p.length; d++) {
              var b = p[d];
              null != (b = "function" == typeof b ? b.call(c, f, o.props, l) : b) && (y ? (y = !1, f = n({}, f, b)) : n(f, b));
            }
            c.state = f;
          }
        } else u = null;
        if (we(e = c.render(), a), "function" == typeof c.getChildContext && "object" == typeof (o = a.childContextTypes)) {
          var h = c.getChildContext();
          for (var m in h) if (!(m in o)) throw Error(i(108, _(a) || "Unknown", m));
        }
        h && (t = n({}, t, h));
      }
      for (; o.isValidElement(e);) {
        var c = e,
          l = c.type;
        if ("function" != typeof l) break;
        a(c, l);
      }
      return {
        child: e,
        context: t
      };
    }
    var _e = function () {
        function e(e, t) {
          o.isValidElement(e) ? e.type !== l ? e = [e] : (e = e.props.children, e = o.isValidElement(e) ? [e] : fe(e)) : e = fe(e), e = {
            type: null,
            domNamespace: oe,
            children: e,
            childIndex: 0,
            context: P,
            footer: ""
          };
          var r = k[0];
          if (0 === r) {
            var n = k,
              a = 2 * (r = n.length);
            if (!(65536 >= a)) throw Error(i(304));
            var c = new Uint16Array(a);
            for (c.set(n), (k = c)[0] = r + 1, n = r; n < a - 1; n++) k[n] = n + 1;
            k[a - 1] = 0;
          } else k[0] = k[r];
          this.threadID = r, this.stack = [e], this.exhausted = !1, this.currentSelectValue = null, this.previousWasTextNode = !1, this.makeStaticMarkup = t, this.suspenseDepth = 0, this.contextIndex = -1, this.contextStack = [], this.contextValueStack = [];
        }
        var t = e.prototype;
        return t.destroy = function () {
          if (!this.exhausted) {
            this.exhausted = !0, this.clearProviders();
            var e = this.threadID;
            k[e] = k[0], k[0] = e;
          }
        }, t.pushProvider = function (e) {
          var t = ++this.contextIndex,
            r = e.type._context,
            n = this.threadID;
          E(r, n);
          var o = r[n];
          this.contextStack[t] = r, this.contextValueStack[t] = o, r[n] = e.props.value;
        }, t.popProvider = function () {
          var e = this.contextIndex,
            t = this.contextStack[e],
            r = this.contextValueStack[e];
          this.contextStack[e] = null, this.contextValueStack[e] = null, this.contextIndex--, t[this.threadID] = r;
        }, t.clearProviders = function () {
          for (var e = this.contextIndex; 0 <= e; e--) this.contextStack[e][this.threadID] = this.contextValueStack[e];
        }, t.read = function (e) {
          if (this.exhausted) return null;
          var t = re;
          re = this.threadID;
          var r = de.current;
          de.current = ne;
          try {
            for (var n = [""], o = !1; n[0].length < e;) {
              if (0 === this.stack.length) {
                this.exhausted = !0;
                var a = this.threadID;
                k[a] = k[0], k[0] = a;
                break;
              }
              var c = this.stack[this.stack.length - 1];
              if (o || c.childIndex >= c.children.length) {
                var l = c.footer;
                if ("" !== l && (this.previousWasTextNode = !1), this.stack.pop(), "select" === c.type) this.currentSelectValue = null;else if (null != c.type && null != c.type.type && c.type.type.$$typeof === p) this.popProvider(c.type);else if (c.type === b) {
                  this.suspenseDepth--;
                  var u = n.pop();
                  if (o) {
                    o = !1;
                    var s = c.fallbackFrame;
                    if (!s) throw Error(i(303));
                    this.stack.push(s), n[this.suspenseDepth] += "\x3c!--$!--\x3e";
                    continue;
                  }
                  n[this.suspenseDepth] += u;
                }
                n[this.suspenseDepth] += l;
              } else {
                var f = c.children[c.childIndex++],
                  d = "";
                try {
                  d += this.render(f, c.context, c.domNamespace);
                } catch (e) {
                  if (null != e && "function" == typeof e.then) throw Error(i(294));
                  throw e;
                }
                n.length <= this.suspenseDepth && n.push(""), n[this.suspenseDepth] += d;
              }
            }
            return n[0];
          } finally {
            de.current = r, re = t;
          }
        }, t.render = function (e, t, r) {
          if ("string" == typeof e || "number" == typeof e) return "" === (r = "" + e) ? "" : this.makeStaticMarkup ? A(r) : this.previousWasTextNode ? "\x3c!-- --\x3e" + A(r) : (this.previousWasTextNode = !0, A(r));
          if (e = (t = Oe(e, t, this.threadID)).child, t = t.context, null === e || !1 === e) return "";
          if (!o.isValidElement(e)) {
            if (null != e && null != e.$$typeof) {
              if ((r = e.$$typeof) === c) throw Error(i(257));
              throw Error(i(258, r.toString()));
            }
            return e = fe(e), this.stack.push({
              type: null,
              domNamespace: r,
              children: e,
              childIndex: 0,
              context: t,
              footer: ""
            }), "";
          }
          var a = e.type;
          if ("string" == typeof a) return this.renderDOM(e, t, r);
          switch (a) {
            case u:
            case d:
            case s:
            case h:
            case l:
              return e = fe(e.props.children), this.stack.push({
                type: null,
                domNamespace: r,
                children: e,
                childIndex: 0,
                context: t,
                footer: ""
              }), "";
            case b:
              throw Error(i(294));
          }
          if ("object" == typeof a && null !== a) switch (a.$$typeof) {
            case y:
              V = {};
              var g = a.render(e.props, e.ref);
              return g = Y(a.render, e.props, g, e.ref), g = fe(g), this.stack.push({
                type: null,
                domNamespace: r,
                children: g,
                childIndex: 0,
                context: t,
                footer: ""
              }), "";
            case m:
              return e = [o.createElement(a.type, n({
                ref: e.ref
              }, e.props))], this.stack.push({
                type: null,
                domNamespace: r,
                children: e,
                childIndex: 0,
                context: t,
                footer: ""
              }), "";
            case p:
              return r = {
                type: e,
                domNamespace: r,
                children: a = fe(e.props.children),
                childIndex: 0,
                context: t,
                footer: ""
              }, this.pushProvider(e), this.stack.push(r), "";
            case f:
              a = e.type, g = e.props;
              var _ = this.threadID;
              return E(a, _), a = fe(g.children(a[_])), this.stack.push({
                type: e,
                domNamespace: r,
                children: a,
                childIndex: 0,
                context: t,
                footer: ""
              }), "";
            case w:
              throw Error(i(338));
            case v:
              switch (function (e) {
                if (-1 === e._status) {
                  e._status = 0;
                  var t = e._ctor;
                  t = t(), e._result = t, t.then(function (t) {
                    0 === e._status && (t = t.default, e._status = 1, e._result = t);
                  }, function (t) {
                    0 === e._status && (e._status = 2, e._result = t);
                  });
                }
              }(a = e.type), a._status) {
                case 1:
                  return e = [o.createElement(a._result, n({
                    ref: e.ref
                  }, e.props))], this.stack.push({
                    type: null,
                    domNamespace: r,
                    children: e,
                    childIndex: 0,
                    context: t,
                    footer: ""
                  }), "";
                case 2:
                  throw a._result;
                default:
                  throw Error(i(295));
              }
            case O:
              throw Error(i(343));
          }
          throw Error(i(130, null == a ? a : typeof a, ""));
        }, t.renderDOM = function (e, t, r) {
          var a = e.type.toLowerCase();
          if (r === oe && ie(a), !he.hasOwnProperty(a)) {
            if (!be.test(a)) throw Error(i(65, a));
            he[a] = !0;
          }
          var c = e.props;
          if ("input" === a) c = n({
            type: void 0
          }, c, {
            defaultChecked: void 0,
            defaultValue: void 0,
            value: null != c.value ? c.value : c.defaultValue,
            checked: null != c.checked ? c.checked : c.defaultChecked
          });else if ("textarea" === a) {
            var l = c.value;
            if (null == l) {
              l = c.defaultValue;
              var u = c.children;
              if (null != u) {
                if (null != l) throw Error(i(92));
                if (Array.isArray(u)) {
                  if (!(1 >= u.length)) throw Error(i(93));
                  u = u[0];
                }
                l = "" + u;
              }
              null == l && (l = "");
            }
            c = n({}, c, {
              value: void 0,
              children: "" + l
            });
          } else if ("select" === a) this.currentSelectValue = null != c.value ? c.value : c.defaultValue, c = n({}, c, {
            value: void 0
          });else if ("option" === a) {
            u = this.currentSelectValue;
            var s = function (e) {
              if (null == e) return e;
              var t = "";
              return o.Children.forEach(e, function (e) {
                null != e && (t += e);
              }), t;
            }(c.children);
            if (null != u) {
              var p = null != c.value ? c.value + "" : s;
              if (l = !1, Array.isArray(u)) {
                for (var f = 0; f < u.length; f++) if ("" + u[f] === p) {
                  l = !0;
                  break;
                }
              } else l = "" + u === p;
              c = n({
                selected: void 0,
                children: void 0
              }, c, {
                selected: l,
                children: s
              });
            }
          }
          if (l = c) {
            if (ce[a] && (null != l.children || null != l.dangerouslySetInnerHTML)) throw Error(i(137, a, ""));
            if (null != l.dangerouslySetInnerHTML) {
              if (null != l.children) throw Error(i(60));
              if ("object" != typeof l.dangerouslySetInnerHTML || !("__html" in l.dangerouslySetInnerHTML)) throw Error(i(61));
            }
            if (null != l.style && "object" != typeof l.style) throw Error(i(62, ""));
          }
          for (w in l = c, u = this.makeStaticMarkup, s = 1 === this.stack.length, p = "<" + e.type, l) if (ve.call(l, w)) {
            var d = l[w];
            if (null != d) {
              if ("style" === w) {
                f = void 0;
                var y = "",
                  b = "";
                for (f in d) if (d.hasOwnProperty(f)) {
                  var h = 0 === f.indexOf("--"),
                    m = d[f];
                  if (null != m) {
                    if (h) var v = f;else if (v = f, me.hasOwnProperty(v)) v = me[v];else {
                      var g = v.replace(se, "-$1").toLowerCase().replace(pe, "-ms-");
                      v = me[v] = g;
                    }
                    y += b + v + ":", b = f, y += h = null == m || "boolean" == typeof m || "" === m ? "" : h || "number" != typeof m || 0 === m || le.hasOwnProperty(b) && le[b] ? ("" + m).trim() : m + "px", b = ";";
                  }
                }
                d = y || null;
              }
              f = null;
              e: if (h = a, m = l, -1 === h.indexOf("-")) h = "string" == typeof m.is;else switch (h) {
                case "annotation-xml":
                case "color-profile":
                case "font-face":
                case "font-face-src":
                case "font-face-uri":
                case "font-face-format":
                case "font-face-name":
                case "missing-glyph":
                  h = !1;
                  break e;
                default:
                  h = !0;
              }
              h ? ge.hasOwnProperty(w) || (f = z(f = w) && null != d ? f + '="' + A(d) + '"' : "") : f = L(w, d), f && (p += " " + f);
            }
          }
          u || s && (p += ' data-reactroot=""');
          var w = p;
          l = "", ae.hasOwnProperty(a) ? w += "/>" : (w += ">", l = "</" + e.type + ">");
          e: {
            if (null != (u = c.dangerouslySetInnerHTML)) {
              if (null != u.__html) {
                u = u.__html;
                break e;
              }
            } else if ("string" == typeof (u = c.children) || "number" == typeof u) {
              u = A(u);
              break e;
            }
            u = null;
          }
          return null != u ? (c = [], ye.hasOwnProperty(a) && "\n" === u.charAt(0) && (w += "\n"), w += u) : c = fe(c.children), e = e.type, r = null == r || "http://www.w3.org/1999/xhtml" === r ? ie(e) : "http://www.w3.org/2000/svg" === r && "foreignObject" === e ? "http://www.w3.org/1999/xhtml" : r, this.stack.push({
            domNamespace: r,
            type: a,
            children: c,
            childIndex: 0,
            context: t,
            footer: l
          }), this.previousWasTextNode = !1, w;
        }, e;
      }(),
      je = {
        renderToString: function (e) {
          e = new _e(e, !1);
          try {
            return e.read(1 / 0);
          } finally {
            e.destroy();
          }
        },
        renderToStaticMarkup: function (e) {
          e = new _e(e, !0);
          try {
            return e.read(1 / 0);
          } finally {
            e.destroy();
          }
        },
        renderToNodeStream: function () {
          throw Error(i(207));
        },
        renderToStaticNodeStream: function () {
          throw Error(i(208));
        },
        version: "16.14.0"
      };
    e.exports = je.default || je;
  }, function (e, t, r) {
    "use strict";

    /*
    object-assign
    (c) Sindre Sorhus
    @license MIT
    */
    var n = Object.getOwnPropertySymbols,
      o = Object.prototype.hasOwnProperty,
      i = Object.prototype.propertyIsEnumerable;
    function a(e) {
      if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(e);
    }
    e.exports = function () {
      try {
        if (!Object.assign) return !1;
        var e = new String("abc");
        if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
        for (var t = {}, r = 0; r < 10; r++) t["_" + String.fromCharCode(r)] = r;
        if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
          return t[e];
        }).join("")) return !1;
        var n = {};
        return "abcdefghijklmnopqrst".split("").forEach(function (e) {
          n[e] = e;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, n)).join("");
      } catch (e) {
        return !1;
      }
    }() ? Object.assign : function (e, t) {
      for (var r, c, l = a(e), u = 1; u < arguments.length; u++) {
        for (var s in r = Object(arguments[u])) o.call(r, s) && (l[s] = r[s]);
        if (n) {
          c = n(r);
          for (var p = 0; p < c.length; p++) i.call(r, c[p]) && (l[c[p]] = r[c[p]]);
        }
      }
      return l;
    };
  }, function (e, t, r) {
    var n = function (e) {
      "use strict";

      var t = Object.prototype,
        r = t.hasOwnProperty,
        n = Object.defineProperty || function (e, t, r) {
          e[t] = r.value;
        },
        o = "function" == typeof Symbol ? Symbol : {},
        i = o.iterator || "@@iterator",
        a = o.asyncIterator || "@@asyncIterator",
        c = o.toStringTag || "@@toStringTag";
      function l(e, t, r) {
        return Object.defineProperty(e, t, {
          value: r,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), e[t];
      }
      try {
        l({}, "");
      } catch (e) {
        l = function (e, t, r) {
          return e[t] = r;
        };
      }
      function u(e, t, r, o) {
        var i = t && t.prototype instanceof f ? t : f,
          a = Object.create(i.prototype),
          c = new E(o || []);
        return n(a, "_invoke", {
          value: O(e, r, c)
        }), a;
      }
      function s(e, t, r) {
        try {
          return {
            type: "normal",
            arg: e.call(t, r)
          };
        } catch (e) {
          return {
            type: "throw",
            arg: e
          };
        }
      }
      e.wrap = u;
      var p = {};
      function f() {}
      function d() {}
      function y() {}
      var b = {};
      l(b, i, function () {
        return this;
      });
      var h = Object.getPrototypeOf,
        m = h && h(h(k([])));
      m && m !== t && r.call(m, i) && (b = m);
      var v = y.prototype = f.prototype = Object.create(b);
      function g(e) {
        ["next", "throw", "return"].forEach(function (t) {
          l(e, t, function (e) {
            return this._invoke(t, e);
          });
        });
      }
      function w(e, t) {
        var o;
        n(this, "_invoke", {
          value: function (n, i) {
            function a() {
              return new t(function (o, a) {
                !function n(o, i, a, c) {
                  var l = s(e[o], e, i);
                  if ("throw" !== l.type) {
                    var u = l.arg,
                      p = u.value;
                    return p && "object" == typeof p && r.call(p, "__await") ? t.resolve(p.__await).then(function (e) {
                      n("next", e, a, c);
                    }, function (e) {
                      n("throw", e, a, c);
                    }) : t.resolve(p).then(function (e) {
                      u.value = e, a(u);
                    }, function (e) {
                      return n("throw", e, a, c);
                    });
                  }
                  c(l.arg);
                }(n, i, o, a);
              });
            }
            return o = o ? o.then(a, a) : a();
          }
        });
      }
      function O(e, t, r) {
        var n = "suspendedStart";
        return function (o, i) {
          if ("executing" === n) throw new Error("Generator is already running");
          if ("completed" === n) {
            if ("throw" === o) throw i;
            return x();
          }
          for (r.method = o, r.arg = i;;) {
            var a = r.delegate;
            if (a) {
              var c = _(a, r);
              if (c) {
                if (c === p) continue;
                return c;
              }
            }
            if ("next" === r.method) r.sent = r._sent = r.arg;else if ("throw" === r.method) {
              if ("suspendedStart" === n) throw n = "completed", r.arg;
              r.dispatchException(r.arg);
            } else "return" === r.method && r.abrupt("return", r.arg);
            n = "executing";
            var l = s(e, t, r);
            if ("normal" === l.type) {
              if (n = r.done ? "completed" : "suspendedYield", l.arg === p) continue;
              return {
                value: l.arg,
                done: r.done
              };
            }
            "throw" === l.type && (n = "completed", r.method = "throw", r.arg = l.arg);
          }
        };
      }
      function _(e, t) {
        var r = t.method,
          n = e.iterator[r];
        if (void 0 === n) return t.delegate = null, "throw" === r && e.iterator.return && (t.method = "return", t.arg = void 0, _(e, t), "throw" === t.method) || "return" !== r && (t.method = "throw", t.arg = new TypeError("The iterator does not provide a '" + r + "' method")), p;
        var o = s(n, e.iterator, t.arg);
        if ("throw" === o.type) return t.method = "throw", t.arg = o.arg, t.delegate = null, p;
        var i = o.arg;
        return i ? i.done ? (t[e.resultName] = i.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, p) : i : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, p);
      }
      function j(e) {
        var t = {
          tryLoc: e[0]
        };
        1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
      }
      function P(e) {
        var t = e.completion || {};
        t.type = "normal", delete t.arg, e.completion = t;
      }
      function E(e) {
        this.tryEntries = [{
          tryLoc: "root"
        }], e.forEach(j, this), this.reset(!0);
      }
      function k(e) {
        if (e) {
          var t = e[i];
          if (t) return t.call(e);
          if ("function" == typeof e.next) return e;
          if (!isNaN(e.length)) {
            var n = -1,
              o = function t() {
                for (; ++n < e.length;) if (r.call(e, n)) return t.value = e[n], t.done = !1, t;
                return t.value = void 0, t.done = !0, t;
              };
            return o.next = o;
          }
        }
        return {
          next: x
        };
      }
      function x() {
        return {
          value: void 0,
          done: !0
        };
      }
      return d.prototype = y, n(v, "constructor", {
        value: y,
        configurable: !0
      }), n(y, "constructor", {
        value: d,
        configurable: !0
      }), d.displayName = l(y, c, "GeneratorFunction"), e.isGeneratorFunction = function (e) {
        var t = "function" == typeof e && e.constructor;
        return !!t && (t === d || "GeneratorFunction" === (t.displayName || t.name));
      }, e.mark = function (e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, y) : (e.__proto__ = y, l(e, c, "GeneratorFunction")), e.prototype = Object.create(v), e;
      }, e.awrap = function (e) {
        return {
          __await: e
        };
      }, g(w.prototype), l(w.prototype, a, function () {
        return this;
      }), e.AsyncIterator = w, e.async = function (t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new w(u(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function (e) {
          return e.done ? e.value : a.next();
        });
      }, g(v), l(v, c, "Generator"), l(v, i, function () {
        return this;
      }), l(v, "toString", function () {
        return "[object Generator]";
      }), e.keys = function (e) {
        var t = Object(e),
          r = [];
        for (var n in t) r.push(n);
        return r.reverse(), function e() {
          for (; r.length;) {
            var n = r.pop();
            if (n in t) return e.value = n, e.done = !1, e;
          }
          return e.done = !0, e;
        };
      }, e.values = k, E.prototype = {
        constructor: E,
        reset: function (e) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(P), !e) for (var t in this) "t" === t.charAt(0) && r.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
        },
        stop: function () {
          this.done = !0;
          var e = this.tryEntries[0].completion;
          if ("throw" === e.type) throw e.arg;
          return this.rval;
        },
        dispatchException: function (e) {
          if (this.done) throw e;
          var t = this;
          function n(r, n) {
            return a.type = "throw", a.arg = e, t.next = r, n && (t.method = "next", t.arg = void 0), !!n;
          }
          for (var o = this.tryEntries.length - 1; o >= 0; --o) {
            var i = this.tryEntries[o],
              a = i.completion;
            if ("root" === i.tryLoc) return n("end");
            if (i.tryLoc <= this.prev) {
              var c = r.call(i, "catchLoc"),
                l = r.call(i, "finallyLoc");
              if (c && l) {
                if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
                if (this.prev < i.finallyLoc) return n(i.finallyLoc);
              } else if (c) {
                if (this.prev < i.catchLoc) return n(i.catchLoc, !0);
              } else {
                if (!l) throw new Error("try statement without catch or finally");
                if (this.prev < i.finallyLoc) return n(i.finallyLoc);
              }
            }
          }
        },
        abrupt: function (e, t) {
          for (var n = this.tryEntries.length - 1; n >= 0; --n) {
            var o = this.tryEntries[n];
            if (o.tryLoc <= this.prev && r.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }
          i && ("break" === e || "continue" === e) && i.tryLoc <= t && t <= i.finallyLoc && (i = null);
          var a = i ? i.completion : {};
          return a.type = e, a.arg = t, i ? (this.method = "next", this.next = i.finallyLoc, p) : this.complete(a);
        },
        complete: function (e, t) {
          if ("throw" === e.type) throw e.arg;
          return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), p;
        },
        finish: function (e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];
            if (r.finallyLoc === e) return this.complete(r.completion, r.afterLoc), P(r), p;
          }
        },
        catch: function (e) {
          for (var t = this.tryEntries.length - 1; t >= 0; --t) {
            var r = this.tryEntries[t];
            if (r.tryLoc === e) {
              var n = r.completion;
              if ("throw" === n.type) {
                var o = n.arg;
                P(r);
              }
              return o;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function (e, t, r) {
          return this.delegate = {
            iterator: k(e),
            resultName: t,
            nextLoc: r
          }, "next" === this.method && (this.arg = void 0), p;
        }
      }, e;
    }(e.exports);
    try {
      regeneratorRuntime = n;
    } catch (e) {
      "object" == typeof globalThis ? globalThis.regeneratorRuntime = n : Function("r", "regeneratorRuntime = r")(n);
    }
  }, function (e, t, r) {
    "use strict";

    r.r(t), r.d(t, "FieldsApi", function () {
      return Rw;
    }), r.d(t, "FieldMapViewer", function () {
      return tO;
    }), r.d(t, "FieldSelectList", function () {
      return X_;
    }), r.d(t, "FieldSelectControls", function () {
      return lj;
    }), r.d(t, "FieldSelectionSummary", function () {
      return pP;
    }), r.d(t, "FieldSummaryLine", function () {
      return vj;
    }), r.d(t, "ItemSummaryLine", function () {
      return tP;
    }), r.d(t, "Field", function () {
      return Jv;
    }), r.d(t, "FieldSelectModel", function () {
      return Ag;
    }), r.d(t, "validateField", function () {
      return rw;
    }), r.d(t, "sanitizeField", function () {
      return nw;
    }), r.d(t, "validateFieldImport", function () {
      return ow;
    }), r.d(t, "IF2FieldsSchemaValidator", function () {
      return tw;
    }), r.d(t, "IF2Fields", function () {
      return n;
    }), r.d(t, "i18n", function () {
      return Re;
    });
    var n = {};
    r.r(n), r.d(n, "CropSelector", function () {
      return Ur;
    }), r.d(n, "CoolingTypeMultiSelect", function () {
      return qo;
    }), r.d(n, "IrrigationMonitoringTypeMultiSelect", function () {
      return hi;
    }), r.d(n, "SoilClassificationMultiSelect", function () {
      return Ui;
    }), r.d(n, "NestedAttributesMultiSelect", function () {
      return oa;
    }), r.d(n, "OrganicSelector", function () {
      return ya;
    }), r.d(n, "NewFieldButton", function () {
      return dd;
    }), r.d(n, "RailsFieldVisualEditor", function () {
      return sw;
    }), r.d(n, "RailsFieldMapViewer", function () {
      return OP;
    }), r.d(n, "RailsUnitSelector", function () {
      return MP;
    }), r.d(n, "GraftCreator", function () {
      return Or;
    }), r.d(n, "CopyToClipboard", function () {
      return ZP;
    }), r.d(n, "FieldPath", function () {
      return iE;
    }), r.d(n, "ExportFieldsButton", function () {
      return hE;
    });
    var o = r(0),
      i = r.n(o),
      a = r(1),
      c = r(2),
      l = r(76),
      u = r.n(l),
      s = r(77),
      p = r.n(s),
      f = r(18),
      d = r.n(f);
    function y(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function b(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? y(Object(r), !0).forEach(function (t) {
          d()(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : y(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    var h,
      m = {
        bindI18n: "languageChanged",
        bindI18nStore: "",
        transEmptyNodeValue: "",
        transSupportBasicHtmlNodes: !0,
        transWrapTextNodes: "",
        transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
        useSuspense: !0
      },
      v = i.a.createContext();
    function g() {
      return m;
    }
    var w = function () {
      function e() {
        u()(this, e), this.usedNamespaces = {};
      }
      return p()(e, [{
        key: "addUsedNamespaces",
        value: function (e) {
          var t = this;
          e.forEach(function (e) {
            t.usedNamespaces[e] || (t.usedNamespaces[e] = !0);
          });
        }
      }, {
        key: "getUsedNamespaces",
        value: function () {
          return Object.keys(this.usedNamespaces);
        }
      }]), e;
    }();
    function O() {
      return h;
    }
    var _ = {
      type: "3rdParty",
      init: function (e) {
        !function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          m = b(b({}, m), e);
        }(e.options.react), function (e) {
          h = e;
        }(e);
      }
    };
    function j(e) {
      var t = e.i18n,
        r = e.defaultNS,
        n = e.children,
        i = Object(o.useMemo)(function () {
          return {
            i18n: t,
            defaultNS: r
          };
        }, [t, r]);
      return Object(o.createElement)(v.Provider, {
        value: i
      }, n);
    }
    var P = r(34),
      E = r.n(P),
      k = r(79),
      x = r.n(k);
    function S() {
      if (console && console.warn) {
        for (var e, t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];
        "string" == typeof r[0] && (r[0] = "react-i18next:: ".concat(r[0])), (e = console).warn.apply(e, r);
      }
    }
    var C = {};
    function R() {
      for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
      "string" == typeof t[0] && C[t[0]] || ("string" == typeof t[0] && (C[t[0]] = new Date()), S.apply(void 0, t));
    }
    function N(e, t, r) {
      e.loadNamespaces(t, function () {
        if (e.isInitialized) r();else {
          e.on("initialized", function t() {
            setTimeout(function () {
              e.off("initialized", t);
            }, 0), r();
          });
        }
      });
    }
    function z(e, t) {
      var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
      if (!t.languages || !t.languages.length) return R("i18n.languages were undefined or empty", t.languages), !0;
      var n = t.languages[0],
        o = !!t.options && t.options.fallbackLng,
        i = t.languages[t.languages.length - 1];
      if ("cimode" === n.toLowerCase()) return !0;
      var a = function (e, r) {
        var n = t.services.backendConnector.state["".concat(e, "|").concat(r)];
        return -1 === n || 2 === n;
      };
      return !(r.bindI18n && r.bindI18n.indexOf("languageChanging") > -1 && t.services.backendConnector.backend && t.isLanguageChangingTo && !a(t.isLanguageChangingTo, e)) && (!!t.hasResourceBundle(n, e) || !t.services.backendConnector.backend || !(!a(n, e) || o && !a(i, e)));
    }
    function D(e) {
      return e.displayName || e.name || ("string" == typeof e && e.length > 0 ? e : "Unknown");
    }
    function T(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function M(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? T(Object(r), !0).forEach(function (t) {
          d()(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : T(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function F(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = t.i18n,
        n = Object(o.useContext)(v) || {},
        i = n.i18n,
        a = n.defaultNS,
        c = r || i || O();
      if (c && !c.reportNamespaces && (c.reportNamespaces = new w()), !c) {
        R("You will need to pass in an i18next instance by using initReactI18next");
        var l = function (e) {
            return Array.isArray(e) ? e[e.length - 1] : e;
          },
          u = [l, {}, !1];
        return u.t = l, u.i18n = {}, u.ready = !1, u;
      }
      c.options.react && void 0 !== c.options.react.wait && R("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
      var s = M(M(M({}, g()), c.options.react), t),
        p = s.useSuspense,
        f = s.keyPrefix,
        d = e || a || c.options && c.options.defaultNS;
      d = "string" == typeof d ? [d] : d || ["translation"], c.reportNamespaces.addUsedNamespaces && c.reportNamespaces.addUsedNamespaces(d);
      var y = (c.isInitialized || c.initializedStoreOnce) && d.every(function (e) {
        return z(e, c, s);
      });
      function b() {
        return c.getFixedT(null, "fallback" === s.nsMode ? d : d[0], f);
      }
      var h = Object(o.useState)(b),
        m = E()(h, 2),
        _ = m[0],
        j = m[1],
        P = Object(o.useRef)(!0);
      Object(o.useEffect)(function () {
        var e = s.bindI18n,
          t = s.bindI18nStore;
        function r() {
          P.current && j(b);
        }
        return P.current = !0, y || p || N(c, d, function () {
          P.current && j(b);
        }), e && c && c.on(e, r), t && c && c.store.on(t, r), function () {
          P.current = !1, e && c && e.split(" ").forEach(function (e) {
            return c.off(e, r);
          }), t && c && t.split(" ").forEach(function (e) {
            return c.store.off(e, r);
          });
        };
      }, [c, d.join()]);
      var k = Object(o.useRef)(!0);
      Object(o.useEffect)(function () {
        P.current && !k.current && j(b), k.current = !1;
      }, [c]);
      var x = [_, c, y];
      if (x.t = _, x.i18n = c, x.ready = y, y) return x;
      if (!y && !p) return x;
      throw new Promise(function (e) {
        N(c, d, function () {
          e();
        });
      });
    }
    var I = ["forwardedRef"];
    function A(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function L(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? A(Object(r), !0).forEach(function (t) {
          d()(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : A(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function U(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
      return function (r) {
        function n(n) {
          var o = n.forwardedRef,
            a = x()(n, I),
            c = F(e, a),
            l = E()(c, 3),
            u = l[0],
            s = l[1],
            p = l[2],
            f = L(L({}, a), {}, {
              t: u,
              i18n: s,
              tReady: p
            });
          return t.withRef && o ? f.ref = o : !t.withRef && o && (f.forwardedRef = o), i.a.createElement(r, f);
        }
        n.displayName = "withI18nextTranslation(".concat(D(r), ")"), n.WrappedComponent = r;
        return t.withRef ? i.a.forwardRef(function (e, t) {
          return i.a.createElement(n, Object.assign({}, e, {
            forwardedRef: t
          }));
        }) : n;
      };
    }
    function V(e) {
      return (V = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      })(e);
    }
    function B(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function q(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? Object(arguments[t]) : {},
          n = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && n.push.apply(n, Object.getOwnPropertySymbols(r).filter(function (e) {
          return Object.getOwnPropertyDescriptor(r, e).enumerable;
        })), n.forEach(function (t) {
          B(e, t, r[t]);
        });
      }
      return e;
    }
    function W(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function H(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function G(e, t, r) {
      return t && H(e.prototype, t), r && H(e, r), e;
    }
    var J = r(72),
      $ = r.n(J);
    function K(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function Z(e, t) {
      if (t && ("object" === $()(t) || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return K(e);
    }
    function Y(e) {
      return (Y = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function Q(e, t) {
      return (Q = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function X(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && Q(e, t);
    }
    var ee = {
        type: "logger",
        log: function (e) {
          this.output("log", e);
        },
        warn: function (e) {
          this.output("warn", e);
        },
        error: function (e) {
          this.output("error", e);
        },
        output: function (e, t) {
          console && console[e] && console[e].apply(console, t);
        }
      },
      te = new (function () {
        function e(t) {
          var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          W(this, e), this.init(t, r);
        }
        return G(e, [{
          key: "init",
          value: function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            this.prefix = t.prefix || "i18next:", this.logger = e || ee, this.options = t, this.debug = t.debug;
          }
        }, {
          key: "setDebug",
          value: function (e) {
            this.debug = e;
          }
        }, {
          key: "log",
          value: function () {
            for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
            return this.forward(t, "log", "", !0);
          }
        }, {
          key: "warn",
          value: function () {
            for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
            return this.forward(t, "warn", "", !0);
          }
        }, {
          key: "error",
          value: function () {
            for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
            return this.forward(t, "error", "");
          }
        }, {
          key: "deprecate",
          value: function () {
            for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
            return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
          }
        }, {
          key: "forward",
          value: function (e, t, r, n) {
            return n && !this.debug ? null : ("string" == typeof e[0] && (e[0] = "".concat(r).concat(this.prefix, " ").concat(e[0])), this.logger[t](e));
          }
        }, {
          key: "create",
          value: function (t) {
            return new e(this.logger, q({}, {
              prefix: "".concat(this.prefix, ":").concat(t, ":")
            }, this.options));
          }
        }]), e;
      }())(),
      re = function () {
        function e() {
          W(this, e), this.observers = {};
        }
        return G(e, [{
          key: "on",
          value: function (e, t) {
            var r = this;
            return e.split(" ").forEach(function (e) {
              r.observers[e] = r.observers[e] || [], r.observers[e].push(t);
            }), this;
          }
        }, {
          key: "off",
          value: function (e, t) {
            this.observers[e] && (t ? this.observers[e] = this.observers[e].filter(function (e) {
              return e !== t;
            }) : delete this.observers[e]);
          }
        }, {
          key: "emit",
          value: function (e) {
            for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) r[n - 1] = arguments[n];
            if (this.observers[e]) {
              var o = [].concat(this.observers[e]);
              o.forEach(function (e) {
                e.apply(void 0, r);
              });
            }
            if (this.observers["*"]) {
              var i = [].concat(this.observers["*"]);
              i.forEach(function (t) {
                t.apply(t, [e].concat(r));
              });
            }
          }
        }]), e;
      }();
    function ne() {
      var e,
        t,
        r = new Promise(function (r, n) {
          e = r, t = n;
        });
      return r.resolve = e, r.reject = t, r;
    }
    function oe(e) {
      return null == e ? "" : "" + e;
    }
    function ie(e, t, r) {
      e.forEach(function (e) {
        t[e] && (r[e] = t[e]);
      });
    }
    function ae(e, t, r) {
      function n(e) {
        return e && e.indexOf("###") > -1 ? e.replace(/###/g, ".") : e;
      }
      function o() {
        return !e || "string" == typeof e;
      }
      for (var i = "string" != typeof t ? [].concat(t) : t.split("."); i.length > 1;) {
        if (o()) return {};
        var a = n(i.shift());
        !e[a] && r && (e[a] = new r()), e = Object.prototype.hasOwnProperty.call(e, a) ? e[a] : {};
      }
      return o() ? {} : {
        obj: e,
        k: n(i.shift())
      };
    }
    function ce(e, t, r) {
      var n = ae(e, t, Object);
      n.obj[n.k] = r;
    }
    function le(e, t) {
      var r = ae(e, t),
        n = r.obj,
        o = r.k;
      if (n) return n[o];
    }
    function ue(e, t, r) {
      var n = le(e, r);
      return void 0 !== n ? n : le(t, r);
    }
    function se(e, t, r) {
      for (var n in t) "__proto__" !== n && "constructor" !== n && (n in e ? "string" == typeof e[n] || e[n] instanceof String || "string" == typeof t[n] || t[n] instanceof String ? r && (e[n] = t[n]) : se(e[n], t[n], r) : e[n] = t[n]);
      return e;
    }
    function pe(e) {
      return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    }
    var fe = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "/": "&#x2F;"
    };
    function de(e) {
      return "string" == typeof e ? e.replace(/[&<>"'\/]/g, function (e) {
        return fe[e];
      }) : e;
    }
    var ye = "undefined" != typeof window && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1,
      be = function (e) {
        function t(e) {
          var r,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
              ns: ["translation"],
              defaultNS: "translation"
            };
          return W(this, t), r = Z(this, Y(t).call(this)), ye && re.call(K(r)), r.data = e || {}, r.options = n, void 0 === r.options.keySeparator && (r.options.keySeparator = "."), r;
        }
        return X(t, e), G(t, [{
          key: "addNamespaces",
          value: function (e) {
            this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
          }
        }, {
          key: "removeNamespaces",
          value: function (e) {
            var t = this.options.ns.indexOf(e);
            t > -1 && this.options.ns.splice(t, 1);
          }
        }, {
          key: "getResource",
          value: function (e, t, r) {
            var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
              o = void 0 !== n.keySeparator ? n.keySeparator : this.options.keySeparator,
              i = [e, t];
            return r && "string" != typeof r && (i = i.concat(r)), r && "string" == typeof r && (i = i.concat(o ? r.split(o) : r)), e.indexOf(".") > -1 && (i = e.split(".")), le(this.data, i);
          }
        }, {
          key: "addResource",
          value: function (e, t, r, n) {
            var o = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {
                silent: !1
              },
              i = this.options.keySeparator;
            void 0 === i && (i = ".");
            var a = [e, t];
            r && (a = a.concat(i ? r.split(i) : r)), e.indexOf(".") > -1 && (n = t, t = (a = e.split("."))[1]), this.addNamespaces(t), ce(this.data, a, n), o.silent || this.emit("added", e, t, r, n);
          }
        }, {
          key: "addResources",
          value: function (e, t, r) {
            var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
              silent: !1
            };
            for (var o in r) "string" != typeof r[o] && "[object Array]" !== Object.prototype.toString.apply(r[o]) || this.addResource(e, t, o, r[o], {
              silent: !0
            });
            n.silent || this.emit("added", e, t, r);
          }
        }, {
          key: "addResourceBundle",
          value: function (e, t, r, n, o) {
            var i = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {
                silent: !1
              },
              a = [e, t];
            e.indexOf(".") > -1 && (n = r, r = t, t = (a = e.split("."))[1]), this.addNamespaces(t);
            var c = le(this.data, a) || {};
            n ? se(c, r, o) : c = q({}, c, r), ce(this.data, a, c), i.silent || this.emit("added", e, t, r);
          }
        }, {
          key: "removeResourceBundle",
          value: function (e, t) {
            this.hasResourceBundle(e, t) && delete this.data[e][t], this.removeNamespaces(t), this.emit("removed", e, t);
          }
        }, {
          key: "hasResourceBundle",
          value: function (e, t) {
            return void 0 !== this.getResource(e, t);
          }
        }, {
          key: "getResourceBundle",
          value: function (e, t) {
            return t || (t = this.options.defaultNS), "v1" === this.options.compatibilityAPI ? q({}, {}, this.getResource(e, t)) : this.getResource(e, t);
          }
        }, {
          key: "getDataByLanguage",
          value: function (e) {
            return this.data[e];
          }
        }, {
          key: "toJSON",
          value: function () {
            return this.data;
          }
        }]), t;
      }(re),
      he = {
        processors: {},
        addPostProcessor: function (e) {
          this.processors[e.name] = e;
        },
        handle: function (e, t, r, n, o) {
          var i = this;
          return e.forEach(function (e) {
            i.processors[e] && (t = i.processors[e].process(t, r, n, o));
          }), t;
        }
      },
      me = {},
      ve = function (e) {
        function t(e) {
          var r,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          return W(this, t), r = Z(this, Y(t).call(this)), ye && re.call(K(r)), ie(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], e, K(r)), r.options = n, void 0 === r.options.keySeparator && (r.options.keySeparator = "."), r.logger = te.create("translator"), r;
        }
        return X(t, e), G(t, [{
          key: "changeLanguage",
          value: function (e) {
            e && (this.language = e);
          }
        }, {
          key: "exists",
          value: function (e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
                interpolation: {}
              },
              r = this.resolve(e, t);
            return r && void 0 !== r.res;
          }
        }, {
          key: "extractFromKey",
          value: function (e, t) {
            var r = void 0 !== t.nsSeparator ? t.nsSeparator : this.options.nsSeparator;
            void 0 === r && (r = ":");
            var n = void 0 !== t.keySeparator ? t.keySeparator : this.options.keySeparator,
              o = t.ns || this.options.defaultNS;
            if (r && e.indexOf(r) > -1) {
              var i = e.match(this.interpolator.nestingRegexp);
              if (i && i.length > 0) return {
                key: e,
                namespaces: o
              };
              var a = e.split(r);
              (r !== n || r === n && this.options.ns.indexOf(a[0]) > -1) && (o = a.shift()), e = a.join(n);
            }
            return "string" == typeof o && (o = [o]), {
              key: e,
              namespaces: o
            };
          }
        }, {
          key: "translate",
          value: function (e, r, n) {
            var o = this;
            if ("object" !== V(r) && this.options.overloadTranslationOptionHandler && (r = this.options.overloadTranslationOptionHandler(arguments)), r || (r = {}), null == e) return "";
            Array.isArray(e) || (e = [String(e)]);
            var i = void 0 !== r.keySeparator ? r.keySeparator : this.options.keySeparator,
              a = this.extractFromKey(e[e.length - 1], r),
              c = a.key,
              l = a.namespaces,
              u = l[l.length - 1],
              s = r.lng || this.language,
              p = r.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
            if (s && "cimode" === s.toLowerCase()) {
              if (p) {
                var f = r.nsSeparator || this.options.nsSeparator;
                return u + f + c;
              }
              return c;
            }
            var d = this.resolve(e, r),
              y = d && d.res,
              b = d && d.usedKey || c,
              h = d && d.exactUsedKey || c,
              m = Object.prototype.toString.apply(y),
              v = ["[object Number]", "[object Function]", "[object RegExp]"],
              g = void 0 !== r.joinArrays ? r.joinArrays : this.options.joinArrays,
              w = !this.i18nFormat || this.i18nFormat.handleAsObject,
              O = "string" != typeof y && "boolean" != typeof y && "number" != typeof y;
            if (w && y && O && v.indexOf(m) < 0 && ("string" != typeof g || "[object Array]" !== m)) {
              if (!r.returnObjects && !this.options.returnObjects) return this.logger.warn("accessing an object - but returnObjects options is not enabled!"), this.options.returnedObjectHandler ? this.options.returnedObjectHandler(b, y, r) : "key '".concat(c, " (").concat(this.language, ")' returned an object instead of string.");
              if (i) {
                var _ = "[object Array]" === m,
                  j = _ ? [] : {},
                  P = _ ? h : b;
                for (var E in y) if (Object.prototype.hasOwnProperty.call(y, E)) {
                  var k = "".concat(P).concat(i).concat(E);
                  j[E] = this.translate(k, q({}, r, {
                    joinArrays: !1,
                    ns: l
                  })), j[E] === k && (j[E] = y[E]);
                }
                y = j;
              }
            } else if (w && "string" == typeof g && "[object Array]" === m) (y = y.join(g)) && (y = this.extendTranslation(y, e, r, n));else {
              var x = !1,
                S = !1,
                C = void 0 !== r.count && "string" != typeof r.count,
                R = t.hasDefaultValue(r),
                N = C ? this.pluralResolver.getSuffix(s, r.count) : "",
                z = r["defaultValue".concat(N)] || r.defaultValue;
              !this.isValidLookup(y) && R && (x = !0, y = z), this.isValidLookup(y) || (S = !0, y = c);
              var D = R && z !== y && this.options.updateMissing;
              if (S || x || D) {
                if (this.logger.log(D ? "updateKey" : "missingKey", s, u, c, D ? z : y), i) {
                  var T = this.resolve(c, q({}, r, {
                    keySeparator: !1
                  }));
                  T && T.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                }
                var M = [],
                  F = this.languageUtils.getFallbackCodes(this.options.fallbackLng, r.lng || this.language);
                if ("fallback" === this.options.saveMissingTo && F && F[0]) for (var I = 0; I < F.length; I++) M.push(F[I]);else "all" === this.options.saveMissingTo ? M = this.languageUtils.toResolveHierarchy(r.lng || this.language) : M.push(r.lng || this.language);
                var A = function (e, t, n) {
                  o.options.missingKeyHandler ? o.options.missingKeyHandler(e, u, t, D ? n : y, D, r) : o.backendConnector && o.backendConnector.saveMissing && o.backendConnector.saveMissing(e, u, t, D ? n : y, D, r), o.emit("missingKey", e, u, t, y);
                };
                this.options.saveMissing && (this.options.saveMissingPlurals && C ? M.forEach(function (e) {
                  o.pluralResolver.getSuffixes(e).forEach(function (t) {
                    A([e], c + t, r["defaultValue".concat(t)] || z);
                  });
                }) : A(M, c, z));
              }
              y = this.extendTranslation(y, e, r, d, n), S && y === c && this.options.appendNamespaceToMissingKey && (y = "".concat(u, ":").concat(c)), S && this.options.parseMissingKeyHandler && (y = this.options.parseMissingKeyHandler(y));
            }
            return y;
          }
        }, {
          key: "extendTranslation",
          value: function (e, t, r, n, o) {
            var i = this;
            if (this.i18nFormat && this.i18nFormat.parse) e = this.i18nFormat.parse(e, r, n.usedLng, n.usedNS, n.usedKey, {
              resolved: n
            });else if (!r.skipInterpolation) {
              r.interpolation && this.interpolator.init(q({}, r, {
                interpolation: q({}, this.options.interpolation, r.interpolation)
              }));
              var a,
                c = r.interpolation && r.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
              if (c) {
                var l = e.match(this.interpolator.nestingRegexp);
                a = l && l.length;
              }
              var u = r.replace && "string" != typeof r.replace ? r.replace : r;
              if (this.options.interpolation.defaultVariables && (u = q({}, this.options.interpolation.defaultVariables, u)), e = this.interpolator.interpolate(e, u, r.lng || this.language, r), c) {
                var s = e.match(this.interpolator.nestingRegexp);
                a < (s && s.length) && (r.nest = !1);
              }
              !1 !== r.nest && (e = this.interpolator.nest(e, function () {
                for (var e = arguments.length, n = new Array(e), a = 0; a < e; a++) n[a] = arguments[a];
                return o && o[0] === n[0] && !r.context ? (i.logger.warn("It seems you are nesting recursively key: ".concat(n[0], " in key: ").concat(t[0])), null) : i.translate.apply(i, n.concat([t]));
              }, r)), r.interpolation && this.interpolator.reset();
            }
            var p = r.postProcess || this.options.postProcess,
              f = "string" == typeof p ? [p] : p;
            return null != e && f && f.length && !1 !== r.applyPostProcessor && (e = he.handle(f, e, t, this.options && this.options.postProcessPassResolved ? q({
              i18nResolved: n
            }, r) : r, this)), e;
          }
        }, {
          key: "resolve",
          value: function (e) {
            var t,
              r,
              n,
              o,
              i,
              a = this,
              c = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return "string" == typeof e && (e = [e]), e.forEach(function (e) {
              if (!a.isValidLookup(t)) {
                var l = a.extractFromKey(e, c),
                  u = l.key;
                r = u;
                var s = l.namespaces;
                a.options.fallbackNS && (s = s.concat(a.options.fallbackNS));
                var p = void 0 !== c.count && "string" != typeof c.count,
                  f = void 0 !== c.context && "string" == typeof c.context && "" !== c.context,
                  d = c.lngs ? c.lngs : a.languageUtils.toResolveHierarchy(c.lng || a.language, c.fallbackLng);
                s.forEach(function (e) {
                  a.isValidLookup(t) || (i = e, !me["".concat(d[0], "-").concat(e)] && a.utils && a.utils.hasLoadedNamespace && !a.utils.hasLoadedNamespace(i) && (me["".concat(d[0], "-").concat(e)] = !0, a.logger.warn('key "'.concat(r, '" for languages "').concat(d.join(", "), '" won\'t get resolved as namespace "').concat(i, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), d.forEach(function (r) {
                    if (!a.isValidLookup(t)) {
                      o = r;
                      var i,
                        l,
                        s = u,
                        d = [s];
                      if (a.i18nFormat && a.i18nFormat.addLookupKeys) a.i18nFormat.addLookupKeys(d, u, r, e, c);else p && (i = a.pluralResolver.getSuffix(r, c.count)), p && f && d.push(s + i), f && d.push(s += "".concat(a.options.contextSeparator).concat(c.context)), p && d.push(s += i);
                      for (; l = d.pop();) a.isValidLookup(t) || (n = l, t = a.getResource(r, e, l, c));
                    }
                  }));
                });
              }
            }), {
              res: t,
              usedKey: r,
              exactUsedKey: n,
              usedLng: o,
              usedNS: i
            };
          }
        }, {
          key: "isValidLookup",
          value: function (e) {
            return !(void 0 === e || !this.options.returnNull && null === e || !this.options.returnEmptyString && "" === e);
          }
        }, {
          key: "getResource",
          value: function (e, t, r) {
            var n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
            return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(e, t, r, n) : this.resourceStore.getResource(e, t, r, n);
          }
        }], [{
          key: "hasDefaultValue",
          value: function (e) {
            for (var t in e) if (Object.prototype.hasOwnProperty.call(e, t) && "defaultValue" === t.substring(0, "defaultValue".length) && void 0 !== e[t]) return !0;
            return !1;
          }
        }]), t;
      }(re);
    function ge(e) {
      return e.charAt(0).toUpperCase() + e.slice(1);
    }
    var we = function () {
        function e(t) {
          W(this, e), this.options = t, this.whitelist = this.options.supportedLngs || !1, this.supportedLngs = this.options.supportedLngs || !1, this.logger = te.create("languageUtils");
        }
        return G(e, [{
          key: "getScriptPartFromCode",
          value: function (e) {
            if (!e || e.indexOf("-") < 0) return null;
            var t = e.split("-");
            return 2 === t.length ? null : (t.pop(), "x" === t[t.length - 1].toLowerCase() ? null : this.formatLanguageCode(t.join("-")));
          }
        }, {
          key: "getLanguagePartFromCode",
          value: function (e) {
            if (!e || e.indexOf("-") < 0) return e;
            var t = e.split("-");
            return this.formatLanguageCode(t[0]);
          }
        }, {
          key: "formatLanguageCode",
          value: function (e) {
            if ("string" == typeof e && e.indexOf("-") > -1) {
              var t = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"],
                r = e.split("-");
              return this.options.lowerCaseLng ? r = r.map(function (e) {
                return e.toLowerCase();
              }) : 2 === r.length ? (r[0] = r[0].toLowerCase(), r[1] = r[1].toUpperCase(), t.indexOf(r[1].toLowerCase()) > -1 && (r[1] = ge(r[1].toLowerCase()))) : 3 === r.length && (r[0] = r[0].toLowerCase(), 2 === r[1].length && (r[1] = r[1].toUpperCase()), "sgn" !== r[0] && 2 === r[2].length && (r[2] = r[2].toUpperCase()), t.indexOf(r[1].toLowerCase()) > -1 && (r[1] = ge(r[1].toLowerCase())), t.indexOf(r[2].toLowerCase()) > -1 && (r[2] = ge(r[2].toLowerCase()))), r.join("-");
            }
            return this.options.cleanCode || this.options.lowerCaseLng ? e.toLowerCase() : e;
          }
        }, {
          key: "isWhitelisted",
          value: function (e) {
            return this.logger.deprecate("languageUtils.isWhitelisted", 'function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it\'s usage asap.'), this.isSupportedCode(e);
          }
        }, {
          key: "isSupportedCode",
          value: function (e) {
            return ("languageOnly" === this.options.load || this.options.nonExplicitSupportedLngs) && (e = this.getLanguagePartFromCode(e)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(e) > -1;
          }
        }, {
          key: "getBestMatchFromCodes",
          value: function (e) {
            var t,
              r = this;
            return e ? (e.forEach(function (e) {
              if (!t) {
                var n = r.formatLanguageCode(e);
                r.options.supportedLngs && !r.isSupportedCode(n) || (t = n);
              }
            }), !t && this.options.supportedLngs && e.forEach(function (e) {
              if (!t) {
                var n = r.getLanguagePartFromCode(e);
                if (r.isSupportedCode(n)) return t = n;
                t = r.options.supportedLngs.find(function (e) {
                  if (0 === e.indexOf(n)) return e;
                });
              }
            }), t || (t = this.getFallbackCodes(this.options.fallbackLng)[0]), t) : null;
          }
        }, {
          key: "getFallbackCodes",
          value: function (e, t) {
            if (!e) return [];
            if ("function" == typeof e && (e = e(t)), "string" == typeof e && (e = [e]), "[object Array]" === Object.prototype.toString.apply(e)) return e;
            if (!t) return e.default || [];
            var r = e[t];
            return r || (r = e[this.getScriptPartFromCode(t)]), r || (r = e[this.formatLanguageCode(t)]), r || (r = e[this.getLanguagePartFromCode(t)]), r || (r = e.default), r || [];
          }
        }, {
          key: "toResolveHierarchy",
          value: function (e, t) {
            var r = this,
              n = this.getFallbackCodes(t || this.options.fallbackLng || [], e),
              o = [],
              i = function (e) {
                e && (r.isSupportedCode(e) ? o.push(e) : r.logger.warn("rejecting language code not found in supportedLngs: ".concat(e)));
              };
            return "string" == typeof e && e.indexOf("-") > -1 ? ("languageOnly" !== this.options.load && i(this.formatLanguageCode(e)), "languageOnly" !== this.options.load && "currentOnly" !== this.options.load && i(this.getScriptPartFromCode(e)), "currentOnly" !== this.options.load && i(this.getLanguagePartFromCode(e))) : "string" == typeof e && i(this.formatLanguageCode(e)), n.forEach(function (e) {
              o.indexOf(e) < 0 && i(r.formatLanguageCode(e));
            }), o;
          }
        }]), e;
      }(),
      Oe = [{
        lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
        nr: [1, 2],
        fc: 1
      }, {
        lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
        nr: [1, 2],
        fc: 2
      }, {
        lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "kk", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
        nr: [1],
        fc: 3
      }, {
        lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
        nr: [1, 2, 5],
        fc: 4
      }, {
        lngs: ["ar"],
        nr: [0, 1, 2, 3, 11, 100],
        fc: 5
      }, {
        lngs: ["cs", "sk"],
        nr: [1, 2, 5],
        fc: 6
      }, {
        lngs: ["csb", "pl"],
        nr: [1, 2, 5],
        fc: 7
      }, {
        lngs: ["cy"],
        nr: [1, 2, 3, 8],
        fc: 8
      }, {
        lngs: ["fr"],
        nr: [1, 2],
        fc: 9
      }, {
        lngs: ["ga"],
        nr: [1, 2, 3, 7, 11],
        fc: 10
      }, {
        lngs: ["gd"],
        nr: [1, 2, 3, 20],
        fc: 11
      }, {
        lngs: ["is"],
        nr: [1, 2],
        fc: 12
      }, {
        lngs: ["jv"],
        nr: [0, 1],
        fc: 13
      }, {
        lngs: ["kw"],
        nr: [1, 2, 3, 4],
        fc: 14
      }, {
        lngs: ["lt"],
        nr: [1, 2, 10],
        fc: 15
      }, {
        lngs: ["lv"],
        nr: [1, 2, 0],
        fc: 16
      }, {
        lngs: ["mk"],
        nr: [1, 2],
        fc: 17
      }, {
        lngs: ["mnk"],
        nr: [0, 1, 2],
        fc: 18
      }, {
        lngs: ["mt"],
        nr: [1, 2, 11, 20],
        fc: 19
      }, {
        lngs: ["or"],
        nr: [2, 1],
        fc: 2
      }, {
        lngs: ["ro"],
        nr: [1, 2, 20],
        fc: 20
      }, {
        lngs: ["sl"],
        nr: [5, 1, 2, 3],
        fc: 21
      }, {
        lngs: ["he", "iw"],
        nr: [1, 2, 20, 21],
        fc: 22
      }],
      _e = {
        1: function (e) {
          return Number(e > 1);
        },
        2: function (e) {
          return Number(1 != e);
        },
        3: function (e) {
          return 0;
        },
        4: function (e) {
          return Number(e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2);
        },
        5: function (e) {
          return Number(0 == e ? 0 : 1 == e ? 1 : 2 == e ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5);
        },
        6: function (e) {
          return Number(1 == e ? 0 : e >= 2 && e <= 4 ? 1 : 2);
        },
        7: function (e) {
          return Number(1 == e ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2);
        },
        8: function (e) {
          return Number(1 == e ? 0 : 2 == e ? 1 : 8 != e && 11 != e ? 2 : 3);
        },
        9: function (e) {
          return Number(e >= 2);
        },
        10: function (e) {
          return Number(1 == e ? 0 : 2 == e ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4);
        },
        11: function (e) {
          return Number(1 == e || 11 == e ? 0 : 2 == e || 12 == e ? 1 : e > 2 && e < 20 ? 2 : 3);
        },
        12: function (e) {
          return Number(e % 10 != 1 || e % 100 == 11);
        },
        13: function (e) {
          return Number(0 !== e);
        },
        14: function (e) {
          return Number(1 == e ? 0 : 2 == e ? 1 : 3 == e ? 2 : 3);
        },
        15: function (e) {
          return Number(e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2);
        },
        16: function (e) {
          return Number(e % 10 == 1 && e % 100 != 11 ? 0 : 0 !== e ? 1 : 2);
        },
        17: function (e) {
          return Number(1 == e || e % 10 == 1 && e % 100 != 11 ? 0 : 1);
        },
        18: function (e) {
          return Number(0 == e ? 0 : 1 == e ? 1 : 2);
        },
        19: function (e) {
          return Number(1 == e ? 0 : 0 == e || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3);
        },
        20: function (e) {
          return Number(1 == e ? 0 : 0 == e || e % 100 > 0 && e % 100 < 20 ? 1 : 2);
        },
        21: function (e) {
          return Number(e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0);
        },
        22: function (e) {
          return Number(1 == e ? 0 : 2 == e ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3);
        }
      };
    function je() {
      var e = {};
      return Oe.forEach(function (t) {
        t.lngs.forEach(function (r) {
          e[r] = {
            numbers: t.nr,
            plurals: _e[t.fc]
          };
        });
      }), e;
    }
    var Pe = function () {
        function e(t) {
          var r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          W(this, e), this.languageUtils = t, this.options = r, this.logger = te.create("pluralResolver"), this.rules = je();
        }
        return G(e, [{
          key: "addRule",
          value: function (e, t) {
            this.rules[e] = t;
          }
        }, {
          key: "getRule",
          value: function (e) {
            return this.rules[e] || this.rules[this.languageUtils.getLanguagePartFromCode(e)];
          }
        }, {
          key: "needsPlural",
          value: function (e) {
            var t = this.getRule(e);
            return t && t.numbers.length > 1;
          }
        }, {
          key: "getPluralFormsOfKey",
          value: function (e, t) {
            return this.getSuffixes(e).map(function (e) {
              return t + e;
            });
          }
        }, {
          key: "getSuffixes",
          value: function (e) {
            var t = this,
              r = this.getRule(e);
            return r ? r.numbers.map(function (r) {
              return t.getSuffix(e, r);
            }) : [];
          }
        }, {
          key: "getSuffix",
          value: function (e, t) {
            var r = this,
              n = this.getRule(e);
            if (n) {
              var o = n.noAbs ? n.plurals(t) : n.plurals(Math.abs(t)),
                i = n.numbers[o];
              this.options.simplifyPluralSuffix && 2 === n.numbers.length && 1 === n.numbers[0] && (2 === i ? i = "plural" : 1 === i && (i = ""));
              var a = function () {
                return r.options.prepend && i.toString() ? r.options.prepend + i.toString() : i.toString();
              };
              return "v1" === this.options.compatibilityJSON ? 1 === i ? "" : "number" == typeof i ? "_plural_".concat(i.toString()) : a() : "v2" === this.options.compatibilityJSON || this.options.simplifyPluralSuffix && 2 === n.numbers.length && 1 === n.numbers[0] ? a() : this.options.prepend && o.toString() ? this.options.prepend + o.toString() : o.toString();
            }
            return this.logger.warn("no plural rule found for: ".concat(e)), "";
          }
        }]), e;
      }(),
      Ee = function () {
        function e() {
          var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          W(this, e), this.logger = te.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || function (e) {
            return e;
          }, this.init(t);
        }
        return G(e, [{
          key: "init",
          value: function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            e.interpolation || (e.interpolation = {
              escapeValue: !0
            });
            var t = e.interpolation;
            this.escape = void 0 !== t.escape ? t.escape : de, this.escapeValue = void 0 === t.escapeValue || t.escapeValue, this.useRawValueToEscape = void 0 !== t.useRawValueToEscape && t.useRawValueToEscape, this.prefix = t.prefix ? pe(t.prefix) : t.prefixEscaped || "{{", this.suffix = t.suffix ? pe(t.suffix) : t.suffixEscaped || "}}", this.formatSeparator = t.formatSeparator ? t.formatSeparator : t.formatSeparator || ",", this.unescapePrefix = t.unescapeSuffix ? "" : t.unescapePrefix || "-", this.unescapeSuffix = this.unescapePrefix ? "" : t.unescapeSuffix || "", this.nestingPrefix = t.nestingPrefix ? pe(t.nestingPrefix) : t.nestingPrefixEscaped || pe("$t("), this.nestingSuffix = t.nestingSuffix ? pe(t.nestingSuffix) : t.nestingSuffixEscaped || pe(")"), this.nestingOptionsSeparator = t.nestingOptionsSeparator ? t.nestingOptionsSeparator : t.nestingOptionsSeparator || ",", this.maxReplaces = t.maxReplaces ? t.maxReplaces : 1e3, this.alwaysFormat = void 0 !== t.alwaysFormat && t.alwaysFormat, this.resetRegExp();
          }
        }, {
          key: "reset",
          value: function () {
            this.options && this.init(this.options);
          }
        }, {
          key: "resetRegExp",
          value: function () {
            var e = "".concat(this.prefix, "(.+?)").concat(this.suffix);
            this.regexp = new RegExp(e, "g");
            var t = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
            this.regexpUnescape = new RegExp(t, "g");
            var r = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
            this.nestingRegexp = new RegExp(r, "g");
          }
        }, {
          key: "interpolate",
          value: function (e, t, r, n) {
            var o,
              i,
              a,
              c = this,
              l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
            function u(e) {
              return e.replace(/\$/g, "$$$$");
            }
            var s = function (e) {
              if (e.indexOf(c.formatSeparator) < 0) {
                var o = ue(t, l, e);
                return c.alwaysFormat ? c.format(o, void 0, r) : o;
              }
              var i = e.split(c.formatSeparator),
                a = i.shift().trim(),
                u = i.join(c.formatSeparator).trim();
              return c.format(ue(t, l, a), u, r, n);
            };
            this.resetRegExp();
            var p = n && n.missingInterpolationHandler || this.options.missingInterpolationHandler,
              f = n && n.interpolation && n.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
            return [{
              regex: this.regexpUnescape,
              safeValue: function (e) {
                return u(e);
              }
            }, {
              regex: this.regexp,
              safeValue: function (e) {
                return c.escapeValue ? u(c.escape(e)) : u(e);
              }
            }].forEach(function (t) {
              for (a = 0; o = t.regex.exec(e);) {
                if (void 0 === (i = s(o[1].trim()))) {
                  if ("function" == typeof p) {
                    var r = p(e, o, n);
                    i = "string" == typeof r ? r : "";
                  } else {
                    if (f) {
                      i = o[0];
                      continue;
                    }
                    c.logger.warn("missed to pass in variable ".concat(o[1], " for interpolating ").concat(e)), i = "";
                  }
                } else "string" == typeof i || c.useRawValueToEscape || (i = oe(i));
                if (e = e.replace(o[0], t.safeValue(i)), t.regex.lastIndex = 0, ++a >= c.maxReplaces) break;
              }
            }), e;
          }
        }, {
          key: "nest",
          value: function (e, t) {
            var r,
              n,
              o = this,
              i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              a = q({}, i);
            function c(e, t) {
              var r = this.nestingOptionsSeparator;
              if (e.indexOf(r) < 0) return e;
              var n = e.split(new RegExp("".concat(r, "[ ]*{"))),
                o = "{".concat(n[1]);
              e = n[0], o = (o = this.interpolate(o, a)).replace(/'/g, '"');
              try {
                a = JSON.parse(o), t && (a = q({}, t, a));
              } catch (t) {
                return this.logger.warn("failed parsing options string in nesting for key ".concat(e), t), "".concat(e).concat(r).concat(o);
              }
              return delete a.defaultValue, e;
            }
            for (a.applyPostProcessor = !1, delete a.defaultValue; r = this.nestingRegexp.exec(e);) {
              var l = [],
                u = !1;
              if (r[0].includes(this.formatSeparator) && !/{.*}/.test(r[1])) {
                var s = r[1].split(this.formatSeparator).map(function (e) {
                  return e.trim();
                });
                r[1] = s.shift(), l = s, u = !0;
              }
              if ((n = t(c.call(this, r[1].trim(), a), a)) && r[0] === e && "string" != typeof n) return n;
              "string" != typeof n && (n = oe(n)), n || (this.logger.warn("missed to resolve ".concat(r[1], " for nesting ").concat(e)), n = ""), u && (n = l.reduce(function (e, t) {
                return o.format(e, t, i.lng, i);
              }, n.trim())), e = e.replace(r[0], n), this.regexp.lastIndex = 0;
            }
            return e;
          }
        }]), e;
      }();
    var ke = function (e) {
      function t(e, r, n) {
        var o,
          i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
        return W(this, t), o = Z(this, Y(t).call(this)), ye && re.call(K(o)), o.backend = e, o.store = r, o.services = n, o.languageUtils = n.languageUtils, o.options = i, o.logger = te.create("backendConnector"), o.state = {}, o.queue = [], o.backend && o.backend.init && o.backend.init(n, i.backend, i), o;
      }
      return X(t, e), G(t, [{
        key: "queueLoad",
        value: function (e, t, r, n) {
          var o = this,
            i = [],
            a = [],
            c = [],
            l = [];
          return e.forEach(function (e) {
            var n = !0;
            t.forEach(function (t) {
              var c = "".concat(e, "|").concat(t);
              !r.reload && o.store.hasResourceBundle(e, t) ? o.state[c] = 2 : o.state[c] < 0 || (1 === o.state[c] ? a.indexOf(c) < 0 && a.push(c) : (o.state[c] = 1, n = !1, a.indexOf(c) < 0 && a.push(c), i.indexOf(c) < 0 && i.push(c), l.indexOf(t) < 0 && l.push(t)));
            }), n || c.push(e);
          }), (i.length || a.length) && this.queue.push({
            pending: a,
            loaded: {},
            errors: [],
            callback: n
          }), {
            toLoad: i,
            pending: a,
            toLoadLanguages: c,
            toLoadNamespaces: l
          };
        }
      }, {
        key: "loaded",
        value: function (e, t, r) {
          var n = e.split("|"),
            o = n[0],
            i = n[1];
          t && this.emit("failedLoading", o, i, t), r && this.store.addResourceBundle(o, i, r), this.state[e] = t ? -1 : 2;
          var a = {};
          this.queue.forEach(function (r) {
            var n, c, l, u, s, p;
            n = r.loaded, c = i, u = ae(n, [o], Object), s = u.obj, p = u.k, s[p] = s[p] || [], l && (s[p] = s[p].concat(c)), l || s[p].push(c), function (e, t) {
              for (var r = e.indexOf(t); -1 !== r;) e.splice(r, 1), r = e.indexOf(t);
            }(r.pending, e), t && r.errors.push(t), 0 !== r.pending.length || r.done || (Object.keys(r.loaded).forEach(function (e) {
              a[e] || (a[e] = []), r.loaded[e].length && r.loaded[e].forEach(function (t) {
                a[e].indexOf(t) < 0 && a[e].push(t);
              });
            }), r.done = !0, r.errors.length ? r.callback(r.errors) : r.callback());
          }), this.emit("loaded", a), this.queue = this.queue.filter(function (e) {
            return !e.done;
          });
        }
      }, {
        key: "read",
        value: function (e, t, r) {
          var n = this,
            o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0,
            i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 350,
            a = arguments.length > 5 ? arguments[5] : void 0;
          return e.length ? this.backend[r](e, t, function (c, l) {
            c && l && o < 5 ? setTimeout(function () {
              n.read.call(n, e, t, r, o + 1, 2 * i, a);
            }, i) : a(c, l);
          }) : a(null, {});
        }
      }, {
        key: "prepareLoading",
        value: function (e, t) {
          var r = this,
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            o = arguments.length > 3 ? arguments[3] : void 0;
          if (!this.backend) return this.logger.warn("No backend was added via i18next.use. Will not load resources."), o && o();
          "string" == typeof e && (e = this.languageUtils.toResolveHierarchy(e)), "string" == typeof t && (t = [t]);
          var i = this.queueLoad(e, t, n, o);
          if (!i.toLoad.length) return i.pending.length || o(), null;
          i.toLoad.forEach(function (e) {
            r.loadOne(e);
          });
        }
      }, {
        key: "load",
        value: function (e, t, r) {
          this.prepareLoading(e, t, {}, r);
        }
      }, {
        key: "reload",
        value: function (e, t, r) {
          this.prepareLoading(e, t, {
            reload: !0
          }, r);
        }
      }, {
        key: "loadOne",
        value: function (e) {
          var t = this,
            r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
            n = e.split("|"),
            o = n[0],
            i = n[1];
          this.read(o, i, "read", void 0, void 0, function (n, a) {
            n && t.logger.warn("".concat(r, "loading namespace ").concat(i, " for language ").concat(o, " failed"), n), !n && a && t.logger.log("".concat(r, "loaded namespace ").concat(i, " for language ").concat(o), a), t.loaded(e, n, a);
          });
        }
      }, {
        key: "saveMissing",
        value: function (e, t, r, n, o) {
          var i = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : {};
          this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(t) ? this.logger.warn('did not save key "'.concat(r, '" as the namespace "').concat(t, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!") : null != r && "" !== r && (this.backend && this.backend.create && this.backend.create(e, t, r, n, null, q({}, i, {
            isUpdate: o
          })), e && e[0] && this.store.addResource(e[0], t, r, n));
        }
      }]), t;
    }(re);
    function xe() {
      return {
        debug: !1,
        initImmediate: !0,
        ns: ["translation"],
        defaultNS: ["translation"],
        fallbackLng: ["dev"],
        fallbackNS: !1,
        whitelist: !1,
        nonExplicitWhitelist: !1,
        supportedLngs: !1,
        nonExplicitSupportedLngs: !1,
        load: "all",
        preload: !1,
        simplifyPluralSuffix: !0,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: !1,
        saveMissing: !1,
        updateMissing: !1,
        saveMissingTo: "fallback",
        saveMissingPlurals: !0,
        missingKeyHandler: !1,
        missingInterpolationHandler: !1,
        postProcess: !1,
        postProcessPassResolved: !1,
        returnNull: !0,
        returnEmptyString: !0,
        returnObjects: !1,
        joinArrays: !1,
        returnedObjectHandler: !1,
        parseMissingKeyHandler: !1,
        appendNamespaceToMissingKey: !1,
        appendNamespaceToCIMode: !1,
        overloadTranslationOptionHandler: function (e) {
          var t = {};
          if ("object" === V(e[1]) && (t = e[1]), "string" == typeof e[1] && (t.defaultValue = e[1]), "string" == typeof e[2] && (t.tDescription = e[2]), "object" === V(e[2]) || "object" === V(e[3])) {
            var r = e[3] || e[2];
            Object.keys(r).forEach(function (e) {
              t[e] = r[e];
            });
          }
          return t;
        },
        interpolation: {
          escapeValue: !0,
          format: function (e, t, r, n) {
            return e;
          },
          prefix: "{{",
          suffix: "}}",
          formatSeparator: ",",
          unescapePrefix: "-",
          nestingPrefix: "$t(",
          nestingSuffix: ")",
          nestingOptionsSeparator: ",",
          maxReplaces: 1e3,
          skipOnVariables: !1
        }
      };
    }
    function Se(e) {
      return "string" == typeof e.ns && (e.ns = [e.ns]), "string" == typeof e.fallbackLng && (e.fallbackLng = [e.fallbackLng]), "string" == typeof e.fallbackNS && (e.fallbackNS = [e.fallbackNS]), e.whitelist && (e.whitelist && e.whitelist.indexOf("cimode") < 0 && (e.whitelist = e.whitelist.concat(["cimode"])), e.supportedLngs = e.whitelist), e.nonExplicitWhitelist && (e.nonExplicitSupportedLngs = e.nonExplicitWhitelist), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e;
    }
    function Ce() {}
    var Re = new (function (e) {
        function t() {
          var e,
            r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = arguments.length > 1 ? arguments[1] : void 0;
          if (W(this, t), e = Z(this, Y(t).call(this)), ye && re.call(K(e)), e.options = Se(r), e.services = {}, e.logger = te, e.modules = {
            external: []
          }, n && !e.isInitialized && !r.isClone) {
            if (!e.options.initImmediate) return e.init(r, n), Z(e, K(e));
            setTimeout(function () {
              e.init(r, n);
            }, 0);
          }
          return e;
        }
        return X(t, e), G(t, [{
          key: "init",
          value: function () {
            var e = this,
              t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              r = arguments.length > 1 ? arguments[1] : void 0;
            function n(e) {
              return e ? "function" == typeof e ? new e() : e : null;
            }
            if ("function" == typeof t && (r = t, t = {}), t.whitelist && !t.supportedLngs && this.logger.deprecate("whitelist", 'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.'), t.nonExplicitWhitelist && !t.nonExplicitSupportedLngs && this.logger.deprecate("whitelist", 'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.'), this.options = q({}, xe(), this.options, Se(t)), this.format = this.options.interpolation.format, r || (r = Ce), !this.options.isClone) {
              this.modules.logger ? te.init(n(this.modules.logger), this.options) : te.init(null, this.options);
              var o = new we(this.options);
              this.store = new be(this.options.resources, this.options);
              var i = this.services;
              i.logger = te, i.resourceStore = this.store, i.languageUtils = o, i.pluralResolver = new Pe(o, {
                prepend: this.options.pluralSeparator,
                compatibilityJSON: this.options.compatibilityJSON,
                simplifyPluralSuffix: this.options.simplifyPluralSuffix
              }), i.interpolator = new Ee(this.options), i.utils = {
                hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
              }, i.backendConnector = new ke(n(this.modules.backend), i.resourceStore, i, this.options), i.backendConnector.on("*", function (t) {
                for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) n[o - 1] = arguments[o];
                e.emit.apply(e, [t].concat(n));
              }), this.modules.languageDetector && (i.languageDetector = n(this.modules.languageDetector), i.languageDetector.init(i, this.options.detection, this.options)), this.modules.i18nFormat && (i.i18nFormat = n(this.modules.i18nFormat), i.i18nFormat.init && i.i18nFormat.init(this)), this.translator = new ve(this.services, this.options), this.translator.on("*", function (t) {
                for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++) n[o - 1] = arguments[o];
                e.emit.apply(e, [t].concat(n));
              }), this.modules.external.forEach(function (t) {
                t.init && t.init(e);
              });
            }
            if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
              var a = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
              a.length > 0 && "dev" !== a[0] && (this.options.lng = a[0]);
            }
            this.services.languageDetector || this.options.lng || this.logger.warn("init: no languageDetector is used and no lng is defined");
            var c = ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"];
            c.forEach(function (t) {
              e[t] = function () {
                var r;
                return (r = e.store)[t].apply(r, arguments);
              };
            });
            var l = ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"];
            l.forEach(function (t) {
              e[t] = function () {
                var r;
                return (r = e.store)[t].apply(r, arguments), e;
              };
            });
            var u = ne(),
              s = function () {
                var t = function (t, n) {
                  e.isInitialized && e.logger.warn("init: i18next is already initialized. You should call init just once!"), e.isInitialized = !0, e.options.isClone || e.logger.log("initialized", e.options), e.emit("initialized", e.options), u.resolve(n), r(t, n);
                };
                if (e.languages && "v1" !== e.options.compatibilityAPI && !e.isInitialized) return t(null, e.t.bind(e));
                e.changeLanguage(e.options.lng, t);
              };
            return this.options.resources || !this.options.initImmediate ? s() : setTimeout(s, 0), u;
          }
        }, {
          key: "loadResources",
          value: function (e) {
            var t = this,
              r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Ce,
              n = r,
              o = "string" == typeof e ? e : this.language;
            if ("function" == typeof e && (n = e), !this.options.resources || this.options.partialBundledLanguages) {
              if (o && "cimode" === o.toLowerCase()) return n();
              var i = [],
                a = function (e) {
                  e && t.services.languageUtils.toResolveHierarchy(e).forEach(function (e) {
                    i.indexOf(e) < 0 && i.push(e);
                  });
                };
              if (o) a(o);else {
                var c = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                c.forEach(function (e) {
                  return a(e);
                });
              }
              this.options.preload && this.options.preload.forEach(function (e) {
                return a(e);
              }), this.services.backendConnector.load(i, this.options.ns, n);
            } else n(null);
          }
        }, {
          key: "reloadResources",
          value: function (e, t, r) {
            var n = ne();
            return e || (e = this.languages), t || (t = this.options.ns), r || (r = Ce), this.services.backendConnector.reload(e, t, function (e) {
              n.resolve(), r(e);
            }), n;
          }
        }, {
          key: "use",
          value: function (e) {
            if (!e) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
            if (!e.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
            return "backend" === e.type && (this.modules.backend = e), ("logger" === e.type || e.log && e.warn && e.error) && (this.modules.logger = e), "languageDetector" === e.type && (this.modules.languageDetector = e), "i18nFormat" === e.type && (this.modules.i18nFormat = e), "postProcessor" === e.type && he.addPostProcessor(e), "3rdParty" === e.type && this.modules.external.push(e), this;
          }
        }, {
          key: "changeLanguage",
          value: function (e, t) {
            var r = this;
            this.isLanguageChangingTo = e;
            var n = ne();
            this.emit("languageChanging", e);
            var o = function (e) {
              var o = "string" == typeof e ? e : r.services.languageUtils.getBestMatchFromCodes(e);
              o && (r.language || (r.language = o, r.languages = r.services.languageUtils.toResolveHierarchy(o)), r.translator.language || r.translator.changeLanguage(o), r.services.languageDetector && r.services.languageDetector.cacheUserLanguage(o)), r.loadResources(o, function (e) {
                !function (e, o) {
                  o ? (r.language = o, r.languages = r.services.languageUtils.toResolveHierarchy(o), r.translator.changeLanguage(o), r.isLanguageChangingTo = void 0, r.emit("languageChanged", o), r.logger.log("languageChanged", o)) : r.isLanguageChangingTo = void 0, n.resolve(function () {
                    return r.t.apply(r, arguments);
                  }), t && t(e, function () {
                    return r.t.apply(r, arguments);
                  });
                }(e, o);
              });
            };
            return e || !this.services.languageDetector || this.services.languageDetector.async ? !e && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect(o) : o(e) : o(this.services.languageDetector.detect()), n;
          }
        }, {
          key: "getFixedT",
          value: function (e, t) {
            var r = this,
              n = function e(t, n) {
                var o;
                if ("object" !== V(n)) {
                  for (var i = arguments.length, a = new Array(i > 2 ? i - 2 : 0), c = 2; c < i; c++) a[c - 2] = arguments[c];
                  o = r.options.overloadTranslationOptionHandler([t, n].concat(a));
                } else o = q({}, n);
                return o.lng = o.lng || e.lng, o.lngs = o.lngs || e.lngs, o.ns = o.ns || e.ns, r.t(t, o);
              };
            return "string" == typeof e ? n.lng = e : n.lngs = e, n.ns = t, n;
          }
        }, {
          key: "t",
          value: function () {
            var e;
            return this.translator && (e = this.translator).translate.apply(e, arguments);
          }
        }, {
          key: "exists",
          value: function () {
            var e;
            return this.translator && (e = this.translator).exists.apply(e, arguments);
          }
        }, {
          key: "setDefaultNamespace",
          value: function (e) {
            this.options.defaultNS = e;
          }
        }, {
          key: "hasLoadedNamespace",
          value: function (e) {
            var t = this,
              r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            if (!this.isInitialized) return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
            if (!this.languages || !this.languages.length) return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
            var n = this.languages[0],
              o = !!this.options && this.options.fallbackLng,
              i = this.languages[this.languages.length - 1];
            if ("cimode" === n.toLowerCase()) return !0;
            var a = function (e, r) {
              var n = t.services.backendConnector.state["".concat(e, "|").concat(r)];
              return -1 === n || 2 === n;
            };
            if (r.precheck) {
              var c = r.precheck(this, a);
              if (void 0 !== c) return c;
            }
            return !!this.hasResourceBundle(n, e) || !this.services.backendConnector.backend || !(!a(n, e) || o && !a(i, e));
          }
        }, {
          key: "loadNamespaces",
          value: function (e, t) {
            var r = this,
              n = ne();
            return this.options.ns ? ("string" == typeof e && (e = [e]), e.forEach(function (e) {
              r.options.ns.indexOf(e) < 0 && r.options.ns.push(e);
            }), this.loadResources(function (e) {
              n.resolve(), t && t(e);
            }), n) : (t && t(), Promise.resolve());
          }
        }, {
          key: "loadLanguages",
          value: function (e, t) {
            var r = ne();
            "string" == typeof e && (e = [e]);
            var n = this.options.preload || [],
              o = e.filter(function (e) {
                return n.indexOf(e) < 0;
              });
            return o.length ? (this.options.preload = n.concat(o), this.loadResources(function (e) {
              r.resolve(), t && t(e);
            }), r) : (t && t(), Promise.resolve());
          }
        }, {
          key: "dir",
          value: function (e) {
            if (e || (e = this.languages && this.languages.length > 0 ? this.languages[0] : this.language), !e) return "rtl";
            return ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam"].indexOf(this.services.languageUtils.getLanguagePartFromCode(e)) >= 0 ? "rtl" : "ltr";
          }
        }, {
          key: "createInstance",
          value: function () {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              r = arguments.length > 1 ? arguments[1] : void 0;
            return new t(e, r);
          }
        }, {
          key: "cloneInstance",
          value: function () {
            var e = this,
              r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Ce,
              o = q({}, this.options, r, {
                isClone: !0
              }),
              i = new t(o),
              a = ["store", "services", "language"];
            return a.forEach(function (t) {
              i[t] = e[t];
            }), i.services = q({}, this.services), i.services.utils = {
              hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
            }, i.translator = new ve(i.services, i.options), i.translator.on("*", function (e) {
              for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) r[n - 1] = arguments[n];
              i.emit.apply(i, [e].concat(r));
            }), i.init(o, n), i.translator.options = i.options, i.translator.backendConnector.services.utils = {
              hasLoadedNamespace: i.hasLoadedNamespace.bind(i)
            }, i;
          }
        }]), t;
      }(re))(),
      Ne = r(73),
      ze = r.n(Ne),
      De = r(74),
      Te = r(75);
    function Me(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Fe(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Me(Object(r), !0).forEach(function (t) {
          Ie(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Me(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function Ie(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    var Ae = {
      en: {
        translation: Le(De.en)
      },
      es: {
        translation: Le(Te.es)
      }
    };
    function Le(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
        r = {};
      return Object.keys(e).forEach(function (n) {
        var o = e[n],
          i = n;
        t.length > 0 && (i = "".concat(t, ".").concat(n)), "string" == typeof o ? r[i] = o : r = Fe(Fe({}, r), Le(o, i));
      }), r;
    }
    Re.use(ze.a).use(_).init({
      resources: Ae,
      languages: ["en", "es"],
      fallbackLng: "en",
      detection: {
        order: ["querystring", "path"],
        lookupFromPathIndex: 1,
        lookupQuerystring: "locale"
      },
      keySeparator: !0,
      interpolation: {
        escapeValue: !1,
        prefix: "%{",
        suffix: "}"
      }
    });
    var Ue = r(4),
      Ve = r(78),
      Be = r.n(Ve);
    function qe(e) {
      return function (e) {
        if (Array.isArray(e)) return We(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
      }(e) || function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return We(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === r && e.constructor && (r = e.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(e);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return We(e, t);
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function We(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    var He,
      Ge = function (e) {
        if (!e.length) return null;
        var t = {
            type: "FeatureCollection",
            features: e.map(function (e) {
              return {
                type: "Feature",
                geometry: {
                  type: "Point",
                  coordinates: [e[1], e[0]]
                }
              };
            })
          },
          r = Be()(t);
        return [r.geometry.coordinates[1], r.geometry.coordinates[0]];
      };
    function Je(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function $e(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Je(Object(r), !0).forEach(function (t) {
          Ke(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Je(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function Ke(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function Ze(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function Ye(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var Qe,
      Xe,
      et,
      tt,
      rt,
      nt,
      ot,
      it,
      at,
      ct,
      lt,
      ut,
      st = (Ye((He = function () {
        function e(t) {
          var r = this;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._defaults = {
            id: "",
            name: "",
            varieties: [],
            cultivars: [],
            rootStocks: [],
            useTypes: [],
            grafts: []
          }, t ? this.update($e($e({}, this._defaults), this.deSerialize(t))) : this.update(this._defaults), Object.keys(this._defaults).forEach(function (e) {
            return Object(a.decorate)(r, Ke({}, e, a.observable));
          });
        }
        var t, r, n;
        return t = e, (r = [{
          key: "varietyPercentSum",
          get: function () {
            return this.computePercentSum(this.varieties);
          }
        }, {
          key: "varietyPercentError",
          get: function () {
            return this.computePercentError(this.varieties);
          }
        }, {
          key: "rootStockPercentSum",
          get: function () {
            return this.computePercentSum(this.rootStocks);
          }
        }, {
          key: "rootStockPercentError",
          get: function () {
            return this.computePercentError(this.rootStocks);
          }
        }, {
          key: "changeElementPercent",
          value: function (e, t, r) {
            e.forEach(function (n) {
              n.name !== t ? e.length > 2 || (n.percent = 100 - r) : n.percent = r;
            });
          }
        }, {
          key: "changeVarietyPercent",
          value: function (e, t) {
            this.changeElementPercent(this.varieties, e, t);
          }
        }, {
          key: "changeRootStockPercent",
          value: function (e, t) {
            this.changeElementPercent(this.rootStocks, e, t);
          }
        }, {
          key: "removeVariety",
          value: function (e) {
            this.varieties = this.varieties.filter(function (t) {
              return t.name !== e;
            }), this.cultivars = this.cultivars.filter(function (t) {
              return t.variety !== e;
            });
          }
        }, {
          key: "removeRootStock",
          value: function (e) {
            this.rootStocks = this.rootStocks.filter(function (t) {
              return t.name !== e;
            });
          }
        }, {
          key: "removeCultivar",
          value: function (e) {
            this.cultivars = e.name && e.variety ? this.cultivars.filter(function (t) {
              return !(t.name === e.name && t.variety === e.variety);
            }) : this.cultivars.filter(function (t) {
              return t.name !== e.name;
            });
          }
        }, {
          key: "removeUseType",
          value: function (e) {
            this.useTypes = this.useTypes.filter(function (t) {
              return t.name !== e;
            });
          }
        }, {
          key: "computePercentSum",
          value: function (e) {
            return e.reduce(function (e, t) {
              return e + Number(t.percent);
            }, 0);
          }
        }, {
          key: "computePercentError",
          value: function (e) {
            var t = this.computePercentSum(e);
            return 1 === e.length && 100 !== t ? "Must be 100%" : 100 === t ? "" : "Must sum to 100%";
          }
        }, {
          key: "deSerialize",
          value: function (e) {
            return e;
          }
        }, {
          key: "serialize",
          value: function () {
            var e = this;
            return Object.keys(this._defaults).map(function (t) {
              return [t, e[t]];
            }).reduce(function (e, t) {
              return $e($e({}, e), {}, Ke({}, t[0], t[1]));
            }, {});
          }
        }, {
          key: "update",
          value: function (e) {
            var t = this,
              r = e || {};
            Object.keys(r).forEach(function (e) {
              t[e] = "varieties" === e || "cultivars" === e || "useTypes" === e || "rootStocks" === e || "grafts" === e ? Array.isArray(r[e]) && r[e] || [] : r[e] || "";
            });
          }
        }]) && Ze(t.prototype, r), n && Ze(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), e;
      }()).prototype, "varietyPercentSum", [a.computed], Object.getOwnPropertyDescriptor(He.prototype, "varietyPercentSum"), He.prototype), Ye(He.prototype, "varietyPercentError", [a.computed], Object.getOwnPropertyDescriptor(He.prototype, "varietyPercentError"), He.prototype), Ye(He.prototype, "rootStockPercentSum", [a.computed], Object.getOwnPropertyDescriptor(He.prototype, "rootStockPercentSum"), He.prototype), Ye(He.prototype, "rootStockPercentError", [a.computed], Object.getOwnPropertyDescriptor(He.prototype, "rootStockPercentError"), He.prototype), Ye(He.prototype, "changeElementPercent", [a.action], Object.getOwnPropertyDescriptor(He.prototype, "changeElementPercent"), He.prototype), Ye(He.prototype, "changeVarietyPercent", [a.action], Object.getOwnPropertyDescriptor(He.prototype, "changeVarietyPercent"), He.prototype), Ye(He.prototype, "changeRootStockPercent", [a.action], Object.getOwnPropertyDescriptor(He.prototype, "changeRootStockPercent"), He.prototype), Ye(He.prototype, "removeVariety", [a.action], Object.getOwnPropertyDescriptor(He.prototype, "removeVariety"), He.prototype), Ye(He.prototype, "removeRootStock", [a.action], Object.getOwnPropertyDescriptor(He.prototype, "removeRootStock"), He.prototype), Ye(He.prototype, "removeCultivar", [a.action], Object.getOwnPropertyDescriptor(He.prototype, "removeCultivar"), He.prototype), Ye(He.prototype, "removeUseType", [a.action], Object.getOwnPropertyDescriptor(He.prototype, "removeUseType"), He.prototype), Ye(He.prototype, "update", [a.action], Object.getOwnPropertyDescriptor(He.prototype, "update"), He.prototype), He);
    function pt(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null == r) return;
        var n,
          o,
          i = [],
          a = !0,
          c = !1;
        try {
          for (r = r.call(e); !(a = (n = r.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0);
        } catch (e) {
          c = !0, o = e;
        } finally {
          try {
            a || null == r.return || r.return();
          } finally {
            if (c) throw o;
          }
        }
        return i;
      }(e, t) || function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return ft(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === r && e.constructor && (r = e.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(e);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ft(e, t);
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function ft(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function dt(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function yt(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? dt(Object(r), !0).forEach(function (t) {
          bt(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : dt(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function bt(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function ht(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function mt(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function vt(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var gt,
      wt = (Xe = vt((Qe = function () {
        function e(t) {
          var r = this;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this.sortCultivars = function (e, t) {
            return Object(Ue.genericSort)(r.cultivarDisplayName(e).toLowerCase(), r.cultivarDisplayName(t).toLowerCase());
          }, ht(this, "crop", Xe, this), ht(this, "objectName", et, this), ht(this, "hasMultipleVarieties", tt, this), ht(this, "hasMultipleCultivars", rt, this), ht(this, "hasMultipleRootStocks", nt, this), ht(this, "hasMultipleUseTypes", ot, this), ht(this, "variety", it, this), ht(this, "rootStock", at, this), ht(this, "useType", ct, this), ht(this, "cultivar", lt, this), ht(this, "cropOptions", ut, this), this.crop.update(this.addCamelCasedCropishAttributes(t.reference)), this.cropOptions = t.crops.map(function (e) {
            return r.addCamelCasedCropishAttributes(e);
          }), this.objectName = t.objectName, this.variety = 1 === this.crop.varieties.length ? this.crop.varieties[0] : "", this.rootStock = 1 === this.crop.rootStocks.length ? this.crop.rootStocks[0] : "", this.cultivar = 1 === this.crop.cultivars.length ? this.crop.cultivars[0] : "", this.useType = 1 === this.crop.useTypes.length ? this.crop.useTypes[0] : "", this.hasMultipleVarieties = this.crop.varieties.length > 1, this.hasMultipleCultivars = this.crop.cultivars.length > 1, this.hasMultipleUseTypes = this.crop.useTypes.length > 1, this.hasMultipleRootStocks = this.crop.rootStocks.length > 1;
        }
        var t, r, n;
        return t = e, (r = [{
          key: "cropId",
          get: function () {
            return this.crop.id;
          }
        }, {
          key: "cropName",
          get: function () {
            return this.crop.name;
          }
        }, {
          key: "cropSerial",
          get: function () {
            return this.crop.serial;
          }
        }, {
          key: "varietyPercentSum",
          get: function () {
            return this.crop.varietyPercentSum;
          }
        }, {
          key: "varietyPercentError",
          get: function () {
            return this.crop.varietyPercentError;
          }
        }, {
          key: "rootStockPercentSum",
          get: function () {
            return this.crop.rootStockPercentSum;
          }
        }, {
          key: "rootStockPercentError",
          get: function () {
            return this.crop.rootStockPercentError;
          }
        }, {
          key: "selectedVarieties",
          get: function () {
            return this.crop.varieties.slice().sort(Ue.sortByName);
          }
        }, {
          key: "grafts",
          get: function () {
            return this.crop.grafts.slice();
          }
        }, {
          key: "selectedRootStocks",
          get: function () {
            return this.crop.rootStocks.slice().sort(Ue.sortByName);
          }
        }, {
          key: "selectedCultivars",
          get: function () {
            return this.crop.cultivars.slice().sort(this.sortCultivars);
          }
        }, {
          key: "selectedUseTypes",
          get: function () {
            return this.crop.useTypes.slice().sort(Ue.sortByName);
          }
        }, {
          key: "selectedCropOptions",
          get: function () {
            var e = this;
            return this.cropOptions.find(function (t) {
              return t.id === e.cropId;
            }) || {
              varieties: [],
              cultivars: [],
              rootStocks: [],
              useTypes: []
            };
          }
        }, {
          key: "varieties",
          get: function () {
            var e = [];
            return "varieties" in this.selectedCropOptions && (e = this.selectedCropOptions.varieties.concat().sort(Ue.sortByName) || []), e;
          }
        }, {
          key: "rootStocks",
          get: function () {
            var e = [];
            return "rootStocks" in this.selectedCropOptions && (e = this.selectedCropOptions.rootStocks.concat().sort(Ue.sortByName) || []), e;
          }
        }, {
          key: "cultivars",
          get: function () {
            var e,
              t,
              r = this;
            return (e = this.varieties.filter(function (e) {
              return r.selectedVarieties.find(function (t) {
                return t.name === e.name;
              });
            }).map(function (e) {
              var t;
              return (null == e || null === (t = e.cultivars) || void 0 === t ? void 0 : t.map(function (t) {
                return yt(yt({}, t), {}, {
                  variety: e.name
                });
              })) || [];
            }), (t = []).concat.apply(t, qe(e))).sort(this.sortCultivars);
          }
        }, {
          key: "useTypes",
          get: function () {
            var e = [];
            return "useTypes" in this.selectedCropOptions && (e = this.selectedCropOptions.useTypes.concat().sort() || []), e;
          }
        }, {
          key: "changeCrop",
          value: function (e) {
            this.crop = new st(e), this.cultivar = "", this.useType = "", this.variety = "", this.rootStock = "";
          }
        }, {
          key: "changeVariety",
          value: function (e) {
            if (!e) return this.resetVariety();
            var t = this.varieties.find(function (t) {
              return t.name === e;
            });
            if (!t) return this.resetVariety();
            var r = yt(yt({}, t), {}, {
              percent: "100"
            });
            if (this.hasMultipleVarieties) return this.crop.update({
              varieties: this.selectedVarieties.find(function (e) {
                return e.name === r.name;
              }) ? this.selectedVarieties : 1 === this.selectedVarieties.length ? [yt(yt({}, this.selectedVarieties[0]), {}, {
                percent: "50"
              }), yt(yt({}, r), {}, {
                percent: "50"
              })] : this.selectedVarieties.concat(0 === this.selectedVarieties.length ? r : yt(yt({}, r), {}, {
                percent: "0"
              }))
            }), void (this.variety = "");
            this.crop.update({
              varieties: [r]
            }), this.variety = r, this.pruneOrphanedCultivars();
          }
        }, {
          key: "changeRootStock",
          value: function (e) {
            if (!e) return this.resetRootStock();
            var t = this.rootStocks.find(function (t) {
              return t.name === e;
            });
            if (!t) return this.resetRootStock();
            var r = yt(yt({}, t), {}, {
              percent: "100"
            });
            if (this.hasMultipleRootStocks) return this.crop.update({
              rootStocks: this.selectedRootStocks.find(function (e) {
                return e.name === r.name;
              }) ? this.selectedRootStocks : 1 === this.selectedRootStocks.length ? [yt(yt({}, this.selectedRootStocks[0]), {}, {
                percent: "50"
              }), yt(yt({}, r), {}, {
                percent: "50"
              })] : this.selectedRootStocks.concat(0 === this.selectedRootStocks.length ? r : yt(yt({}, r), {}, {
                percent: "0"
              }))
            }), void (this.rootStock = "");
            this.crop.update({
              rootStocks: [r]
            }), this.rootStock = r;
          }
        }, {
          key: "changeVarietyPercent",
          value: function (e, t) {
            this.crop.changeVarietyPercent(e, t);
          }
        }, {
          key: "changeRootStockPercent",
          value: function (e, t) {
            this.crop.changeRootStockPercent(e, t);
          }
        }, {
          key: "changeUseType",
          value: function (e) {
            if (!e) return this.resetUseType();
            var t = this.useTypes.find(function (t) {
              return t.name === e;
            });
            return t ? this.hasMultipleUseTypes ? (this.useType = "", void this.crop.update({
              useTypes: this.selectedUseTypes.find(function (e) {
                return e.name === t.name;
              }) ? this.selectedUseTypes : this.selectedUseTypes.concat(t)
            })) : (this.crop.update({
              useTypes: t ? [t] : []
            }), void (this.useType = t || "")) : this.resetUseType();
          }
        }, {
          key: "changeCultivar",
          value: function (e) {
            if (!e) return this.resetCultivar();
            var t = pt(e.split(":"), 2),
              r = t[0],
              n = t[1],
              o = r && n ? this.cultivars.find(function (e) {
                return e.name === n && e.variety === r;
              }) : n ? this.cultivars.find(function (e) {
                return e.name === n;
              }) : null;
            if (this.hasMultipleCultivars) {
              if (this.cultivar = "", !o) return;
              this.crop.update({
                cultivars: this.selectedCultivars.find(function (e) {
                  return e.name === o.name && e.variety === o.variety;
                }) ? this.selectedCultivars : this.selectedCultivars.concat(o)
              });
            } else this.crop.update({
              cultivars: o ? [o] : []
            }), this.cultivar = o || "";
          }
        }, {
          key: "pruneOrphanedCultivars",
          value: function () {
            var e = this;
            this.hasMultipleCultivars ? (this.cultivar = "", this.crop.update({
              cultivars: this.selectedCultivars.filter(function (t) {
                return e.selectedVarieties.find(function (e) {
                  return e === t.variety;
                });
              })
            })) : this.cultivar && !this.selectedVarieties.find(function (t) {
              return e.cultivar.variety === t;
            }) && (this.cultivar = "", this.crop.update({
              cultivars: []
            }));
          }
        }, {
          key: "toggleMultipleVarieties",
          value: function () {
            var e = this.selectedVarieties.length ? this.selectedVarieties[0] : "";
            this.hasMultipleVarieties && e && (e.percent = "100"), this.variety = this.hasMultipleVarieties ? e : "", this.crop.update({
              varieties: e ? [e] : [],
              cultivars: []
            }), this.cultivar = "", this.hasMultipleVarieties = !this.hasMultipleVarieties;
          }
        }, {
          key: "toggleMultipleRootStocks",
          value: function () {
            var e = this.selectedRootStocks.length ? this.selectedRootStocks[0] : "";
            this.hasMultipleRootStocks && e && (e.percent = "100"), this.rootStock = this.hasMultipleRootStocks ? e : "", this.crop.update({
              rootStocks: e ? [e] : []
            }), this.hasMultipleRootStocks = !this.hasMultipleRootStocks;
          }
        }, {
          key: "toggleMultipleCultivars",
          value: function () {
            var e = this.selectedCultivars.length ? this.selectedCultivars[0] : "";
            this.cultivar = this.hasMultipleCultivars ? e : "", this.crop.update({
              cultivars: e ? [e] : []
            }), this.hasMultipleCultivars = !this.hasMultipleCultivars;
          }
        }, {
          key: "toggleMultipleUseTypes",
          value: function () {
            var e = this.selectedUseTypes.length ? this.selectedUseTypes[0] : "";
            this.useType = this.hasMultipleUseTypes ? e : "", this.crop.update({
              useTypes: e ? [e] : []
            }), this.hasMultipleUseTypes = !this.hasMultipleUseTypes;
          }
        }, {
          key: "removeVariety",
          value: function (e) {
            this.crop.removeVariety(e);
          }
        }, {
          key: "resetVariety",
          value: function () {
            this.variety = "", this.hasMultipleVarieties || this.crop.update({
              varieties: []
            });
          }
        }, {
          key: "removeRootStock",
          value: function (e) {
            this.crop.removeRootStock(e);
          }
        }, {
          key: "resetRootStock",
          value: function () {
            this.rootStock = "", this.hasMultipleRootStocks || this.crop.update({
              rootStocks: []
            });
          }
        }, {
          key: "removeCultivar",
          value: function (e) {
            this.crop.removeCultivar(e);
          }
        }, {
          key: "resetCultivar",
          value: function () {
            this.cultivar = "", this.hasMultipleCultivars || this.crop.update({
              cultivars: []
            });
          }
        }, {
          key: "removeUseType",
          value: function (e) {
            this.crop.removeUseType(e);
          }
        }, {
          key: "resetUseType",
          value: function () {
            this.useType = "", this.hasMultipleUseTypes || this.crop.update({
              useTypes: []
            });
          }
        }, {
          key: "cultivarDisplayName",
          value: function (e) {
            return "".concat(e.variety || "", ":").concat(e.name || "");
          }
        }, {
          key: "cultivarSerial",
          value: function (e) {
            return e && e.serial || "";
          }
        }, {
          key: "varietyDisplayName",
          value: function (e) {
            return e && e.name || "";
          }
        }, {
          key: "varietyPercent",
          value: function (e) {
            return e && e.percent || "";
          }
        }, {
          key: "varietySerial",
          value: function (e) {
            return e && e.serial || "";
          }
        }, {
          key: "rootStockDisplayName",
          value: function (e) {
            return e && e.name || "";
          }
        }, {
          key: "rootStockPercent",
          value: function (e) {
            return e && e.percent || "";
          }
        }, {
          key: "rootStockSerial",
          value: function (e) {
            return e && e.serial || "";
          }
        }, {
          key: "useTypeDisplayName",
          value: function (e) {
            return e && e.name || "";
          }
        }, {
          key: "useTypeSerial",
          value: function (e) {
            return e && e.serial || "";
          }
        }, {
          key: "fieldName",
          value: function (e) {
            return "".concat(this.objectName, "[crop][").concat(e, "]");
          }
        }, {
          key: "addCamelCasedCropishAttributes",
          value: function (e) {
            return e ? ("root_stocks" in e && (e.rootStocks = e.root_stocks), "use_types" in e && (e.useTypes = e.use_types), e) : null;
          }
        }]) && mt(t.prototype, r), n && mt(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), e;
      }()).prototype, "crop", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return new st();
        }
      }), et = vt(Qe.prototype, "objectName", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return "";
        }
      }), tt = vt(Qe.prototype, "hasMultipleVarieties", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return !1;
        }
      }), rt = vt(Qe.prototype, "hasMultipleCultivars", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return !1;
        }
      }), nt = vt(Qe.prototype, "hasMultipleRootStocks", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return !1;
        }
      }), ot = vt(Qe.prototype, "hasMultipleUseTypes", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return !1;
        }
      }), it = vt(Qe.prototype, "variety", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), at = vt(Qe.prototype, "rootStock", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), ct = vt(Qe.prototype, "useType", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), lt = vt(Qe.prototype, "cultivar", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), ut = vt(Qe.prototype, "cropOptions", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return [];
        }
      }), vt(Qe.prototype, "cropId", [a.computed], Object.getOwnPropertyDescriptor(Qe.prototype, "cropId"), Qe.prototype), vt(Qe.prototype, "cropName", [a.computed], Object.getOwnPropertyDescriptor(Qe.prototype, "cropName"), Qe.prototype), vt(Qe.prototype, "cropSerial", [a.computed], Object.getOwnPropertyDescriptor(Qe.prototype, "cropSerial"), Qe.prototype), vt(Qe.prototype, "varietyPercentSum", [a.computed], Object.getOwnPropertyDescriptor(Qe.prototype, "varietyPercentSum"), Qe.prototype), vt(Qe.prototype, "varietyPercentError", [a.computed], Object.getOwnPropertyDescriptor(Qe.prototype, "varietyPercentError"), Qe.prototype), vt(Qe.prototype, "rootStockPercentSum", [a.computed], Object.getOwnPropertyDescriptor(Qe.prototype, "rootStockPercentSum"), Qe.prototype), vt(Qe.prototype, "rootStockPercentError", [a.computed], Object.getOwnPropertyDescriptor(Qe.prototype, "rootStockPercentError"), Qe.prototype), vt(Qe.prototype, "selectedVarieties", [a.computed], Object.getOwnPropertyDescriptor(Qe.prototype, "selectedVarieties"), Qe.prototype), vt(Qe.prototype, "grafts", [a.computed], Object.getOwnPropertyDescriptor(Qe.prototype, "grafts"), Qe.prototype), vt(Qe.prototype, "selectedRootStocks", [a.computed], Object.getOwnPropertyDescriptor(Qe.prototype, "selectedRootStocks"), Qe.prototype), vt(Qe.prototype, "selectedCultivars", [a.computed], Object.getOwnPropertyDescriptor(Qe.prototype, "selectedCultivars"), Qe.prototype), vt(Qe.prototype, "selectedUseTypes", [a.computed], Object.getOwnPropertyDescriptor(Qe.prototype, "selectedUseTypes"), Qe.prototype), vt(Qe.prototype, "selectedCropOptions", [a.computed], Object.getOwnPropertyDescriptor(Qe.prototype, "selectedCropOptions"), Qe.prototype), vt(Qe.prototype, "varieties", [a.computed], Object.getOwnPropertyDescriptor(Qe.prototype, "varieties"), Qe.prototype), vt(Qe.prototype, "rootStocks", [a.computed], Object.getOwnPropertyDescriptor(Qe.prototype, "rootStocks"), Qe.prototype), vt(Qe.prototype, "cultivars", [a.computed], Object.getOwnPropertyDescriptor(Qe.prototype, "cultivars"), Qe.prototype), vt(Qe.prototype, "useTypes", [a.computed], Object.getOwnPropertyDescriptor(Qe.prototype, "useTypes"), Qe.prototype), vt(Qe.prototype, "changeCrop", [a.action], Object.getOwnPropertyDescriptor(Qe.prototype, "changeCrop"), Qe.prototype), vt(Qe.prototype, "changeVariety", [a.action], Object.getOwnPropertyDescriptor(Qe.prototype, "changeVariety"), Qe.prototype), vt(Qe.prototype, "changeRootStock", [a.action], Object.getOwnPropertyDescriptor(Qe.prototype, "changeRootStock"), Qe.prototype), vt(Qe.prototype, "changeVarietyPercent", [a.action], Object.getOwnPropertyDescriptor(Qe.prototype, "changeVarietyPercent"), Qe.prototype), vt(Qe.prototype, "changeRootStockPercent", [a.action], Object.getOwnPropertyDescriptor(Qe.prototype, "changeRootStockPercent"), Qe.prototype), vt(Qe.prototype, "changeUseType", [a.action], Object.getOwnPropertyDescriptor(Qe.prototype, "changeUseType"), Qe.prototype), vt(Qe.prototype, "changeCultivar", [a.action], Object.getOwnPropertyDescriptor(Qe.prototype, "changeCultivar"), Qe.prototype), vt(Qe.prototype, "pruneOrphanedCultivars", [a.action], Object.getOwnPropertyDescriptor(Qe.prototype, "pruneOrphanedCultivars"), Qe.prototype), vt(Qe.prototype, "toggleMultipleVarieties", [a.action], Object.getOwnPropertyDescriptor(Qe.prototype, "toggleMultipleVarieties"), Qe.prototype), vt(Qe.prototype, "toggleMultipleRootStocks", [a.action], Object.getOwnPropertyDescriptor(Qe.prototype, "toggleMultipleRootStocks"), Qe.prototype), vt(Qe.prototype, "toggleMultipleCultivars", [a.action], Object.getOwnPropertyDescriptor(Qe.prototype, "toggleMultipleCultivars"), Qe.prototype), vt(Qe.prototype, "toggleMultipleUseTypes", [a.action], Object.getOwnPropertyDescriptor(Qe.prototype, "toggleMultipleUseTypes"), Qe.prototype), vt(Qe.prototype, "removeVariety", [a.action], Object.getOwnPropertyDescriptor(Qe.prototype, "removeVariety"), Qe.prototype), vt(Qe.prototype, "resetVariety", [a.action], Object.getOwnPropertyDescriptor(Qe.prototype, "resetVariety"), Qe.prototype), vt(Qe.prototype, "removeRootStock", [a.action], Object.getOwnPropertyDescriptor(Qe.prototype, "removeRootStock"), Qe.prototype), vt(Qe.prototype, "resetRootStock", [a.action], Object.getOwnPropertyDescriptor(Qe.prototype, "resetRootStock"), Qe.prototype), vt(Qe.prototype, "removeCultivar", [a.action], Object.getOwnPropertyDescriptor(Qe.prototype, "removeCultivar"), Qe.prototype), vt(Qe.prototype, "resetCultivar", [a.action], Object.getOwnPropertyDescriptor(Qe.prototype, "resetCultivar"), Qe.prototype), vt(Qe.prototype, "removeUseType", [a.action], Object.getOwnPropertyDescriptor(Qe.prototype, "removeUseType"), Qe.prototype), vt(Qe.prototype, "resetUseType", [a.action], Object.getOwnPropertyDescriptor(Qe.prototype, "resetUseType"), Qe.prototype), Qe),
      Ot = r(7),
      _t = r(9),
      jt = r(26);
    function Pt(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function Et(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function kt(e, t) {
      return (kt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function xt(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = Ct(e);
        if (t) {
          var o = Ct(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return St(this, r);
      };
    }
    function St(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function Ct(e) {
      return (Ct = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var Rt,
      Nt = Object(c.observer)(gt = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && kt(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = xt(a);
        function a() {
          var e;
          Pt(this, a);
          for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];
          return (e = o.call.apply(o, [this].concat(r))).onToggleMultiSelect = function (t) {
            var r = e.props.onToggleMultiSelect;
            t.preventDefault(), r();
          }, e.onSelect = function (t) {
            var r = e.props.onSelect;
            r && r(t.target.value);
          }, e.renderChildren = function (e) {
            return e.renderChildren ? e.renderChildren(e) : null;
          }, e.removeItem = function (e) {
            return e.remove ? e.remove(e) : null;
          }, e;
        }
        return t = a, (r = [{
          key: "render",
          value: function () {
            var e = this,
              t = this.props,
              r = t.label,
              n = t.isMultiSelect,
              o = t.multiSelectToggleLabel,
              a = t.singleSelectValue,
              c = t.selectOptions,
              l = t.selectedItems,
              u = t.children,
              s = t.t;
            return t.enable ? i.a.createElement(j, {
              i18n: Re
            }, i.a.createElement("div", {
              className: "row form-group mb-0"
            }, i.a.createElement("div", {
              className: "col-md-auto"
            }, i.a.createElement("label", {
              className: "pr-3"
            }, r), i.a.createElement("a", {
              href: "#",
              className: "multiple-selections-checkbox",
              onClick: this.onToggleMultiSelect
            }, i.a.createElement("small", null, n ? i.a.createElement(Ot.FontAwesomeIcon, {
              icon: jt.faCheckSquare
            }) : i.a.createElement(Ot.FontAwesomeIcon, {
              icon: jt.faSquare
            }), i.a.createElement("span", {
              className: "pl-2"
            }, o)))), i.a.createElement("div", {
              className: "col"
            }, u)), i.a.createElement("div", {
              className: "row form-group"
            }, i.a.createElement("div", {
              className: "col"
            }, i.a.createElement("select", {
              className: "form-control",
              value: a,
              onChange: this.onSelect
            }, i.a.createElement("option", {
              value: ""
            }, n ? s("if2_fields.field_form.add_label", {
              label: r
            }) : s("if2_fields.field_form.not_specified"), " "), c.map(function (e) {
              return i.a.createElement("option", {
                key: e.key,
                value: e.value
              }, e.name);
            })))), n ? i.a.createElement("div", {
              className: "row form-group"
            }, i.a.createElement("div", {
              className: "col"
            }, i.a.createElement("ul", {
              className: "list-group"
            }, l.map(function (t) {
              return i.a.createElement("li", {
                className: "list-group-item d-flex justify-content-between align-items-center",
                key: t.key
              }, i.a.createElement("div", {
                className: "col"
              }, i.a.createElement("div", {
                className: "row align-items-center"
              }, i.a.createElement("div", {
                className: "col-md-4"
              }, t.name), i.a.createElement("div", {
                className: "col-md-8"
              }, e.renderChildren(t)))), i.a.createElement("a", {
                href: "#",
                onClick: function (r) {
                  r.preventDefault(), e.removeItem(t);
                }
              }, i.a.createElement(Ot.FontAwesomeIcon, {
                icon: _t.faTimes
              })), t.hiddenInputs.map(function (e) {
                return i.a.createElement("input", {
                  type: "hidden",
                  key: e.key,
                  name: e.name,
                  value: e.value
                });
              }));
            })))) : l.map(function (e) {
              return e.hiddenInputs.map(function (e) {
                return i.a.createElement("input", {
                  type: "hidden",
                  key: e.key,
                  name: e.name,
                  value: e.value
                });
              });
            })) : null;
          }
        }]) && Et(t.prototype, r), n && Et(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component)) || gt,
      zt = U()(Nt);
    function Dt(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function Tt(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function Mt(e, t) {
      return (Mt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function Ft(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = At(e);
        if (t) {
          var o = At(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return It(this, r);
      };
    }
    function It(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function At(e) {
      return (At = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var Lt,
      Ut,
      Vt,
      Bt,
      qt,
      Wt,
      Ht,
      Gt = Object(c.observer)(Rt = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && Mt(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = Ft(a);
        function a() {
          var e;
          Dt(this, a);
          for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];
          return (e = o.call.apply(o, [this].concat(r))).onChange = function (t) {
            var r = e.props.onChange;
            r && r(t.target.value);
          }, e;
        }
        return t = a, (r = [{
          key: "render",
          value: function () {
            var e = this.props,
              t = e.value,
              r = e.errorMessage;
            return i.a.createElement("div", {
              className: "input-group align-items-center percent-input"
            }, i.a.createElement("input", {
              type: "range",
              className: r ? "form-control custom-range is-invalid" : "form-control custom-range",
              min: "0",
              max: "100",
              value: t,
              onChange: this.onChange
            }), i.a.createElement("div", {
              className: "input-group-append"
            }, i.a.createElement("input", {
              className: r ? "form-control is-invalid" : "form-control",
              type: "number",
              value: t,
              onChange: this.onChange
            }), i.a.createElement("span", {
              className: "input-group-text"
            }, "%")));
          }
        }]) && Tt(t.prototype, r), n && Tt(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component)) || Rt,
      Jt = r(14);
    function $t(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function Kt(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var Zt,
      Yt,
      Qt,
      Xt = (Ut = Kt((Lt = function e(t, r, n, o) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), $t(this, "id", Ut, this), $t(this, "variety", Vt, this), $t(this, "date", Bt, this), $t(this, "year", qt, this), $t(this, "timeType", Wt, this), $t(this, "destroyed", Ht, this), this.id = t, this.date = r, this.year = n, this.timeType = r || !n ? "date" : "year", this.variety = o, this.destroyed = !1;
      }).prototype, "id", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), Vt = Kt(Lt.prototype, "variety", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), Bt = Kt(Lt.prototype, "date", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), qt = Kt(Lt.prototype, "year", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), Wt = Kt(Lt.prototype, "timeType", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), Ht = Kt(Lt.prototype, "destroyed", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), Lt);
    function er(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function tr(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var rr,
      nr,
      or,
      ir,
      ar,
      cr,
      lr = (Yt = tr((Zt = function e(t, r) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), er(this, "id", Yt, this), er(this, "name", Qt, this), this.id = t, this.name = r;
      }).prototype, "id", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), Qt = tr(Zt.prototype, "name", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), Zt);
    function ur(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function sr(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function pr(e, t) {
      return (pr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function fr(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = br(e);
        if (t) {
          var o = br(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return dr(this, r);
      };
    }
    function dr(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return yr(e);
    }
    function yr(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function br(e) {
      return (br = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function hr(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var mr,
      vr,
      gr,
      wr = Object(c.observer)((nr = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && pr(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = fr(a);
        function a(e) {
          var t;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, a), ur(t = o.call(this, e), "_grafts", or, yr(t)), ur(t, "_pruneGrafts", ir, yr(t)), ur(t, "_remove", ar, yr(t)), ur(t, "onTimeTypeChange", cr, yr(t)), t._baseInputName = function (e) {
            return "field[grafts_attributes][".concat(e, "]");
          }, t._handleAddGraft = function () {
            t._grafts.push(new Xt());
          }, t._renderGraft = function (e, r) {
            var n,
              o = "".concat(t._formId, "-variety-select"),
              a = t.props.t,
              c = t._baseInputName(r),
              l = "".concat(c, "[variety_id]"),
              u = "".concat(c, "[date]"),
              s = "".concat(c, "[year]"),
              p = "".concat(c, "[time_type]");
            return i.a.createElement("li", {
              className: "list-group-item d-flex justify-content-between align-items-top",
              key: c
            }, i.a.createElement("div", null, i.a.createElement("div", {
              className: "form-check"
            }, i.a.createElement("input", {
              type: "radio",
              className: "form-check-input",
              name: p,
              value: "date",
              checked: "date" === e.timeType,
              onChange: function () {
                return t.onTimeTypeChange(e, "date");
              }
            }), i.a.createElement("label", {
              className: "form-check-label"
            }, a("if2_fields.date"))), i.a.createElement("input", {
              type: "date",
              name: u,
              disabled: "date" !== e.timeType,
              className: "form-control",
              placeholder: a("if2_fields.graft_date"),
              defaultValue: e.date
            }), i.a.createElement("div", {
              className: "form-check"
            }, i.a.createElement("input", {
              type: "radio",
              className: "form-check-input",
              name: p,
              value: "year",
              checked: "year" === e.timeType,
              onChange: function () {
                return t.onTimeTypeChange(e, "year");
              }
            }), i.a.createElement("label", {
              className: "form-check-label"
            }, a("if2_fields.year"))), i.a.createElement("input", {
              type: "number",
              name: s,
              disabled: "year" !== e.timeType,
              className: "form-control",
              placeholder: a("if2_fields.year"),
              onChange: function (t) {
                return e.year = t.target.value;
              },
              value: e.year
            })), i.a.createElement("div", null, i.a.createElement("label", {
              className: "form-label",
              htmlFor: o
            }, a("if2_fields.variety")), i.a.createElement("select", {
              id: o,
              className: "form-control",
              name: l,
              defaultValue: null === (n = e.variety) || void 0 === n ? void 0 : n.id
            }, i.a.createElement("option", {
              value: ""
            }, a("if2_fields.select_interstem_variety")), t._varieties.map(function (e) {
              return i.a.createElement("option", {
                key: "interstem-variety-".concat(e.id),
                value: e.id
              }, e.name);
            }))), i.a.createElement("a", {
              href: "#",
              onClick: function (r) {
                r.preventDefault(), t._remove(e);
              }
            }, i.a.createElement(Ot.FontAwesomeIcon, {
              icon: _t.faTimes
            })));
          }, t._renderGrafts = function () {
            if (t._currentGrafts.length > 0) {
              var e = t.props.t;
              return i.a.createElement("div", {
                className: "row form-group"
              }, i.a.createElement("div", {
                className: "col"
              }, i.a.createElement("ul", {
                className: "list-group"
              }, t._grafts.map(function (e, r) {
                return e.destroyed ? null : t._renderGraft(e, r);
              }), i.a.createElement("li", {
                className: "list-group-item"
              }, i.a.createElement("small", {
                className: "form-text text-muted"
              }, e("if2_fields.graft_information"))))));
            }
          }, t._grafts = t._current, t._formId = Object(Jt.uniqueId)("graft-creator-"), t;
        }
        return t = a, (r = [{
          key: "_varieties",
          get: function () {
            var e = this.props.varieties;
            return e.map(function (e) {
              if (!("serial" in e)) throw new Error("All varieties must include a 'serial' property");
              if (!("name" in e)) throw new Error("All varieties must include a 'name' property");
              return new lr(e.serial, e.name);
            });
          }
        }, {
          key: "_current",
          get: function () {
            var e,
              t,
              r = this.props.current;
            return e = r, t = this._varieties, e.map(function (e) {
              if (!("id" in e)) throw new Error("All grafts must include an 'id' property");
              if (!("date" in e)) throw new Error("All grafts must include a 'date' property");
              if (!("variety_id" in e)) throw new Error("All grafts must include a 'variety_id' property");
              var r = t.find(function (t) {
                return t.id == e.variety_id;
              });
              return r ? new Xt(e.id, e.date, e.year, r) : new Xt(e.id, e.date, e.year);
            });
          }
        }, {
          key: "_currentGrafts",
          get: function () {
            return this._grafts.filter(function (e) {
              return !e.destroyed;
            });
          }
        }, {
          key: "_renderFormItemInputs",
          value: function (e, t) {
            var r = this._baseInputName(t),
              n = "".concat(r, "[id]"),
              o = "".concat(r, "[_destroy]");
            return i.a.createElement(i.a.Fragment, {
              key: r
            }, null !== e.id ? i.a.createElement("input", {
              type: "hidden",
              name: n,
              value: e.id
            }) : null, null !== e.id && e.destroyed ? i.a.createElement("input", {
              type: "hidden",
              name: o,
              value: !0
            }) : null);
          }
        }, {
          key: "_renderFormItems",
          value: function () {
            var e = this;
            return i.a.createElement(i.a.Fragment, null, this._grafts.map(function (t, r) {
              return e._renderFormItemInputs(t, r);
            }));
          }
        }, {
          key: "render",
          value: function () {
            var e = this.props.t;
            return i.a.createElement(j, {
              i18n: Re
            }, i.a.createElement("div", {
              className: "form-group d-flex"
            }, i.a.createElement("div", {
              className: "mr-3"
            }, i.a.createElement("label", null, e("if2_fields.grafts"))), i.a.createElement("div", null, i.a.createElement("a", {
              href: "#",
              onClick: this._handleAddGraft
            }, "(", e("if2_fields.add_graft"), ")"))), this._renderGrafts(), this._renderFormItems());
          }
        }]) && sr(t.prototype, r), n && sr(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(i.a.Component), or = hr(nr.prototype, "_grafts", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return [];
        }
      }), hr(nr.prototype, "_varieties", [a.computed], Object.getOwnPropertyDescriptor(nr.prototype, "_varieties"), nr.prototype), hr(nr.prototype, "_current", [a.computed], Object.getOwnPropertyDescriptor(nr.prototype, "_current"), nr.prototype), hr(nr.prototype, "_currentGrafts", [a.computed], Object.getOwnPropertyDescriptor(nr.prototype, "_currentGrafts"), nr.prototype), ir = hr(nr.prototype, "_pruneGrafts", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function () {
            e._grafts = e._grafts.filter(function (e) {
              return null !== e.id || !e.destroyed;
            });
          };
        }
      }), ar = hr(nr.prototype, "_remove", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            t.destroyed = !0, e._pruneGrafts();
          };
        }
      }), cr = hr(nr.prototype, "onTimeTypeChange", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return function (e, t) {
            e.timeType = t;
          };
        }
      }), rr = nr)) || rr,
      Or = U()(wr);
    function _r(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function jr(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? _r(Object(r), !0).forEach(function (t) {
          Pr(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : _r(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function Pr(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function Er(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function kr(e, t) {
      return (kr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function xr(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = Rr(e);
        if (t) {
          var o = Rr(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return Sr(this, r);
      };
    }
    function Sr(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return Cr(e);
    }
    function Cr(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function Rr(e) {
      return (Rr = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var Nr,
      zr,
      Dr,
      Tr,
      Mr,
      Fr,
      Ir,
      Ar,
      Lr = Object(c.observer)((vr = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && kr(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = xr(a);
        function a(e) {
          var t, r, n, i, c;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, a), t = o.call(this, e), r = t, n = "model", i = gr, c = Cr(t), i && Object.defineProperty(r, n, {
            enumerable: i.enumerable,
            configurable: i.configurable,
            writable: i.writable,
            value: i.initializer ? i.initializer.call(c) : void 0
          }), t.changeCultivar = function (e) {
            t.model.changeCultivar(e);
          }, t.changeRootStock = function (e) {
            t.model.changeRootStock(e);
          }, t.changeUseType = function (e) {
            t.model.changeUseType(e);
          }, t.changeVariety = function (e) {
            t.model.changeVariety(e);
          }, t.toggleMultipleVarieties = function () {
            t.model.toggleMultipleVarieties();
          }, t.toggleMultipleRootStocks = function () {
            t.model.toggleMultipleRootStocks();
          }, t.toggleMultipleCultivars = function () {
            t.model.toggleMultipleCultivars();
          }, t.toggleMultipleUseTypes = function () {
            t.model.toggleMultipleUseTypes();
          }, t.model = new wt(e), t;
        }
        return t = a, (r = [{
          key: "changeCrop",
          value: function (e) {
            var t = this.props.crops.find(function (t) {
              return t.id == e;
            });
            t && this.model.changeCrop(jr(jr({}, t), {}, {
              varieties: [],
              cultivars: [],
              rootStocks: [],
              useTypes: []
            }));
          }
        }, {
          key: "changeVarietyPercent",
          value: function (e, t) {
            this.model.changeVarietyPercent(e, t);
          }
        }, {
          key: "changeRootStockPercent",
          value: function (e, t) {
            this.model.changeRootStockPercent(e, t);
          }
        }, {
          key: "removeVariety",
          value: function (e) {
            this.model.removeVariety(e);
          }
        }, {
          key: "removeRootStock",
          value: function (e) {
            this.model.removeRootStock(e);
          }
        }, {
          key: "removeCultivar",
          value: function (e) {
            this.model.removeCultivar(e);
          }
        }, {
          key: "removeUseType",
          value: function (e) {
            this.model.removeUseType(e);
          }
        }, {
          key: "render",
          value: function () {
            var e = this,
              t = this.props,
              r = t.t,
              n = t.crops,
              o = t.includeVarieties,
              a = t.includeCultivars,
              c = t.includeUseTypes,
              l = t.includeRootStocks;
            return i.a.createElement(j, {
              i18n: Re
            }, i.a.createElement("div", {
              className: "crop-selector"
            }, i.a.createElement("label", null, r("if2_fields.crop")), i.a.createElement("div", {
              className: "row form-group"
            }, i.a.createElement("div", {
              className: "col"
            }, i.a.createElement("select", {
              className: "form-control",
              value: this.model.cropId,
              onChange: function (t) {
                return e.changeCrop(t.target.value);
              }
            }, i.a.createElement("option", {
              value: ""
            }, r("if2_fields.field_form.not_specified")), n.map(function (e) {
              return i.a.createElement("option", {
                key: "crop-".concat(e.id),
                value: e.id
              }, e.name);
            })), i.a.createElement("input", {
              type: "hidden",
              name: this.model.fieldName("id"),
              value: this.model.cropSerial || ""
            }))), i.a.createElement(zt, {
              label: r("if2_fields.variety"),
              enable: o,
              isMultiSelect: this.model.hasMultipleVarieties,
              multiSelectToggleLabel: r("if2_fields.field_form.field_has_multiple_varieties"),
              singleSelectValue: this.model.varietyDisplayName(this.model.variety),
              selectOptions: this.model.varieties.map(function (e) {
                return {
                  key: e.name,
                  value: e.name,
                  name: e.name
                };
              }),
              selectedItems: this.model.selectedVarieties.map(function (t) {
                return {
                  key: t.name,
                  name: t.name,
                  value: t,
                  hiddenInputs: [{
                    key: "".concat(e.model.fieldName("varieties"), "[][id]"),
                    name: "".concat(e.model.fieldName("varieties"), "[][id]"),
                    value: e.model.varietySerial(t)
                  }, {
                    key: "".concat(e.model.fieldName("varieties"), "[][percent]"),
                    name: "".concat(e.model.fieldName("varieties"), "[][percent]"),
                    value: e.model.varietyPercent(t)
                  }],
                  renderChildren: function (t) {
                    return i.a.createElement(Gt, {
                      value: t.value.percent,
                      errorMessage: e.model.varietyPercentError,
                      onChange: function (r) {
                        return e.changeVarietyPercent(t.name, r);
                      }
                    });
                  },
                  remove: function (t) {
                    return e.removeVariety(t.name);
                  }
                };
              }),
              onSelect: this.changeVariety,
              onToggleMultiSelect: this.toggleMultipleVarieties
            }, this.model.hasMultipleVarieties ? i.a.createElement("div", {
              className: "d-flex align-items-start"
            }, i.a.createElement("label", {
              className: "text-nowrap pr-2"
            }, r("if2_fields.field_form.varieties_accounted_for")), i.a.createElement("input", {
              className: "form-control-plaintext w-auto py-0".concat(this.model.varietyPercentError ? " text-danger" : ""),
              value: "".concat(this.model.varietyPercentSum, " %"),
              readOnly: !0
            })) : null), i.a.createElement(zt, {
              label: r("if2_fields.cultivar"),
              enable: a,
              isMultiSelect: this.model.hasMultipleCultivars,
              multiSelectToggleLabel: r("if2_fields.field_form.field_has_multiple_cultivars"),
              singleSelectValue: this.model.cultivarDisplayName(this.model.cultivar),
              selectOptions: this.model.cultivars.map(function (t) {
                return {
                  key: e.model.cultivarDisplayName(t),
                  value: e.model.cultivarDisplayName(t),
                  name: e.model.cultivarDisplayName(t)
                };
              }),
              selectedItems: this.model.selectedCultivars.map(function (t) {
                return {
                  key: e.model.cultivarDisplayName(t),
                  name: e.model.cultivarDisplayName(t),
                  value: t,
                  hiddenInputs: [{
                    key: "".concat(e.model.fieldName("cultivars"), "[][id]"),
                    name: "".concat(e.model.fieldName("cultivars"), "[][id]"),
                    value: e.model.cultivarSerial(t)
                  }],
                  remove: function (t) {
                    return e.removeCultivar(t.value);
                  }
                };
              }),
              onSelect: this.changeCultivar,
              onToggleMultiSelect: this.toggleMultipleCultivars
            }), i.a.createElement(zt, {
              label: r("if2_fields.use_type"),
              enable: c,
              isMultiSelect: this.model.hasMultipleUseTypes,
              multiSelectToggleLabel: r("if2_fields.field_form.field_has_multiple_use_types"),
              singleSelectValue: this.model.useTypeDisplayName(this.model.useType),
              selectOptions: this.model.useTypes.map(function (e) {
                return {
                  key: e.name,
                  value: e.name,
                  name: e.name
                };
              }),
              selectedItems: this.model.selectedUseTypes.map(function (t) {
                return {
                  key: e.model.useTypeDisplayName(t),
                  name: e.model.useTypeDisplayName(t),
                  value: t,
                  hiddenInputs: [{
                    key: "".concat(e.model.fieldName("use_types"), "[][id]"),
                    name: "".concat(e.model.fieldName("use_types"), "[][id]"),
                    value: e.model.useTypeSerial(t)
                  }],
                  remove: function (t) {
                    return e.removeUseType(t.name);
                  }
                };
              }),
              onSelect: this.changeUseType,
              onToggleMultiSelect: this.toggleMultipleUseTypes
            }), i.a.createElement(zt, {
              label: r("if2_fields.root_stock"),
              enable: l,
              isMultiSelect: this.model.hasMultipleRootStocks,
              multiSelectToggleLabel: r("if2_fields.field_form.field_has_multiple_root_stocks"),
              singleSelectValue: this.model.rootStockDisplayName(this.model.rootStock),
              selectOptions: this.model.rootStocks.map(function (e) {
                return {
                  key: e.name,
                  value: e.name,
                  name: e.name
                };
              }),
              selectedItems: this.model.selectedRootStocks.map(function (t) {
                return {
                  key: t.name,
                  name: t.name,
                  value: t,
                  hiddenInputs: [{
                    key: "".concat(e.model.fieldName("root_stocks"), "[][id]"),
                    name: "".concat(e.model.fieldName("root_stocks"), "[][id]"),
                    value: e.model.rootStockSerial(t)
                  }, {
                    key: "".concat(e.model.fieldName("root_stocks"), "[][percent]"),
                    name: "".concat(e.model.fieldName("root_stocks"), "[][percent]"),
                    value: e.model.rootStockPercent(t)
                  }],
                  renderChildren: function (t) {
                    return i.a.createElement(Gt, {
                      value: t.value.percent,
                      errorMessage: e.model.rootStockPercentError,
                      onChange: function (r) {
                        return e.changeRootStockPercent(t.name, r);
                      }
                    });
                  },
                  remove: function (t) {
                    return e.removeRootStock(t.name);
                  }
                };
              }),
              onSelect: this.changeRootStock,
              onToggleMultiSelect: this.toggleMultipleRootStocks
            }, this.model.hasMultipleRootStocks ? i.a.createElement("div", {
              className: "d-flex align-items-start"
            }, i.a.createElement("label", {
              className: "text-nowrap pr-2"
            }, r("if2_fields.field_form.root_stocks_accounted_for")), i.a.createElement("input", {
              className: "form-control-plaintext w-auto py-0".concat(this.model.rootStockPercentError ? " text-danger" : ""),
              value: "".concat(this.model.rootStockPercentSum, " %"),
              readOnly: !0
            })) : null), o ? i.a.createElement(Or, {
              current: this.model.grafts,
              varieties: this.model.varieties
            }) : null));
          }
        }]) && Er(t.prototype, r), n && Er(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component), Nr = vr.prototype, zr = "model", Dr = [a.observable], Tr = {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }, Fr = {}, Object.keys(Tr).forEach(function (e) {
        Fr[e] = Tr[e];
      }), Fr.enumerable = !!Fr.enumerable, Fr.configurable = !!Fr.configurable, ("value" in Fr || Fr.initializer) && (Fr.writable = !0), Fr = Dr.slice().reverse().reduce(function (e, t) {
        return t(Nr, zr, e) || e;
      }, Fr), Mr && void 0 !== Fr.initializer && (Fr.value = Fr.initializer ? Fr.initializer.call(Mr) : void 0, Fr.initializer = void 0), void 0 === Fr.initializer && (Object.defineProperty(Nr, zr, Fr), Fr = null), gr = Fr, mr = vr)) || mr,
      Ur = U()(Lr);
    function Vr(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function Br(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function qr(e, t) {
      return (qr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function Wr(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = Gr(e);
        if (t) {
          var o = Gr(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return Hr(this, r);
      };
    }
    function Hr(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function Gr(e) {
      return (Gr = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var Jr,
      $r,
      Kr,
      Zr,
      Yr,
      Qr = Object(c.observer)((function (e, t, r, n, o) {
        var i = {};
        Object.keys(n).forEach(function (e) {
          i[e] = n[e];
        }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
          return n(e, t, r) || r;
        }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null);
      }((Ar = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && qr(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = Wr(a);
        function a() {
          return Vr(this, a), o.apply(this, arguments);
        }
        return t = a, (r = [{
          key: "_item",
          get: function () {
            var e = this.props.item;
            if (!e) throw new Error("NamedSelectedItem needs an 'item' property");
            return e;
          }
        }, {
          key: "render",
          value: function () {
            return i.a.createElement(j, {
              i18n: Re
            }, this._item.option.name);
          }
        }]) && Br(t.prototype, r), n && Br(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component)).prototype, "_item", [a.computed], Object.getOwnPropertyDescriptor(Ar.prototype, "_item"), Ar.prototype), Ir = Ar)) || Ir,
      Xr = U()(Qr);
    function en(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function tn(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function rn(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function nn(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    function on(e) {
      return e.map(function (e) {
        if (!("id" in e)) throw new Error("All options must include an 'id' property");
        if (!("name" in e)) throw new Error("All options must include a 'name' property");
        return new sn(e.id, e.name, e.type);
      });
    }
    var an,
      cn,
      ln,
      un,
      sn = ($r = nn((Jr = function e(t, r, n, o) {
        var a = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), rn(this, "id", $r, this), rn(this, "name", Kr, this), rn(this, "type", Zr, this), rn(this, "component", Yr, this), this.renderComponent = function (e, t, r) {
          var n = function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var r = null != arguments[t] ? arguments[t] : {};
                t % 2 ? en(Object(r), !0).forEach(function (t) {
                  tn(e, t, r[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : en(Object(r)).forEach(function (t) {
                  Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
                });
              }
              return e;
            }({
              item: e,
              baseInputName: t
            }, r),
            o = a.component;
          return i.a.createElement(o, n);
        }, this.id = t, this.name = r, this.type = n, this.component = o || Xr;
      }).prototype, "id", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), Kr = nn(Jr.prototype, "name", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), Zr = nn(Jr.prototype, "type", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), Yr = nn(Jr.prototype, "component", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), Jr);
    function pn(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function fn(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    function dn(e, t, r) {
      if (!e) return [];
      return (Array.isArray(e) ? e : [e]).map(function (e) {
        if (!("id" in e)) throw new Error("All items must include an 'id' property");
        if (!(r in e)) throw new Error("All items must include a '".concat(r, "' property"));
        var n = e[r],
          o = t.find(function (e) {
            return e.id == n;
          });
        if (!o) throw new Error("Unable to find option for id: ".concat(n));
        return new wn(e.id, o);
      });
    }
    var yn,
      bn,
      hn,
      mn,
      vn,
      gn,
      wn = (cn = fn((an = function e(t, r) {
        var n = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), pn(this, "id", cn, this), pn(this, "option", ln, this), pn(this, "destroyed", un, this), this.renderComponent = function (e, t) {
          return n.option.renderComponent(n, e, t);
        }, this.id = t, this.option = r, this.destroyed = !1;
      }).prototype, "id", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), ln = fn(an.prototype, "option", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), un = fn(an.prototype, "destroyed", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), an);
    function On(e) {
      return function (e) {
        if (Array.isArray(e)) return _n(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
      }(e) || function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return _n(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === r && e.constructor && (r = e.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(e);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return _n(e, t);
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function _n(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function jn(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function Pn(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function En(e, t) {
      return (En = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function kn(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = Cn(e);
        if (t) {
          var o = Cn(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return xn(this, r);
      };
    }
    function xn(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return Sn(e);
    }
    function Sn(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function Cn(e) {
      return (Cn = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function Rn(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var Nn,
      zn,
      Dn,
      Tn,
      Mn,
      Fn,
      In = Object(c.observer)((bn = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && En(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = kn(a);
        function a(e) {
          var t;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, a), jn(t = o.call(this, e), "_selections", hn, Sn(t)), jn(t, "_handleNewSelection", mn, Sn(t)), jn(t, "_remove", vn, Sn(t)), jn(t, "_pruneSelections", gn, Sn(t)), t._baseInputName = function (e) {
            return "".concat(t._modelName, "[").concat(t._attributeName, "][").concat(e, "]");
          }, t._selections = On(t._initialSelections), t._formId = Object(Jt.uniqueId)("multi-select-"), t;
        }
        return t = a, (r = [{
          key: "_options",
          get: function () {
            var e = this.props.options;
            if (!e) throw new Error("MultiSelect needs an 'options' property");
            return e.forEach(function (e) {
              if (!(e instanceof sn)) throw new Error("MultiSelect requires all options to be SelectOption instances");
            }), e;
          }
        }, {
          key: "_validOptions",
          get: function () {
            var e = this,
              t = this._options;
            return this._supportMultiple ? t.filter(function (t) {
              return !e._currentSelections.find(function (e) {
                return e.option.id == t.id;
              });
            }) : t;
          }
        }, {
          key: "_label",
          get: function () {
            var e = this.props.label;
            if (!e) throw new Error("MultiSelect needs a 'label' property");
            return e;
          }
        }, {
          key: "_relationAttributeName",
          get: function () {
            var e = this.props.relationAttributeName;
            if (!e) throw new Error("MultiSelect needs a 'relationAttributeName' property");
            return e;
          }
        }, {
          key: "_modelName",
          get: function () {
            var e = this.props.modelName;
            if (!e) throw new Error("MultiSelect needs an 'modelName' property");
            return e;
          }
        }, {
          key: "_attributeName",
          get: function () {
            var e = this.props.attributeName;
            if (!e) throw new Error("MultiSelect needs an 'attributeName' property");
            return e;
          }
        }, {
          key: "_supportMultiple",
          get: function () {
            return !0 === this.props.supportMultiple;
          }
        }, {
          key: "_initialSelections",
          get: function () {
            var e = this.props.current;
            if (!e) return [];
            var t = null;
            return (t = Array.isArray(e) ? e : [e]).forEach(function (e) {
              if (!(e instanceof wn)) throw new Error("MultiSelect requires all current objects to be SelectedItem instances");
            }), t;
          }
        }, {
          key: "_currentSelections",
          get: function () {
            return this._selections.filter(function (e) {
              return !e.destroyed;
            });
          }
        }, {
          key: "_optionFromId",
          value: function (e) {
            var t = this._options.find(function (t) {
              return t.id == e;
            });
            if (!t) throw new Error("Unable to find option for id: ".concat(e));
            return t;
          }
        }, {
          key: "_renderEachSelection",
          value: function (e, t) {
            var r = this,
              n = this.props.renderSelectionOptions;
            return i.a.createElement("li", {
              className: "list-group-item d-flex justify-content-between align-items-center",
              key: e.option.id,
              "data-testid": "selection-item-".concat(e.option.id)
            }, i.a.createElement("div", {
              className: "col"
            }, e.renderComponent(this._baseInputName(t), n)), i.a.createElement("a", {
              href: "#",
              onClick: function (t) {
                t.preventDefault(), r._remove(e);
              }
            }, i.a.createElement(Ot.FontAwesomeIcon, {
              icon: _t.faTimes
            })));
          }
        }, {
          key: "_renderSelections",
          value: function () {
            var e = this;
            if (this._supportMultiple && this._currentSelections.length > 0) return i.a.createElement("div", {
              className: "row form-group"
            }, i.a.createElement("div", {
              className: "col"
            }, i.a.createElement("ul", {
              className: "list-group"
            }, this._selections.map(function (t, r) {
              return t.destroyed ? null : e._renderEachSelection(t, r);
            }))));
          }
        }, {
          key: "_renderFormItemInputs",
          value: function (e, t) {
            var r = this._baseInputName(t),
              n = "".concat(r, "[id]"),
              o = "".concat(r, "[_destroy]"),
              a = "".concat(r, "[").concat(this._relationAttributeName, "]");
            return i.a.createElement(i.a.Fragment, {
              key: r
            }, i.a.createElement("input", {
              type: "hidden",
              name: a,
              value: e.option.id
            }), null !== e.id ? i.a.createElement("input", {
              type: "hidden",
              name: n,
              value: e.id
            }) : null, null !== e.id && e.destroyed ? i.a.createElement("input", {
              type: "hidden",
              name: o,
              value: !0
            }) : null);
          }
        }, {
          key: "_renderFormItems",
          value: function () {
            var e = this;
            return i.a.createElement(i.a.Fragment, null, this._selections.map(function (t, r) {
              return e._renderFormItemInputs(t, r);
            }));
          }
        }, {
          key: "_renderOptions",
          value: function () {
            var e = !0,
              t = {};
            if (this._validOptions.forEach(function (r) {
              r.type ? (r.type in t || (t[r.type] = []), t[r.type].push(r)) : e = !1;
            }), e) {
              var r = Object.keys(t).sort();
              return i.a.createElement(i.a.Fragment, null, r.map(function (e) {
                return i.a.createElement("optgroup", {
                  key: e,
                  label: e
                }, t[e].map(function (e) {
                  return i.a.createElement("option", {
                    key: e.id,
                    value: e.id
                  }, e.name);
                }));
              }));
            }
            return i.a.createElement(i.a.Fragment, null, this._validOptions.sort(Ue.sortByName).map(function (e) {
              return i.a.createElement("option", {
                key: e.id,
                value: e.id
              }, e.name);
            }));
          }
        }, {
          key: "render",
          value: function () {
            var e = "".concat(this._formId, "-select"),
              t = this.props.t;
            return i.a.createElement(j, {
              i18n: Re
            }, i.a.createElement("div", {
              className: "row form-group mb-0"
            }, i.a.createElement("div", {
              className: "col-md-auto"
            }, i.a.createElement("label", {
              className: "pr-3",
              htmlFor: e
            }, this._label))), i.a.createElement("div", {
              className: "row form-group"
            }, i.a.createElement("div", {
              className: "col"
            }, i.a.createElement("select", {
              id: e,
              className: "form-control",
              value: this._supportMultiple ? "" : this._currentSelections.length > 0 ? this._currentSelections[0].option.id : "",
              onChange: this._handleNewSelection
            }, i.a.createElement("option", {
              value: ""
            }, this._supportMultiple ? t("if2_fields.field_form.add_label", {
              label: this._label
            }) : t("if2_fields.field_form.not_specified"), " "), this._renderOptions()))), this._renderSelections(), this._renderFormItems());
          }
        }]) && Pn(t.prototype, r), n && Pn(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component), hn = Rn(bn.prototype, "_selections", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return [];
        }
      }), Rn(bn.prototype, "_options", [a.computed], Object.getOwnPropertyDescriptor(bn.prototype, "_options"), bn.prototype), Rn(bn.prototype, "_validOptions", [a.computed], Object.getOwnPropertyDescriptor(bn.prototype, "_validOptions"), bn.prototype), Rn(bn.prototype, "_label", [a.computed], Object.getOwnPropertyDescriptor(bn.prototype, "_label"), bn.prototype), Rn(bn.prototype, "_relationAttributeName", [a.computed], Object.getOwnPropertyDescriptor(bn.prototype, "_relationAttributeName"), bn.prototype), Rn(bn.prototype, "_modelName", [a.computed], Object.getOwnPropertyDescriptor(bn.prototype, "_modelName"), bn.prototype), Rn(bn.prototype, "_attributeName", [a.computed], Object.getOwnPropertyDescriptor(bn.prototype, "_attributeName"), bn.prototype), Rn(bn.prototype, "_supportMultiple", [a.computed], Object.getOwnPropertyDescriptor(bn.prototype, "_supportMultiple"), bn.prototype), Rn(bn.prototype, "_initialSelections", [a.computed], Object.getOwnPropertyDescriptor(bn.prototype, "_initialSelections"), bn.prototype), Rn(bn.prototype, "_currentSelections", [a.computed], Object.getOwnPropertyDescriptor(bn.prototype, "_currentSelections"), bn.prototype), mn = Rn(bn.prototype, "_handleNewSelection", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            var r = t.target.value,
              n = null;
            if (r) {
              var o = e._optionFromId(t.target.value);
              (n = e._selections.find(function (e) {
                return e.option.id == o.id;
              })) ? n.destroyed = !1 : (n = new wn(null, o), e._selections.push(n));
            }
            e._supportMultiple || (e._selections.map(function (e) {
              return n && e.option.id === n.option.id || (e.destroyed = !0), e;
            }), e._pruneSelections());
          };
        }
      }), vn = Rn(bn.prototype, "_remove", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            t.destroyed = !0, e._pruneSelections();
          };
        }
      }), gn = Rn(bn.prototype, "_pruneSelections", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function () {
            e._selections = e._selections.filter(function (e) {
              return null !== e.id || !e.destroyed;
            });
          };
        }
      }), yn = bn)) || yn,
      An = U()(In),
      Ln = r(12),
      Un = r.n(Ln),
      Vn = r(10);
    function Bn(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function qn(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function Wn(e, t) {
      return (Wn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function Hn(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = $n(e);
        if (t) {
          var o = $n(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return Gn(this, r);
      };
    }
    function Gn(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return Jn(e);
    }
    function Jn(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function $n(e) {
      return ($n = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function Kn(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var Zn,
      Yn,
      Qn,
      Xn,
      eo = Object(c.observer)((zn = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && Wn(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = Hn(a);
        function a(e) {
          var t;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, a), Bn(t = o.call(this, e), "currentUnit", Dn, Jn(t)), Bn(t, "currentValue", Tn, Jn(t)), Bn(t, "updateValue", Mn, Jn(t)), Bn(t, "updateUnit", Fn, Jn(t));
          var r = t.props,
            n = r.current,
            i = r.unitList,
            c = t.props,
            l = c.currentUnit,
            u = c.currentValue;
          if (n) {
            var s = new Ue.Quantity(n);
            u = "".concat(s.scalar), l = s.units;
          }
          return t.currentUnit = l || new Vn.UnitChoiceModel(i[0]).value || "", t.currentValue = u || "", t;
        }
        return t = a, (r = [{
          key: "current",
          get: function () {
            var e, t;
            return this.currentValue || "0" === this.currentValue || "dry" === (null === (e = this.currentUnit) || void 0 === e || null === (t = e.toLowerCase) || void 0 === t ? void 0 : t.call(e)) ? [this.currentValue, this.currentUnit].filter(Boolean).join(" ") : "";
          }
        }, {
          key: "unitChoices",
          get: function () {
            var e = this,
              t = this.props.unitList.map(function (e) {
                return new Vn.UnitChoiceModel(e);
              });
            return this.currentUnit && !t.find(function (t) {
              return e.currentUnit === t.value;
            }) ? [new Vn.UnitChoiceModel(this.currentUnit)].concat(t) : t;
          }
        }, {
          key: "_valueColumnClassName",
          get: function () {
            var e = this.props.valueColumnClassName;
            return e || "col-6";
          }
        }, {
          key: "_unitColumnClassName",
          get: function () {
            var e = this.props.unitColumnClassName;
            return e || "col-4";
          }
        }, {
          key: "render",
          value: function () {
            var e = this.props,
              t = e.name,
              r = e.placeholder;
            return i.a.createElement(i.a.Fragment, null, i.a.createElement("input", {
              type: "hidden",
              name: t,
              value: this.current
            }), i.a.createElement(Vn.UnitSelector, {
              placeholder: r,
              valueColumnClassName: this._valueColumnClassName,
              unitColumnClassName: this._unitColumnClassName,
              currentUnit: this.currentUnit,
              currentValue: this.currentValue,
              onUpdateValue: this.updateValue,
              onUpdateUnit: this.updateUnit,
              unitChoices: this.unitChoices
            }));
          }
        }]) && qn(t.prototype, r), n && qn(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component), Dn = Kn(zn.prototype, "currentUnit", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), Tn = Kn(zn.prototype, "currentValue", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), Kn(zn.prototype, "current", [a.computed], Object.getOwnPropertyDescriptor(zn.prototype, "current"), zn.prototype), Kn(zn.prototype, "unitChoices", [a.computed], Object.getOwnPropertyDescriptor(zn.prototype, "unitChoices"), zn.prototype), Kn(zn.prototype, "_valueColumnClassName", [a.computed], Object.getOwnPropertyDescriptor(zn.prototype, "_valueColumnClassName"), zn.prototype), Kn(zn.prototype, "_unitColumnClassName", [a.computed], Object.getOwnPropertyDescriptor(zn.prototype, "_unitColumnClassName"), zn.prototype), Mn = Kn(zn.prototype, "updateValue", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            e.currentValue = t;
          };
        }
      }), Fn = Kn(zn.prototype, "updateUnit", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            e.currentUnit = t;
          };
        }
      }), Nn = zn)) || Nn;
    function to(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function ro(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function no(e, t) {
      return (no = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function oo(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = co(e);
        if (t) {
          var o = co(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return io(this, r);
      };
    }
    function io(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return ao(e);
    }
    function ao(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function co(e) {
      return (co = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function lo(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var uo,
      so,
      po,
      fo,
      yo,
      bo = Object(c.observer)((Yn = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && no(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = oo(a);
        function a(e) {
          var t;
          if (function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, a), to(t = o.call(this, e), "_rate", Qn, ao(t)), to(t, "_rateUnit", Xn, ao(t)), "waterRate" in t._item) if (t._item.waterRate) {
            var r = Un()(t._item.waterRate);
            t._rate = r.scalar, t._rateUnit = r.units();
          } else t._rate = "";
          return t;
        }
        return t = a, (r = [{
          key: "_item",
          get: function () {
            var e = this.props.item;
            if (!e) throw new Error("SelectedWaterCoolingTypeItem needs an 'item' property");
            return e;
          }
        }, {
          key: "_baseInputName",
          get: function () {
            var e = this.props.baseInputName;
            if (!e) throw new Error("SelectedWaterCoolingTypeItem needs a 'baseInputName' property");
            return e;
          }
        }, {
          key: "render",
          value: function () {
            var e = this.props.t;
            return i.a.createElement(j, {
              i18n: Re
            }, i.a.createElement("div", {
              className: "row align-items-center"
            }, i.a.createElement("div", {
              className: "col-2"
            }, this._item.option.name), i.a.createElement(eo, {
              name: "".concat(this._baseInputName, "[water_rate]"),
              placeholder: e("if2_fields.rate"),
              unitList: ["gal/h", "gal/min", "l/h", "l/min"],
              currentValue: this._rate,
              currentUnit: this._rateUnit
            })));
          }
        }]) && ro(t.prototype, r), n && ro(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component), Qn = lo(Yn.prototype, "_rate", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return "";
        }
      }), Xn = lo(Yn.prototype, "_rateUnit", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return "gal/h";
        }
      }), lo(Yn.prototype, "_item", [a.computed], Object.getOwnPropertyDescriptor(Yn.prototype, "_item"), Yn.prototype), lo(Yn.prototype, "_baseInputName", [a.computed], Object.getOwnPropertyDescriptor(Yn.prototype, "_baseInputName"), Yn.prototype), Zn = Yn)) || Zn,
      ho = U()(bo);
    function mo(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function vo(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function go(e, t) {
      return (go = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function wo(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = jo(e);
        if (t) {
          var o = jo(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return Oo(this, r);
      };
    }
    function Oo(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return _o(e);
    }
    function _o(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function jo(e) {
      return (jo = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function Po(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var Eo,
      ko,
      xo = Object(c.observer)((so = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && go(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = wo(a);
        function a(e) {
          var t;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, a), mo(t = o.call(this, e), "_color", po, _o(t)), mo(t, "_percentage", fo, _o(t)), mo(t, "_onChange", yo, _o(t)), "shadeColor" in t._item && (t._color = t._item.shadeColor), "percentage" in t._item && (t._percentage = (100 * t._item.percentage).toFixed()), t;
        }
        return t = a, (r = [{
          key: "_item",
          get: function () {
            var e = this.props.item;
            if (!e) throw new Error("SelectedShadeCoolingTypeItem needs an 'item' property");
            return e;
          }
        }, {
          key: "_baseInputName",
          get: function () {
            var e = this.props.baseInputName;
            if (!e) throw new Error("SelectedShadeCoolingTypeItem needs a 'baseInputName' property");
            return e;
          }
        }, {
          key: "render",
          value: function () {
            var e = this.props.t;
            return i.a.createElement(j, {
              i18n: Re
            }, i.a.createElement("div", {
              className: "row align-items-center"
            }, i.a.createElement("div", {
              className: "col-2"
            }, this._item.option.name), i.a.createElement("div", {
              className: "col-4"
            }, i.a.createElement("input", {
              type: "text",
              className: "form-control",
              placeholder: e("if2_fields.shade_color"),
              name: "".concat(this._baseInputName, "[shade_color]"),
              defaultValue: this._color
            })), i.a.createElement("div", {
              className: "col-6"
            }, i.a.createElement("div", {
              className: "input-group align-items-center percent-input"
            }, i.a.createElement("input", {
              type: "range",
              className: "form-control custom-range",
              min: "0",
              max: "100",
              value: this._percentage,
              onChange: this._onChange
            }), i.a.createElement("div", {
              className: "input-group-append"
            }, i.a.createElement("input", {
              className: "form-control",
              type: "number",
              value: this._percentage,
              onChange: this._onChange
            }), i.a.createElement("span", {
              className: "input-group-text"
            }, "%")))), i.a.createElement("input", {
              type: "hidden",
              name: "".concat(this._baseInputName, "[percentage]"),
              value: this._percentage / 100
            })));
          }
        }]) && vo(t.prototype, r), n && vo(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component), po = Po(so.prototype, "_color", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return "";
        }
      }), fo = Po(so.prototype, "_percentage", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return 0;
        }
      }), Po(so.prototype, "_item", [a.computed], Object.getOwnPropertyDescriptor(so.prototype, "_item"), so.prototype), Po(so.prototype, "_baseInputName", [a.computed], Object.getOwnPropertyDescriptor(so.prototype, "_baseInputName"), so.prototype), yo = Po(so.prototype, "_onChange", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            e._percentage = t.target.value, e._percentage < 0 && (e._percentage = 0), e._percentage > 100 && (e._percentage = 100);
          };
        }
      }), uo = so)) || uo,
      So = U()(xo);
    function Co(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Ro(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Co(Object(r), !0).forEach(function (t) {
          No(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Co(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function No(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function zo(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function Do(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function To(e, t) {
      return (To = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function Mo(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = Io(e);
        if (t) {
          var o = Io(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return Fo(this, r);
      };
    }
    function Fo(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function Io(e) {
      return (Io = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function Ao(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var Lo,
      Uo,
      Vo,
      Bo = Object(c.observer)((Ao((ko = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && To(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = Mo(a);
        function a() {
          return zo(this, a), o.apply(this, arguments);
        }
        return t = a, (r = [{
          key: "_options",
          get: function () {
            var e = this.props.options;
            if (!e) throw new Error("CoolingTypeMultiSelect needs an 'options' property");
            return on(e).map(function (e) {
              if (!e.type) throw new Error("CoolingTypeMultiSelect requires all options to have a type");
              var t = e.type.split("::");
              return e.type = t[t.length - 1], "Water" === e.type ? e.component = ho : "Shade" === e.type && (e.component = So), e;
            });
          }
        }, {
          key: "_current",
          get: function () {
            var e = this.props.current;
            return dn(e, this._options, this._relationAttributeName).map(function (t) {
              var r = e.find(function (e) {
                return e.id == t.id;
              });
              if (!r) throw new Error("Unable to find selection with id: ".concat(t.id));
              return t.percentage = r.percentage, t.waterRate = r.water_rate, t.shadeColor = r.shade_color, t;
            });
          }
        }, {
          key: "_relationAttributeName",
          get: function () {
            var e = this.props.relationAttributeName;
            if (!e) throw new Error("CoolingTypeMultiSelect needs a 'relationAttributeName' property");
            return e;
          }
        }, {
          key: "render",
          value: function () {
            var e = Ro(Ro({}, this.props), {}, {
              options: this._options,
              current: this._current
            });
            return i.a.createElement(j, {
              i18n: Re
            }, i.a.createElement(An, e));
          }
        }]) && Do(t.prototype, r), n && Do(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(i.a.Component)).prototype, "_options", [a.computed], Object.getOwnPropertyDescriptor(ko.prototype, "_options"), ko.prototype), Ao(ko.prototype, "_current", [a.computed], Object.getOwnPropertyDescriptor(ko.prototype, "_current"), ko.prototype), Ao(ko.prototype, "_relationAttributeName", [a.computed], Object.getOwnPropertyDescriptor(ko.prototype, "_relationAttributeName"), ko.prototype), Eo = ko)) || Eo,
      qo = U()(Bo);
    function Wo(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function Ho(e, t) {
      return (Ho = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function Go(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = Ko(e);
        if (t) {
          var o = Ko(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return Jo(this, r);
      };
    }
    function Jo(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return $o(e);
    }
    function $o(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function Ko(e) {
      return (Ko = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function Zo(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var Yo,
      Qo,
      Xo = Object(c.observer)((Uo = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && Ho(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = Go(a);
        function a(e) {
          var t;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, a), function (e, t, r, n) {
            r && Object.defineProperty(e, t, {
              enumerable: r.enumerable,
              configurable: r.configurable,
              writable: r.writable,
              value: r.initializer ? r.initializer.call(n) : void 0
            });
          }(t = o.call(this, e), "_brand", Vo, $o(t)), "brand" in t._item && (t._brand = t._item.brand), t;
        }
        return t = a, (r = [{
          key: "_item",
          get: function () {
            var e = this.props.item;
            if (!e) throw new Error("SelectedIrrigationMonitoringTypeItem needs an 'item' property");
            return e;
          }
        }, {
          key: "_baseInputName",
          get: function () {
            var e = this.props.baseInputName;
            if (!e) throw new Error("SelectedIrrigationMonitoringTypeItem needs a 'baseInputName' property");
            return e;
          }
        }, {
          key: "render",
          value: function () {
            var e = this.props.t;
            return i.a.createElement(j, {
              i18n: Re
            }, i.a.createElement("div", {
              className: "row align-items-center"
            }, i.a.createElement("div", {
              className: "col"
            }, this._item.option.name), i.a.createElement("div", {
              className: "col"
            }, i.a.createElement("input", {
              type: "text",
              className: "form-control",
              placeholder: e("if2_fields.brand"),
              name: "".concat(this._baseInputName, "[brand]"),
              defaultValue: this._brand
            }))));
          }
        }]) && Wo(t.prototype, r), n && Wo(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(i.a.Component), Vo = Zo(Uo.prototype, "_brand", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return "";
        }
      }), Zo(Uo.prototype, "_item", [a.computed], Object.getOwnPropertyDescriptor(Uo.prototype, "_item"), Uo.prototype), Zo(Uo.prototype, "_baseInputName", [a.computed], Object.getOwnPropertyDescriptor(Uo.prototype, "_baseInputName"), Uo.prototype), Lo = Uo)) || Lo,
      ei = U()(Xo);
    function ti(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function ri(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? ti(Object(r), !0).forEach(function (t) {
          ni(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ti(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function ni(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function oi(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function ii(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function ai(e, t) {
      return (ai = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function ci(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = ui(e);
        if (t) {
          var o = ui(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return li(this, r);
      };
    }
    function li(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function ui(e) {
      return (ui = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function si(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var pi,
      fi,
      di,
      yi,
      bi = Object(c.observer)((si((Qo = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && ai(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = ci(a);
        function a() {
          return oi(this, a), o.apply(this, arguments);
        }
        return t = a, (r = [{
          key: "_options",
          get: function () {
            var e = this.props.options;
            if (!e) throw new Error("IrrigationMonitoringTypeMultiSelect needs an 'options' property");
            return on(e).map(function (e) {
              return e.component = ei, e;
            });
          }
        }, {
          key: "_current",
          get: function () {
            var e = this.props.current;
            return dn(e, this._options, this._relationAttributeName).map(function (t) {
              var r = e.find(function (e) {
                return e.id == t.id;
              });
              if (!r) throw new Error("Unable to find selection with id: ".concat(t.id));
              return t.brand = r.brand, t;
            });
          }
        }, {
          key: "_relationAttributeName",
          get: function () {
            var e = this.props.relationAttributeName;
            if (!e) throw new Error("IrrigationMonitoringTypeMultiSelect needs a 'relationAttributeName' property");
            return e;
          }
        }, {
          key: "render",
          value: function () {
            var e = ri(ri({}, this.props), {}, {
              options: this._options,
              current: this._current
            });
            return i.a.createElement(j, {
              i18n: Re
            }, i.a.createElement(An, e));
          }
        }]) && ii(t.prototype, r), n && ii(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(i.a.Component)).prototype, "_options", [a.computed], Object.getOwnPropertyDescriptor(Qo.prototype, "_options"), Qo.prototype), si(Qo.prototype, "_current", [a.computed], Object.getOwnPropertyDescriptor(Qo.prototype, "_current"), Qo.prototype), si(Qo.prototype, "_relationAttributeName", [a.computed], Object.getOwnPropertyDescriptor(Qo.prototype, "_relationAttributeName"), Qo.prototype), Yo = Qo)) || Yo,
      hi = U()(bi);
    function mi(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function vi(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function gi(e, t) {
      return (gi = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function wi(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = ji(e);
        if (t) {
          var o = ji(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return Oi(this, r);
      };
    }
    function Oi(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return _i(e);
    }
    function _i(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function ji(e) {
      return (ji = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function Pi(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var Ei,
      ki,
      xi = Object(c.observer)((fi = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && gi(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = wi(a);
        function a(e) {
          var t;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, a), mi(t = o.call(this, e), "_percentage", di, _i(t)), mi(t, "_onChange", yi, _i(t)), "percentage" in t._item && (t._percentage = (100 * t._item.percentage).toFixed()), t;
        }
        return t = a, (r = [{
          key: "_item",
          get: function () {
            var e = this.props.item;
            if (!e) throw new Error("SelectedSoilTypeItem needs an 'item' property");
            return e;
          }
        }, {
          key: "_baseInputName",
          get: function () {
            var e = this.props.baseInputName;
            if (!e) throw new Error("SelectedSoilTypeItem needs a 'baseInputName' property");
            return e;
          }
        }, {
          key: "render",
          value: function () {
            return i.a.createElement(j, {
              i18n: Re
            }, i.a.createElement("div", {
              className: "row align-items-center"
            }, i.a.createElement("div", {
              className: "col-4"
            }, this._item.option.name), i.a.createElement("div", {
              className: "col-8"
            }, i.a.createElement("div", {
              className: "input-group align-items-center percent-input"
            }, i.a.createElement("input", {
              type: "range",
              className: "form-control custom-range",
              min: "0",
              max: "100",
              value: this._percentage,
              onChange: this._onChange
            }), i.a.createElement("div", {
              className: "input-group-append"
            }, i.a.createElement("input", {
              className: "form-control",
              type: "number",
              value: this._percentage,
              onChange: this._onChange
            }), i.a.createElement("span", {
              className: "input-group-text"
            }, "%")))), i.a.createElement("input", {
              type: "hidden",
              name: "".concat(this._baseInputName, "[percentage]"),
              value: this._percentage / 100
            })));
          }
        }]) && vi(t.prototype, r), n && vi(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component), di = Pi(fi.prototype, "_percentage", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return 0;
        }
      }), Pi(fi.prototype, "_item", [a.computed], Object.getOwnPropertyDescriptor(fi.prototype, "_item"), fi.prototype), Pi(fi.prototype, "_baseInputName", [a.computed], Object.getOwnPropertyDescriptor(fi.prototype, "_baseInputName"), fi.prototype), yi = Pi(fi.prototype, "_onChange", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            e._percentage = t.target.value;
            var r = e.props.onPercentageChanged;
            r && (e._percentage = r(e._item, e._percentage)), e._percentage < 0 && (e._percentage = 0), e._percentage > 100 && (e._percentage = 100);
          };
        }
      }), pi = fi)) || pi,
      Si = U()(xi);
    function Ci(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Ri(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Ci(Object(r), !0).forEach(function (t) {
          Ni(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ci(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function Ni(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function zi(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function Di(e, t) {
      return (Di = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function Ti(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = Fi(e);
        if (t) {
          var o = Fi(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return Mi(this, r);
      };
    }
    function Mi(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function Fi(e) {
      return (Fi = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function Ii(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var Ai,
      Li,
      Ui = Object(c.observer)((Ii((ki = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && Di(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = Ti(a);
        function a(e) {
          var t;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, a), (t = o.call(this, e))._onPercentageChanged = function (e, r) {
            var n = Object(Jt.cloneDeep)(t._percentages);
            n[e.option.name] = r;
            var o = Object.values(n).reduce(function (e, t) {
                return parseInt(e, 10) + parseInt(t, 10);
              }),
              i = r;
            return o > 100 && (i -= o - 100), t._percentages[e.option.name] = i, i;
          }, t._percentages = {}, t;
        }
        return t = a, (r = [{
          key: "_options",
          get: function () {
            var e = this.props.options;
            if (!e) throw new Error("SoilClassificationMultiSelect needs an 'options' property");
            return on(e).map(function (e) {
              return e.component = Si, e;
            });
          }
        }, {
          key: "_current",
          get: function () {
            var e = this.props.current;
            return dn(e, this._options, this._relationAttributeName).map(function (t) {
              var r = e.find(function (e) {
                return e.id == t.id;
              });
              if (!r) throw new Error("Unable to find selection with id: ".concat(t.id));
              return t.percentage = r.percentage, t;
            });
          }
        }, {
          key: "_relationAttributeName",
          get: function () {
            var e = this.props.relationAttributeName;
            if (!e) throw new Error("SoilClassificationMultiSelect needs a 'relationAttributeName' property");
            return e;
          }
        }, {
          key: "render",
          value: function () {
            var e = Ri(Ri({}, this.props), {}, {
              options: this._options,
              current: this._current,
              renderSelectionOptions: {
                onPercentageChanged: this._onPercentageChanged
              }
            });
            return i.a.createElement(An, e);
          }
        }]) && zi(t.prototype, r), n && zi(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(i.a.Component)).prototype, "_options", [a.computed], Object.getOwnPropertyDescriptor(ki.prototype, "_options"), ki.prototype), Ii(ki.prototype, "_current", [a.computed], Object.getOwnPropertyDescriptor(ki.prototype, "_current"), ki.prototype), Ii(ki.prototype, "_relationAttributeName", [a.computed], Object.getOwnPropertyDescriptor(ki.prototype, "_relationAttributeName"), ki.prototype), Ei = ki)) || Ei;
    function Vi(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Bi(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Vi(Object(r), !0).forEach(function (t) {
          qi(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Vi(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function qi(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function Wi(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function Hi(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function Gi(e, t) {
      return (Gi = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function Ji(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = Ki(e);
        if (t) {
          var o = Ki(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return $i(this, r);
      };
    }
    function $i(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function Ki(e) {
      return (Ki = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function Zi(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var Yi,
      Qi,
      Xi,
      ea,
      ta,
      ra,
      na = Object(c.observer)((Zi((Li = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && Gi(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = Ji(a);
        function a() {
          return Wi(this, a), o.apply(this, arguments);
        }
        return t = a, (r = [{
          key: "_options",
          get: function () {
            var e = this.props.options;
            if (!e) throw new Error("NestedAttributesMultiSelect needs an 'options' property");
            return on(e);
          }
        }, {
          key: "_current",
          get: function () {
            return dn(this.props.current, this._options, this._relationAttributeName);
          }
        }, {
          key: "_relationAttributeName",
          get: function () {
            var e = this.props.relationAttributeName;
            if (!e) throw new Error("NestedAttributesMultiSelect needs a 'relationAttributeName' property");
            return e;
          }
        }, {
          key: "render",
          value: function () {
            var e = Bi(Bi({}, this.props), {}, {
              options: this._options,
              current: this._current
            });
            return i.a.createElement(j, {
              i18n: Re
            }, i.a.createElement(An, e));
          }
        }]) && Hi(t.prototype, r), n && Hi(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(i.a.Component)).prototype, "_options", [a.computed], Object.getOwnPropertyDescriptor(Li.prototype, "_options"), Li.prototype), Zi(Li.prototype, "_current", [a.computed], Object.getOwnPropertyDescriptor(Li.prototype, "_current"), Li.prototype), Zi(Li.prototype, "_relationAttributeName", [a.computed], Object.getOwnPropertyDescriptor(Li.prototype, "_relationAttributeName"), Li.prototype), Ai = Li)) || Ai,
      oa = U()(na);
    function ia(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function aa(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function ca(e, t) {
      return (ca = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function la(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = pa(e);
        if (t) {
          var o = pa(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return ua(this, r);
      };
    }
    function ua(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return sa(e);
    }
    function sa(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function pa(e) {
      return (pa = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function fa(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var da = Object(c.observer)((Qi = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && ca(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = la(a);
        function a(e) {
          var t;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, a), ia(t = o.call(this, e), "_organicState", Xi, sa(t)), ia(t, "_organicDate", ea, sa(t)), ia(t, "_transitionalDate", ta, sa(t)), ia(t, "_changeOrganicState", ra, sa(t)), t._renderTransitionalDate = function (e) {
            return t._organic || t._transitional ? i.a.createElement("div", {
              className: "form-group"
            }, i.a.createElement("label", null, e("if2_fields.transitional_date")), i.a.createElement("input", {
              type: "date",
              name: "field[transitional_date]",
              className: "form-control",
              placeholder: e("if2_fields.transitional_date"),
              defaultValue: t._transitionalDate
            }), i.a.createElement("small", {
              className: "form-text text-muted"
            }, e("if2_fields.date_began_organic_transition"))) : null;
          }, t._renderOrganicDate = function (e) {
            return t._organic ? i.a.createElement("div", {
              className: "form-group"
            }, i.a.createElement("label", null, e("if2_fields.declaration_date_label")), i.a.createElement("input", {
              type: "date",
              name: "field[organic_date]",
              className: "form-control",
              placeholder: e("if2_fields.declaration_date"),
              defaultValue: t._organicDate
            }), i.a.createElement("small", {
              className: "form-text text-muted"
            }, e("if2_fields.date_completed_organic_transition"))) : null;
          };
          var r = e.organic,
            n = e.organicDate,
            c = e.transitional,
            l = e.transitionalDate;
          if (void 0 === r) throw new Error("OrganicSelector needs an organic property");
          if (void 0 === n) throw new Error("OrganicSelector needs an organicDate property");
          if (void 0 === c) throw new Error("OrganicSelector needs a transitional property");
          if (void 0 === l) throw new Error("OrganicSelector needs a transitionalDate property");
          return t._organicDate = n, t._transitionalDate = l, t._organicState = r ? "yes" : c ? "transitioning" : "no", t;
        }
        return t = a, (r = [{
          key: "_organic",
          get: function () {
            return "yes" === this._organicState;
          }
        }, {
          key: "_transitional",
          get: function () {
            return "transitioning" === this._organicState;
          }
        }, {
          key: "render",
          value: function () {
            var e = this,
              t = this.props.t;
            return i.a.createElement(j, {
              i18n: Re
            }, i.a.createElement("div", {
              className: "form-group"
            }, i.a.createElement("label", {
              htmlFor: "organic-state-select"
            }, t("if2_fields.organic")), i.a.createElement("select", {
              className: "form-control",
              id: "organic-state-select",
              value: this._organicState,
              onChange: function (t) {
                return e._changeOrganicState(t.target.value);
              }
            }, i.a.createElement("option", {
              value: "no"
            }, t("if2_fields.field_form.organic_state.not_organic")), i.a.createElement("option", {
              value: "transitioning"
            }, t("if2_fields.field_form.organic_state.transitioning")), i.a.createElement("option", {
              value: "yes"
            }, t("if2_fields.field_form.organic_state.organic")))), this._renderTransitionalDate(t), this._renderOrganicDate(t), i.a.createElement("input", {
              type: "hidden",
              name: "field[organic]",
              value: this._organic
            }), i.a.createElement("input", {
              type: "hidden",
              name: "field[transitional]",
              value: this._transitional
            }));
          }
        }]) && aa(t.prototype, r), n && aa(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(i.a.Component), Xi = fa(Qi.prototype, "_organicState", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), ea = fa(Qi.prototype, "_organicDate", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), ta = fa(Qi.prototype, "_transitionalDate", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), fa(Qi.prototype, "_organic", [a.computed], Object.getOwnPropertyDescriptor(Qi.prototype, "_organic"), Qi.prototype), fa(Qi.prototype, "_transitional", [a.computed], Object.getOwnPropertyDescriptor(Qi.prototype, "_transitional"), Qi.prototype), ra = fa(Qi.prototype, "_changeOrganicState", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            e._organicState = t;
          };
        }
      }), Yi = Qi)) || Yi,
      ya = U()(da),
      ba = r(19);
    function ha() {
      return (ha = Object.assign ? Object.assign.bind() : function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
      }).apply(this, arguments);
    }
    function ma(e, t) {
      if (null == e) return {};
      var r,
        n,
        o = {},
        i = Object.keys(e);
      for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
      return o;
    }
    var va,
      ga = r(6),
      wa = r.n(ga);
    var Oa = Function.prototype.bind.call(Function.prototype.call, [].slice);
    function _a(e, t) {
      return Oa(e.querySelectorAll(t));
    }
    var ja = !("undefined" == typeof window || !window.document || !window.document.createElement),
      Pa = !1,
      Ea = !1;
    try {
      var ka = {
        get passive() {
          return Pa = !0;
        },
        get once() {
          return Ea = Pa = !0;
        }
      };
      ja && (window.addEventListener("test", ka, ka), window.removeEventListener("test", ka, !0));
    } catch (e) {}
    var xa = function (e, t, r, n) {
        if (n && "boolean" != typeof n && !Ea) {
          var o = n.once,
            i = n.capture,
            a = r;
          !Ea && o && (a = r.__once || function e(n) {
            this.removeEventListener(t, e, i), r.call(this, n);
          }, r.__once = a), e.addEventListener(t, a, Pa ? n : i);
        }
        e.addEventListener(t, r, n);
      },
      Sa = r(3),
      Ca = r.n(Sa);
    function Ra() {
      return (Ra = Object.assign ? Object.assign.bind() : function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
      }).apply(this, arguments);
    }
    function Na(e, t) {
      if (null == e) return {};
      var r,
        n,
        o = {},
        i = Object.keys(e);
      for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
      return o;
    }
    r(25);
    function za(e) {
      return "default" + e.charAt(0).toUpperCase() + e.substr(1);
    }
    function Da(e) {
      var t = function (e, t) {
        if ("object" != typeof e || null === e) return e;
        var r = e[Symbol.toPrimitive];
        if (void 0 !== r) {
          var n = r.call(e, t || "default");
          if ("object" != typeof n) return n;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === t ? String : Number)(e);
      }(e, "string");
      return "symbol" == typeof t ? t : String(t);
    }
    function Ta(e, t, r) {
      var n = Object(o.useRef)(void 0 !== e),
        i = Object(o.useState)(t),
        a = i[0],
        c = i[1],
        l = void 0 !== e,
        u = n.current;
      return n.current = l, !l && u && a !== t && c(t), [l ? e : a, Object(o.useCallback)(function (e) {
        for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++) n[o - 1] = arguments[o];
        r && r.apply(void 0, [e].concat(n)), c(e);
      }, [r])];
    }
    function Ma() {
      var e = this.constructor.getDerivedStateFromProps(this.props, this.state);
      null != e && this.setState(e);
    }
    function Fa(e) {
      this.setState(function (t) {
        var r = this.constructor.getDerivedStateFromProps(e, t);
        return null != r ? r : null;
      }.bind(this));
    }
    function Ia(e, t) {
      try {
        var r = this.props,
          n = this.state;
        this.props = e, this.state = t, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(r, n);
      } finally {
        this.props = r, this.state = n;
      }
    }
    Ma.__suppressDeprecationWarning = !0, Fa.__suppressDeprecationWarning = !0, Ia.__suppressDeprecationWarning = !0;
    function Aa(e) {
      var t = Object(o.useRef)(null);
      return Object(o.useEffect)(function () {
        t.current = e;
      }), t.current;
    }
    var La = function (e) {
      var t = Object(o.useRef)(e);
      return Object(o.useEffect)(function () {
        t.current = e;
      }, [e]), t;
    };
    function Ua(e) {
      var t = La(e);
      return Object(o.useCallback)(function () {
        return t.current && t.current.apply(t, arguments);
      }, [t]);
    }
    function Va(e, t, r) {
      return void 0 === r && (r = !1), function (e, t, r, n) {
        void 0 === n && (n = !1);
        var i = Ua(r);
        Object(o.useEffect)(function () {
          var r = "function" == typeof e ? e() : e;
          return r.addEventListener(t, i, n), function () {
            return r.removeEventListener(t, i, n);
          };
        }, [e]);
      }(Object(o.useCallback)(function () {
        return document;
      }, []), e, t, r);
    }
    var Ba = i.a.createContext(null);
    function qa(e, t) {
      if (null == e) return {};
      var r,
        n,
        o = {},
        i = Object.keys(e);
      for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
      return o;
    }
    function Wa() {
      return (Wa = Object.assign ? Object.assign.bind() : function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
      }).apply(this, arguments);
    }
    function Ha() {
      return Object(o.useState)(null);
    }
    function Ga() {
      var e = Object(o.useRef)(!0),
        t = Object(o.useRef)(function () {
          return e.current;
        });
      return Object(o.useEffect)(function () {
        return e.current = !0, function () {
          e.current = !1;
        };
      }, []), t.current;
    }
    var Ja = function (e) {
      var t = Ga();
      return [e[0], Object(o.useCallback)(function (r) {
        if (t()) return e[1](r);
      }, [t, e[1]])];
    };
    function $a(e) {
      return e.split("-")[0];
    }
    function Ka(e) {
      if (null == e) return window;
      if ("[object Window]" !== e.toString()) {
        var t = e.ownerDocument;
        return t && t.defaultView || window;
      }
      return e;
    }
    function Za(e) {
      return e instanceof Ka(e).Element || e instanceof Element;
    }
    function Ya(e) {
      return e instanceof Ka(e).HTMLElement || e instanceof HTMLElement;
    }
    function Qa(e) {
      return "undefined" != typeof ShadowRoot && (e instanceof Ka(e).ShadowRoot || e instanceof ShadowRoot);
    }
    var Xa = Math.max,
      ec = Math.min,
      tc = Math.round;
    function rc(e, t) {
      void 0 === t && (t = !1);
      var r = e.getBoundingClientRect(),
        n = 1,
        o = 1;
      if (Ya(e) && t) {
        var i = e.offsetHeight,
          a = e.offsetWidth;
        a > 0 && (n = tc(r.width) / a || 1), i > 0 && (o = tc(r.height) / i || 1);
      }
      return {
        width: r.width / n,
        height: r.height / o,
        top: r.top / o,
        right: r.right / n,
        bottom: r.bottom / o,
        left: r.left / n,
        x: r.left / n,
        y: r.top / o
      };
    }
    function nc(e) {
      var t = rc(e),
        r = e.offsetWidth,
        n = e.offsetHeight;
      return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
        x: e.offsetLeft,
        y: e.offsetTop,
        width: r,
        height: n
      };
    }
    function oc(e, t) {
      var r = t.getRootNode && t.getRootNode();
      if (e.contains(t)) return !0;
      if (r && Qa(r)) {
        var n = t;
        do {
          if (n && e.isSameNode(n)) return !0;
          n = n.parentNode || n.host;
        } while (n);
      }
      return !1;
    }
    function ic(e) {
      return e ? (e.nodeName || "").toLowerCase() : null;
    }
    function ac(e) {
      return Ka(e).getComputedStyle(e);
    }
    function cc(e) {
      return ["table", "td", "th"].indexOf(ic(e)) >= 0;
    }
    function lc(e) {
      return ((Za(e) ? e.ownerDocument : e.document) || window.document).documentElement;
    }
    function uc(e) {
      return "html" === ic(e) ? e : e.assignedSlot || e.parentNode || (Qa(e) ? e.host : null) || lc(e);
    }
    function sc(e) {
      return Ya(e) && "fixed" !== ac(e).position ? e.offsetParent : null;
    }
    function pc(e) {
      for (var t = Ka(e), r = sc(e); r && cc(r) && "static" === ac(r).position;) r = sc(r);
      return r && ("html" === ic(r) || "body" === ic(r) && "static" === ac(r).position) ? t : r || function (e) {
        var t = -1 !== navigator.userAgent.toLowerCase().indexOf("firefox");
        if (-1 !== navigator.userAgent.indexOf("Trident") && Ya(e) && "fixed" === ac(e).position) return null;
        var r = uc(e);
        for (Qa(r) && (r = r.host); Ya(r) && ["html", "body"].indexOf(ic(r)) < 0;) {
          var n = ac(r);
          if ("none" !== n.transform || "none" !== n.perspective || "paint" === n.contain || -1 !== ["transform", "perspective"].indexOf(n.willChange) || t && "filter" === n.willChange || t && n.filter && "none" !== n.filter) return r;
          r = r.parentNode;
        }
        return null;
      }(e) || t;
    }
    function fc(e) {
      return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
    }
    function dc(e, t, r) {
      return Xa(e, ec(t, r));
    }
    function yc(e) {
      return Object.assign({}, {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      }, e);
    }
    function bc(e, t) {
      return t.reduce(function (t, r) {
        return t[r] = e, t;
      }, {});
    }
    var hc = "top",
      mc = "bottom",
      vc = "right",
      gc = "left",
      wc = [hc, mc, vc, gc],
      Oc = wc.reduce(function (e, t) {
        return e.concat([t + "-start", t + "-end"]);
      }, []),
      _c = [].concat(wc, ["auto"]).reduce(function (e, t) {
        return e.concat([t, t + "-start", t + "-end"]);
      }, []),
      jc = ["beforeRead", "read", "afterRead", "beforeMain", "main", "afterMain", "beforeWrite", "write", "afterWrite"];
    var Pc = {
      name: "arrow",
      enabled: !0,
      phase: "main",
      fn: function (e) {
        var t,
          r = e.state,
          n = e.name,
          o = e.options,
          i = r.elements.arrow,
          a = r.modifiersData.popperOffsets,
          c = $a(r.placement),
          l = fc(c),
          u = [gc, vc].indexOf(c) >= 0 ? "height" : "width";
        if (i && a) {
          var s = function (e, t) {
              return yc("number" != typeof (e = "function" == typeof e ? e(Object.assign({}, t.rects, {
                placement: t.placement
              })) : e) ? e : bc(e, wc));
            }(o.padding, r),
            p = nc(i),
            f = "y" === l ? hc : gc,
            d = "y" === l ? mc : vc,
            y = r.rects.reference[u] + r.rects.reference[l] - a[l] - r.rects.popper[u],
            b = a[l] - r.rects.reference[l],
            h = pc(i),
            m = h ? "y" === l ? h.clientHeight || 0 : h.clientWidth || 0 : 0,
            v = y / 2 - b / 2,
            g = s[f],
            w = m - p[u] - s[d],
            O = m / 2 - p[u] / 2 + v,
            _ = dc(g, O, w),
            j = l;
          r.modifiersData[n] = ((t = {})[j] = _, t.centerOffset = _ - O, t);
        }
      },
      effect: function (e) {
        var t = e.state,
          r = e.options.element,
          n = void 0 === r ? "[data-popper-arrow]" : r;
        null != n && ("string" != typeof n || (n = t.elements.popper.querySelector(n))) && oc(t.elements.popper, n) && (t.elements.arrow = n);
      },
      requires: ["popperOffsets"],
      requiresIfExists: ["preventOverflow"]
    };
    function Ec(e) {
      return e.split("-")[1];
    }
    var kc = {
      top: "auto",
      right: "auto",
      bottom: "auto",
      left: "auto"
    };
    function xc(e) {
      var t,
        r = e.popper,
        n = e.popperRect,
        o = e.placement,
        i = e.variation,
        a = e.offsets,
        c = e.position,
        l = e.gpuAcceleration,
        u = e.adaptive,
        s = e.roundOffsets,
        p = e.isFixed,
        f = a.x,
        d = void 0 === f ? 0 : f,
        y = a.y,
        b = void 0 === y ? 0 : y,
        h = "function" == typeof s ? s({
          x: d,
          y: b
        }) : {
          x: d,
          y: b
        };
      d = h.x, b = h.y;
      var m = a.hasOwnProperty("x"),
        v = a.hasOwnProperty("y"),
        g = gc,
        w = hc,
        O = window;
      if (u) {
        var _ = pc(r),
          j = "clientHeight",
          P = "clientWidth";
        if (_ === Ka(r) && "static" !== ac(_ = lc(r)).position && "absolute" === c && (j = "scrollHeight", P = "scrollWidth"), _ = _, o === hc || (o === gc || o === vc) && "end" === i) w = mc, b -= (p && _ === O && O.visualViewport ? O.visualViewport.height : _[j]) - n.height, b *= l ? 1 : -1;
        if (o === gc || (o === hc || o === mc) && "end" === i) g = vc, d -= (p && _ === O && O.visualViewport ? O.visualViewport.width : _[P]) - n.width, d *= l ? 1 : -1;
      }
      var E,
        k = Object.assign({
          position: c
        }, u && kc),
        x = !0 === s ? function (e) {
          var t = e.x,
            r = e.y,
            n = window.devicePixelRatio || 1;
          return {
            x: tc(t * n) / n || 0,
            y: tc(r * n) / n || 0
          };
        }({
          x: d,
          y: b
        }) : {
          x: d,
          y: b
        };
      return d = x.x, b = x.y, l ? Object.assign({}, k, ((E = {})[w] = v ? "0" : "", E[g] = m ? "0" : "", E.transform = (O.devicePixelRatio || 1) <= 1 ? "translate(" + d + "px, " + b + "px)" : "translate3d(" + d + "px, " + b + "px, 0)", E)) : Object.assign({}, k, ((t = {})[w] = v ? b + "px" : "", t[g] = m ? d + "px" : "", t.transform = "", t));
    }
    var Sc = {
        name: "computeStyles",
        enabled: !0,
        phase: "beforeWrite",
        fn: function (e) {
          var t = e.state,
            r = e.options,
            n = r.gpuAcceleration,
            o = void 0 === n || n,
            i = r.adaptive,
            a = void 0 === i || i,
            c = r.roundOffsets,
            l = void 0 === c || c,
            u = {
              placement: $a(t.placement),
              variation: Ec(t.placement),
              popper: t.elements.popper,
              popperRect: t.rects.popper,
              gpuAcceleration: o,
              isFixed: "fixed" === t.options.strategy
            };
          null != t.modifiersData.popperOffsets && (t.styles.popper = Object.assign({}, t.styles.popper, xc(Object.assign({}, u, {
            offsets: t.modifiersData.popperOffsets,
            position: t.options.strategy,
            adaptive: a,
            roundOffsets: l
          })))), null != t.modifiersData.arrow && (t.styles.arrow = Object.assign({}, t.styles.arrow, xc(Object.assign({}, u, {
            offsets: t.modifiersData.arrow,
            position: "absolute",
            adaptive: !1,
            roundOffsets: l
          })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
            "data-popper-placement": t.placement
          });
        },
        data: {}
      },
      Cc = {
        passive: !0
      };
    var Rc = {
        name: "eventListeners",
        enabled: !0,
        phase: "write",
        fn: function () {},
        effect: function (e) {
          var t = e.state,
            r = e.instance,
            n = e.options,
            o = n.scroll,
            i = void 0 === o || o,
            a = n.resize,
            c = void 0 === a || a,
            l = Ka(t.elements.popper),
            u = [].concat(t.scrollParents.reference, t.scrollParents.popper);
          return i && u.forEach(function (e) {
            e.addEventListener("scroll", r.update, Cc);
          }), c && l.addEventListener("resize", r.update, Cc), function () {
            i && u.forEach(function (e) {
              e.removeEventListener("scroll", r.update, Cc);
            }), c && l.removeEventListener("resize", r.update, Cc);
          };
        },
        data: {}
      },
      Nc = {
        left: "right",
        right: "left",
        bottom: "top",
        top: "bottom"
      };
    function zc(e) {
      return e.replace(/left|right|bottom|top/g, function (e) {
        return Nc[e];
      });
    }
    var Dc = {
      start: "end",
      end: "start"
    };
    function Tc(e) {
      return e.replace(/start|end/g, function (e) {
        return Dc[e];
      });
    }
    function Mc(e) {
      var t = Ka(e);
      return {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
      };
    }
    function Fc(e) {
      return rc(lc(e)).left + Mc(e).scrollLeft;
    }
    function Ic(e) {
      var t = ac(e),
        r = t.overflow,
        n = t.overflowX,
        o = t.overflowY;
      return /auto|scroll|overlay|hidden/.test(r + o + n);
    }
    function Ac(e, t) {
      var r;
      void 0 === t && (t = []);
      var n = function e(t) {
          return ["html", "body", "#document"].indexOf(ic(t)) >= 0 ? t.ownerDocument.body : Ya(t) && Ic(t) ? t : e(uc(t));
        }(e),
        o = n === (null == (r = e.ownerDocument) ? void 0 : r.body),
        i = Ka(n),
        a = o ? [i].concat(i.visualViewport || [], Ic(n) ? n : []) : n,
        c = t.concat(a);
      return o ? c : c.concat(Ac(uc(a)));
    }
    function Lc(e) {
      return Object.assign({}, e, {
        left: e.x,
        top: e.y,
        right: e.x + e.width,
        bottom: e.y + e.height
      });
    }
    function Uc(e, t) {
      return "viewport" === t ? Lc(function (e) {
        var t = Ka(e),
          r = lc(e),
          n = t.visualViewport,
          o = r.clientWidth,
          i = r.clientHeight,
          a = 0,
          c = 0;
        return n && (o = n.width, i = n.height, /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (a = n.offsetLeft, c = n.offsetTop)), {
          width: o,
          height: i,
          x: a + Fc(e),
          y: c
        };
      }(e)) : Za(t) ? function (e) {
        var t = rc(e);
        return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t;
      }(t) : Lc(function (e) {
        var t,
          r = lc(e),
          n = Mc(e),
          o = null == (t = e.ownerDocument) ? void 0 : t.body,
          i = Xa(r.scrollWidth, r.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0),
          a = Xa(r.scrollHeight, r.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0),
          c = -n.scrollLeft + Fc(e),
          l = -n.scrollTop;
        return "rtl" === ac(o || r).direction && (c += Xa(r.clientWidth, o ? o.clientWidth : 0) - i), {
          width: i,
          height: a,
          x: c,
          y: l
        };
      }(lc(e)));
    }
    function Vc(e, t, r) {
      var n = "clippingParents" === t ? function (e) {
          var t = Ac(uc(e)),
            r = ["absolute", "fixed"].indexOf(ac(e).position) >= 0 && Ya(e) ? pc(e) : e;
          return Za(r) ? t.filter(function (e) {
            return Za(e) && oc(e, r) && "body" !== ic(e);
          }) : [];
        }(e) : [].concat(t),
        o = [].concat(n, [r]),
        i = o[0],
        a = o.reduce(function (t, r) {
          var n = Uc(e, r);
          return t.top = Xa(n.top, t.top), t.right = ec(n.right, t.right), t.bottom = ec(n.bottom, t.bottom), t.left = Xa(n.left, t.left), t;
        }, Uc(e, i));
      return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
    }
    function Bc(e) {
      var t,
        r = e.reference,
        n = e.element,
        o = e.placement,
        i = o ? $a(o) : null,
        a = o ? Ec(o) : null,
        c = r.x + r.width / 2 - n.width / 2,
        l = r.y + r.height / 2 - n.height / 2;
      switch (i) {
        case hc:
          t = {
            x: c,
            y: r.y - n.height
          };
          break;
        case mc:
          t = {
            x: c,
            y: r.y + r.height
          };
          break;
        case vc:
          t = {
            x: r.x + r.width,
            y: l
          };
          break;
        case gc:
          t = {
            x: r.x - n.width,
            y: l
          };
          break;
        default:
          t = {
            x: r.x,
            y: r.y
          };
      }
      var u = i ? fc(i) : null;
      if (null != u) {
        var s = "y" === u ? "height" : "width";
        switch (a) {
          case "start":
            t[u] = t[u] - (r[s] / 2 - n[s] / 2);
            break;
          case "end":
            t[u] = t[u] + (r[s] / 2 - n[s] / 2);
        }
      }
      return t;
    }
    function qc(e, t) {
      void 0 === t && (t = {});
      var r = t,
        n = r.placement,
        o = void 0 === n ? e.placement : n,
        i = r.boundary,
        a = void 0 === i ? "clippingParents" : i,
        c = r.rootBoundary,
        l = void 0 === c ? "viewport" : c,
        u = r.elementContext,
        s = void 0 === u ? "popper" : u,
        p = r.altBoundary,
        f = void 0 !== p && p,
        d = r.padding,
        y = void 0 === d ? 0 : d,
        b = yc("number" != typeof y ? y : bc(y, wc)),
        h = "popper" === s ? "reference" : "popper",
        m = e.rects.popper,
        v = e.elements[f ? h : s],
        g = Vc(Za(v) ? v : v.contextElement || lc(e.elements.popper), a, l),
        w = rc(e.elements.reference),
        O = Bc({
          reference: w,
          element: m,
          strategy: "absolute",
          placement: o
        }),
        _ = Lc(Object.assign({}, m, O)),
        j = "popper" === s ? _ : w,
        P = {
          top: g.top - j.top + b.top,
          bottom: j.bottom - g.bottom + b.bottom,
          left: g.left - j.left + b.left,
          right: j.right - g.right + b.right
        },
        E = e.modifiersData.offset;
      if ("popper" === s && E) {
        var k = E[o];
        Object.keys(P).forEach(function (e) {
          var t = [vc, mc].indexOf(e) >= 0 ? 1 : -1,
            r = [hc, mc].indexOf(e) >= 0 ? "y" : "x";
          P[e] += k[r] * t;
        });
      }
      return P;
    }
    var Wc = {
      name: "flip",
      enabled: !0,
      phase: "main",
      fn: function (e) {
        var t = e.state,
          r = e.options,
          n = e.name;
        if (!t.modifiersData[n]._skip) {
          for (var o = r.mainAxis, i = void 0 === o || o, a = r.altAxis, c = void 0 === a || a, l = r.fallbackPlacements, u = r.padding, s = r.boundary, p = r.rootBoundary, f = r.altBoundary, d = r.flipVariations, y = void 0 === d || d, b = r.allowedAutoPlacements, h = t.options.placement, m = $a(h), v = l || (m === h || !y ? [zc(h)] : function (e) {
              if ("auto" === $a(e)) return [];
              var t = zc(e);
              return [Tc(e), t, Tc(t)];
            }(h)), g = [h].concat(v).reduce(function (e, r) {
              return e.concat("auto" === $a(r) ? function (e, t) {
                void 0 === t && (t = {});
                var r = t,
                  n = r.placement,
                  o = r.boundary,
                  i = r.rootBoundary,
                  a = r.padding,
                  c = r.flipVariations,
                  l = r.allowedAutoPlacements,
                  u = void 0 === l ? _c : l,
                  s = Ec(n),
                  p = s ? c ? Oc : Oc.filter(function (e) {
                    return Ec(e) === s;
                  }) : wc,
                  f = p.filter(function (e) {
                    return u.indexOf(e) >= 0;
                  });
                0 === f.length && (f = p);
                var d = f.reduce(function (t, r) {
                  return t[r] = qc(e, {
                    placement: r,
                    boundary: o,
                    rootBoundary: i,
                    padding: a
                  })[$a(r)], t;
                }, {});
                return Object.keys(d).sort(function (e, t) {
                  return d[e] - d[t];
                });
              }(t, {
                placement: r,
                boundary: s,
                rootBoundary: p,
                padding: u,
                flipVariations: y,
                allowedAutoPlacements: b
              }) : r);
            }, []), w = t.rects.reference, O = t.rects.popper, _ = new Map(), j = !0, P = g[0], E = 0; E < g.length; E++) {
            var k = g[E],
              x = $a(k),
              S = "start" === Ec(k),
              C = [hc, mc].indexOf(x) >= 0,
              R = C ? "width" : "height",
              N = qc(t, {
                placement: k,
                boundary: s,
                rootBoundary: p,
                altBoundary: f,
                padding: u
              }),
              z = C ? S ? vc : gc : S ? mc : hc;
            w[R] > O[R] && (z = zc(z));
            var D = zc(z),
              T = [];
            if (i && T.push(N[x] <= 0), c && T.push(N[z] <= 0, N[D] <= 0), T.every(function (e) {
              return e;
            })) {
              P = k, j = !1;
              break;
            }
            _.set(k, T);
          }
          if (j) for (var M = function (e) {
              var t = g.find(function (t) {
                var r = _.get(t);
                if (r) return r.slice(0, e).every(function (e) {
                  return e;
                });
              });
              if (t) return P = t, "break";
            }, F = y ? 3 : 1; F > 0; F--) {
            if ("break" === M(F)) break;
          }
          t.placement !== P && (t.modifiersData[n]._skip = !0, t.placement = P, t.reset = !0);
        }
      },
      requiresIfExists: ["offset"],
      data: {
        _skip: !1
      }
    };
    function Hc(e, t, r) {
      return void 0 === r && (r = {
        x: 0,
        y: 0
      }), {
        top: e.top - t.height - r.y,
        right: e.right - t.width + r.x,
        bottom: e.bottom - t.height + r.y,
        left: e.left - t.width - r.x
      };
    }
    function Gc(e) {
      return [hc, vc, mc, gc].some(function (t) {
        return e[t] >= 0;
      });
    }
    var Jc = {
      name: "hide",
      enabled: !0,
      phase: "main",
      requiresIfExists: ["preventOverflow"],
      fn: function (e) {
        var t = e.state,
          r = e.name,
          n = t.rects.reference,
          o = t.rects.popper,
          i = t.modifiersData.preventOverflow,
          a = qc(t, {
            elementContext: "reference"
          }),
          c = qc(t, {
            altBoundary: !0
          }),
          l = Hc(a, n),
          u = Hc(c, o, i),
          s = Gc(l),
          p = Gc(u);
        t.modifiersData[r] = {
          referenceClippingOffsets: l,
          popperEscapeOffsets: u,
          isReferenceHidden: s,
          hasPopperEscaped: p
        }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
          "data-popper-reference-hidden": s,
          "data-popper-escaped": p
        });
      }
    };
    var $c = {
      name: "offset",
      enabled: !0,
      phase: "main",
      requires: ["popperOffsets"],
      fn: function (e) {
        var t = e.state,
          r = e.options,
          n = e.name,
          o = r.offset,
          i = void 0 === o ? [0, 0] : o,
          a = _c.reduce(function (e, r) {
            return e[r] = function (e, t, r) {
              var n = $a(e),
                o = [gc, hc].indexOf(n) >= 0 ? -1 : 1,
                i = "function" == typeof r ? r(Object.assign({}, t, {
                  placement: e
                })) : r,
                a = i[0],
                c = i[1];
              return a = a || 0, c = (c || 0) * o, [gc, vc].indexOf(n) >= 0 ? {
                x: c,
                y: a
              } : {
                x: a,
                y: c
              };
            }(r, t.rects, i), e;
          }, {}),
          c = a[t.placement],
          l = c.x,
          u = c.y;
        null != t.modifiersData.popperOffsets && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += u), t.modifiersData[n] = a;
      }
    };
    var Kc = {
      name: "popperOffsets",
      enabled: !0,
      phase: "read",
      fn: function (e) {
        var t = e.state,
          r = e.name;
        t.modifiersData[r] = Bc({
          reference: t.rects.reference,
          element: t.rects.popper,
          strategy: "absolute",
          placement: t.placement
        });
      },
      data: {}
    };
    var Zc = {
      name: "preventOverflow",
      enabled: !0,
      phase: "main",
      fn: function (e) {
        var t = e.state,
          r = e.options,
          n = e.name,
          o = r.mainAxis,
          i = void 0 === o || o,
          a = r.altAxis,
          c = void 0 !== a && a,
          l = r.boundary,
          u = r.rootBoundary,
          s = r.altBoundary,
          p = r.padding,
          f = r.tether,
          d = void 0 === f || f,
          y = r.tetherOffset,
          b = void 0 === y ? 0 : y,
          h = qc(t, {
            boundary: l,
            rootBoundary: u,
            padding: p,
            altBoundary: s
          }),
          m = $a(t.placement),
          v = Ec(t.placement),
          g = !v,
          w = fc(m),
          O = "x" === w ? "y" : "x",
          _ = t.modifiersData.popperOffsets,
          j = t.rects.reference,
          P = t.rects.popper,
          E = "function" == typeof b ? b(Object.assign({}, t.rects, {
            placement: t.placement
          })) : b,
          k = "number" == typeof E ? {
            mainAxis: E,
            altAxis: E
          } : Object.assign({
            mainAxis: 0,
            altAxis: 0
          }, E),
          x = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null,
          S = {
            x: 0,
            y: 0
          };
        if (_) {
          if (i) {
            var C,
              R = "y" === w ? hc : gc,
              N = "y" === w ? mc : vc,
              z = "y" === w ? "height" : "width",
              D = _[w],
              T = D + h[R],
              M = D - h[N],
              F = d ? -P[z] / 2 : 0,
              I = "start" === v ? j[z] : P[z],
              A = "start" === v ? -P[z] : -j[z],
              L = t.elements.arrow,
              U = d && L ? nc(L) : {
                width: 0,
                height: 0
              },
              V = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
              },
              B = V[R],
              q = V[N],
              W = dc(0, j[z], U[z]),
              H = g ? j[z] / 2 - F - W - B - k.mainAxis : I - W - B - k.mainAxis,
              G = g ? -j[z] / 2 + F + W + q + k.mainAxis : A + W + q + k.mainAxis,
              J = t.elements.arrow && pc(t.elements.arrow),
              $ = J ? "y" === w ? J.clientTop || 0 : J.clientLeft || 0 : 0,
              K = null != (C = null == x ? void 0 : x[w]) ? C : 0,
              Z = D + G - K,
              Y = dc(d ? ec(T, D + H - K - $) : T, D, d ? Xa(M, Z) : M);
            _[w] = Y, S[w] = Y - D;
          }
          if (c) {
            var Q,
              X = "x" === w ? hc : gc,
              ee = "x" === w ? mc : vc,
              te = _[O],
              re = "y" === O ? "height" : "width",
              ne = te + h[X],
              oe = te - h[ee],
              ie = -1 !== [hc, gc].indexOf(m),
              ae = null != (Q = null == x ? void 0 : x[O]) ? Q : 0,
              ce = ie ? ne : te - j[re] - P[re] - ae + k.altAxis,
              le = ie ? te + j[re] + P[re] - ae - k.altAxis : oe,
              ue = d && ie ? function (e, t, r) {
                var n = dc(e, t, r);
                return n > r ? r : n;
              }(ce, te, le) : dc(d ? ce : ne, te, d ? le : oe);
            _[O] = ue, S[O] = ue - te;
          }
          t.modifiersData[n] = S;
        }
      },
      requiresIfExists: ["offset"]
    };
    function Yc(e, t, r) {
      void 0 === r && (r = !1);
      var n,
        o,
        i = Ya(t),
        a = Ya(t) && function (e) {
          var t = e.getBoundingClientRect(),
            r = tc(t.width) / e.offsetWidth || 1,
            n = tc(t.height) / e.offsetHeight || 1;
          return 1 !== r || 1 !== n;
        }(t),
        c = lc(t),
        l = rc(e, a),
        u = {
          scrollLeft: 0,
          scrollTop: 0
        },
        s = {
          x: 0,
          y: 0
        };
      return (i || !i && !r) && (("body" !== ic(t) || Ic(c)) && (u = (n = t) !== Ka(n) && Ya(n) ? {
        scrollLeft: (o = n).scrollLeft,
        scrollTop: o.scrollTop
      } : Mc(n)), Ya(t) ? ((s = rc(t, !0)).x += t.clientLeft, s.y += t.clientTop) : c && (s.x = Fc(c))), {
        x: l.left + u.scrollLeft - s.x,
        y: l.top + u.scrollTop - s.y,
        width: l.width,
        height: l.height
      };
    }
    function Qc(e) {
      var t = new Map(),
        r = new Set(),
        n = [];
      return e.forEach(function (e) {
        t.set(e.name, e);
      }), e.forEach(function (e) {
        r.has(e.name) || function e(o) {
          r.add(o.name), [].concat(o.requires || [], o.requiresIfExists || []).forEach(function (n) {
            if (!r.has(n)) {
              var o = t.get(n);
              o && e(o);
            }
          }), n.push(o);
        }(e);
      }), n;
    }
    var Xc = {
      placement: "bottom",
      modifiers: [],
      strategy: "absolute"
    };
    function el() {
      for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
      return !t.some(function (e) {
        return !(e && "function" == typeof e.getBoundingClientRect);
      });
    }
    function tl(e) {
      void 0 === e && (e = {});
      var t = e,
        r = t.defaultModifiers,
        n = void 0 === r ? [] : r,
        o = t.defaultOptions,
        i = void 0 === o ? Xc : o;
      return function (e, t, r) {
        void 0 === r && (r = i);
        var o,
          a,
          c = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, Xc, i),
            modifiersData: {},
            elements: {
              reference: e,
              popper: t
            },
            attributes: {},
            styles: {}
          },
          l = [],
          u = !1,
          s = {
            state: c,
            setOptions: function (r) {
              var o = "function" == typeof r ? r(c.options) : r;
              p(), c.options = Object.assign({}, i, c.options, o), c.scrollParents = {
                reference: Za(e) ? Ac(e) : e.contextElement ? Ac(e.contextElement) : [],
                popper: Ac(t)
              };
              var a = function (e) {
                var t = Qc(e);
                return jc.reduce(function (e, r) {
                  return e.concat(t.filter(function (e) {
                    return e.phase === r;
                  }));
                }, []);
              }(function (e) {
                var t = e.reduce(function (e, t) {
                  var r = e[t.name];
                  return e[t.name] = r ? Object.assign({}, r, t, {
                    options: Object.assign({}, r.options, t.options),
                    data: Object.assign({}, r.data, t.data)
                  }) : t, e;
                }, {});
                return Object.keys(t).map(function (e) {
                  return t[e];
                });
              }([].concat(n, c.options.modifiers)));
              return c.orderedModifiers = a.filter(function (e) {
                return e.enabled;
              }), c.orderedModifiers.forEach(function (e) {
                var t = e.name,
                  r = e.options,
                  n = void 0 === r ? {} : r,
                  o = e.effect;
                if ("function" == typeof o) {
                  var i = o({
                    state: c,
                    name: t,
                    instance: s,
                    options: n
                  });
                  l.push(i || function () {});
                }
              }), s.update();
            },
            forceUpdate: function () {
              if (!u) {
                var e = c.elements,
                  t = e.reference,
                  r = e.popper;
                if (el(t, r)) {
                  c.rects = {
                    reference: Yc(t, pc(r), "fixed" === c.options.strategy),
                    popper: nc(r)
                  }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function (e) {
                    return c.modifiersData[e.name] = Object.assign({}, e.data);
                  });
                  for (var n = 0; n < c.orderedModifiers.length; n++) if (!0 !== c.reset) {
                    var o = c.orderedModifiers[n],
                      i = o.fn,
                      a = o.options,
                      l = void 0 === a ? {} : a,
                      p = o.name;
                    "function" == typeof i && (c = i({
                      state: c,
                      options: l,
                      name: p,
                      instance: s
                    }) || c);
                  } else c.reset = !1, n = -1;
                }
              }
            },
            update: (o = function () {
              return new Promise(function (e) {
                s.forceUpdate(), e(c);
              });
            }, function () {
              return a || (a = new Promise(function (e) {
                Promise.resolve().then(function () {
                  a = void 0, e(o());
                });
              })), a;
            }),
            destroy: function () {
              p(), u = !0;
            }
          };
        if (!el(e, t)) return s;
        function p() {
          l.forEach(function (e) {
            return e();
          }), l = [];
        }
        return s.setOptions(r).then(function (e) {
          !u && r.onFirstUpdate && r.onFirstUpdate(e);
        }), s;
      };
    }
    var rl = tl({
        defaultModifiers: [Jc, Kc, Sc, Rc, $c, Wc, Zc, Pc]
      }),
      nl = function (e) {
        return {
          position: e,
          top: "0",
          left: "0",
          opacity: "0",
          pointerEvents: "none"
        };
      },
      ol = {
        name: "applyStyles",
        enabled: !1
      },
      il = {
        name: "ariaDescribedBy",
        enabled: !0,
        phase: "afterWrite",
        effect: function (e) {
          var t = e.state;
          return function () {
            var e = t.elements,
              r = e.reference,
              n = e.popper;
            if ("removeAttribute" in r) {
              var o = (r.getAttribute("aria-describedby") || "").split(",").filter(function (e) {
                return e.trim() !== n.id;
              });
              o.length ? r.setAttribute("aria-describedby", o.join(",")) : r.removeAttribute("aria-describedby");
            }
          };
        },
        fn: function (e) {
          var t,
            r = e.state.elements,
            n = r.popper,
            o = r.reference,
            i = null == (t = n.getAttribute("role")) ? void 0 : t.toLowerCase();
          if (n.id && "tooltip" === i && "setAttribute" in o) {
            var a = o.getAttribute("aria-describedby");
            if (a && -1 !== a.split(",").indexOf(n.id)) return;
            o.setAttribute("aria-describedby", a ? a + "," + n.id : n.id);
          }
        }
      },
      al = [];
    var cl = function (e, t, r) {
      var n = void 0 === r ? {} : r,
        i = n.enabled,
        a = void 0 === i || i,
        c = n.placement,
        l = void 0 === c ? "bottom" : c,
        u = n.strategy,
        s = void 0 === u ? "absolute" : u,
        p = n.modifiers,
        f = void 0 === p ? al : p,
        d = qa(n, ["enabled", "placement", "strategy", "modifiers"]),
        y = Object(o.useRef)(),
        b = Object(o.useCallback)(function () {
          var e;
          null == (e = y.current) || e.update();
        }, []),
        h = Object(o.useCallback)(function () {
          var e;
          null == (e = y.current) || e.forceUpdate();
        }, []),
        m = Ja(Object(o.useState)({
          placement: l,
          update: b,
          forceUpdate: h,
          attributes: {},
          styles: {
            popper: nl(s),
            arrow: {}
          }
        })),
        v = m[0],
        g = m[1],
        w = Object(o.useMemo)(function () {
          return {
            name: "updateStateModifier",
            enabled: !0,
            phase: "write",
            requires: ["computeStyles"],
            fn: function (e) {
              var t = e.state,
                r = {},
                n = {};
              Object.keys(t.elements).forEach(function (e) {
                r[e] = t.styles[e], n[e] = t.attributes[e];
              }), g({
                state: t,
                styles: r,
                attributes: n,
                update: b,
                forceUpdate: h,
                placement: t.placement
              });
            }
          };
        }, [b, h, g]);
      return Object(o.useEffect)(function () {
        y.current && a && y.current.setOptions({
          placement: l,
          strategy: s,
          modifiers: [].concat(f, [w, ol])
        });
      }, [s, l, w, a]), Object(o.useEffect)(function () {
        if (a && null != e && null != t) return y.current = rl(e, t, Wa({}, d, {
          placement: l,
          strategy: s,
          modifiers: [].concat(f, [il, w])
        })), function () {
          null != y.current && (y.current.destroy(), y.current = void 0, g(function (e) {
            return Wa({}, e, {
              attributes: {},
              styles: {
                popper: nl(s)
              }
            });
          }));
        };
      }, [a, e, t]), v;
    };
    function ll(e, t) {
      return e.contains ? e.contains(t) : e.compareDocumentPosition ? e === t || !!(16 & e.compareDocumentPosition(t)) : void 0;
    }
    var ul = function (e, t, r, n) {
      var o = n && "boolean" != typeof n ? n.capture : n;
      e.removeEventListener(t, r, o), r.__once && e.removeEventListener(t, r.__once, o);
    };
    var sl = function (e, t, r, n) {
        return xa(e, t, r, n), function () {
          ul(e, t, r, n);
        };
      },
      pl = r(24),
      fl = r.n(pl);
    function dl(e) {
      return e && e.ownerDocument || document;
    }
    var yl = r(11),
      bl = r.n(yl);
    function hl(e) {
      return e && "setState" in e ? bl.a.findDOMNode(e) : null != e ? e : null;
    }
    var ml = function () {};
    var vl = function (e) {
      return e && ("current" in e ? e.current : e);
    };
    var gl = function (e, t, r) {
      var n = void 0 === r ? {} : r,
        i = n.disabled,
        a = n.clickTrigger,
        c = void 0 === a ? "click" : a,
        l = Object(o.useRef)(!1),
        u = t || ml,
        s = Object(o.useCallback)(function (t) {
          var r,
            n,
            o = vl(e);
          fl()(!!o, "RootClose captured a close event but does not have a ref to compare it to. useRootClose(), should be passed a ref that resolves to a DOM node"), l.current = !(o && (n = t, !(n.metaKey || n.altKey || n.ctrlKey || n.shiftKey)) && function (e) {
            return 0 === e.button;
          }(t) && !ll(o, null != (r = null == t.composedPath ? void 0 : t.composedPath()[0]) ? r : t.target));
        }, [e]),
        p = Ua(function (e) {
          l.current || u(e);
        }),
        f = Ua(function (e) {
          27 === e.keyCode && u(e);
        });
      Object(o.useEffect)(function () {
        if (!i && null != e) {
          var t = window.event,
            r = dl(hl(vl(e))),
            n = sl(r, c, s, !0),
            o = sl(r, c, function (e) {
              e !== t ? p(e) : t = void 0;
            }),
            a = sl(r, "keyup", function (e) {
              e !== t ? f(e) : t = void 0;
            }),
            l = [];
          return "ontouchstart" in r.documentElement && (l = [].slice.call(r.body.children).map(function (e) {
            return sl(e, "mousemove", ml);
          })), function () {
            n(), o(), a(), l.forEach(function (e) {
              return e();
            });
          };
        }
      }, [e, i, c, s, p, f]);
    };
    function wl(e) {
      var t,
        r,
        n,
        o,
        i,
        a = e.enabled,
        c = e.enableEvents,
        l = e.placement,
        u = e.flip,
        s = e.offset,
        p = e.fixed,
        f = e.containerPadding,
        d = e.arrowElement,
        y = e.popperConfig,
        b = void 0 === y ? {} : y,
        h = function (e) {
          var t = {};
          return Array.isArray(e) ? (null == e || e.forEach(function (e) {
            t[e.name] = e;
          }), t) : e || t;
        }(b.modifiers);
      return Wa({}, b, {
        placement: l,
        enabled: a,
        strategy: p ? "fixed" : b.strategy,
        modifiers: (i = Wa({}, h, {
          eventListeners: {
            enabled: c
          },
          preventOverflow: Wa({}, h.preventOverflow, {
            options: f ? Wa({
              padding: f
            }, null == (t = h.preventOverflow) ? void 0 : t.options) : null == (r = h.preventOverflow) ? void 0 : r.options
          }),
          offset: {
            options: Wa({
              offset: s
            }, null == (n = h.offset) ? void 0 : n.options)
          },
          arrow: Wa({}, h.arrow, {
            enabled: !!d,
            options: Wa({}, null == (o = h.arrow) ? void 0 : o.options, {
              element: d
            })
          }),
          flip: Wa({
            enabled: !!u
          }, h.flip)
        }), void 0 === i && (i = {}), Array.isArray(i) ? i : Object.keys(i).map(function (e) {
          return i[e].name = e, i[e];
        }))
      });
    }
    var Ol = function () {};
    function _l(e) {
      void 0 === e && (e = {});
      var t = Object(o.useContext)(Ba),
        r = Ha(),
        n = r[0],
        i = r[1],
        a = Object(o.useRef)(!1),
        c = e,
        l = c.flip,
        u = c.offset,
        s = c.rootCloseEvent,
        p = c.fixed,
        f = void 0 !== p && p,
        d = c.popperConfig,
        y = void 0 === d ? {} : d,
        b = c.usePopper,
        h = void 0 === b ? !!t : b,
        m = null == (null == t ? void 0 : t.show) ? !!e.show : t.show,
        v = null == (null == t ? void 0 : t.alignEnd) ? e.alignEnd : t.alignEnd;
      m && !a.current && (a.current = !0);
      var g = t || {},
        w = g.drop,
        O = g.setMenu,
        _ = g.menuElement,
        j = g.toggleElement,
        P = v ? "bottom-end" : "bottom-start";
      "up" === w ? P = v ? "top-end" : "top-start" : "right" === w ? P = v ? "right-end" : "right-start" : "left" === w && (P = v ? "left-end" : "left-start");
      var E = cl(j, _, wl({
          placement: P,
          enabled: !(!h || !m),
          enableEvents: m,
          offset: u,
          flip: l,
          fixed: f,
          arrowElement: n,
          popperConfig: y
        })),
        k = Wa({
          ref: O || Ol,
          "aria-labelledby": null == j ? void 0 : j.id
        }, E.attributes.popper, {
          style: E.styles.popper
        }),
        x = {
          show: m,
          alignEnd: v,
          hasShown: a.current,
          toggle: null == t ? void 0 : t.toggle,
          popper: h ? E : null,
          arrowProps: h ? Wa({
            ref: i
          }, E.attributes.arrow, {
            style: E.styles.arrow
          }) : {}
        };
      return gl(_, function (e) {
        null == t || t.toggle(!1, e);
      }, {
        clickTrigger: s,
        disabled: !m
      }), [k, x];
    }
    var jl = {
      children: Ca.a.func.isRequired,
      show: Ca.a.bool,
      alignEnd: Ca.a.bool,
      flip: Ca.a.bool,
      usePopper: Ca.a.oneOf([!0, !1]),
      popperConfig: Ca.a.object,
      rootCloseEvent: Ca.a.string
    };
    function Pl(e) {
      var t = e.children,
        r = _l(qa(e, ["children"])),
        n = r[0],
        o = r[1];
      return i.a.createElement(i.a.Fragment, null, o.hasShown ? t(n, o) : null);
    }
    Pl.displayName = "ReactOverlaysDropdownMenu", Pl.propTypes = jl, Pl.defaultProps = {
      usePopper: !0
    };
    var El = Pl,
      kl = function () {};
    function xl() {
      var e = Object(o.useContext)(Ba) || {},
        t = e.show,
        r = void 0 !== t && t,
        n = e.toggle,
        i = void 0 === n ? kl : n,
        a = e.setToggle,
        c = Object(o.useCallback)(function (e) {
          i(!r, e);
        }, [r, i]);
      return [{
        ref: a || kl,
        onClick: c,
        "aria-haspopup": !0,
        "aria-expanded": !!r
      }, {
        show: r,
        toggle: i
      }];
    }
    var Sl = {
      children: Ca.a.func.isRequired
    };
    function Cl(e) {
      var t = e.children,
        r = xl(),
        n = r[0],
        o = r[1];
      return i.a.createElement(i.a.Fragment, null, t(n, o));
    }
    Cl.displayName = "ReactOverlaysDropdownToggle", Cl.propTypes = Sl;
    var Rl = Cl,
      Nl = {
        children: Ca.a.node,
        drop: Ca.a.oneOf(["up", "left", "right", "down"]),
        focusFirstItemOnShow: Ca.a.oneOf([!1, !0, "keyboard"]),
        itemSelector: Ca.a.string,
        alignEnd: Ca.a.bool,
        show: Ca.a.bool,
        defaultShow: Ca.a.bool,
        onToggle: Ca.a.func
      };
    function zl() {
      var e = Object(o.useReducer)(function (e) {
          return !e;
        }, !1)[1],
        t = Object(o.useRef)(null),
        r = Object(o.useCallback)(function (r) {
          t.current = r, e();
        }, [e]);
      return [t, r];
    }
    function Dl(e) {
      var t = e.drop,
        r = e.alignEnd,
        n = e.defaultShow,
        a = e.show,
        c = e.onToggle,
        l = e.itemSelector,
        u = void 0 === l ? "* > *" : l,
        s = e.focusFirstItemOnShow,
        p = e.children,
        f = Ta(a, n, c),
        d = f[0],
        y = f[1],
        b = zl(),
        h = b[0],
        m = b[1],
        v = h.current,
        g = zl(),
        w = g[0],
        O = g[1],
        _ = w.current,
        j = Aa(d),
        P = Object(o.useRef)(null),
        E = Object(o.useRef)(!1),
        k = Object(o.useCallback)(function (e, t) {
          y(e, t);
        }, [y]),
        x = Object(o.useMemo)(function () {
          return {
            toggle: k,
            drop: t,
            show: d,
            alignEnd: r,
            menuElement: v,
            toggleElement: _,
            setMenu: m,
            setToggle: O
          };
        }, [k, t, d, r, v, _, m, O]);
      v && j && !d && (E.current = v.contains(document.activeElement));
      var S = Ua(function () {
          _ && _.focus && _.focus();
        }),
        C = Ua(function () {
          var e = P.current,
            t = s;
          if (null == t && (t = !(!h.current || !function (e, t) {
            if (!va) {
              var r = document.body,
                n = r.matches || r.matchesSelector || r.webkitMatchesSelector || r.mozMatchesSelector || r.msMatchesSelector;
              va = function (e, t) {
                return n.call(e, t);
              };
            }
            return va(e, t);
          }(h.current, "[role=menu]")) && "keyboard"), !1 !== t && ("keyboard" !== t || /^key.+$/.test(e))) {
            var r = _a(h.current, u)[0];
            r && r.focus && r.focus();
          }
        });
      Object(o.useEffect)(function () {
        d ? C() : E.current && (E.current = !1, S());
      }, [d, E, S, C]), Object(o.useEffect)(function () {
        P.current = null;
      });
      var R = function (e, t) {
        if (!h.current) return null;
        var r = _a(h.current, u),
          n = r.indexOf(e) + t;
        return r[n = Math.max(0, Math.min(n, r.length))];
      };
      return Va("keydown", function (e) {
        var t,
          r,
          n = e.key,
          o = e.target,
          i = null == (t = h.current) ? void 0 : t.contains(o),
          a = null == (r = w.current) ? void 0 : r.contains(o);
        if ((!/input|textarea/i.test(o.tagName) || !(" " === n || "Escape" !== n && i)) && (i || a) && (h.current || "Tab" !== n)) switch (P.current = e.type, n) {
          case "ArrowUp":
            var c = R(o, -1);
            return c && c.focus && c.focus(), void e.preventDefault();
          case "ArrowDown":
            if (e.preventDefault(), d) {
              var l = R(o, 1);
              l && l.focus && l.focus();
            } else y(!0, e);
            return;
          case "Tab":
            xa(document, "keyup", function (t) {
              var r;
              ("Tab" !== t.key || t.target) && null != (r = h.current) && r.contains(t.target) || y(!1, e);
            }, {
              once: !0
            });
            break;
          case "Escape":
            e.preventDefault(), e.stopPropagation(), y(!1, e);
        }
      }), i.a.createElement(Ba.Provider, {
        value: x
      }, p);
    }
    Dl.displayName = "ReactOverlaysDropdown", Dl.propTypes = Nl, Dl.Menu = El, Dl.Toggle = Rl;
    var Tl = Dl,
      Ml = function (e, t) {
        return void 0 === t && (t = null), null != e ? String(e) : t || null;
      },
      Fl = i.a.createContext(null),
      Il = i.a.createContext({});
    Il.Consumer, Il.Provider;
    function Al(e, t) {
      var r = Object(o.useContext)(Il);
      return e || r[t] || t;
    }
    var Ll = i.a.createContext(null);
    Ll.displayName = "NavContext";
    var Ul = Ll;
    var Vl = function () {
        for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
        return t.filter(function (e) {
          return null != e;
        }).reduce(function (e, t) {
          if ("function" != typeof t) throw new Error("Invalid Argument Type, must only provide functions, undefined, or null.");
          return null === e ? t : function () {
            for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++) n[o] = arguments[o];
            e.apply(this, n), t.apply(this, n);
          };
        }, null);
      },
      Bl = ["as", "disabled", "onKeyDown"];
    function ql(e) {
      return !e || "#" === e.trim();
    }
    var Wl = i.a.forwardRef(function (e, t) {
      var r = e.as,
        n = void 0 === r ? "a" : r,
        o = e.disabled,
        a = e.onKeyDown,
        c = ma(e, Bl),
        l = function (e) {
          var t = c.href,
            r = c.onClick;
          (o || ql(t)) && e.preventDefault(), o ? e.stopPropagation() : r && r(e);
        };
      return ql(c.href) && (c.role = c.role || "button", c.href = c.href || "#"), o && (c.tabIndex = -1, c["aria-disabled"] = !0), i.a.createElement(n, ha({
        ref: t
      }, c, {
        onClick: l,
        onKeyDown: Vl(function (e) {
          " " === e.key && (e.preventDefault(), l(e));
        }, a)
      }));
    });
    Wl.displayName = "SafeAnchor";
    var Hl = Wl,
      Gl = ["bsPrefix", "className", "children", "eventKey", "disabled", "href", "onClick", "onSelect", "active", "as"],
      Jl = {
        as: Hl,
        disabled: !1
      },
      $l = i.a.forwardRef(function (e, t) {
        var r = e.bsPrefix,
          n = e.className,
          a = e.children,
          c = e.eventKey,
          l = e.disabled,
          u = e.href,
          s = e.onClick,
          p = e.onSelect,
          f = e.active,
          d = e.as,
          y = ma(e, Gl),
          b = Al(r, "dropdown-item"),
          h = Object(o.useContext)(Fl),
          m = (Object(o.useContext)(Ul) || {}).activeKey,
          v = Ml(c, u),
          g = null == f && null != v ? Ml(m) === v : f,
          w = Ua(function (e) {
            l || (s && s(e), h && h(v, e), p && p(v, e));
          });
        return i.a.createElement(d, ha({}, y, {
          ref: t,
          href: u,
          disabled: l,
          className: wa()(n, b, g && "active", l && "disabled"),
          onClick: w
        }), a);
      });
    $l.displayName = "DropdownItem", $l.defaultProps = Jl;
    var Kl = $l,
      Zl = function (e) {
        return e && "function" != typeof e ? function (t) {
          e.current = t;
        } : e;
      };
    var Yl = function (e, t) {
        return Object(o.useMemo)(function () {
          return function (e, t) {
            var r = Zl(e),
              n = Zl(t);
            return function (e) {
              r && r(e), n && n(e);
            };
          }(e, t);
        }, [e, t]);
      },
      Ql = i.a.createContext(null);
    Ql.displayName = "NavbarContext";
    var Xl = Ql;
    function eu(e, t) {
      return e;
    }
    function tu(e, t) {
      return e.classList ? !!t && e.classList.contains(t) : -1 !== (" " + (e.className.baseVal || e.className) + " ").indexOf(" " + t + " ");
    }
    function ru(e) {
      var t = window.getComputedStyle(e);
      return {
        top: parseFloat(t.marginTop) || 0,
        right: parseFloat(t.marginRight) || 0,
        bottom: parseFloat(t.marginBottom) || 0,
        left: parseFloat(t.marginLeft) || 0
      };
    }
    function nu() {
      var e = Object(o.useRef)(null),
        t = Object(o.useRef)(null),
        r = Object(o.useRef)(null),
        n = Al(void 0, "popover"),
        i = Al(void 0, "dropdown-menu");
      return [Object(o.useCallback)(function (r) {
        r && (tu(r, n) || tu(r, i)) && (t.current = ru(r), r.style.margin = "0", e.current = r);
      }, [n, i]), [Object(o.useMemo)(function () {
        return {
          name: "offset",
          options: {
            offset: function (e) {
              var r = e.placement;
              if (!t.current) return [0, 0];
              var n = t.current,
                o = n.top,
                i = n.left,
                a = n.bottom,
                c = n.right;
              switch (r.split("-")[0]) {
                case "top":
                  return [0, a];
                case "left":
                  return [0, c];
                case "bottom":
                  return [0, o];
                case "right":
                  return [0, i];
                default:
                  return [0, 0];
              }
            }
          }
        };
      }, [t]), Object(o.useMemo)(function () {
        return {
          name: "arrow",
          options: {
            padding: function () {
              if (!r.current) return 0;
              var e = r.current,
                t = e.top,
                n = e.right,
                o = t || n;
              return {
                top: o,
                left: o,
                right: o,
                bottom: o
              };
            }
          }
        };
      }, [r]), Object(o.useMemo)(function () {
        return {
          name: "popoverArrowMargins",
          enabled: !0,
          phase: "main",
          fn: function () {},
          requiresIfExists: ["arrow"],
          effect: function (t) {
            var o = t.state;
            if (e.current && o.elements.arrow && tu(e.current, n)) {
              if (o.modifiersData["arrow#persistent"]) {
                var i = ru(o.elements.arrow),
                  a = i.top,
                  c = i.right,
                  l = a || c;
                o.modifiersData["arrow#persistent"].padding = {
                  top: l,
                  left: l,
                  right: l,
                  bottom: l
                };
              } else r.current = ru(o.elements.arrow);
              return o.elements.arrow.style.margin = "0", function () {
                o.elements.arrow && (o.elements.arrow.style.margin = "");
              };
            }
          }
        };
      }, [n])]];
    }
    var ou = ["bsPrefix", "className", "align", "alignRight", "rootCloseEvent", "flip", "show", "renderOnMount", "as", "popperConfig"],
      iu = Ca.a.oneOf(["left", "right"]),
      au = (Ca.a.oneOfType([iu, Ca.a.shape({
        sm: iu
      }), Ca.a.shape({
        md: iu
      }), Ca.a.shape({
        lg: iu
      }), Ca.a.shape({
        xl: iu
      })]), i.a.forwardRef(function (e, t) {
        var r = e.bsPrefix,
          n = e.className,
          a = e.align,
          c = e.alignRight,
          l = e.rootCloseEvent,
          u = e.flip,
          s = e.show,
          p = e.renderOnMount,
          f = e.as,
          d = void 0 === f ? "div" : f,
          y = e.popperConfig,
          b = ma(e, ou),
          h = Object(o.useContext)(Xl),
          m = Al(r, "dropdown-menu"),
          v = nu(),
          g = v[0],
          w = v[1],
          O = [];
        if (a) if ("object" == typeof a) {
          var _ = Object.keys(a);
          if (_.length) {
            var j = _[0],
              P = a[j];
            c = "left" === P, O.push(m + "-" + j + "-" + P);
          }
        } else "right" === a && (c = !0);
        var E = _l({
            flip: u,
            rootCloseEvent: l,
            show: s,
            alignEnd: c,
            usePopper: !h && 0 === O.length,
            popperConfig: ha({}, y, {
              modifiers: w.concat((null == y ? void 0 : y.modifiers) || [])
            })
          }),
          k = E[0],
          x = E[1],
          S = x.hasShown,
          C = x.popper,
          R = x.show,
          N = x.alignEnd,
          z = x.toggle;
        if (k.ref = Yl(g, Yl(eu(t), k.ref)), !S && !p) return null;
        "string" != typeof d && (k.show = R, k.close = function () {
          return null == z ? void 0 : z(!1);
        }, k.alignRight = N);
        var D = b.style;
        return null != C && C.placement && (D = ha({}, b.style, k.style), b["x-placement"] = C.placement), i.a.createElement(d, ha({}, b, k, {
          style: D,
          className: wa.a.apply(void 0, [n, m, R && "show", N && m + "-right"].concat(O))
        }));
      }));
    au.displayName = "DropdownMenu", au.defaultProps = {
      align: "left",
      alignRight: !1,
      flip: !0
    };
    var cu = au,
      lu = (r(55), ["bsPrefix", "variant", "size", "active", "className", "block", "type", "as"]),
      uu = i.a.forwardRef(function (e, t) {
        var r = e.bsPrefix,
          n = e.variant,
          o = e.size,
          a = e.active,
          c = e.className,
          l = e.block,
          u = e.type,
          s = e.as,
          p = ma(e, lu),
          f = Al(r, "btn"),
          d = wa()(c, f, a && "active", n && f + "-" + n, l && f + "-block", o && f + "-" + o);
        if (p.href) return i.a.createElement(Hl, ha({}, p, {
          as: s,
          ref: t,
          className: wa()(d, p.disabled && "disabled")
        }));
        t && (p.ref = t), u ? p.type = u : s || (p.type = "button");
        var y = s || "button";
        return i.a.createElement(y, ha({}, p, {
          className: d
        }));
      });
    uu.displayName = "Button", uu.defaultProps = {
      variant: "primary",
      active: !1,
      disabled: !1
    };
    var su = uu,
      pu = ["bsPrefix", "split", "className", "childBsPrefix", "as"],
      fu = i.a.forwardRef(function (e, t) {
        var r = e.bsPrefix,
          n = e.split,
          o = e.className,
          a = e.childBsPrefix,
          c = e.as,
          l = void 0 === c ? su : c,
          u = ma(e, pu),
          s = Al(r, "dropdown-toggle");
        void 0 !== a && (u.bsPrefix = a);
        var p = xl()[0];
        return p.ref = Yl(p.ref, eu(t)), i.a.createElement(l, ha({
          className: wa()(o, s, n && s + "-split")
        }, p, u));
      });
    fu.displayName = "DropdownToggle";
    var du = fu,
      yu = /-(.)/g;
    var bu = ["className", "bsPrefix", "as"],
      hu = function (e) {
        return e[0].toUpperCase() + (t = e, t.replace(yu, function (e, t) {
          return t.toUpperCase();
        })).slice(1);
        var t;
      };
    function mu(e, t) {
      var r = void 0 === t ? {} : t,
        n = r.displayName,
        o = void 0 === n ? hu(e) : n,
        a = r.Component,
        c = r.defaultProps,
        l = i.a.forwardRef(function (t, r) {
          var n = t.className,
            o = t.bsPrefix,
            c = t.as,
            l = void 0 === c ? a || "div" : c,
            u = ma(t, bu),
            s = Al(o, e);
          return i.a.createElement(l, ha({
            ref: r,
            className: wa()(n, s)
          }, u));
        });
      return l.defaultProps = c, l.displayName = o, l;
    }
    var vu = ["bsPrefix", "drop", "show", "className", "alignRight", "onSelect", "onToggle", "focusFirstItemOnShow", "as", "navbar"],
      gu = mu("dropdown-header", {
        defaultProps: {
          role: "heading"
        }
      }),
      wu = mu("dropdown-divider", {
        defaultProps: {
          role: "separator"
        }
      }),
      Ou = mu("dropdown-item-text", {
        Component: "span"
      }),
      _u = i.a.forwardRef(function (e, t) {
        var r = function (e, t) {
            return Object.keys(t).reduce(function (r, n) {
              var o,
                i = r,
                a = i[za(n)],
                c = i[n],
                l = Na(i, [za(n), n].map(Da)),
                u = t[n],
                s = Ta(c, a, e[u]),
                p = s[0],
                f = s[1];
              return Ra({}, l, ((o = {})[n] = p, o[u] = f, o));
            }, e);
          }(e, {
            show: "onToggle"
          }),
          n = r.bsPrefix,
          a = r.drop,
          c = r.show,
          l = r.className,
          u = r.alignRight,
          s = r.onSelect,
          p = r.onToggle,
          f = r.focusFirstItemOnShow,
          d = r.as,
          y = void 0 === d ? "div" : d,
          b = (r.navbar, ma(r, vu)),
          h = Object(o.useContext)(Fl),
          m = Al(n, "dropdown"),
          v = Ua(function (e, t, r) {
            void 0 === r && (r = t.type), t.currentTarget !== document || "keydown" === r && "Escape" !== t.key || (r = "rootClose"), p && p(e, t, {
              source: r
            });
          }),
          g = Ua(function (e, t) {
            h && h(e, t), s && s(e, t), v(!1, t, "select");
          });
        return i.a.createElement(Fl.Provider, {
          value: g
        }, i.a.createElement(Tl, {
          drop: a,
          show: c,
          alignEnd: u,
          onToggle: v,
          focusFirstItemOnShow: f,
          itemSelector: "." + m + "-item:not(.disabled):not(:disabled)"
        }, i.a.createElement(y, ha({}, b, {
          ref: t,
          className: wa()(l, c && "show", (!a || "down" === a) && m, "up" === a && "dropup", "right" === a && "dropright", "left" === a && "dropleft")
        }))));
      });
    _u.displayName = "Dropdown", _u.defaultProps = {
      navbar: !1
    }, _u.Divider = wu, _u.Header = gu, _u.Item = Kl, _u.ItemText = Ou, _u.Menu = cu, _u.Toggle = du;
    var ju = _u,
      Pu = ["bsPrefix", "size", "toggle", "vertical", "className", "as"],
      Eu = i.a.forwardRef(function (e, t) {
        var r = e.bsPrefix,
          n = e.size,
          o = e.toggle,
          a = e.vertical,
          c = e.className,
          l = e.as,
          u = void 0 === l ? "div" : l,
          s = ma(e, Pu),
          p = Al(r, "btn-group"),
          f = p;
        return a && (f = p + "-vertical"), i.a.createElement(u, ha({}, s, {
          ref: t,
          className: wa()(c, f, n && p + "-" + n, o && p + "-toggle")
        }));
      });
    Eu.displayName = "ButtonGroup", Eu.defaultProps = {
      vertical: !1,
      toggle: !1,
      role: "group"
    };
    var ku = Eu,
      xu = ["bsPrefix", "variant", "pill", "className", "as"],
      Su = i.a.forwardRef(function (e, t) {
        var r = e.bsPrefix,
          n = e.variant,
          o = e.pill,
          a = e.className,
          c = e.as,
          l = void 0 === c ? "span" : c,
          u = ma(e, xu),
          s = Al(r, "badge");
        return i.a.createElement(l, ha({
          ref: t
        }, u, {
          className: wa()(a, s, o && s + "-pill", n && s + "-" + n)
        }));
      });
    Su.displayName = "Badge", Su.defaultProps = {
      pill: !1
    };
    var Cu,
      Ru = Su,
      Nu = r(35),
      zu = r.n(Nu);
    function Du(e) {
      if ((!Cu && 0 !== Cu || e) && ja) {
        var t = document.createElement("div");
        t.style.position = "absolute", t.style.top = "-9999px", t.style.width = "50px", t.style.height = "50px", t.style.overflow = "scroll", document.body.appendChild(t), Cu = t.offsetWidth - t.clientWidth, document.body.removeChild(t);
      }
      return Cu;
    }
    function Tu(e) {
      var t,
        r,
        n = (t = e, (r = Object(o.useRef)(t)).current = t, r);
      Object(o.useEffect)(function () {
        return function () {
          return n.current();
        };
      }, []);
    }
    function Mu(e, t) {
      return function (e) {
        var t = dl(e);
        return t && t.defaultView || window;
      }(e).getComputedStyle(e, t);
    }
    var Fu = /([A-Z])/g;
    var Iu = /^ms-/;
    function Au(e) {
      return function (e) {
        return e.replace(Fu, "-$1").toLowerCase();
      }(e).replace(Iu, "-ms-");
    }
    var Lu = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
    var Uu = function (e, t) {
      var r = "",
        n = "";
      if ("string" == typeof t) return e.style.getPropertyValue(Au(t)) || Mu(e).getPropertyValue(Au(t));
      Object.keys(t).forEach(function (o) {
        var i = t[o];
        i || 0 === i ? !function (e) {
          return !(!e || !Lu.test(e));
        }(o) ? r += Au(o) + ": " + i + ";" : n += o + "(" + i + ") " : e.style.removeProperty(Au(o));
      }), n && (r += "transform: " + n + ";"), e.style.cssText += ";" + r;
    };
    function Vu(e, t, r) {
      void 0 === r && (r = 5);
      var n = !1,
        o = setTimeout(function () {
          n || function (e, t, r, n) {
            if (void 0 === r && (r = !1), void 0 === n && (n = !0), e) {
              var o = document.createEvent("HTMLEvents");
              o.initEvent(t, r, n), e.dispatchEvent(o);
            }
          }(e, "transitionend", !0);
        }, t + r),
        i = sl(e, "transitionend", function () {
          n = !0;
        }, {
          once: !0
        });
      return function () {
        clearTimeout(o), i();
      };
    }
    function Bu(e, t, r, n) {
      var o, i;
      null == r && (o = Uu(e, "transitionDuration") || "", i = -1 === o.indexOf("ms") ? 1e3 : 1, r = parseFloat(o) * i || 0);
      var a = Vu(e, r, n),
        c = sl(e, "transitionend", t);
      return function () {
        a(), c();
      };
    }
    function qu(e) {
      void 0 === e && (e = dl());
      try {
        var t = e.activeElement;
        return t && t.nodeName ? t : null;
      } catch (t) {
        return e.body;
      }
    }
    function Wu(e, t) {
      e.classList ? e.classList.add(t) : tu(e, t) || ("string" == typeof e.className ? e.className = e.className + " " + t : e.setAttribute("class", (e.className && e.className.baseVal || "") + " " + t));
    }
    function Hu(e, t) {
      return e.replace(new RegExp("(^|\\s)" + t + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
    }
    function Gu(e, t) {
      e.classList ? e.classList.remove(t) : "string" == typeof e.className ? e.className = Hu(e.className, t) : e.setAttribute("class", Hu(e.className && e.className.baseVal || "", t));
    }
    function Ju(e) {
      return "window" in e && e.window === e ? e : "nodeType" in (t = e) && t.nodeType === document.DOCUMENT_NODE && e.defaultView || !1;
      var t;
    }
    function $u(e) {
      var t;
      return Ju(e) || (t = e) && "body" === t.tagName.toLowerCase() ? function (e) {
        var t = Ju(e) ? dl() : dl(e),
          r = Ju(e) || t.defaultView;
        return t.body.clientWidth < r.innerWidth;
      }(e) : e.scrollHeight > e.clientHeight;
    }
    var Ku = ["template", "script", "style"],
      Zu = function (e, t, r) {
        [].forEach.call(e.children, function (e) {
          var n, o, i;
          -1 === t.indexOf(e) && (o = (n = e).nodeType, i = n.tagName, 1 === o && -1 === Ku.indexOf(i.toLowerCase())) && r(e);
        });
      };
    function Yu(e, t) {
      t && (e ? t.setAttribute("aria-hidden", "true") : t.removeAttribute("aria-hidden"));
    }
    var Qu,
      Xu = function () {
        function e(e) {
          var t = void 0 === e ? {} : e,
            r = t.hideSiblingNodes,
            n = void 0 === r || r,
            o = t.handleContainerOverflow,
            i = void 0 === o || o;
          this.hideSiblingNodes = void 0, this.handleContainerOverflow = void 0, this.modals = void 0, this.containers = void 0, this.data = void 0, this.scrollbarSize = void 0, this.hideSiblingNodes = n, this.handleContainerOverflow = i, this.modals = [], this.containers = [], this.data = [], this.scrollbarSize = Du();
        }
        var t = e.prototype;
        return t.isContainerOverflowing = function (e) {
          var t = this.data[this.containerIndexFromModal(e)];
          return t && t.overflowing;
        }, t.containerIndexFromModal = function (e) {
          return t = this.data, r = function (t) {
            return -1 !== t.modals.indexOf(e);
          }, n = -1, t.some(function (e, t) {
            return !!r(e, t) && (n = t, !0);
          }), n;
          var t, r, n;
        }, t.setContainerStyle = function (e, t) {
          var r = {
            overflow: "hidden"
          };
          e.style = {
            overflow: t.style.overflow,
            paddingRight: t.style.paddingRight
          }, e.overflowing && (r.paddingRight = parseInt(Uu(t, "paddingRight") || "0", 10) + this.scrollbarSize + "px"), Uu(t, r);
        }, t.removeContainerStyle = function (e, t) {
          Object.assign(t.style, e.style);
        }, t.add = function (e, t, r) {
          var n = this.modals.indexOf(e),
            o = this.containers.indexOf(t);
          if (-1 !== n) return n;
          if (n = this.modals.length, this.modals.push(e), this.hideSiblingNodes && function (e, t) {
            var r = t.dialog,
              n = t.backdrop;
            Zu(e, [r, n], function (e) {
              return Yu(!0, e);
            });
          }(t, e), -1 !== o) return this.data[o].modals.push(e), n;
          var i = {
            modals: [e],
            classes: r ? r.split(/\s+/) : [],
            overflowing: $u(t)
          };
          return this.handleContainerOverflow && this.setContainerStyle(i, t), i.classes.forEach(Wu.bind(null, t)), this.containers.push(t), this.data.push(i), n;
        }, t.remove = function (e) {
          var t = this.modals.indexOf(e);
          if (-1 !== t) {
            var r = this.containerIndexFromModal(e),
              n = this.data[r],
              o = this.containers[r];
            if (n.modals.splice(n.modals.indexOf(e), 1), this.modals.splice(t, 1), 0 === n.modals.length) n.classes.forEach(Gu.bind(null, o)), this.handleContainerOverflow && this.removeContainerStyle(n, o), this.hideSiblingNodes && function (e, t) {
              var r = t.dialog,
                n = t.backdrop;
              Zu(e, [r, n], function (e) {
                return Yu(!1, e);
              });
            }(o, e), this.containers.splice(r, 1), this.data.splice(r, 1);else if (this.hideSiblingNodes) {
              var i = n.modals[n.modals.length - 1],
                a = i.backdrop;
              Yu(!1, i.dialog), Yu(!1, a);
            }
          }
        }, t.isTopModal = function (e) {
          return !!this.modals.length && this.modals[this.modals.length - 1] === e;
        }, e;
      }(),
      es = function (e) {
        var t;
        return "undefined" == typeof document ? null : null == e ? dl().body : ("function" == typeof e && (e = e()), e && "current" in e && (e = e.current), null != (t = e) && t.nodeType && e || null);
      };
    function ts(e, t) {
      var r = Object(o.useState)(function () {
          return es(e);
        }),
        n = r[0],
        i = r[1];
      if (!n) {
        var a = es(e);
        a && i(a);
      }
      return Object(o.useEffect)(function () {
        t && n && t(n);
      }, [t, n]), Object(o.useEffect)(function () {
        var t = es(e);
        t !== n && i(t);
      }, [e, n]), n;
    }
    function rs(e) {
      var t = e || (Qu || (Qu = new Xu()), Qu),
        r = Object(o.useRef)({
          dialog: null,
          backdrop: null
        });
      return Object.assign(r.current, {
        add: function (e, n) {
          return t.add(r.current, e, n);
        },
        remove: function () {
          return t.remove(r.current);
        },
        isTopModal: function () {
          return t.isTopModal(r.current);
        },
        setDialogRef: Object(o.useCallback)(function (e) {
          r.current.dialog = e;
        }, []),
        setBackdropRef: Object(o.useCallback)(function (e) {
          r.current.backdrop = e;
        }, [])
      });
    }
    var ns = Object(o.forwardRef)(function (e, t) {
        var r = e.show,
          n = void 0 !== r && r,
          a = e.role,
          c = void 0 === a ? "dialog" : a,
          l = e.className,
          u = e.style,
          s = e.children,
          p = e.backdrop,
          f = void 0 === p || p,
          d = e.keyboard,
          y = void 0 === d || d,
          b = e.onBackdropClick,
          h = e.onEscapeKeyDown,
          m = e.transition,
          v = e.backdropTransition,
          g = e.autoFocus,
          w = void 0 === g || g,
          O = e.enforceFocus,
          _ = void 0 === O || O,
          j = e.restoreFocus,
          P = void 0 === j || j,
          E = e.restoreFocusOptions,
          k = e.renderDialog,
          x = e.renderBackdrop,
          S = void 0 === x ? function (e) {
            return i.a.createElement("div", e);
          } : x,
          C = e.manager,
          R = e.container,
          N = e.containerClassName,
          z = e.onShow,
          D = e.onHide,
          T = void 0 === D ? function () {} : D,
          M = e.onExit,
          F = e.onExited,
          I = e.onExiting,
          A = e.onEnter,
          L = e.onEntering,
          U = e.onEntered,
          V = qa(e, ["show", "role", "className", "style", "children", "backdrop", "keyboard", "onBackdropClick", "onEscapeKeyDown", "transition", "backdropTransition", "autoFocus", "enforceFocus", "restoreFocus", "restoreFocusOptions", "renderDialog", "renderBackdrop", "manager", "container", "containerClassName", "onShow", "onHide", "onExit", "onExited", "onExiting", "onEnter", "onEntering", "onEntered"]),
          B = ts(R),
          q = rs(C),
          W = Ga(),
          H = Aa(n),
          G = Object(o.useState)(!n),
          J = G[0],
          $ = G[1],
          K = Object(o.useRef)(null);
        Object(o.useImperativeHandle)(t, function () {
          return q;
        }, [q]), ja && !H && n && (K.current = qu()), m || n || J ? n && J && $(!1) : $(!0);
        var Z = Ua(function () {
            if (q.add(B, N), re.current = sl(document, "keydown", ee), te.current = sl(document, "focus", function () {
              return setTimeout(Q);
            }, !0), z && z(), w) {
              var e = qu(document);
              q.dialog && e && !ll(q.dialog, e) && (K.current = e, q.dialog.focus());
            }
          }),
          Y = Ua(function () {
            var e;
            (q.remove(), null == re.current || re.current(), null == te.current || te.current(), P) && (null == (e = K.current) || null == e.focus || e.focus(E), K.current = null);
          });
        Object(o.useEffect)(function () {
          n && B && Z();
        }, [n, B, Z]), Object(o.useEffect)(function () {
          J && Y();
        }, [J, Y]), Tu(function () {
          Y();
        });
        var Q = Ua(function () {
            if (_ && W() && q.isTopModal()) {
              var e = qu();
              q.dialog && e && !ll(q.dialog, e) && q.dialog.focus();
            }
          }),
          X = Ua(function (e) {
            e.target === e.currentTarget && (null == b || b(e), !0 === f && T());
          }),
          ee = Ua(function (e) {
            y && 27 === e.keyCode && q.isTopModal() && (null == h || h(e), e.defaultPrevented || T());
          }),
          te = Object(o.useRef)(),
          re = Object(o.useRef)(),
          ne = m;
        if (!B || !(n || ne && !J)) return null;
        var oe = Wa({
            role: c,
            ref: q.setDialogRef,
            "aria-modal": "dialog" === c || void 0
          }, V, {
            style: u,
            className: l,
            tabIndex: -1
          }),
          ie = k ? k(oe) : i.a.createElement("div", oe, i.a.cloneElement(s, {
            role: "document"
          }));
        ne && (ie = i.a.createElement(ne, {
          appear: !0,
          unmountOnExit: !0,
          in: !!n,
          onExit: M,
          onExiting: I,
          onExited: function () {
            $(!0);
            for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
            null == F || F.apply(void 0, t);
          },
          onEnter: A,
          onEntering: L,
          onEntered: U
        }, ie));
        var ae = null;
        if (f) {
          var ce = v;
          ae = S({
            ref: q.setBackdropRef,
            onClick: X
          }), ce && (ae = i.a.createElement(ce, {
            appear: !0,
            in: !!n
          }, ae));
        }
        return i.a.createElement(i.a.Fragment, null, bl.a.createPortal(i.a.createElement(i.a.Fragment, null, ae, ie), B));
      }),
      os = {
        show: Ca.a.bool,
        container: Ca.a.any,
        onShow: Ca.a.func,
        onHide: Ca.a.func,
        backdrop: Ca.a.oneOfType([Ca.a.bool, Ca.a.oneOf(["static"])]),
        renderDialog: Ca.a.func,
        renderBackdrop: Ca.a.func,
        onEscapeKeyDown: Ca.a.func,
        onBackdropClick: Ca.a.func,
        containerClassName: Ca.a.string,
        keyboard: Ca.a.bool,
        transition: Ca.a.elementType,
        backdropTransition: Ca.a.elementType,
        autoFocus: Ca.a.bool,
        enforceFocus: Ca.a.bool,
        restoreFocus: Ca.a.bool,
        restoreFocusOptions: Ca.a.shape({
          preventScroll: Ca.a.bool
        }),
        onEnter: Ca.a.func,
        onEntering: Ca.a.func,
        onEntered: Ca.a.func,
        onExit: Ca.a.func,
        onExiting: Ca.a.func,
        onExited: Ca.a.func,
        manager: Ca.a.instanceOf(Xu)
      };
    ns.displayName = "Modal", ns.propTypes = os;
    var is = Object.assign(ns, {
      Manager: Xu
    });
    function as(e, t) {
      return (as = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function cs(e, t) {
      e.prototype = Object.create(t.prototype), e.prototype.constructor = e, as(e, t);
    }
    var ls = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",
      us = ".sticky-top",
      ss = ".navbar-toggler",
      ps = function (e) {
        function t() {
          return e.apply(this, arguments) || this;
        }
        cs(t, e);
        var r = t.prototype;
        return r.adjustAndStore = function (e, t, r) {
          var n,
            o = t.style[e];
          t.dataset[e] = o, Uu(t, ((n = {})[e] = parseFloat(Uu(t, e)) + r + "px", n));
        }, r.restore = function (e, t) {
          var r,
            n = t.dataset[e];
          void 0 !== n && (delete t.dataset[e], Uu(t, ((r = {})[e] = n, r)));
        }, r.setContainerStyle = function (t, r) {
          var n = this;
          if (e.prototype.setContainerStyle.call(this, t, r), t.overflowing) {
            var o = Du();
            _a(r, ls).forEach(function (e) {
              return n.adjustAndStore("paddingRight", e, o);
            }), _a(r, us).forEach(function (e) {
              return n.adjustAndStore("marginRight", e, -o);
            }), _a(r, ss).forEach(function (e) {
              return n.adjustAndStore("marginRight", e, o);
            });
          }
        }, r.removeContainerStyle = function (t, r) {
          var n = this;
          e.prototype.removeContainerStyle.call(this, t, r), _a(r, ls).forEach(function (e) {
            return n.restore("paddingRight", e);
          }), _a(r, us).forEach(function (e) {
            return n.restore("marginRight", e);
          }), _a(r, ss).forEach(function (e) {
            return n.restore("marginRight", e);
          });
        }, t;
      }(Xu);
    function fs(e, t) {
      return (fs = Object.setPrototypeOf || function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    var ds = !1,
      ys = i.a.createContext(null),
      bs = function (e) {
        var t, r;
        function n(t, r) {
          var n;
          n = e.call(this, t, r) || this;
          var o,
            i = r && !r.isMounting ? t.enter : t.appear;
          return n.appearStatus = null, t.in ? i ? (o = "exited", n.appearStatus = "entering") : o = "entered" : o = t.unmountOnExit || t.mountOnEnter ? "unmounted" : "exited", n.state = {
            status: o
          }, n.nextCallback = null, n;
        }
        r = e, (t = n).prototype = Object.create(r.prototype), t.prototype.constructor = t, fs(t, r), n.getDerivedStateFromProps = function (e, t) {
          return e.in && "unmounted" === t.status ? {
            status: "exited"
          } : null;
        };
        var o = n.prototype;
        return o.componentDidMount = function () {
          this.updateStatus(!0, this.appearStatus);
        }, o.componentDidUpdate = function (e) {
          var t = null;
          if (e !== this.props) {
            var r = this.state.status;
            this.props.in ? "entering" !== r && "entered" !== r && (t = "entering") : "entering" !== r && "entered" !== r || (t = "exiting");
          }
          this.updateStatus(!1, t);
        }, o.componentWillUnmount = function () {
          this.cancelNextCallback();
        }, o.getTimeouts = function () {
          var e,
            t,
            r,
            n = this.props.timeout;
          return e = t = r = n, null != n && "number" != typeof n && (e = n.exit, t = n.enter, r = void 0 !== n.appear ? n.appear : t), {
            exit: e,
            enter: t,
            appear: r
          };
        }, o.updateStatus = function (e, t) {
          void 0 === e && (e = !1), null !== t ? (this.cancelNextCallback(), "entering" === t ? this.performEnter(e) : this.performExit()) : this.props.unmountOnExit && "exited" === this.state.status && this.setState({
            status: "unmounted"
          });
        }, o.performEnter = function (e) {
          var t = this,
            r = this.props.enter,
            n = this.context ? this.context.isMounting : e,
            o = this.props.nodeRef ? [n] : [bl.a.findDOMNode(this), n],
            i = o[0],
            a = o[1],
            c = this.getTimeouts(),
            l = n ? c.appear : c.enter;
          !e && !r || ds ? this.safeSetState({
            status: "entered"
          }, function () {
            t.props.onEntered(i);
          }) : (this.props.onEnter(i, a), this.safeSetState({
            status: "entering"
          }, function () {
            t.props.onEntering(i, a), t.onTransitionEnd(l, function () {
              t.safeSetState({
                status: "entered"
              }, function () {
                t.props.onEntered(i, a);
              });
            });
          }));
        }, o.performExit = function () {
          var e = this,
            t = this.props.exit,
            r = this.getTimeouts(),
            n = this.props.nodeRef ? void 0 : bl.a.findDOMNode(this);
          t && !ds ? (this.props.onExit(n), this.safeSetState({
            status: "exiting"
          }, function () {
            e.props.onExiting(n), e.onTransitionEnd(r.exit, function () {
              e.safeSetState({
                status: "exited"
              }, function () {
                e.props.onExited(n);
              });
            });
          })) : this.safeSetState({
            status: "exited"
          }, function () {
            e.props.onExited(n);
          });
        }, o.cancelNextCallback = function () {
          null !== this.nextCallback && (this.nextCallback.cancel(), this.nextCallback = null);
        }, o.safeSetState = function (e, t) {
          t = this.setNextCallback(t), this.setState(e, t);
        }, o.setNextCallback = function (e) {
          var t = this,
            r = !0;
          return this.nextCallback = function (n) {
            r && (r = !1, t.nextCallback = null, e(n));
          }, this.nextCallback.cancel = function () {
            r = !1;
          }, this.nextCallback;
        }, o.onTransitionEnd = function (e, t) {
          this.setNextCallback(t);
          var r = this.props.nodeRef ? this.props.nodeRef.current : bl.a.findDOMNode(this),
            n = null == e && !this.props.addEndListener;
          if (r && !n) {
            if (this.props.addEndListener) {
              var o = this.props.nodeRef ? [this.nextCallback] : [r, this.nextCallback],
                i = o[0],
                a = o[1];
              this.props.addEndListener(i, a);
            }
            null != e && setTimeout(this.nextCallback, e);
          } else setTimeout(this.nextCallback, 0);
        }, o.render = function () {
          var e = this.state.status;
          if ("unmounted" === e) return null;
          var t = this.props,
            r = t.children,
            n = (t.in, t.mountOnEnter, t.unmountOnExit, t.appear, t.enter, t.exit, t.timeout, t.addEndListener, t.onEnter, t.onEntering, t.onEntered, t.onExit, t.onExiting, t.onExited, t.nodeRef, function (e, t) {
              if (null == e) return {};
              var r,
                n,
                o = {},
                i = Object.keys(e);
              for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
              return o;
            }(t, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]));
          return i.a.createElement(ys.Provider, {
            value: null
          }, "function" == typeof r ? r(e, n) : i.a.cloneElement(i.a.Children.only(r), n));
        }, n;
      }(i.a.Component);
    function hs() {}
    bs.contextType = ys, bs.propTypes = {}, bs.defaultProps = {
      in: !1,
      mountOnEnter: !1,
      unmountOnExit: !1,
      appear: !1,
      enter: !0,
      exit: !0,
      onEnter: hs,
      onEntering: hs,
      onEntered: hs,
      onExit: hs,
      onExiting: hs,
      onExited: hs
    }, bs.UNMOUNTED = "unmounted", bs.EXITED = "exited", bs.ENTERING = "entering", bs.ENTERED = "entered", bs.EXITING = "exiting";
    var ms = bs;
    function vs(e, t) {
      var r = Uu(e, t) || "",
        n = -1 === r.indexOf("ms") ? 1e3 : 1;
      return parseFloat(r) * n;
    }
    function gs(e, t) {
      var r = vs(e, "transitionDuration"),
        n = vs(e, "transitionDelay"),
        o = Bu(e, function (r) {
          r.target === e && (o(), t(r));
        }, r + n);
    }
    var ws,
      Os = ["className", "children"],
      _s = ((ws = {}).entering = "show", ws.entered = "show", ws),
      js = i.a.forwardRef(function (e, t) {
        var r = e.className,
          n = e.children,
          a = ma(e, Os),
          c = Object(o.useCallback)(function (e) {
            !function (e) {
              e.offsetHeight;
            }(e), a.onEnter && a.onEnter(e);
          }, [a]);
        return i.a.createElement(ms, ha({
          ref: t,
          addEndListener: gs
        }, a, {
          onEnter: c
        }), function (e, t) {
          return i.a.cloneElement(n, ha({}, t, {
            className: wa()("fade", r, n.props.className, _s[e])
          }));
        });
      });
    js.defaultProps = {
      in: !1,
      timeout: 300,
      mountOnEnter: !1,
      unmountOnExit: !1,
      appear: !1
    }, js.displayName = "Fade";
    var Ps = js,
      Es = mu("modal-body"),
      ks = i.a.createContext({
        onHide: function () {}
      }),
      xs = ["bsPrefix", "className", "contentClassName", "centered", "size", "children", "scrollable"],
      Ss = i.a.forwardRef(function (e, t) {
        var r = e.bsPrefix,
          n = e.className,
          o = e.contentClassName,
          a = e.centered,
          c = e.size,
          l = e.children,
          u = e.scrollable,
          s = ma(e, xs),
          p = (r = Al(r, "modal")) + "-dialog";
        return i.a.createElement("div", ha({}, s, {
          ref: t,
          className: wa()(p, n, c && r + "-" + c, a && p + "-centered", u && p + "-scrollable")
        }), i.a.createElement("div", {
          className: wa()(r + "-content", o)
        }, l));
      });
    Ss.displayName = "ModalDialog";
    var Cs = Ss,
      Rs = mu("modal-footer"),
      Ns = ["label", "onClick", "className"],
      zs = {
        label: Ca.a.string.isRequired,
        onClick: Ca.a.func
      },
      Ds = i.a.forwardRef(function (e, t) {
        var r = e.label,
          n = e.onClick,
          o = e.className,
          a = ma(e, Ns);
        return i.a.createElement("button", ha({
          ref: t,
          type: "button",
          className: wa()("close", o),
          onClick: n
        }, a), i.a.createElement("span", {
          "aria-hidden": "true"
        }, "×"), i.a.createElement("span", {
          className: "sr-only"
        }, r));
      });
    Ds.displayName = "CloseButton", Ds.propTypes = zs, Ds.defaultProps = {
      label: "Close"
    };
    var Ts = Ds,
      Ms = ["bsPrefix", "closeLabel", "closeButton", "onHide", "className", "children"],
      Fs = i.a.forwardRef(function (e, t) {
        var r = e.bsPrefix,
          n = e.closeLabel,
          a = e.closeButton,
          c = e.onHide,
          l = e.className,
          u = e.children,
          s = ma(e, Ms);
        r = Al(r, "modal-header");
        var p = Object(o.useContext)(ks),
          f = Ua(function () {
            p && p.onHide(), c && c();
          });
        return i.a.createElement("div", ha({
          ref: t
        }, s, {
          className: wa()(l, r)
        }), u, a && i.a.createElement(Ts, {
          label: n,
          onClick: f
        }));
      });
    Fs.displayName = "ModalHeader", Fs.defaultProps = {
      closeLabel: "Close",
      closeButton: !1
    };
    var Is,
      As,
      Ls = Fs,
      Us = mu("modal-title", {
        Component: (Is = "h4", i.a.forwardRef(function (e, t) {
          return i.a.createElement("div", ha({}, e, {
            ref: t,
            className: wa()(e.className, Is)
          }));
        }))
      }),
      Vs = ["bsPrefix", "className", "style", "dialogClassName", "contentClassName", "children", "dialogAs", "aria-labelledby", "show", "animation", "backdrop", "keyboard", "onEscapeKeyDown", "onShow", "onHide", "container", "autoFocus", "enforceFocus", "restoreFocus", "restoreFocusOptions", "onEntered", "onExit", "onExiting", "onEnter", "onEntering", "onExited", "backdropClassName", "manager"],
      Bs = {
        show: !1,
        backdrop: !0,
        keyboard: !0,
        autoFocus: !0,
        enforceFocus: !0,
        restoreFocus: !0,
        animation: !0,
        dialogAs: Cs
      };
    function qs(e) {
      return i.a.createElement(Ps, ha({}, e, {
        timeout: null
      }));
    }
    function Ws(e) {
      return i.a.createElement(Ps, ha({}, e, {
        timeout: null
      }));
    }
    var Hs = i.a.forwardRef(function (e, t) {
      var r = e.bsPrefix,
        n = e.className,
        a = e.style,
        c = e.dialogClassName,
        l = e.contentClassName,
        u = e.children,
        s = e.dialogAs,
        p = e["aria-labelledby"],
        f = e.show,
        d = e.animation,
        y = e.backdrop,
        b = e.keyboard,
        h = e.onEscapeKeyDown,
        m = e.onShow,
        v = e.onHide,
        g = e.container,
        w = e.autoFocus,
        O = e.enforceFocus,
        _ = e.restoreFocus,
        j = e.restoreFocusOptions,
        P = e.onEntered,
        E = e.onExit,
        k = e.onExiting,
        x = e.onEnter,
        S = e.onEntering,
        C = e.onExited,
        R = e.backdropClassName,
        N = e.manager,
        z = ma(e, Vs),
        D = Object(o.useState)({}),
        T = D[0],
        M = D[1],
        F = Object(o.useState)(!1),
        I = F[0],
        A = F[1],
        L = Object(o.useRef)(!1),
        U = Object(o.useRef)(!1),
        V = Object(o.useRef)(null),
        B = Ha(),
        q = B[0],
        W = B[1],
        H = Ua(v);
      r = Al(r, "modal"), Object(o.useImperativeHandle)(t, function () {
        return {
          get _modal() {
            return q;
          }
        };
      }, [q]);
      var G = Object(o.useMemo)(function () {
        return {
          onHide: H
        };
      }, [H]);
      function J() {
        return N || (As || (As = new ps()), As);
      }
      function $(e) {
        if (ja) {
          var t = J().isContainerOverflowing(q),
            r = e.scrollHeight > dl(e).documentElement.clientHeight;
          M({
            paddingRight: t && !r ? Du() : void 0,
            paddingLeft: !t && r ? Du() : void 0
          });
        }
      }
      var K = Ua(function () {
        q && $(q.dialog);
      });
      Tu(function () {
        ul(window, "resize", K), V.current && V.current();
      });
      var Z = function () {
          L.current = !0;
        },
        Y = function (e) {
          L.current && q && e.target === q.dialog && (U.current = !0), L.current = !1;
        },
        Q = function () {
          A(!0), V.current = Bu(q.dialog, function () {
            A(!1);
          });
        },
        X = function (e) {
          "static" !== y ? U.current || e.target !== e.currentTarget ? U.current = !1 : null == v || v() : function (e) {
            e.target === e.currentTarget && Q();
          }(e);
        },
        ee = Object(o.useCallback)(function (e) {
          return i.a.createElement("div", ha({}, e, {
            className: wa()(r + "-backdrop", R, !d && "show")
          }));
        }, [d, R, r]),
        te = ha({}, a, T);
      d || (te.display = "block");
      return i.a.createElement(ks.Provider, {
        value: G
      }, i.a.createElement(is, {
        show: f,
        ref: W,
        backdrop: y,
        container: g,
        keyboard: !0,
        autoFocus: w,
        enforceFocus: O,
        restoreFocus: _,
        restoreFocusOptions: j,
        onEscapeKeyDown: function (e) {
          b || "static" !== y ? b && h && h(e) : (e.preventDefault(), Q());
        },
        onShow: m,
        onHide: v,
        onEnter: function (e, t) {
          e && (e.style.display = "block", $(e)), null == x || x(e, t);
        },
        onEntering: function (e, t) {
          null == S || S(e, t), xa(window, "resize", K);
        },
        onEntered: P,
        onExit: function (e) {
          null == V.current || V.current(), null == E || E(e);
        },
        onExiting: k,
        onExited: function (e) {
          e && (e.style.display = ""), null == C || C(e), ul(window, "resize", K);
        },
        manager: J(),
        containerClassName: r + "-open",
        transition: d ? qs : void 0,
        backdropTransition: d ? Ws : void 0,
        renderBackdrop: ee,
        renderDialog: function (e) {
          return i.a.createElement("div", ha({
            role: "dialog"
          }, e, {
            style: te,
            className: wa()(n, r, I && r + "-static"),
            onClick: y ? X : void 0,
            onMouseUp: Y,
            "aria-labelledby": p
          }), i.a.createElement(s, ha({}, z, {
            onMouseDown: Z,
            className: c,
            contentClassName: l
          }), u));
        }
      }));
    });
    Hs.displayName = "Modal", Hs.defaultProps = Bs, Hs.Body = Es, Hs.Header = Ls, Hs.Title = Us, Hs.Footer = Rs, Hs.Dialog = Cs, Hs.TRANSITION_DURATION = 300, Hs.BACKDROP_TRANSITION_DURATION = 150;
    var Gs,
      Js,
      $s,
      Ks,
      Zs,
      Ys,
      Qs,
      Xs,
      ep,
      tp,
      rp,
      np,
      op = Hs,
      ip = r(27);
    function ap(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function cp(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var lp,
      up,
      sp,
      pp = (Js = cp((Gs = function e(t, r, n, o, i) {
        var a = this;
        if (function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), ap(this, "percentComplete", Js, this), ap(this, "uploading", $s, this), ap(this, "failed", Ks, this), ap(this, "errorMessage", Zs, this), ap(this, "startedAt", Ys, this), ap(this, "file", Qs, this), this.abort = function () {
          a.uploading && a._request.abort();
        }, this._uploadFile = function () {
          a.startedAt = new Date(), a._request = new XMLHttpRequest(), a._request.upload.addEventListener("progress", a._updateProgress), a._request.addEventListener("loadstart", a._onLoadStart), a._request.addEventListener("load", a._onSuccess), a._request.addEventListener("abort", a._onAbort), a._request.addEventListener("error", a._onError), a._request.open("POST", a._postUrl), a._request.setRequestHeader("X-CSRF-Token", a._csrf);
          var e = new FormData();
          e.append("file", a.file), a._request.send(e);
        }, ap(this, "_updateProgress", Xs, this), ap(this, "_onLoadStart", ep, this), ap(this, "_onSuccess", tp, this), this._onError = function () {
          a._handleError("Network error");
        }, ap(this, "_handleError", rp, this), this._onAbort = function () {
          a._reset();
        }, ap(this, "_reset", np, this), !t) throw new Error("FileUploader requires an postUrl");
        if (!r) throw new Error("FileUploader requires a csrf");
        if (!n) throw new Error("FileUploader requires a file");
        this._postUrl = t, this._csrf = r, this.file = n, this._onSuccessCallback = o, this._onErrorCallback = i, this._request = null, this._uploadFile();
      }).prototype, "percentComplete", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return 0;
        }
      }), $s = cp(Gs.prototype, "uploading", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return !1;
        }
      }), Ks = cp(Gs.prototype, "failed", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return !1;
        }
      }), Zs = cp(Gs.prototype, "errorMessage", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return "";
        }
      }), Ys = cp(Gs.prototype, "startedAt", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return null;
        }
      }), Qs = cp(Gs.prototype, "file", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return "";
        }
      }), Xs = cp(Gs.prototype, "_updateProgress", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            t.total > 0 && (e.percentComplete = Math.round(100 * t.loaded / t.total));
          };
        }
      }), ep = cp(Gs.prototype, "_onLoadStart", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function () {
            e.uploading = !0;
          };
        }
      }), tp = cp(Gs.prototype, "_onSuccess", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function () {
            if (200 === e._request.status) e.uploading = !1, e.response = e._request.response, e._onSuccessCallback && e._onSuccessCallback(e.response), e._reset();else {
              var t = e._request.statusText;
              if (e._request.response) try {
                t = JSON.parse(e._request.response).message;
              } catch (e) {}
              e._handleError(t);
            }
          };
        }
      }), rp = cp(Gs.prototype, "_handleError", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            e.errorMessage = "Upload failed: ".concat(t), e.failed = !0, e._onErrorCallback && e._onErrorCallback(e.errorMessage), e._reset();
          };
        }
      }), np = cp(Gs.prototype, "_reset", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function () {
            e.uploading = !1, e._request = null;
          };
        }
      }), Gs);
    function fp(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function dp(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? fp(Object(r), !0).forEach(function (t) {
          yp(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : fp(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function yp(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function bp(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function hp(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function mp() {
      return (mp = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = vp(e, t);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(this, arguments);
    }
    function vp(e, t) {
      for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = _p(e)););
      return e;
    }
    function gp(e, t) {
      return (gp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function wp(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = _p(e);
        if (t) {
          var o = _p(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return Op(this, r);
      };
    }
    function Op(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function _p(e) {
      return (_p = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function jp(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var Pp,
      Ep,
      kp,
      xp = (sp = up = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && gp(e, t);
        }(i, e);
        var t,
          r,
          n,
          o = wp(i);
        function i() {
          return bp(this, i), o.apply(this, arguments);
        }
        return t = i, n = [{
          key: "getAttributeDefinition",
          value: function () {
            var e = mp(_p(i), "getAttributeDefinition", this).call(this);
            return dp(dp({}, e), {}, {
              type: dp(dp({}, e.type), {}, {
                defaultValue: this.type
              }),
              accountId: {
                key: "accountId",
                type: "number"
              },
              fileName: {
                key: "fileName",
                type: "string"
              },
              status: {
                key: "status",
                type: "string"
              },
              message: {
                key: "message",
                type: "string"
              },
              total: {
                key: "total",
                type: "number",
                defaultValue: 0
              },
              processed: {
                key: "processed",
                type: "number",
                defaultValue: 0
              },
              fieldsCreated: {
                key: "fieldsCreated",
                type: "number",
                defaultValue: 0
              },
              cropsCreated: {
                key: "cropsCreated",
                type: "number",
                defaultValue: 0
              },
              varietiesCreated: {
                key: "varietiesCreated",
                type: "number",
                defaultValue: 0
              },
              cultivarsCreated: {
                key: "cultivarsCreated",
                type: "number",
                defaultValue: 0
              },
              rootStocksCreated: {
                key: "rootStocksCreated",
                type: "number",
                defaultValue: 0
              },
              useTypesCreated: {
                key: "useTypesCreated",
                type: "number",
                defaultValue: 0
              }
            });
          }
        }], (r = [{
          key: "enqueued",
          get: function () {
            return "enqueued" === this.status;
          }
        }, {
          key: "running",
          get: function () {
            return "running" === this.status;
          }
        }, {
          key: "complete",
          get: function () {
            return "complete" === this.status;
          }
        }, {
          key: "failed",
          get: function () {
            return "failed" === this.status;
          }
        }, {
          key: "percentComplete",
          get: function () {
            return this.complete ? 100 : this.total > 0 ? Math.round(100 * this.processed / this.total) : null;
          }
        }]) && hp(t.prototype, r), n && hp(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), i;
      }(Object(Ue.MixInto)(Ue.UpdatableBase, Ue.serialAttributeMixin, Ue.typeAttributeMixin, Ue.timestampAttributesMixin)), up.type = "IF2::Fields::FieldImport", jp((lp = sp).prototype, "enqueued", [a.computed], Object.getOwnPropertyDescriptor(lp.prototype, "enqueued"), lp.prototype), jp(lp.prototype, "running", [a.computed], Object.getOwnPropertyDescriptor(lp.prototype, "running"), lp.prototype), jp(lp.prototype, "complete", [a.computed], Object.getOwnPropertyDescriptor(lp.prototype, "complete"), lp.prototype), jp(lp.prototype, "failed", [a.computed], Object.getOwnPropertyDescriptor(lp.prototype, "failed"), lp.prototype), jp(lp.prototype, "percentComplete", [a.computed], Object.getOwnPropertyDescriptor(lp.prototype, "percentComplete"), lp.prototype), lp);
    function Sp(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function Cp(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var Rp,
      Np,
      zp,
      Dp,
      Tp,
      Mp = (Ep = Cp((Pp = function e(t, r, n, o) {
        var i = this;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), Sp(this, "fieldImport", Ep, this), this.update = function () {
          if (!i.fieldImport.complete && !i.fieldImport.failed) return fetch(i._statusUrl).then(function (e) {
            if (!e.ok) throw new Error(e.statusText);
            return e.json();
          }).then(i._handleUpdate).catch(function (e) {
            return console.error("Failed to get field import status: ".concat(e.message));
          });
        }, Sp(this, "_handleUpdate", kp, this), this.destroy = function () {
          fetch(i._destroyUrl, {
            method: "DELETE",
            headers: {
              "X-CSRF-Token": i._csrf
            }
          }).then(function (e) {
            if (!e.ok) throw new Error(e.statusText);
            return null;
          }).catch(function (e) {
            return console.error("Failed to destroy field import: ".concat(e.message));
          });
        }, this._statusUrl = "".concat(t, "/").concat(n), this._destroyUrl = "".concat(r, "/").concat(n), this._csrf = o, this.fieldImport.update({
          serial: n
        });
      }).prototype, "fieldImport", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return new xp();
        }
      }), kp = Cp(Pp.prototype, "_handleUpdate", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            e.fieldImport.update(t);
          };
        }
      }), Pp);
    function Fp(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function Ip(e, t) {
      return (Ip = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function Ap(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = Vp(e);
        if (t) {
          var o = Vp(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return Lp(this, r);
      };
    }
    function Lp(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return Up(e);
    }
    function Up(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function Vp(e) {
      return (Vp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function Bp(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var qp,
      Wp,
      Hp = Object(c.observer)((Tp = Dp = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && Ip(e, t);
        }(c, e);
        var t,
          r,
          n,
          o = Ap(c);
        function c(e) {
          var t;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, c), function (e, t, r, n) {
            r && Object.defineProperty(e, t, {
              enumerable: r.enumerable,
              configurable: r.configurable,
              writable: r.writable,
              value: r.initializer ? r.initializer.call(n) : void 0
            });
          }(t = o.call(this, e), "throttledValue", zp, Up(t)), t._valueThrottleDisposer = Object(a.reaction)(function () {
            return t.value;
          }, function (e) {
            t.throttledValue = e;
          }, {
            fireImmediately: !0,
            delay: 100
          }), t;
        }
        return t = c, (r = [{
          key: "value",
          get: function () {
            return this.props.valueNow;
          }
        }, {
          key: "failed",
          get: function () {
            return this.props.failed;
          }
        }, {
          key: "_barWidth",
          get: function () {
            return this.failed || 0 === this.throttledValue || null === this.throttledValue ? 100 : this.throttledValue;
          }
        }, {
          key: "_progressClass",
          get: function () {
            var e = "progress-bar";
            return this.failed ? e += " bg-danger" : 100 === this.throttledValue ? e += " bg-success" : 0 !== this.throttledValue && null !== this.throttledValue || (e += " progress-bar-striped progress-bar-animated"), e;
          }
        }, {
          key: "_progressText",
          get: function () {
            return this.failed ? "failed" : 0 === this.throttledValue || null === this.throttledValue ? "" : "".concat(this.throttledValue, "%");
          }
        }, {
          key: "componentWillUnmount",
          value: function () {
            this._valueThrottleDisposer();
          }
        }, {
          key: "render",
          value: function () {
            var e = this.props,
              t = e.className,
              r = e.valueMin,
              n = e.valueMax;
            return i.a.createElement("div", {
              className: "progress".concat(t ? " ".concat(t) : "")
            }, i.a.createElement("div", {
              className: this._progressClass,
              role: "progressbar",
              "aria-valuenow": this._barWidth,
              "aria-valuemin": r,
              "aria-valuemax": n,
              style: {
                width: "".concat(this._barWidth, "%")
              }
            }, this._progressText));
          }
        }]) && Fp(t.prototype, r), n && Fp(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), c;
      }(o.Component), Dp.defaultProps = {
        valueMin: 0,
        valueMax: 100,
        valueNow: 0
      }, zp = Bp((Np = Tp).prototype, "throttledValue", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return 0;
        }
      }), Bp(Np.prototype, "value", [a.computed], Object.getOwnPropertyDescriptor(Np.prototype, "value"), Np.prototype), Bp(Np.prototype, "failed", [a.computed], Object.getOwnPropertyDescriptor(Np.prototype, "failed"), Np.prototype), Bp(Np.prototype, "_barWidth", [a.computed], Object.getOwnPropertyDescriptor(Np.prototype, "_barWidth"), Np.prototype), Bp(Np.prototype, "_progressClass", [a.computed], Object.getOwnPropertyDescriptor(Np.prototype, "_progressClass"), Np.prototype), Bp(Np.prototype, "_progressText", [a.computed], Object.getOwnPropertyDescriptor(Np.prototype, "_progressText"), Np.prototype), Rp = Np)) || Rp;
    function Gp(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function Jp(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function $p(e, t) {
      return ($p = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function Kp(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = Yp(e);
        if (t) {
          var o = Yp(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return Zp(this, r);
      };
    }
    function Zp(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function Yp(e) {
      return (Yp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var Qp,
      Xp,
      ef = Object(c.observer)((function (e, t, r, n, o) {
        var i = {};
        Object.keys(n).forEach(function (e) {
          i[e] = n[e];
        }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
          return n(e, t, r) || r;
        }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null);
      }((Wp = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && $p(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = Kp(a);
        function a() {
          var e;
          Gp(this, a);
          for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];
          return (e = o.call.apply(o, [this].concat(r))).renderFailure = function () {
            return i.a.createElement(i.a.Fragment, null, e._fieldImportMonitor.fieldImport.message);
          }, e.renderSuccess = function (t) {
            return i.a.createElement(i.a.Fragment, null, i.a.createElement("p", null, t("if2_fields.successfully_imported_following")), i.a.createElement("table", {
              className: "import-summary"
            }, i.a.createElement("tbody", null, i.a.createElement("tr", null, i.a.createElement("th", null, t("if2_fields.fields")), i.a.createElement("td", null, e._fieldImportMonitor.fieldImport.fieldsCreated || 0), i.a.createElement("th", null, t("if2_fields.crops")), i.a.createElement("td", null, e._fieldImportMonitor.fieldImport.cropsCreated || 0), i.a.createElement("th", null, t("if2_fields.varieties")), i.a.createElement("td", null, e._fieldImportMonitor.fieldImport.varietiesCreated || 0)), i.a.createElement("tr", null, i.a.createElement("th", null, t("if2_fields.cultivars")), i.a.createElement("td", null, e._fieldImportMonitor.fieldImport.cultivarsCreated || 0), i.a.createElement("th", null, t("if2_fields.root_stocks")), i.a.createElement("td", null, e._fieldImportMonitor.fieldImport.rootStocksCreated || 0), i.a.createElement("th", null, t("if2_fields.use_types")), i.a.createElement("td", null, e._fieldImportMonitor.fieldImport.useTypesCreated || 0)))));
          }, e.renderStatus = function (t) {
            return e._fieldImportMonitor.fieldImport.complete ? e.renderSuccess(t) : e._fieldImportMonitor.fieldImport.failed ? e.renderFailure() : i.a.createElement(i.a.Fragment, null, e._fieldImportMonitor.fieldImport.running ? t("if2_fields.processing") : t("if2_fields.import_enqueued"), "...");
          }, e;
        }
        return t = a, (r = [{
          key: "_fieldImportMonitor",
          get: function () {
            var e = this.props.fieldImportMonitor;
            if (!e) throw new Error("ImportMonitor requires a fieldImportMonitor");
            return e;
          }
        }, {
          key: "render",
          value: function () {
            var e = this.props.t;
            return i.a.createElement(j, {
              i18n: Re
            }, i.a.createElement("div", {
              className: "import-monitor-item"
            }, i.a.createElement("div", {
              className: "row align-items-center"
            }, i.a.createElement("div", {
              className: "col-4 pl-0"
            }, i.a.createElement("div", {
              className: "row align-items-center"
            }, i.a.createElement("div", {
              className: "col-3 align-self-center"
            }, i.a.createElement(Ot.FontAwesomeIcon, {
              icon: _t.faFileCsv
            })), i.a.createElement("div", {
              className: "col-9 align-self-center pl-0 pr-0 text-truncate",
              style: {
                fontSize: "smaller"
              }
            }, this._fieldImportMonitor.fieldImport.fileName))), i.a.createElement("div", {
              className: "col-7"
            }, i.a.createElement(Hp, {
              valueNow: this._fieldImportMonitor.fieldImport.percentComplete,
              failed: this._fieldImportMonitor.fieldImport.failed
            })), i.a.createElement("div", {
              className: "col-1 pr-0 text-right"
            }, i.a.createElement("a", {
              href: "#",
              onClick: this._fieldImportMonitor.destroy
            }, i.a.createElement(Ot.FontAwesomeIcon, {
              icon: _t.faTimes
            })))), i.a.createElement("div", {
              className: "row mt-3"
            }, i.a.createElement("div", {
              className: "col"
            }, this.renderStatus(e)))));
          }
        }]) && Jp(t.prototype, r), n && Jp(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component)).prototype, "_fieldImportMonitor", [a.computed], Object.getOwnPropertyDescriptor(Wp.prototype, "_fieldImportMonitor"), Wp.prototype), qp = Wp)) || qp,
      tf = U()(ef);
    function rf(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function nf(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function of(e, t) {
      return (of = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function af(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = lf(e);
        if (t) {
          var o = lf(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return cf(this, r);
      };
    }
    function cf(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function lf(e) {
      return (lf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function uf(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var sf,
      pf,
      ff,
      df,
      yf,
      bf,
      hf,
      mf,
      vf,
      gf,
      wf = Object(c.observer)((uf((Xp = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && of(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = af(a);
        function a() {
          var e;
          rf(this, a);
          for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];
          return (e = o.call.apply(o, [this].concat(r)))._removeUpload = function () {
            e._fileUploader.abort(), e._onRemovedCallback && e._onRemovedCallback(e._fileUploader);
          }, e;
        }
        return t = a, (r = [{
          key: "_fileUploader",
          get: function () {
            var e = this.props.fileUploader;
            if (!e) throw new Error("UploadMonitor requires a fileUploader");
            return e;
          }
        }, {
          key: "_onRemovedCallback",
          get: function () {
            return this.props.onRemove;
          }
        }, {
          key: "render",
          value: function () {
            var e = this.props.t;
            return i.a.createElement(j, {
              i18n: Re
            }, i.a.createElement("div", {
              className: "import-monitor-item"
            }, i.a.createElement("div", {
              className: "row align-items-center"
            }, i.a.createElement("div", {
              className: "col-4 pl-0"
            }, i.a.createElement("div", {
              className: "row align-items-center"
            }, i.a.createElement("div", {
              className: "col-3 align-self-center"
            }, i.a.createElement(Ot.FontAwesomeIcon, {
              icon: _t.faFileCsv
            })), i.a.createElement("div", {
              className: "col-9 align-self-center pl-0 pr-0 text-truncate",
              style: {
                fontSize: "smaller"
              }
            }, this._fileUploader.file.name))), i.a.createElement("div", {
              className: "col-7"
            }, i.a.createElement(Hp, {
              valueNow: this._fileUploader.percentComplete,
              failed: this._fileUploader.failed
            })), i.a.createElement("div", {
              className: "col-1 pr-0 text-right"
            }, i.a.createElement("a", {
              href: "#",
              onClick: this._removeUpload
            }, i.a.createElement(Ot.FontAwesomeIcon, {
              icon: _t.faTimes
            })))), i.a.createElement("div", {
              className: "row mt-3"
            }, i.a.createElement("div", {
              className: "col"
            }, this._fileUploader.uploading ? "".concat(e("if2_fields.uploading"), "...") : this._fileUploader.failed ? this._fileUploader.errorMessage : e("if2_fields.uploaded")))));
          }
        }]) && nf(t.prototype, r), n && nf(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component)).prototype, "_fileUploader", [a.computed], Object.getOwnPropertyDescriptor(Xp.prototype, "_fileUploader"), Xp.prototype), uf(Xp.prototype, "_onRemovedCallback", [a.computed], Object.getOwnPropertyDescriptor(Xp.prototype, "_onRemovedCallback"), Xp.prototype), Qp = Xp)) || Qp,
      Of = U()(wf);
    function _f(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function jf(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function Pf(e, t) {
      return (Pf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function Ef(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = Sf(e);
        if (t) {
          var o = Sf(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return kf(this, r);
      };
    }
    function kf(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return xf(e);
    }
    function xf(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function Sf(e) {
      return (Sf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function Cf(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var Rf,
      Nf,
      zf,
      Df,
      Tf = Object(c.observer)((pf = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && Pf(e, t);
        }(c, e);
        var t,
          r,
          n,
          o = Ef(c);
        function c(e) {
          var t;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, c), _f(t = o.call(this, e), "_fileUploaders", ff, xf(t)), _f(t, "_fieldImportMonitors", df, xf(t)), _f(t, "errorMessage", yf, xf(t)), _f(t, "uploadFile", bf, xf(t)), _f(t, "abort", hf, xf(t)), _f(t, "_updateImportMonitors", mf, xf(t)), _f(t, "_updateFileUploaders", vf, xf(t)), _f(t, "_removeFileUploader", gf, xf(t)), t._updateFieldImportMonitorsDisposer = Object(a.reaction)(function () {
            return t._fieldImportsTracker.fieldImports;
          }, function (e) {
            t._updateFieldImportMonitors(e);
          }, {
            fireImmediately: !0
          }), t;
        }
        return t = c, (r = [{
          key: "_fieldImportsTracker",
          get: function () {
            var e = this.props.fieldImportsTracker;
            if (!e) throw new Error("FieldsImporter requires a fieldImportsTracker");
            return e;
          }
        }, {
          key: "_importUrl",
          get: function () {
            var e = this.props.importUrl;
            if (!e) throw new Error("FieldsImporter requires an importUrl");
            return e;
          }
        }, {
          key: "_importStatusUrl",
          get: function () {
            var e = this.props.importStatusUrl;
            if (!e) throw new Error("FieldsImporter requires an importStatusUrl");
            return e;
          }
        }, {
          key: "_destroyImportUrl",
          get: function () {
            var e = this.props.destroyImportUrl;
            if (!e) throw new Error("FieldsImporter requires a destroyImportUrl");
            return e;
          }
        }, {
          key: "_csrf",
          get: function () {
            var e = this.props.csrf;
            if (!e) throw new Error("FieldsImporter requires a csrf");
            return e;
          }
        }, {
          key: "_maxUploadSize",
          get: function () {
            return this.props.maxUploadSize;
          }
        }, {
          key: "fieldImportMonitors",
          get: function () {
            return Object.values(this._fieldImportMonitors).sort(function (e, t) {
              return e.createdAt > t.createdAt ? 1 : -1;
            });
          }
        }, {
          key: "componentWillUnmount",
          value: function () {
            this.abort(), this._updateFieldImportMonitorsDisposer();
          }
        }, {
          key: "_updateFieldImportMonitors",
          value: function (e) {
            var t = this;
            e.forEach(function (e) {
              e.serial in t._fieldImportMonitors || (t._fieldImportMonitors[e.serial] = new Mp(t._importStatusUrl, t._destroyImportUrl, e.serial, t._csrf));
            });
            var r = e.map(function (e) {
              return e.serial.toString();
            });
            Object.keys(this._fieldImportMonitors).forEach(function (e) {
              r.includes(e) || delete t._fieldImportMonitors[e];
            });
          }
        }, {
          key: "renderUploads",
          value: function () {
            var e = this;
            return i.a.createElement(ip.TransitionGroup, {
              className: "upload-list"
            }, this._fileUploaders.map(function (t) {
              return i.a.createElement(ip.CSSTransition, {
                key: t.startedAt,
                timeout: 500,
                classNames: "monitor-item"
              }, i.a.createElement(Of, {
                key: t.startedAt,
                fileUploader: t,
                onRemove: e._removeFileUploader
              }));
            }));
          }
        }, {
          key: "renderImports",
          value: function () {
            var e = this;
            return i.a.createElement(ip.TransitionGroup, {
              className: "import-list"
            }, this.fieldImportMonitors.map(function (t) {
              return i.a.createElement(ip.CSSTransition, {
                key: t.fieldImport.serial,
                timeout: 500,
                classNames: "monitor-item"
              }, i.a.createElement(tf, {
                key: t.fieldImport.serial,
                fieldImportMonitor: t,
                destroyImportUrl: e._destroyImportUrl
              }));
            }));
          }
        }, {
          key: "renderErrors",
          value: function () {
            return 0 === this.errorMessage.length ? null : i.a.createElement("div", {
              className: "alert alert-danger mt-3"
            }, this.errorMessage);
          }
        }, {
          key: "render",
          value: function () {
            var e = this.props.t;
            return i.a.createElement(j, {
              i18n: Re
            }, i.a.createElement(ba.ReactInterval, {
              enabled: !0,
              timeout: 500,
              callback: this._updateImportMonitors
            }), i.a.createElement("div", {
              className: "fields-importer"
            }, i.a.createElement("form", null, i.a.createElement("div", {
              className: "custom-file"
            }, i.a.createElement("input", {
              type: "file",
              className: "custom-file-input",
              id: "import-file",
              onChange: this.uploadFile
            }), i.a.createElement("label", {
              className: "custom-file-label",
              htmlFor: "import-file"
            }, e("if2_fields.choose_fields_spreadsheet")))), this.renderErrors(), this.renderUploads(), this.renderImports()));
          }
        }]) && jf(t.prototype, r), n && jf(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), c;
      }(o.Component), ff = Cf(pf.prototype, "_fileUploaders", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return [];
        }
      }), df = Cf(pf.prototype, "_fieldImportMonitors", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return {};
        }
      }), yf = Cf(pf.prototype, "errorMessage", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return "";
        }
      }), Cf(pf.prototype, "_fieldImportsTracker", [a.computed], Object.getOwnPropertyDescriptor(pf.prototype, "_fieldImportsTracker"), pf.prototype), Cf(pf.prototype, "_importUrl", [a.computed], Object.getOwnPropertyDescriptor(pf.prototype, "_importUrl"), pf.prototype), Cf(pf.prototype, "_importStatusUrl", [a.computed], Object.getOwnPropertyDescriptor(pf.prototype, "_importStatusUrl"), pf.prototype), Cf(pf.prototype, "_destroyImportUrl", [a.computed], Object.getOwnPropertyDescriptor(pf.prototype, "_destroyImportUrl"), pf.prototype), Cf(pf.prototype, "_csrf", [a.computed], Object.getOwnPropertyDescriptor(pf.prototype, "_csrf"), pf.prototype), Cf(pf.prototype, "_maxUploadSize", [a.computed], Object.getOwnPropertyDescriptor(pf.prototype, "_maxUploadSize"), pf.prototype), Cf(pf.prototype, "fieldImportMonitors", [a.computed], Object.getOwnPropertyDescriptor(pf.prototype, "fieldImportMonitors"), pf.prototype), Cf(pf.prototype, "_updateFieldImportMonitors", [a.action], Object.getOwnPropertyDescriptor(pf.prototype, "_updateFieldImportMonitors"), pf.prototype), bf = Cf(pf.prototype, "uploadFile", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function () {
            e.errorMessage = "";
            var t = zu()("#import-file"),
              r = t.prop("files");
            if (0 !== r.length) {
              var n = r[0];
              if (e._maxUploadSize && n.size > e._maxUploadSize) {
                var o = e.props.t;
                e.errorMessage = o("if2_fields.max_import_size_exceeded", {
                  max: "".concat(e._maxUploadSize, " bytes")
                });
              } else e._fileUploaders.push(new pp(e._importUrl, e._csrf, n, e._updateFileUploaders)), t.val("");
            }
          };
        }
      }), hf = Cf(pf.prototype, "abort", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function () {
            e._fileUploaders.forEach(function (e) {
              return e.abort();
            });
          };
        }
      }), mf = Cf(pf.prototype, "_updateImportMonitors", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function () {
            Object.values(e._fieldImportMonitors).forEach(function (e) {
              return e.update();
            });
          };
        }
      }), vf = Cf(pf.prototype, "_updateFileUploaders", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function () {
            e._fileUploaders = e._fileUploaders.filter(function (e) {
              return e.uploading || e.failed;
            });
          };
        }
      }), gf = Cf(pf.prototype, "_removeFileUploader", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            e._fileUploaders = e._fileUploaders.filter(function (e) {
              return e.startedAt !== t.startedAt;
            });
          };
        }
      }), sf = pf)) || sf,
      Mf = U()(Tf);
    function Ff(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function If(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function Af(e, t) {
      return (Af = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function Lf(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = Bf(e);
        if (t) {
          var o = Bf(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return Uf(this, r);
      };
    }
    function Uf(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return Vf(e);
    }
    function Vf(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function Bf(e) {
      return (Bf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function qf(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var Wf,
      Hf,
      Gf,
      Jf = Object(c.observer)((Nf = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && Af(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = Lf(a);
        function a(e) {
          var t;
          if (function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, a), Ff(t = o.call(this, e), "visible", zf, Vf(t)), Ff(t, "_handleClose", Df, Vf(t)), t._csrf = zu()("[name='csrf-token']").prop("content"), !t._csrf) throw new Error("ImportFieldsModal requires a csrf-token");
          return t._modalContainerRef = i.a.createRef(), t;
        }
        return t = a, (r = [{
          key: "_onClosedCallback",
          get: function () {
            return this.props.onClose;
          }
        }, {
          key: "render",
          value: function () {
            var e = this.props,
              t = e.t,
              r = e.importUrl,
              n = e.importStatusUrl,
              o = e.destroyImportUrl,
              a = e.fieldImportsTracker,
              c = e.formatUrl,
              l = e.maxUploadSize;
            return i.a.createElement(j, {
              i18n: Re
            }, i.a.createElement("div", {
              className: "import-fields-modal",
              ref: this._modalContainerRef
            }), i.a.createElement(op, {
              show: this.visible,
              backdrop: "static",
              onHide: this._handleClose,
              container: this._modalContainerRef
            }, i.a.createElement(op.Header, {
              closeButton: !0
            }, i.a.createElement(op.Title, null, t("if2_fields.import_fields"))), i.a.createElement(op.Body, null, i.a.createElement(Mf, {
              importUrl: r,
              importStatusUrl: n,
              destroyImportUrl: o,
              fieldImportsTracker: a,
              maxUploadSize: l,
              csrf: this._csrf
            })), i.a.createElement(op.Footer, null, i.a.createElement("div", {
              className: "import-fields-format"
            }, t("if2_fields.import_file_must_follow"), " ", i.a.createElement("a", {
              href: c
            }, t("if2_fields.specific_format"))), i.a.createElement(su, {
              variant: "secondary",
              onClick: this._handleClose
            }, t("if2_fields.close")))));
          }
        }]) && If(t.prototype, r), n && If(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component), zf = qf(Nf.prototype, "visible", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return !0;
        }
      }), qf(Nf.prototype, "_onClosedCallback", [a.computed], Object.getOwnPropertyDescriptor(Nf.prototype, "_onClosedCallback"), Nf.prototype), Df = qf(Nf.prototype, "_handleClose", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function () {
            e.visible = !1, e._onClosedCallback && e._onClosedCallback();
          };
        }
      }), Rf = Nf)) || Rf,
      $f = U()(Jf);
    function Kf(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function Zf(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function Yf(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var Qf,
      Xf,
      ed,
      td,
      rd,
      nd = (Hf = Yf((Wf = function () {
        function e(t) {
          var r = this;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), Kf(this, "_fieldImports", Hf, this), this.update = function () {
            return fetch(r._importUrl).then(function (e) {
              if (!e.ok) throw new Error(e.statusText);
              return e.json();
            }).then(r._handleUpdate).catch(function (e) {
              return console.error("Failed to get field imports for account: ".concat(e.message));
            });
          }, Kf(this, "_handleUpdate", Gf, this), this._importUrl = t;
        }
        var t, r, n;
        return t = e, (r = [{
          key: "fieldImports",
          get: function () {
            return Object.values(this._fieldImports);
          }
        }, {
          key: "anyFailures",
          get: function () {
            return this.fieldImports.some(function (e) {
              return e.failed;
            });
          }
        }]) && Zf(t.prototype, r), n && Zf(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), e;
      }()).prototype, "_fieldImports", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return {};
        }
      }), Gf = Yf(Wf.prototype, "_handleUpdate", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            t.forEach(function (t) {
              t.serial in e._fieldImports ? e._fieldImports[t.serial].update(t) : e._fieldImports[t.serial] = new xp(t);
            });
            var r = t.map(function (e) {
              return e.serial.toString();
            });
            Object.keys(e._fieldImports).forEach(function (t) {
              r.includes(t) || delete e._fieldImports[t];
            });
          };
        }
      }), Yf(Wf.prototype, "fieldImports", [a.computed], Object.getOwnPropertyDescriptor(Wf.prototype, "fieldImports"), Wf.prototype), Yf(Wf.prototype, "anyFailures", [a.computed], Object.getOwnPropertyDescriptor(Wf.prototype, "anyFailures"), Wf.prototype), Wf);
    function od(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function id(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function ad(e, t) {
      return (ad = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function cd(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = sd(e);
        if (t) {
          var o = sd(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return ld(this, r);
      };
    }
    function ld(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return ud(e);
    }
    function ud(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function sd(e) {
      return (sd = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function pd(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var fd = Object(c.observer)((Xf = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && ad(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = cd(a);
        function a(e) {
          var t;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, a), od(t = o.call(this, e), "_importFieldsModalActivated", ed, ud(t)), t.handleImportFieldsClicked = function (e) {
            e.preventDefault(), t.activateImportFieldsModal();
          }, od(t, "activateImportFieldsModal", td, ud(t)), od(t, "deactivateImportFieldsModal", rd, ud(t)), t.renderButton = function (e) {
            return i.a.createElement(su, {
              variant: "secondary",
              className: "new-field-button",
              onClick: t.handleImportFieldsClicked
            }, e("if2_fields.imports"), " ", i.a.createElement(Ru, {
              variant: "".concat(t._fieldImportsTracker.anyFailures ? "danger" : "light")
            }, t._fieldImportsTracker.fieldImports.length));
          }, t.renderDropDown = function (e) {
            return i.a.createElement(i.a.Fragment, null, i.a.createElement(ju.Toggle, {
              split: !0,
              variant: "primary"
            }), i.a.createElement(ju.Menu, null, i.a.createElement(ju.Item, {
              href: "#",
              onClick: t.handleImportFieldsClicked
            }, e("if2_fields.import_fields"))));
          }, t._fieldImportsTracker = new nd(t._importUrl), t._fieldImportsTracker.update(), t;
        }
        return t = a, (r = [{
          key: "_newUrl",
          get: function () {
            var e = this.props.newUrl;
            if (!e) throw new Error("NewFieldButton requires an newUrl");
            return e;
          }
        }, {
          key: "_importUrl",
          get: function () {
            var e = this.props.importUrl;
            if (!e) throw new Error("NewFieldButton requires an importUrl");
            return e;
          }
        }, {
          key: "_importStatusUrl",
          get: function () {
            var e = this.props.importStatusUrl;
            if (!e) throw new Error("NewFieldButton requires an importStatusUrl");
            return e;
          }
        }, {
          key: "_destroyImportUrl",
          get: function () {
            var e = this.props.destroyImportUrl;
            if (!e) throw new Error("NewFieldButton requires a destroyImportUrl");
            return e;
          }
        }, {
          key: "_formatUrl",
          get: function () {
            var e = this.props.formatUrl;
            if (!e) throw new Error("NewFieldButton requires a formatUrl");
            return e;
          }
        }, {
          key: "_maxUploadSize",
          get: function () {
            var e = this.props.maxUploadSize;
            if (!e) throw new Error("NewFieldButton requires a maxUploadSize");
            return e;
          }
        }, {
          key: "render",
          value: function () {
            var e = this.props.t;
            return i.a.createElement(j, {
              i18n: Re
            }, i.a.createElement(ba.ReactInterval, {
              enabled: !0,
              timeout: this._importFieldsModalActivated ? 500 : 5e3,
              callback: this._fieldImportsTracker.update
            }), i.a.createElement(ju, {
              as: ku
            }, i.a.createElement(su, {
              variant: "primary",
              href: this._newUrl
            }, e("if2_fields.new_field")), this._fieldImportsTracker.fieldImports.length > 0 ? this.renderButton(e) : this.renderDropDown(e)), this._importFieldsModalActivated ? i.a.createElement($f, {
              importUrl: this._importUrl,
              importStatusUrl: this._importStatusUrl,
              destroyImportUrl: this._destroyImportUrl,
              formatUrl: this._formatUrl,
              fieldImportsTracker: this._fieldImportsTracker,
              maxUploadSize: this._maxUploadSize,
              onClose: this.deactivateImportFieldsModal
            }) : null);
          }
        }]) && id(t.prototype, r), n && id(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component), ed = pd(Xf.prototype, "_importFieldsModalActivated", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return !1;
        }
      }), pd(Xf.prototype, "_newUrl", [a.computed], Object.getOwnPropertyDescriptor(Xf.prototype, "_newUrl"), Xf.prototype), pd(Xf.prototype, "_importUrl", [a.computed], Object.getOwnPropertyDescriptor(Xf.prototype, "_importUrl"), Xf.prototype), pd(Xf.prototype, "_importStatusUrl", [a.computed], Object.getOwnPropertyDescriptor(Xf.prototype, "_importStatusUrl"), Xf.prototype), pd(Xf.prototype, "_destroyImportUrl", [a.computed], Object.getOwnPropertyDescriptor(Xf.prototype, "_destroyImportUrl"), Xf.prototype), pd(Xf.prototype, "_formatUrl", [a.computed], Object.getOwnPropertyDescriptor(Xf.prototype, "_formatUrl"), Xf.prototype), pd(Xf.prototype, "_maxUploadSize", [a.computed], Object.getOwnPropertyDescriptor(Xf.prototype, "_maxUploadSize"), Xf.prototype), td = pd(Xf.prototype, "activateImportFieldsModal", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function () {
            e._importFieldsModalActivated = !0;
          };
        }
      }), rd = pd(Xf.prototype, "deactivateImportFieldsModal", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function () {
            e._importFieldsModalActivated = !1;
          };
        }
      }), Qf = Xf)) || Qf,
      dd = U()(fd),
      yd = r(20),
      bd = r(80),
      hd = r.n(bd),
      md = r(21),
      vd = r.n(md),
      gd = r(5),
      wd = r.n(gd),
      Od = r(50),
      _d = r.n(Od),
      jd = Math.pow(2, 31) - 1;
    function Pd() {
      var e = Ga(),
        t = Object(o.useRef)();
      return Tu(function () {
        return clearTimeout(t.current);
      }), Object(o.useMemo)(function () {
        var r = function () {
          return clearTimeout(t.current);
        };
        return {
          set: function (n, o) {
            void 0 === o && (o = 0), e() && (r(), o <= jd ? t.current = setTimeout(n, o) : function e(t, r, n) {
              var o = n - Date.now();
              t.current = o <= jd ? setTimeout(r, o) : setTimeout(function () {
                return e(t, r, n);
              }, jd);
            }(t, n, Date.now() + o));
          },
          clear: r
        };
      }, []);
    }
    var Ed = i.a.forwardRef(function (e, t) {
      var r = e.flip,
        n = e.offset,
        a = e.placement,
        c = e.containerPadding,
        l = void 0 === c ? 5 : c,
        u = e.popperConfig,
        s = void 0 === u ? {} : u,
        p = e.transition,
        f = Ha(),
        d = f[0],
        y = f[1],
        b = Ha(),
        h = b[0],
        m = b[1],
        v = Yl(y, t),
        g = ts(e.container),
        w = ts(e.target),
        O = Object(o.useState)(!e.show),
        _ = O[0],
        j = O[1],
        P = cl(w, d, wl({
          placement: a,
          enableEvents: !!e.show,
          containerPadding: l || 5,
          flip: r,
          offset: n,
          arrowElement: h,
          popperConfig: s
        })),
        E = P.styles,
        k = P.attributes,
        x = qa(P, ["styles", "attributes"]);
      e.show ? _ && j(!1) : e.transition || _ || j(!0);
      var S = e.show || p && !_;
      if (gl(d, e.onHide, {
        disabled: !e.rootClose || e.rootCloseDisabled,
        clickTrigger: e.rootCloseEvent
      }), !S) return null;
      var C = e.children(Wa({}, x, {
        show: !!e.show,
        props: Wa({}, k.popper, {
          style: E.popper,
          ref: v
        }),
        arrowProps: Wa({}, k.arrow, {
          style: E.arrow,
          ref: m
        })
      }));
      if (p) {
        var R = e.onExit,
          N = e.onExiting,
          z = e.onEnter,
          D = e.onEntering,
          T = e.onEntered;
        C = i.a.createElement(p, {
          in: e.show,
          appear: !0,
          onExit: R,
          onExiting: N,
          onExited: function () {
            j(!0), e.onExited && e.onExited.apply(e, arguments);
          },
          onEnter: z,
          onEntering: D,
          onEntered: T
        }, C);
      }
      return g ? bl.a.createPortal(C, g) : null;
    });
    Ed.displayName = "Overlay", Ed.propTypes = {
      show: Ca.a.bool,
      placement: Ca.a.oneOf(_c),
      target: Ca.a.any,
      container: Ca.a.any,
      flip: Ca.a.bool,
      children: Ca.a.func.isRequired,
      containerPadding: Ca.a.number,
      popperConfig: Ca.a.object,
      rootClose: Ca.a.bool,
      rootCloseEvent: Ca.a.oneOf(["click", "mousedown"]),
      rootCloseDisabled: Ca.a.bool,
      onHide: function (e) {
        for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++) r[n - 1] = arguments[n];
        var o;
        return e.rootClose ? (o = Ca.a.func).isRequired.apply(o, [e].concat(r)) : Ca.a.func.apply(Ca.a, [e].concat(r));
      },
      transition: Ca.a.elementType,
      onEnter: Ca.a.func,
      onEntering: Ca.a.func,
      onEntered: Ca.a.func,
      onExit: Ca.a.func,
      onExiting: Ca.a.func,
      onExited: Ca.a.func
    };
    var kd = Ed,
      xd = ["children", "transition", "popperConfig"],
      Sd = ["props", "arrowProps", "show", "update", "forceUpdate", "placement", "state"],
      Cd = {
        transition: Ps,
        rootClose: !1,
        show: !1,
        placement: "top"
      };
    function Rd(e) {
      var t = e.children,
        r = e.transition,
        n = e.popperConfig,
        a = void 0 === n ? {} : n,
        c = ma(e, xd),
        l = Object(o.useRef)({}),
        u = nu(),
        s = u[0],
        p = u[1],
        f = !0 === r ? Ps : r || null;
      return i.a.createElement(kd, ha({}, c, {
        ref: s,
        popperConfig: ha({}, a, {
          modifiers: p.concat(a.modifiers || [])
        }),
        transition: f
      }), function (e) {
        var n,
          o = e.props,
          a = e.arrowProps,
          c = e.show,
          u = e.update,
          s = (e.forceUpdate, e.placement),
          p = e.state,
          f = ma(e, Sd);
        !function (e, t) {
          var r = e.ref,
            n = t.ref;
          e.ref = r.__wrapped || (r.__wrapped = function (e) {
            return r(hl(e));
          }), t.ref = n.__wrapped || (n.__wrapped = function (e) {
            return n(hl(e));
          });
        }(o, a);
        var d = Object.assign(l.current, {
          state: p,
          scheduleUpdate: u,
          placement: s,
          outOfBoundaries: (null == p || null == (n = p.modifiersData.hide) ? void 0 : n.isReferenceHidden) || !1
        });
        return "function" == typeof t ? t(ha({}, f, o, {
          placement: s,
          show: c
        }, !r && c && {
          className: "show"
        }, {
          popper: d,
          arrowProps: a
        })) : i.a.cloneElement(t, ha({}, f, o, {
          placement: s,
          arrowProps: a,
          popper: d,
          className: wa()(t.props.className, !r && c && "show"),
          style: ha({}, t.props.style, o.style)
        }));
      });
    }
    Rd.defaultProps = Cd;
    var Nd = Rd,
      zd = ["trigger", "overlay", "children", "popperConfig", "show", "defaultShow", "onToggle", "delay", "placement", "flip"],
      Dd = function (e) {
        function t() {
          return e.apply(this, arguments) || this;
        }
        return cs(t, e), t.prototype.render = function () {
          return this.props.children;
        }, t;
      }(i.a.Component);
    function Td(e, t, r) {
      var n = t[0],
        o = n.currentTarget,
        i = n.relatedTarget || n.nativeEvent[r];
      i && i === o || ll(o, i) || e.apply(void 0, t);
    }
    function Md(e) {
      var t = e.trigger,
        r = e.overlay,
        n = e.children,
        a = e.popperConfig,
        c = void 0 === a ? {} : a,
        l = e.show,
        u = e.defaultShow,
        s = void 0 !== u && u,
        p = e.onToggle,
        f = e.delay,
        d = e.placement,
        y = e.flip,
        b = void 0 === y ? d && -1 !== d.indexOf("auto") : y,
        h = ma(e, zd),
        m = Object(o.useRef)(null),
        v = Pd(),
        g = Object(o.useRef)(""),
        w = Ta(l, s, p),
        O = w[0],
        _ = w[1],
        j = function (e) {
          return e && "object" == typeof e ? e : {
            show: e,
            hide: e
          };
        }(f),
        P = "function" != typeof n ? i.a.Children.only(n).props : {},
        E = P.onFocus,
        k = P.onBlur,
        x = P.onClick,
        S = Object(o.useCallback)(function () {
          return hl(m.current);
        }, []),
        C = Object(o.useCallback)(function () {
          v.clear(), g.current = "show", j.show ? v.set(function () {
            "show" === g.current && _(!0);
          }, j.show) : _(!0);
        }, [j.show, _, v]),
        R = Object(o.useCallback)(function () {
          v.clear(), g.current = "hide", j.hide ? v.set(function () {
            "hide" === g.current && _(!1);
          }, j.hide) : _(!1);
        }, [j.hide, _, v]),
        N = Object(o.useCallback)(function () {
          C();
          for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
          null == E || E.apply(void 0, t);
        }, [C, E]),
        z = Object(o.useCallback)(function () {
          R();
          for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
          null == k || k.apply(void 0, t);
        }, [R, k]),
        D = Object(o.useCallback)(function () {
          _(!O), x && x.apply(void 0, arguments);
        }, [x, _, O]),
        T = Object(o.useCallback)(function () {
          for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
          Td(C, t, "fromElement");
        }, [C]),
        M = Object(o.useCallback)(function () {
          for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
          Td(R, t, "toElement");
        }, [R]),
        F = null == t ? [] : [].concat(t),
        I = {};
      return -1 !== F.indexOf("click") && (I.onClick = D), -1 !== F.indexOf("focus") && (I.onFocus = N, I.onBlur = z), -1 !== F.indexOf("hover") && (I.onMouseOver = T, I.onMouseOut = M), i.a.createElement(i.a.Fragment, null, "function" == typeof n ? n(ha({}, I, {
        ref: m
      })) : i.a.createElement(Dd, {
        ref: m
      }, Object(o.cloneElement)(n, I)), i.a.createElement(Nd, ha({}, h, {
        show: O,
        onHide: R,
        flip: b,
        placement: d,
        popperConfig: c,
        target: S
      }), r));
    }
    Md.defaultProps = {
      defaultShow: !1,
      trigger: ["hover", "focus"]
    };
    var Fd = Md,
      Id = ["bsPrefix", "placement", "className", "style", "children", "arrowProps", "popper", "show"],
      Ad = i.a.forwardRef(function (e, t) {
        var r = e.bsPrefix,
          n = e.placement,
          o = e.className,
          a = e.style,
          c = e.children,
          l = e.arrowProps,
          u = (e.popper, e.show, ma(e, Id));
        r = Al(r, "tooltip");
        var s = ((null == n ? void 0 : n.split("-")) || [])[0];
        return i.a.createElement("div", ha({
          ref: t,
          style: a,
          role: "tooltip",
          "x-placement": s,
          className: wa()(o, r, "bs-tooltip-" + s)
        }, u), i.a.createElement("div", ha({
          className: "arrow"
        }, l)), i.a.createElement("div", {
          className: r + "-inner"
        }, c));
      });
    Ad.defaultProps = {
      placement: "right"
    }, Ad.displayName = "Tooltip";
    var Ld,
      Ud,
      Vd,
      Bd,
      qd,
      Wd,
      Hd,
      Gd,
      Jd,
      $d,
      Kd = Ad,
      Zd = r(15),
      Yd = r.n(Zd);
    function Qd(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Xd(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function ey(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function ty(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function ry(e, t) {
      return (ry = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function ny(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = ay(e);
        if (t) {
          var o = ay(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return oy(this, r);
      };
    }
    function oy(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return iy(e);
    }
    function iy(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function ay(e) {
      return (ay = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function cy(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var ly,
      uy,
      sy = (Ld = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && ry(e, t);
        }(i, e);
        var t,
          r,
          n,
          o = ny(i);
        function i(e) {
          var t;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, i), (t = o.call(this)).map = void 0, t.centerMarker = void 0, t.circle = void 0, ey(t, "centerPoint", Ud, iy(t)), ey(t, "color", Vd, iy(t)), ey(t, "opacity", Bd, iy(t)), ey(t, "geoJSON", qd, iy(t)), ey(t, "isResizingCircle", Wd, iy(t)), ey(t, "radius", Hd, iy(t)), ey(t, "onDrawCircleEnd", Gd, iy(t)), ey(t, "onResizeCircle", Jd, iy(t)), ey(t, "onResizeCircleEnd", $d, iy(t));
          var r = function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = null != arguments[t] ? arguments[t] : {};
              t % 2 ? Qd(Object(r), !0).forEach(function (t) {
                Xd(e, t, r[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Qd(Object(r)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
              });
            }
            return e;
          }({
            centerPoint: t.centerPoint,
            color: t.color,
            opacity: t.opacity,
            radius: t.radius,
            map: null,
            popup: null,
            isResizingCircle: t.isResizingCircle,
            id: ""
          }, e || {});
          if (!r.map) throw new Error("Attempted to instantiate Circle without a map");
          if (!r.centerPoint) throw new Error("Attempted to instantiate Circle without a centerPoint");
          return t.map = r.map, t.popup = r.popup, t.radius = r.radius, t.centerPoint = r.centerPoint, t.color = r.color, t.opacity = r.opacity, t.isResizingCircle = r.isResizingCircle, t.id = r.id, t.init(), t.update(), t;
        }
        return t = i, (r = [{
          key: "area",
          get: function () {
            return Math.PI * this.radius * this.radius;
          }
        }, {
          key: "latitude",
          get: function () {
            return this.centerPoint.lat;
          }
        }, {
          key: "longitude",
          get: function () {
            return this.centerPoint.lng;
          }
        }, {
          key: "clearCenterMarker",
          value: function () {
            this.centerMarker && this.centerMarker.remove(), this.centerMarker = null;
          }
        }, {
          key: "clearCircle",
          value: function () {
            this.circle && this.circle.remove(), this.circle = null;
          }
        }, {
          key: "clearEventHandlers",
          value: function () {
            this.map.off("click", this.onDrawCircleEnd), this.map.off("mousemove", this.onResizeCircle);
          }
        }, {
          key: "init",
          value: function () {
            this.circle = wd.a.circle(this.centerPoint, {
              radius: this.radius,
              color: this.color,
              fillOpacity: this.opacity
            }).addTo(this.map), this.isResizingCircle && (this.centerMarker = wd.a.circleMarker(this.centerPoint, {
              radius: 5,
              color: "white",
              fill: !0,
              fillColor: "white",
              fillOpacity: 1,
              bubblingMouseEvents: !1
            }).addTo(this.map), this.map.on("click", this.onDrawCircleEnd), this.map.on("mousemove", this.onResizeCircle)), this.popup && !this.isResizingCircle && this.circle.bindPopup(this.popup, {
              minWidth: 30
            });
          }
        }, {
          key: "remove",
          value: function () {
            this.clearCenterMarker(), this.clearCircle(), this.clearEventHandlers();
          }
        }, {
          key: "resizeCircleToPoint",
          value: function (e) {
            this.radius = e.distanceTo(this.centerPoint), this.update();
          }
        }, {
          key: "setRadius",
          value: function (e) {
            this.radius = e;
          }
        }, {
          key: "update",
          value: function () {
            this.circle && (this.circle.setLatLng(this.centerPoint), this.circle.setRadius(this.radius), this.geoJSON = this.circle.toGeoJSON(), this.geoJSON.properties.pointType = "circle", this.geoJSON.properties.radius = this.radius, this.geoJSON.properties.radiusUnits = "meters");
          }
        }]) && ty(t.prototype, r), n && ty(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), i;
      }(Yd.a), Ud = cy(Ld.prototype, "centerPoint", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return {};
        }
      }), Vd = cy(Ld.prototype, "color", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return "#3388ff";
        }
      }), Bd = cy(Ld.prototype, "opacity", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return "0.2";
        }
      }), qd = cy(Ld.prototype, "geoJSON", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), Wd = cy(Ld.prototype, "isResizingCircle", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return !1;
        }
      }), Hd = cy(Ld.prototype, "radius", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return 0;
        }
      }), cy(Ld.prototype, "area", [a.computed], Object.getOwnPropertyDescriptor(Ld.prototype, "area"), Ld.prototype), cy(Ld.prototype, "latitude", [a.computed], Object.getOwnPropertyDescriptor(Ld.prototype, "latitude"), Ld.prototype), cy(Ld.prototype, "longitude", [a.computed], Object.getOwnPropertyDescriptor(Ld.prototype, "longitude"), Ld.prototype), Gd = cy(Ld.prototype, "onDrawCircleEnd", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            e.onResizeCircleEnd(t), e.emit("drawCircleEnd", e), e.map.off("click", e.onDrawCircleEnd), e.popup && e.isResizingCircle && (e.circle.bindPopup(e.popup, {
              minWidth: 30
            }), e.isResizingCircle = !1);
          };
        }
      }), Jd = cy(Ld.prototype, "onResizeCircle", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            e.resizeCircleToPoint(t.latlng);
          };
        }
      }), $d = cy(Ld.prototype, "onResizeCircleEnd", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            e.resizeCircleToPoint(t.latlng), e.map.off("mousemove", e.onResizeCircle);
          };
        }
      }), cy(Ld.prototype, "setRadius", [a.action], Object.getOwnPropertyDescriptor(Ld.prototype, "setRadius"), Ld.prototype), Ld);
    function py(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function fy(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function dy(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function yy(e, t) {
      return (yy = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function by(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = vy(e);
        if (t) {
          var o = vy(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return hy(this, r);
      };
    }
    function hy(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return my(e);
    }
    function my(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function vy(e) {
      return (vy = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function gy(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var wy,
      Oy,
      _y,
      jy,
      Py,
      Ey,
      ky,
      xy,
      Sy = (ly = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && yy(e, t);
        }(i, e);
        var t,
          r,
          n,
          o = by(i);
        function i(e) {
          var t;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, i), (t = o.call(this)).map = void 0, t.polyline = void 0, t.startingPoint = void 0, function (e, t, r, n) {
            r && Object.defineProperty(e, t, {
              enumerable: r.enumerable,
              configurable: r.configurable,
              writable: r.writable,
              value: r.initializer ? r.initializer.call(n) : void 0
            });
          }(t, "points", uy, my(t)), t.disposePolylineUpdater = Object(a.autorun)(function () {
            1 === t.points.length && t.start(t.points[0]), t.points.length < 2 || t.polyline.setLatLngs(t.points);
          }), t.onClickPolyline = function (e) {
            return t.emit("click", {
              event: e,
              points: t.points
            });
          }, t.onClickStartingPoint = function (e) {
            return t.emit("clickStartingPoint", e);
          };
          var r = function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = null != arguments[t] ? arguments[t] : {};
              t % 2 ? py(Object(r), !0).forEach(function (t) {
                fy(e, t, r[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : py(Object(r)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
              });
            }
            return e;
          }({
            points: [],
            map: null
          }, e || {});
          if (!r.map) throw new Error("Attempted to instantiate Polyline without a map");
          return t.map = r.map, t.init(), t.points = r.points, t;
        }
        return t = i, (r = [{
          key: "addPoint",
          value: function (e) {
            this.points.push(e);
          }
        }, {
          key: "clearPolyline",
          value: function () {
            this.polyline && (this.polyline.off("click", this.onClickPolyline), this.polyline.remove()), this.polyline = null;
          }
        }, {
          key: "clearStartingPoint",
          value: function () {
            this.startingPoint && (this.startingPoint.off("click", this.onClickStartingPoint), this.startingPoint.remove()), this.startingPoint = null;
          }
        }, {
          key: "init",
          value: function () {
            this.polyline = wd.a.polyline([], {
              className: "field-visual-editor-polyline",
              color: "white"
            }).addTo(this.map), this.polyline.on("click", this.onClickPolyline);
          }
        }, {
          key: "reset",
          value: function () {
            this.points = [], this.polyline && this.polyline.remove(), this.polyline = null, this.clearStartingPoint(), this.init();
          }
        }, {
          key: "remove",
          value: function () {
            this.clearStartingPoint(), this.clearPolyline(), this.disposePolylineUpdater();
          }
        }, {
          key: "start",
          value: function (e) {
            this.clearStartingPoint(), this.startingPoint = wd.a.circleMarker(e, {
              radius: 5,
              color: "white",
              fill: !0,
              fillColor: "white",
              fillOpacity: 1,
              bubblingMouseEvents: !1
            }).addTo(this.map), this.startingPoint.on("click", this.onClickStartingPoint);
          }
        }]) && dy(t.prototype, r), n && dy(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), i;
      }(Yd.a), uy = gy(ly.prototype, "points", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return [];
        }
      }), gy(ly.prototype, "addPoint", [a.action], Object.getOwnPropertyDescriptor(ly.prototype, "addPoint"), ly.prototype), gy(ly.prototype, "reset", [a.action], Object.getOwnPropertyDescriptor(ly.prototype, "reset"), ly.prototype), ly),
      Cy = r(81),
      Ry = r.n(Cy),
      Ny = r(82),
      zy = r.n(Ny);
    function Dy(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Ty(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function My(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function Fy(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function Iy(e, t) {
      return (Iy = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function Ay(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = Vy(e);
        if (t) {
          var o = Vy(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return Ly(this, r);
      };
    }
    function Ly(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return Uy(e);
    }
    function Uy(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function Vy(e) {
      return (Vy = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function By(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var qy,
      Wy = (wy = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && Iy(e, t);
        }(i, e);
        var t,
          r,
          n,
          o = Ay(i);
        function i(e) {
          var t;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, i), (t = o.call(this)).draggable = void 0, t.map = void 0, t.marker = void 0, t.point = void 0, My(t, "color", Oy, Uy(t)), My(t, "fill", _y, Uy(t)), My(t, "fillColor", jy, Uy(t)), My(t, "fillOpacity", Py, Uy(t)), My(t, "radius", Ey, Uy(t)), My(t, "dragEndHandler", ky, Uy(t)), My(t, "dragHandler", xy, Uy(t));
          var r = function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = null != arguments[t] ? arguments[t] : {};
              t % 2 ? Dy(Object(r), !0).forEach(function (t) {
                Ty(e, t, r[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Dy(Object(r)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
              });
            }
            return e;
          }({
            radius: t.radius,
            color: t.color,
            fill: t.fill,
            fillColor: t.fillColor,
            fillOpacity: t.fillOpacity,
            map: null,
            point: null,
            popup: null,
            id: ""
          }, e || {});
          if (!r.map) throw new Error("Attempted to instantiate PolygonVertex without a map");
          if (!r.point) throw new Error("Attempted to instantiate PolygonVertex without a point");
          return t.map = r.map, t.point = r.point, t.radius = r.radius, t.color = r.color, t.fill = r.fill, t.fillColor = r.fillColor, t.fillOpacity = r.fillOpacity, t.popup = r.popup, t.id = r.id, t.initMarker(), t.initDraggable(), t.initPopup(), t;
        }
        return t = i, (r = [{
          key: "destroy",
          value: function () {
            this.destroyDraggable(), this.destroyMarker();
          }
        }, {
          key: "destroyDraggable",
          value: function () {
            this.draggable.off("drag", this.dragHandler), this.draggable.off("dragend", this.dragEndHandler), this.draggable = null;
          }
        }, {
          key: "destroyMarker",
          value: function () {
            this.marker.remove(), this.marker = null;
          }
        }, {
          key: "initDraggable",
          value: function () {
            if (this.marker) {
              var e = this.marker.getElement();
              this.draggable = new wd.a.Draggable(e), this.draggable.enable(), this.draggable.on("drag", this.dragHandler), this.draggable.on("dragend", this.dragEndHandler);
            }
          }
        }, {
          key: "initMarker",
          value: function () {
            this.marker = wd.a.circleMarker(this.point, {
              radius: this.radius,
              color: this.color,
              fill: this.fill,
              fillColor: this.fillColor,
              fillOpacity: this.fillOpacity,
              bubblingMouseEvents: !1
            }).addTo(this.map);
          }
        }, {
          key: "initPopup",
          value: function () {
            this.popup && this.marker.bindPopup(this.popup, {
              minWidth: 30
            });
          }
        }]) && Fy(t.prototype, r), n && Fy(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), i;
      }(Yd.a), Oy = By(wy.prototype, "color", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return "white";
        }
      }), _y = By(wy.prototype, "fill", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return !0;
        }
      }), jy = By(wy.prototype, "fillColor", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return "white";
        }
      }), Py = By(wy.prototype, "fillOpacity", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return 1;
        }
      }), Ey = By(wy.prototype, "radius", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return 5;
        }
      }), ky = By(wy.prototype, "dragEndHandler", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function () {
            e.destroyDraggable(), e.marker.remove(), e.marker.setLatLng(e.point), e.marker.addTo(e.map), e.initDraggable();
          };
        }
      }), xy = By(wy.prototype, "dragHandler", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            e.point = e.map.mouseEventToLatLng(t.originalEvent), e.emit("drag", {
              id: e.id,
              point: e.point
            });
          };
        }
      }), By(wy.prototype, "initMarker", [a.action], Object.getOwnPropertyDescriptor(wy.prototype, "initMarker"), wy.prototype), wy);
    function Hy(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function Gy(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function Jy(e, t) {
      return (Jy = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function $y(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = Zy(e);
        if (t) {
          var o = Zy(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return Ky(this, r);
      };
    }
    function Ky(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function Zy(e) {
      return (Zy = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var Yy,
      Qy,
      Xy,
      eb,
      tb,
      rb,
      nb,
      ob,
      ib,
      ab,
      cb,
      lb,
      ub,
      sb = Object(c.observer)(qy = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && Jy(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = $y(a);
        function a() {
          return Hy(this, a), o.apply(this, arguments);
        }
        return t = a, (r = [{
          key: "render",
          value: function () {
            var e = this.props.onClick;
            return i.a.createElement(j, {
              i18n: Re
            }, i.a.createElement("button", {
              type: "button",
              className: "btn btn-sm btn-danger",
              onClick: e
            }, i.a.createElement(Ot.FontAwesomeIcon, {
              icon: _t.faTrashAlt
            })));
          }
        }]) && Gy(t.prototype, r), n && Gy(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component)) || qy,
      pb = U()(sb);
    function fb(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null == r) return;
        var n,
          o,
          i = [],
          a = !0,
          c = !1;
        try {
          for (r = r.call(e); !(a = (n = r.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0);
        } catch (e) {
          c = !0, o = e;
        } finally {
          try {
            a || null == r.return || r.return();
          } finally {
            if (c) throw o;
          }
        }
        return i;
      }(e, t) || function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return db(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === r && e.constructor && (r = e.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(e);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return db(e, t);
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function db(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function yb(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function bb(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function hb(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function mb(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function vb(e, t) {
      return (vb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function gb(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = _b(e);
        if (t) {
          var o = _b(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return wb(this, r);
      };
    }
    function wb(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return Ob(e);
    }
    function Ob(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function _b(e) {
      return (_b = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function jb(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var Pb = (Yy = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && vb(e, t);
      }(a, e);
      var t,
        r,
        n,
        o = gb(a);
      function a(e) {
        var t;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, a), (t = o.call(this)).map = void 0, t.polygon = void 0, hb(t, "area", Qy, Ob(t)), hb(t, "color", Xy, Ob(t)), hb(t, "opacity", eb, Ob(t)), hb(t, "geoJSON", tb, Ob(t)), hb(t, "isEditingPolygon", rb, Ob(t)), hb(t, "latitude", nb, Ob(t)), hb(t, "longitude", ob, Ob(t)), hb(t, "points", ib, Ob(t)), hb(t, "vertices", ab, Ob(t)), hb(t, "paths", cb, Ob(t)), hb(t, "onAddVertex", lb, Ob(t)), hb(t, "onDragVertex", ub, Ob(t));
        var r = function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? yb(Object(r), !0).forEach(function (t) {
              bb(e, t, r[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : yb(Object(r)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
          }
          return e;
        }({
          points: t.points,
          color: t.color,
          opacity: t.opacity,
          map: null,
          popup: null,
          id: ""
        }, e || {});
        if (!r.map) throw new Error("Attempted to instantiate Polygon without a map");
        return t.map = r.map, t.color = r.color, t.opacity = r.opacity, t.popup = r.popup, t.id = r.id, t.init(), t.points = r.points, t.update(), t;
      }
      return t = a, (r = [{
        key: "clearPolygon",
        value: function () {
          this.stopEditing(), this.polygon && this.polygon.remove(), this.polygon = null;
        }
      }, {
        key: "createVertexPopup",
        value: function (e) {
          var t = this,
            r = document.createElement("div");
          return bl.a.render(i.a.createElement(pb, {
            onClick: function () {
              return t.onRemoveVertex(e);
            }
          }), r), r;
        }
      }, {
        key: "edit",
        value: function () {
          this.isEditingPolygon = !0, this.showPaths(), this.showVertices();
        }
      }, {
        key: "hidePaths",
        value: function () {
          var e = this;
          this.paths && (this.paths.forEach(function (t) {
            t.off("click", e.onAddVertex), t.remove();
          }), this.paths = []);
        }
      }, {
        key: "hideVertices",
        value: function () {
          var e = this;
          this.vertices && (this.vertices.forEach(function (t) {
            t.destroy(), t.off("drag", e.onDragVertex);
          }), this.vertices = []);
        }
      }, {
        key: "init",
        value: function () {
          this.polygon = wd.a.polygon([], {
            color: this.color,
            fillOpacity: this.opacity
          }).addTo(this.map), this.popup && this.polygon.bindPopup(this.popup, {
            minWidth: 30
          });
        }
      }, {
        key: "isLastIndex",
        value: function (e) {
          return this.points.length - 1 === e;
        }
      }, {
        key: "onRemoveVertex",
        value: function (e) {
          var t = this.vertices.find(function (t) {
              return t.id === e;
            }),
            r = this.isLastIndex(e);
          t && (this.hideVertices(), this.points.splice(e, 1), r && (this.points[0] = this.points[e - 1]), this.update(), this.showVertices());
        }
      }, {
        key: "reset",
        value: function () {
          this.points = [], this.clearPolygon(), this.init();
        }
      }, {
        key: "remove",
        value: function () {
          this.clearPolygon();
        }
      }, {
        key: "rewindPoints",
        value: function () {
          var e = this.points.map(function (e) {
              var t;
              return [null !== (t = e.lon) && void 0 !== t ? t : e.lng, e.lat];
            }),
            t = zy()({
              type: "LineString",
              coordinates: e
            });
          this.points = t.coordinates.map(function (e) {
            var t = fb(e, 2),
              r = t[0];
            return {
              lat: t[1],
              lon: r
            };
          });
        }
      }, {
        key: "setPopup",
        value: function (e) {
          this.popup = e, this.polygon.bindPopup(this.popup, {
            minWidth: 30
          });
        }
      }, {
        key: "showPaths",
        value: function () {
          var e = this;
          this.points.length < 3 || (this.paths = this.points.reduce(function (t, r, n) {
            if (0 === n) return t;
            var o = new Sy({
              points: e.points.slice(n - 1, n + 1),
              map: e.map
            });
            return o.on("click", e.onAddVertex), t.concat(o);
          }, []));
        }
      }, {
        key: "showVertices",
        value: function () {
          var e = this;
          this.points.length < 3 || (this.vertices = this.points.slice(1).map(function (t, r) {
            var n = r + 1,
              o = new Wy({
                map: e.map,
                point: t,
                id: n,
                popup: e.createVertexPopup(n)
              });
            return o.on("drag", e.onDragVertex), o;
          }));
        }
      }, {
        key: "stopEditing",
        value: function () {
          this.isEditingPolygon = !1, this.hidePaths(), this.hideVertices();
        }
      }, {
        key: "update",
        value: function () {
          if (this.polygon) {
            this.rewindPoints(), this.hidePaths(), this.polygon.setLatLngs(this.points);
            var e = this.polygon.getCenter();
            this.geoJSON = this.polygon.toGeoJSON(), this.latitude = e.lat, this.longitude = e.lng, this.area = Ry()(this.geoJSON), this.isEditingPolygon && (this.showPaths(), this.vertices.forEach(function (e) {
              return e.marker.bringToFront();
            }));
          }
        }
      }]) && mb(t.prototype, r), n && mb(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), a;
    }(Yd.a), Qy = jb(Yy.prototype, "area", [a.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return 0;
      }
    }), Xy = jb(Yy.prototype, "color", [a.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "#3388ff";
      }
    }), eb = jb(Yy.prototype, "opacity", [a.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return "0.2";
      }
    }), tb = jb(Yy.prototype, "geoJSON", [a.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), rb = jb(Yy.prototype, "isEditingPolygon", [a.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return !1;
      }
    }), nb = jb(Yy.prototype, "latitude", [a.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), ob = jb(Yy.prototype, "longitude", [a.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: null
    }), ib = jb(Yy.prototype, "points", [a.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), ab = jb(Yy.prototype, "vertices", [a.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), cb = jb(Yy.prototype, "paths", [a.observable], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        return [];
      }
    }), jb(Yy.prototype, "hidePaths", [a.action], Object.getOwnPropertyDescriptor(Yy.prototype, "hidePaths"), Yy.prototype), jb(Yy.prototype, "hideVertices", [a.action], Object.getOwnPropertyDescriptor(Yy.prototype, "hideVertices"), Yy.prototype), lb = jb(Yy.prototype, "onAddVertex", [a.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = t.event,
            n = t.points;
          if (2 === (null == n ? void 0 : n.length) && !(e.points.indexOf(n[0]) < 0)) {
            var o = e.points.indexOf(n[1]);
            o < 0 || (e.hideVertices(), e.points.splice(o, 0, r.latlng), e.update(), e.showVertices());
          }
        };
      }
    }), ub = jb(Yy.prototype, "onDragVertex", [a.action], {
      configurable: !0,
      enumerable: !0,
      writable: !0,
      initializer: function () {
        var e = this;
        return function (t) {
          var r = t || {},
            n = r.id,
            o = r.point;
          e.points[n] = o, e.isLastIndex(n) && (e.points[0] = o), e.update();
        };
      }
    }), jb(Yy.prototype, "onRemoveVertex", [a.action], Object.getOwnPropertyDescriptor(Yy.prototype, "onRemoveVertex"), Yy.prototype), jb(Yy.prototype, "reset", [a.action], Object.getOwnPropertyDescriptor(Yy.prototype, "reset"), Yy.prototype), jb(Yy.prototype, "rewindPoints", [a.action], Object.getOwnPropertyDescriptor(Yy.prototype, "rewindPoints"), Yy.prototype), jb(Yy.prototype, "setPopup", [a.action], Object.getOwnPropertyDescriptor(Yy.prototype, "setPopup"), Yy.prototype), jb(Yy.prototype, "showPaths", [a.action], Object.getOwnPropertyDescriptor(Yy.prototype, "showPaths"), Yy.prototype), jb(Yy.prototype, "showVertices", [a.action], Object.getOwnPropertyDescriptor(Yy.prototype, "showVertices"), Yy.prototype), jb(Yy.prototype, "stopEditing", [a.action], Object.getOwnPropertyDescriptor(Yy.prototype, "stopEditing"), Yy.prototype), jb(Yy.prototype, "update", [a.action], Object.getOwnPropertyDescriptor(Yy.prototype, "update"), Yy.prototype), Yy);
    function Eb(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null == r) return;
        var n,
          o,
          i = [],
          a = !0,
          c = !1;
        try {
          for (r = r.call(e); !(a = (n = r.next()).done) && (i.push(n.value), !t || i.length !== t); a = !0);
        } catch (e) {
          c = !0, o = e;
        } finally {
          try {
            a || null == r.return || r.return();
          } finally {
            if (c) throw o;
          }
        }
        return i;
      }(e, t) || function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return kb(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === r && e.constructor && (r = e.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(e);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return kb(e, t);
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function kb(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function xb(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Sb(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? xb(Object(r), !0).forEach(function (t) {
          Cb(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : xb(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function Cb(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function Rb(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    var Nb,
      zb = function () {
        function e(t) {
          var r = this;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this._defaultProps = {
            emitPoint: this._doNothing,
            emitPolygon: this._doNothing
          }, this._doNothing = function () {};
          var n = Sb(Sb({}, this._defaultProps), t || {});
          Object.keys(n).forEach(function (e) {
            r[e] = n[e];
          });
        }
        var t, r, n;
        return t = e, (r = [{
          key: "parse",
          value: function (e) {
            this.parseGeoJSON(e);
          }
        }, {
          key: "parseFeature",
          value: function (e) {
            this.parseGeoJSON(e.geometry, e.properties);
          }
        }, {
          key: "parseFeatureCollection",
          value: function (e) {
            var t = this;
            e.features.map(function (e) {
              return t.parseGeoJSON(e);
            });
          }
        }, {
          key: "parseGeoJSON",
          value: function (e, t) {
            if (e) switch (e.type) {
              case "FeatureCollection":
                return this.parseFeatureCollection(e);
              case "Feature":
                return this.parseFeature(e);
              case "Point":
                return this.parsePoint(e, t);
              case "Polygon":
                return this.parsePolygon(e, t);
              case "MultiPolygon":
                return this.parseMultiPolygon(e, t);
              default:
                console.log('Error parsing geoJSON--unhandled "type":', e.type);
            }
          }
        }, {
          key: "parseMultiPolygon",
          value: function (e, t) {
            var r = this;
            e.coordinates.map(function (e) {
              return r.parsePolygon({
                coordinates: e
              }, t);
            });
          }
        }, {
          key: "parsePoint",
          value: function (e, t) {
            var r = Eb(e.coordinates, 2),
              n = r[0],
              o = {
                lat: r[1],
                lng: n
              };
            this.emitPoint(o, t);
          }
        }, {
          key: "parsePolygon",
          value: function (e, t) {
            e.coordinates.length > 1 && console.log("Warning parsing polygon--holes are unsupported.  Only outer shape will be drawn");
            var r = e.coordinates[0].map(function (e) {
              return {
                lat: e[1],
                lon: e[0]
              };
            });
            this.emitPolygon(r, t);
          }
        }]) && Rb(t.prototype, r), n && Rb(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), e;
      }();
    function Db(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function Tb(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function Mb(e, t) {
      return (Mb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function Fb(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = Ab(e);
        if (t) {
          var o = Ab(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return Ib(this, r);
      };
    }
    function Ib(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function Ab(e) {
      return (Ab = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var Lb,
      Ub = Object(c.observer)(Nb = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && Mb(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = Fb(a);
        function a() {
          return Db(this, a), o.apply(this, arguments);
        }
        return t = a, (r = [{
          key: "render",
          value: function () {
            var e = this.props,
              t = e.isEditing,
              r = e.onClick;
            return i.a.createElement(j, {
              i18n: Re
            }, i.a.createElement("button", {
              type: "button",
              className: "btn btn-sm btn-outline-primary".concat(t ? " active" : ""),
              onClick: r
            }, i.a.createElement(Ot.FontAwesomeIcon, {
              icon: _t.faPencilAlt
            })));
          }
        }]) && Tb(t.prototype, r), n && Tb(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component)) || Nb,
      Vb = U()(Ub),
      Bb = r(83),
      qb = r.n(Bb);
    function Wb(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function Hb(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function Gb(e, t) {
      return (Gb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function Jb(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = Kb(e);
        if (t) {
          var o = Kb(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return $b(this, r);
      };
    }
    function $b(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function Kb(e) {
      return (Kb = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var Zb = (function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null);
    }((Lb = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Gb(e, t);
      }(i, e);
      var t,
        r,
        n,
        o = Jb(i);
      function i() {
        return Wb(this, i), o.apply(this, arguments);
      }
      return t = i, (r = [{
        key: "hue",
        get: function () {
          var e = this.id;
          return "string" != typeof e && (e = e.toString()), Math.abs(qb.a.str(e)) % 360;
        }
      }]) && Hb(t.prototype, r), n && Hb(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), i;
    }(Object(Ue.MixInto)(Ue.UpdatableBase, Ue.idAttributeMixin, Ue.serialAttributeMixin, Ue.nameAttributeMixin))).prototype, "hue", [a.computed], Object.getOwnPropertyDescriptor(Lb.prototype, "hue"), Lb.prototype), Lb);
    function Yb(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function Qb(e, t) {
      return (Qb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function Xb(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = th(e);
        if (t) {
          var o = th(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return eh(this, r);
      };
    }
    function eh(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function th(e) {
      return (th = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var rh = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Qb(e, t);
      }(r, e);
      var t = Xb(r);
      function r() {
        return Yb(this, r), t.apply(this, arguments);
      }
      return r;
    }(Object(Ue.MixInto)(Ue.UpdatableBase, Ue.idAttributeMixin, Ue.serialAttributeMixin, Ue.nameAttributeMixin));
    function nh(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function oh(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? nh(Object(r), !0).forEach(function (t) {
          ih(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : nh(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function ih(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function ah(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function ch(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function lh() {
      return (lh = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = uh(e, t);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(this, arguments);
    }
    function uh(e, t) {
      for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = dh(e)););
      return e;
    }
    function sh(e, t) {
      return (sh = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function ph(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = dh(e);
        if (t) {
          var o = dh(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return fh(this, r);
      };
    }
    function fh(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function dh(e) {
      return (dh = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var yh = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && sh(e, t);
      }(i, e);
      var t,
        r,
        n,
        o = ph(i);
      function i() {
        return ah(this, i), o.apply(this, arguments);
      }
      return t = i, n = [{
        key: "getAttributeDefinition",
        value: function () {
          return oh(oh({}, lh(dh(i), "getAttributeDefinition", this).call(this)), {}, {
            percentage: {
              key: "percentage",
              type: "number",
              defaultValue: 1
            }
          });
        }
      }], (r = null) && ch(t.prototype, r), n && ch(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), i;
    }(Object(Ue.MixInto)(Ue.UpdatableBase, Ue.nameAttributeMixin));
    function bh(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function hh(e, t) {
      return (hh = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function mh(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = gh(e);
        if (t) {
          var o = gh(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return vh(this, r);
      };
    }
    function vh(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function gh(e) {
      return (gh = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var wh = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && hh(e, t);
      }(r, e);
      var t = mh(r);
      function r() {
        return bh(this, r), t.apply(this, arguments);
      }
      return r;
    }(Object(Ue.MixInto)(Ue.UpdatableBase, Ue.nameAttributeMixin));
    function Oh(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function _h(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Oh(Object(r), !0).forEach(function (t) {
          jh(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Oh(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function jh(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function Ph(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function Eh(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function kh() {
      return (kh = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = xh(e, t);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(this, arguments);
    }
    function xh(e, t) {
      for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = Nh(e)););
      return e;
    }
    function Sh(e, t) {
      return (Sh = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function Ch(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = Nh(e);
        if (t) {
          var o = Nh(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return Rh(this, r);
      };
    }
    function Rh(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function Nh(e) {
      return (Nh = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var zh = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Sh(e, t);
      }(i, e);
      var t,
        r,
        n,
        o = Ch(i);
      function i() {
        return Ph(this, i), o.apply(this, arguments);
      }
      return t = i, n = [{
        key: "getAttributeDefinition",
        value: function () {
          return _h(_h({}, kh(Nh(i), "getAttributeDefinition", this).call(this)), {}, {
            percentage: {
              key: "percentage",
              type: "number",
              defaultValue: 1
            }
          });
        }
      }], (r = null) && Eh(t.prototype, r), n && Eh(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), i;
    }(Object(Ue.MixInto)(Ue.UpdatableBase, Ue.nameAttributeMixin));
    function Dh(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function Th(e, t) {
      return (Th = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function Mh(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = Ih(e);
        if (t) {
          var o = Ih(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return Fh(this, r);
      };
    }
    function Fh(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function Ih(e) {
      return (Ih = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var Ah,
      Lh = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && Th(e, t);
        }(r, e);
        var t = Mh(r);
        function r() {
          return Dh(this, r), t.apply(this, arguments);
        }
        return r;
      }(Object(Ue.MixInto)(Ue.UpdatableBase, Ue.nameAttributeMixin));
    function Uh(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function Vh(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function Bh(e, t) {
      return (Bh = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function qh(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = Hh(e);
        if (t) {
          var o = Hh(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return Wh(this, r);
      };
    }
    function Wh(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function Hh(e) {
      return (Hh = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var Gh = (function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null);
    }((Ah = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Bh(e, t);
      }(i, e);
      var t,
        r,
        n,
        o = qh(i);
      function i() {
        return Uh(this, i), o.apply(this, arguments);
      }
      return t = i, n = [{
        key: "getAttributeDefinition",
        value: function () {
          return {
            type: {
              name: "Type",
              key: "type",
              type: "string"
            }
          };
        }
      }], (r = [{
        key: "jsonString",
        get: function () {
          return JSON.stringify(this);
        }
      }]) && Vh(t.prototype, r), n && Vh(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), i;
    }(Object(Ue.Mix)(Ue.updatableMixin))).prototype, "jsonString", [a.computed], Object.getOwnPropertyDescriptor(Ah.prototype, "jsonString"), Ah.prototype), Ah);
    function Jh(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function $h(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Jh(Object(r), !0).forEach(function (t) {
          Kh(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Jh(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function Kh(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function Zh(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function Yh(e, t) {
      return (Yh = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function Qh(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = em(e);
        if (t) {
          var o = em(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return Xh(this, r);
      };
    }
    function Xh(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function em(e) {
      return (em = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var tm = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && Yh(e, t);
      }(i, e);
      var t,
        r,
        n,
        o = Qh(i);
      function i(e) {
        var t;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, i), (t = o.call(this, e)).update(e), t;
      }
      return t = i, n = [{
        key: "getAttributeDefinition",
        value: function () {
          return $h($h({}, Gh.getAttributeDefinition()), {}, {
            coordinates: {
              name: "Coordinate",
              key: "coordinates",
              type: "array"
            }
          });
        }
      }], (r = null) && Zh(t.prototype, r), n && Zh(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), i;
    }(Gh);
    function rm(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function nm(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? rm(Object(r), !0).forEach(function (t) {
          om(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : rm(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function om(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function im(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function am(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function cm(e, t) {
      return (cm = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function lm(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = sm(e);
        if (t) {
          var o = sm(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return um(this, r);
      };
    }
    function um(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function sm(e) {
      return (sm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var pm = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && cm(e, t);
      }(i, e);
      var t,
        r,
        n,
        o = lm(i);
      function i() {
        return im(this, i), o.apply(this, arguments);
      }
      return t = i, n = [{
        key: "getAttributeDefinition",
        value: function () {
          var e = tm.getAttributeDefinition();
          return nm(nm({}, e), {}, {
            type: nm(nm({}, e.type), {}, {
              defaultValue: this.type
            })
          });
        }
      }], (r = null) && am(t.prototype, r), n && am(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), i;
    }(tm);
    function fm(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function dm(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? fm(Object(r), !0).forEach(function (t) {
          ym(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : fm(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function ym(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function bm(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function hm(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function mm(e, t) {
      return (mm = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function vm(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = wm(e);
        if (t) {
          var o = wm(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return gm(this, r);
      };
    }
    function gm(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function wm(e) {
      return (wm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    pm.type = "Polygon";
    var Om = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && mm(e, t);
      }(i, e);
      var t,
        r,
        n,
        o = vm(i);
      function i() {
        return bm(this, i), o.apply(this, arguments);
      }
      return t = i, n = [{
        key: "getAttributeDefinition",
        value: function () {
          var e = tm.getAttributeDefinition();
          return dm(dm({}, e), {}, {
            type: dm(dm({}, e.type), {}, {
              defaultValue: this.type
            })
          });
        }
      }], (r = null) && hm(t.prototype, r), n && hm(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), i;
    }(tm);
    function _m(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function jm(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? _m(Object(r), !0).forEach(function (t) {
          Pm(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : _m(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function Pm(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function Em(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function km(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function xm(e, t) {
      return (xm = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function Sm(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = Rm(e);
        if (t) {
          var o = Rm(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return Cm(this, r);
      };
    }
    function Cm(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function Rm(e) {
      return (Rm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    Om.type = "MultiPolygon";
    var Nm = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && xm(e, t);
      }(i, e);
      var t,
        r,
        n,
        o = Sm(i);
      function i() {
        return Em(this, i), o.apply(this, arguments);
      }
      return t = i, n = [{
        key: "getAttributeDefinition",
        value: function () {
          var e = tm.getAttributeDefinition();
          return jm(jm({}, e), {}, {
            type: jm(jm({}, e.type), {}, {
              defaultValue: this.type
            })
          });
        }
      }], (r = null) && km(t.prototype, r), n && km(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), i;
    }(tm);
    function zm(e, t) {
      return (zm = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function Dm(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = Mm(e);
        if (t) {
          var o = Mm(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return Tm(this, r);
      };
    }
    function Tm(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function Mm(e) {
      return (Mm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    Nm.type = "Point";
    var Fm = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && zm(e, t);
      }(r, e);
      var t = Dm(r);
      function r(e) {
        var n;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, r);
        var o = e || {};
        if (n = t.call(this, o), !o.type) throw new Error("Not valid GeoJSON");
        switch (o.type) {
          case "Point":
            return Tm(n, new n.constructor.PointGeometryClass(o));
          case "Polygon":
            return Tm(n, new n.constructor.PolygonGeometryClass(o));
          case "MultiPolygon":
            return Tm(n, new n.constructor.MultiPolygonGeometryClass(o));
          default:
            throw new Error("".concat(o.type, " type is not currently handled."));
        }
        return n;
      }
      return r;
    }(tm);
    function Im(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Am(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Im(Object(r), !0).forEach(function (t) {
          Lm(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Im(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function Lm(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function Um(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function Vm(e, t) {
      return (Vm = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function Bm(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = Wm(e);
        if (t) {
          var o = Wm(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return qm(this, r);
      };
    }
    function qm(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function Wm(e) {
      return (Wm = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    Fm.PointGeometryClass = Nm, Fm.PolygonGeometryClass = pm, Fm.MultiPolygonGeometryClass = Om;
    var Hm,
      Gm,
      Jm,
      $m = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && Vm(e, t);
        }(i, e);
        var t,
          r,
          n,
          o = Bm(i);
        function i(e) {
          var t;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, i), (t = o.call(this, e)).update(e), t;
        }
        return t = i, n = [{
          key: "getAttributeDefinition",
          value: function () {
            var e = Gh.getAttributeDefinition();
            return Am(Am({}, e), {}, {
              type: Am(Am({}, e.type), {}, {
                defaultValue: this.type
              }),
              geometry: {
                name: "Geometry",
                key: "geometry",
                type: "model",
                modelClass: Fm
              },
              properties: {
                name: "Properties",
                key: "properties",
                type: "object"
              }
            });
          }
        }], (r = null) && Um(t.prototype, r), n && Um(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), i;
      }(Gh);
    function Km(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Zm(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Km(Object(r), !0).forEach(function (t) {
          Ym(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Km(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function Ym(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function Qm(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function Xm() {
      return (Xm = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = ev(e, t);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(this, arguments);
    }
    function ev(e, t) {
      for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = ov(e)););
      return e;
    }
    function tv(e, t) {
      return (tv = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function rv(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = ov(e);
        if (t) {
          var o = ov(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return nv(this, r);
      };
    }
    function nv(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function ov(e) {
      return (ov = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    $m.type = "Feature";
    var iv = (Jm = Gm = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && tv(e, t);
      }(i, e);
      var t,
        r,
        n,
        o = rv(i);
      function i(e) {
        var t;
        return function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, i), (t = o.call(this, e)).update(e), t;
      }
      return t = i, n = [{
        key: "getAttributeDefinition",
        value: function () {
          var e = Gh.getAttributeDefinition();
          return Zm(Zm({}, e), {}, {
            type: Zm(Zm({}, e.type), {}, {
              defaultValue: "FeatureCollection"
            }),
            features: {
              name: "Feature",
              key: "features",
              type: "modelCollection"
            }
          });
        }
      }], (r = [{
        key: "updateCollectionAttributeElement",
        value: function (e, t) {
          return ["FeatureCollection", "Feature"].includes(t.type) ? new ("FeatureCollection" === t.type ? this.constructor.FeatureCollectionClass : this.constructor.FeatureClass)(t) : Xm(ov(i.prototype), "updateCollectionAttributeElement", this).call(this, e, t);
        }
      }]) && Qm(t.prototype, r), n && Qm(t, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), i;
    }(Gh), Gm.type = "FeatureCollection", Gm.FeatureCollectionClass = Gm, Gm.FeatureClass = $m, function (e, t, r, n, o) {
      var i = {};
      Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null);
    }((Hm = Jm).prototype, "updateCollectionAttributeElement", [a.action], Object.getOwnPropertyDescriptor(Hm.prototype, "updateCollectionAttributeElement"), Hm.prototype), Hm);
    function av(e, t) {
      return (av = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function cv(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = uv(e);
        if (t) {
          var o = uv(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return lv(this, r);
      };
    }
    function lv(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function uv(e) {
      return (uv = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var sv = function (e) {
      !function (e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
          constructor: {
            value: e,
            writable: !0,
            configurable: !0
          }
        }), Object.defineProperty(e, "prototype", {
          writable: !1
        }), t && av(e, t);
      }(r, e);
      var t = cv(r);
      function r(e) {
        var n;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, r);
        var o = e || {};
        if (n = t.call(this, o), !o.type) throw new Error("Not valid GeoJSON");
        switch (o.type) {
          case "FeatureCollection":
            return lv(n, new n.constructor.FeatureCollectionClass(o));
          case "Feature":
            return lv(n, new n.constructor.FeatureClass(o));
          default:
            throw new Error("Not valid Feature");
        }
        return n;
      }
      return r;
    }(Gh);
    function pv(e, t) {
      return (pv = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function fv(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = yv(e);
        if (t) {
          var o = yv(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return dv(this, r);
      };
    }
    function dv(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function yv(e) {
      return (yv = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    sv.FeatureCollectionClass = iv, sv.FeatureClass = $m;
    var bv,
      hv,
      mv,
      vv = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && pv(e, t);
        }(r, e);
        var t = fv(r);
        function r(e) {
          var n;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, r);
          var o = e || {
            type: "FeatureCollection",
            features: []
          };
          if ("string" == typeof o && (o = JSON.parse(o)), n = t.call(this, o), !o.type) throw new Error("Not valid GeoJSON");
          return "FeatureCollection" === o.type || "Feature" === o.type ? dv(n, new n.constructor.FeatureBuilderClass(o)) : dv(n, new n.constructor.FeatureGeometryClass(o));
        }
        return r;
      }(Gh);
    function gv(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function wv(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? gv(Object(r), !0).forEach(function (t) {
          Ov(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : gv(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function Ov(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function _v(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function jv(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function Pv() {
      return (Pv = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
        var n = Ev(e, t);
        if (n) {
          var o = Object.getOwnPropertyDescriptor(n, t);
          return o.get ? o.get.call(arguments.length < 3 ? e : r) : o.value;
        }
      }).apply(this, arguments);
    }
    function Ev(e, t) {
      for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = Cv(e)););
      return e;
    }
    function kv(e, t) {
      return (kv = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function xv(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = Cv(e);
        if (t) {
          var o = Cv(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return Sv(this, r);
      };
    }
    function Sv(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function Cv(e) {
      return (Cv = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function Rv(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    vv.FeatureBuilderClass = sv, vv.FeatureGeometryClass = Fm;
    var Nv,
      zv,
      Dv,
      Tv,
      Mv,
      Fv,
      Iv,
      Av,
      Lv,
      Uv,
      Vv,
      Bv,
      qv,
      Wv,
      Hv,
      Gv,
      Jv = (mv = hv = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && kv(e, t);
        }(i, e);
        var t,
          r,
          n,
          o = xv(i);
        function i() {
          return _v(this, i), o.apply(this, arguments);
        }
        return t = i, n = [{
          key: "getAttributeDefinition",
          value: function () {
            var e = Pv(Cv(i), "getAttributeDefinition", this).call(this);
            return wv(wv({}, e), {}, {
              type: wv(wv({}, e.type), {}, {
                defaultValue: this.type
              }),
              account: {
                key: "account",
                type: "model",
                modelClass: rh,
                defaultValue: new rh()
              },
              crop: {
                key: "crop",
                type: "model",
                modelClass: Zb,
                defaultValue: new Zb()
              },
              county: {
                key: "county",
                type: "string"
              },
              yearPlanted: {
                key: "yearPlanted",
                type: "string"
              },
              area: {
                key: "area",
                type: "model",
                modelClass: Ue.Quantity,
                defaultValue: new Ue.Quantity("")
              },
              rowSpacing: {
                key: "rowSpacing",
                type: "model",
                modelClass: Ue.Quantity,
                defaultValue: new Ue.Quantity("")
              },
              plantSpacing: {
                key: "plantSpacing",
                type: "model",
                modelClass: Ue.Quantity,
                defaultValue: new Ue.Quantity("")
              },
              treeDensity: {
                key: "treeDensity",
                type: "model",
                modelClass: Ue.Quantity,
                defaultValue: new Ue.Quantity("")
              },
              irrigationRate: {
                key: "irrigationRate",
                type: "model",
                modelClass: Ue.Quantity,
                defaultValue: new Ue.Quantity("")
              },
              elevation: {
                key: "elevation",
                type: "model",
                modelClass: Ue.Quantity,
                defaultValue: new Ue.Quantity("")
              },
              notes: {
                key: "notes",
                type: "string"
              },
              nearestRegion: {
                key: "nearestRegion",
                type: "string"
              },
              harvestLot: {
                key: "harvestLot",
                type: "string"
              },
              previousCrop: {
                key: "previousCrop",
                type: "string"
              },
              longitude: {
                key: "longitude",
                type: "string"
              },
              latitude: {
                key: "latitude",
                type: "string"
              },
              geoJson: {
                key: "geoJson",
                type: "model",
                modelClass: vv
              },
              inactive: {
                key: "inactive",
                type: "boolean"
              },
              nonBearing: {
                key: "nonBearing",
                type: "boolean"
              },
              acidWaterTreatment: {
                key: "acidWaterTreatment",
                type: "boolean"
              },
              organic: {
                key: "organic",
                type: "boolean"
              },
              transitional: {
                key: "transitional",
                type: "boolean"
              },
              organicDate: {
                key: "organicDate",
                type: "string"
              },
              transitionalDate: {
                key: "transitionalDate",
                type: "string"
              },
              accountingReference: {
                key: "accountingReference",
                type: "string"
              },
              varieties: {
                key: "varieties",
                type: "modelCollection",
                searchKey: "name",
                modelClass: yh
              },
              cultivars: {
                key: "cultivars",
                type: "modelCollection",
                searchKey: "name",
                modelClass: wh
              },
              rootStocks: {
                key: "rootStocks",
                type: "modelCollection",
                searchKey: "name",
                modelClass: zh
              },
              useTypes: {
                key: "useTypes",
                type: "modelCollection",
                searchKey: "name",
                modelClass: Lh
              }
            });
          }
        }], (r = [{
          key: "acreage",
          get: function () {
            return this.area.displayValue;
          }
        }, {
          key: "acres",
          get: function () {
            var e;
            return (null === (e = this.area) || void 0 === e ? void 0 : e.scalar) || 0;
          }
        }, {
          key: "countyName",
          get: function () {
            return this.county ? this.county.match(/county/i) ? this.county : "".concat(this.county, " County") : null;
          }
        }, {
          key: "gps",
          get: function () {
            if (!this.latitude && !this.longitude) return "";
            var e = parseFloat(this.latitude).toFixed(4),
              t = parseFloat(this.longitude).toFixed(4);
            return "".concat(e, ",").concat(t);
          }
        }]) && jv(t.prototype, r), n && jv(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), i;
      }(Object(Ue.MixInto)(Ue.UpdatableBase, Ue.idAttributeMixin, Ue.nameAttributeMixin, Ue.selectableMixin, Ue.serialAttributeMixin, Ue.timestampAttributesMixin, Ue.typeAttributeMixin, Ue.checkableMixin)), hv.type = "IF2::Field", Rv((bv = mv).prototype, "acreage", [a.computed], Object.getOwnPropertyDescriptor(bv.prototype, "acreage"), bv.prototype), Rv(bv.prototype, "acres", [a.computed], Object.getOwnPropertyDescriptor(bv.prototype, "acres"), bv.prototype), Rv(bv.prototype, "countyName", [a.computed], Object.getOwnPropertyDescriptor(bv.prototype, "countyName"), bv.prototype), Rv(bv.prototype, "gps", [a.computed], Object.getOwnPropertyDescriptor(bv.prototype, "gps"), bv.prototype), bv),
      $v = r(17);
    function Kv(e) {
      return function (e) {
        if (Array.isArray(e)) return Zv(e);
      }(e) || function (e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
      }(e) || function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return Zv(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === r && e.constructor && (r = e.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(e);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Zv(e, t);
      }(e) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function Zv(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
      return n;
    }
    function Yv(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function Qv(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function Xv(e, t) {
      return (Xv = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function eg(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = ng(e);
        if (t) {
          var o = ng(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return tg(this, r);
      };
    }
    function tg(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return rg(e);
    }
    function rg(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function ng(e) {
      return (ng = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function og(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var ig,
      ag,
      cg,
      lg,
      ug,
      sg,
      pg,
      fg,
      dg,
      yg,
      bg,
      hg,
      mg,
      vg,
      gg,
      wg,
      Og,
      _g,
      jg,
      Pg,
      Eg,
      kg,
      xg,
      Sg,
      Cg,
      Rg,
      Ng,
      zg,
      Dg,
      Tg,
      Mg,
      Fg,
      Ig,
      Ag = (Gv = Hv = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && Xv(e, t);
        }(i, e);
        var t,
          r,
          n,
          o = eg(i);
        function i(e) {
          var t;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, i), (t = o.call(this, e)).searchModel = new Vn.SearchBoxModel(), Yv(t, "cropSelectModel", zv, rg(t)), Yv(t, "varietySelectModel", Dv, rg(t)), Yv(t, "organicFilter", Tv, rg(t)), Yv(t, "organicRadioBtnGroupModel", Mv, rg(t)), Yv(t, "props", Fv, rg(t)), Yv(t, "cropFilter", Iv, rg(t)), Yv(t, "varietyFilter", Av, rg(t)), Yv(t, "tableRowMap", Lv, rg(t)), Yv(t, "onCheckOrganicRadioBtn", Uv, rg(t)), Yv(t, "onChangeCropFilter", Vv, rg(t)), Yv(t, "onChangeVarietyFilter", Bv, rg(t)), Yv(t, "onRegisterCropSelectModel", qv, rg(t)), Yv(t, "onRegisterVarietySelectModel", Wv, rg(t)), t.props = e || {}, t.initialize(), t;
        }
        return t = i, n = [{
          key: "sortFields",
          value: function (e, t) {
            var r, n;
            return Object(Vn.naturalSort)([].concat((null === (r = e.account) || void 0 === r ? void 0 : r.name) || []).concat(e.name || []).join(" "), [].concat((null === (n = t.account) || void 0 === n ? void 0 : n.name) || []).concat(t.name || []).join(" "));
          }
        }], (r = [{
          key: "allChecked",
          get: function () {
            var e = this;
            return this.filteredFields.length > 0 && this.filteredFields.every(function (t) {
              return e.isChecked(t.id);
            });
          }
        }, {
          key: "availableCrops",
          get: function () {
            return Object(Ue.uniqBy)("id", this.indexedFields.map(function (e) {
              return e.crop;
            }));
          }
        }, {
          key: "availableVarieties",
          get: function () {
            return Object(Ue.uniqBy)("name", this.indexedFields.reduce(function (e, t) {
              return e.concat(t.varieties || []);
            }, []));
          }
        }, {
          key: "cropNames",
          get: function () {
            return this.props.cropNames || [];
          }
        }, {
          key: "cropOptions",
          get: function () {
            return this.availableCrops.map(this.constructor.makeCropOption).sort(function (e, t) {
              return Object(Vn.naturalSort)(e.text, t.text);
            });
          }
        }, {
          key: "filtersApplied",
          get: function () {
            return this.cropFilter.length > 0 || this.varietyFilter.length > 0 || this.isFilteringOrganic || this.isFilteringConventional;
          }
        }, {
          key: "filteredFields",
          get: function () {
            var e = this;
            return this.indexedFields ? (this.filtersApplied || this.searchModel.text ? this.indexedFields.filter(function (t) {
              var r;
              return !(e.cropFilter.length && !e.cropFilter.find(function (e) {
                var r;
                return (null === (r = t.crop) || void 0 === r ? void 0 : r.id) === e.id;
              }) || e.varietyFilter.length && !e.varietyFilter.find(function (e) {
                return t.varieties.find(function (t) {
                  return t.name === e.name;
                });
              }) || e.isFilteringOrganic && !t.organic && !t.transitional || e.isFilteringConventional && (t.organic || t.transitional) || e.searchModel.text && !t.searchIndex.includes(null === (r = e.searchModel.text) || void 0 === r ? void 0 : r.toLowerCase()));
            }) : this.indexedFields).sort(this.constructor.sortFields) : [];
          }
        }, {
          key: "includeVarieties",
          get: function () {
            return this.props.includeVarieties;
          }
        }, {
          key: "indexedFields",
          get: function () {
            return (this.props.fields || []).map(this.constructor.indexField);
          }
        }, {
          key: "initialCropsToFilter",
          get: function () {
            var e = this;
            return Object(Ue.uniqBy)("id", this.indexedFields.reduce(function (t, r) {
              return e.cropNames.find(function (e) {
                var t;
                return e === (null === (t = r.crop) || void 0 === t ? void 0 : t.name);
              }) && t.push(r.crop), t;
            }, []));
          }
        }, {
          key: "isFilteringConventional",
          get: function () {
            return "conventional" === this.organicFilter;
          }
        }, {
          key: "isFilteringOrganic",
          get: function () {
            return "organic" === this.organicFilter;
          }
        }, {
          key: "varietyOptions",
          get: function () {
            return this.props.includeVarieties ? this.availableVarieties.map(this.constructor.makeVarietyOption).sort(function (e, t) {
              return Object(Vn.naturalSort)(e.text, t.text);
            }) : [];
          }
        }, {
          key: "t",
          get: function () {
            return this.props.t || Re.t.bind(Re);
          }
        }, {
          key: "unlistedCrops",
          get: function () {
            var e = this;
            return Object(Ue.uniq)(this.checkedFields.filter(function (t) {
              return !e.cropNames.includes(t.cropName);
            }).map(function (e) {
              return e.cropName;
            }));
          }
        }, {
          key: "fieldsWithCheckedState",
          get: function () {
            return this.props.fields.map(this.constructor.viewWithChecked(this));
          }
        }, {
          key: "checkedFields",
          get: function () {
            return this.fieldsWithCheckedState.filter(function (e) {
              return e.isChecked;
            });
          }
        }, {
          key: "acresSelected",
          get: function () {
            return this.checkedFields.reduce(function (e, t) {
              return e.add(t.area).to("acre");
            }, new Ue.Quantity("0 acre"));
          }
        }, {
          key: "selectedCropNames",
          get: function () {
            return Kv(this.checkedFields.reduce(function (e, t) {
              var r,
                n = null == t || null === (r = t.crop) || void 0 === r ? void 0 : r.name;
              return n && e.add(n), e;
            }, new Set())).sort();
          }
        }, {
          key: "selectedVarieties",
          get: function () {
            return Kv(this.checkedFields.reduce(function (e, t) {
              return t.varieties.forEach(function (t) {
                return e.add(t.name);
              }), e;
            }, new Set())).sort();
          }
        }, {
          key: "isScrollable",
          get: function () {
            return this.constructor.itemSize * this.filteredFields.length > this.constructor.listHeight;
          }
        }, {
          key: "dispose",
          value: function () {
            this.disposeInitialization();
          }
        }, {
          key: "disposeInitialization",
          value: function () {
            "function" == typeof this.initializationDisposer && this.initializationDisposer();
          }
        }, {
          key: "initialize",
          value: function (e) {
            var t = this;
            this.update(e), this.initOrganicRadioModel(), this.checkMany(this.props.checkedFields || []), this.disposeInitialization(), this.initializationDisposer = Object(a.when)(function () {
              return Boolean(t.cropSelectModel);
            }, function () {
              t.cropSelectModel.selectMany(t.initialCropsToFilter.map(function (e) {
                return e.id;
              })), t.cropFilter = t.initialCropsToFilter;
            });
          }
        }, {
          key: "initOrganicRadioModel",
          value: function () {
            this.props.isOrganic ? this.organicFilter = "organic" : this.organicFilter = "conventional", this.organicRadioBtnGroupModel ? this.organicRadioBtnGroupModel.onChange(this.organicFilter) : this.organicRadioBtnGroupModel = new Vn.RadioBtnGroupModel({
              buttons: [{
                id: "organic",
                label: this.t("if2_fields.organic"),
                className: "organic-radio-btn"
              }, {
                id: "conventional",
                label: this.t("if2_fields.conventional"),
                className: "organic-radio-btn"
              }, {
                id: "both",
                label: this.t("if2_fields.both"),
                className: "organic-radio-btn"
              }],
              value: this.organicFilter,
              onChange: this.onCheckOrganicRadioBtn
            });
          }
        }, {
          key: "noMatchText",
          value: function () {
            return this.t("if2_fields.no_fields_match");
          }
        }, {
          key: "onCheckAll",
          value: function (e) {
            var t = this;
            this.filteredFields.forEach(function (r) {
              t.setCheck(r.id, e);
            });
          }
        }, {
          key: "reset",
          value: function () {
            this.disposeInitialization(), this.searchModel && this.searchModel.clearText(), [this.cropSelectModel, this.varietySelectModel].filter(Boolean).forEach(function (e) {
              e.clearSearch(), e.clearSelection();
            }), this.organicFilter = "conventional", this.organicRadioBtnGroupModel && this.organicRadioBtnGroupModel.onChange(this.organicFilter), this.cropFilter = [], this.varietyFilter = [], this.tableRowMap.clear(), this.unCheckAll();
          }
        }, {
          key: "shouldConfirmCrops",
          value: function () {
            return this.unlistedCrops.length > 0;
          }
        }, {
          key: "shouldConfirmOrganicStatus",
          value: function () {
            var e = this.props.isOrganic;
            return Boolean(!e && this.checkedFields.some(function (e) {
              return e.organic || e.transitional;
            }));
          }
        }, {
          key: "update",
          value: function (e) {
            var t = this;
            Object.keys(e || {}).forEach(function (r) {
              t.props[r] = e[r];
            });
          }
        }, {
          key: "warningsForField",
          value: function () {
            return Promise.resolve([]);
          }
        }]) && Qv(t.prototype, r), n && Qv(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), i;
      }(Object(Ue.Mix)(Ue.checkableCollectionMixin)), Hv.itemSize = 20, Hv.makeCropOption = Object($v.createTransformer)(function (e) {
        return {
          key: e.id,
          text: e.name,
          value: e
        };
      }), Hv.makeVarietyOption = Object($v.createTransformer)(function (e) {
        return {
          key: e.name,
          text: e.name,
          value: e
        };
      }), Hv.indexField = Object($v.createTransformer)(function (e) {
        var t,
          r = Object($v.createViewModel)(e);
        return r.searchIndex = [r.name, null === (t = r.crop) || void 0 === t ? void 0 : t.name, r.organic ? "organic" : "", (r.varieties || []).map(function (e) {
          var t;
          return null === (t = e.name) || void 0 === t ? void 0 : t.toLowerCase();
        }).filter(Boolean).join(" ")].filter(Boolean).map(function (e) {
          return e.toLowerCase();
        }).join(" "), r;
      }), Hv.viewWithChecked = function (e) {
        return Object($v.createTransformer)(function (t) {
          var r = Object($v.createViewModel)(t);
          return r.isChecked = e.isChecked(t.id), r;
        });
      }, zv = og((Nv = Gv).prototype, "cropSelectModel", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), Dv = og(Nv.prototype, "varietySelectModel", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), Tv = og(Nv.prototype, "organicFilter", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return "conventional";
        }
      }), Mv = og(Nv.prototype, "organicRadioBtnGroupModel", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), Fv = og(Nv.prototype, "props", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), Iv = og(Nv.prototype, "cropFilter", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return [];
        }
      }), Av = og(Nv.prototype, "varietyFilter", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return [];
        }
      }), Lv = og(Nv.prototype, "tableRowMap", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return new Map();
        }
      }), og(Nv.prototype, "allChecked", [a.computed], Object.getOwnPropertyDescriptor(Nv.prototype, "allChecked"), Nv.prototype), og(Nv.prototype, "availableCrops", [a.computed], Object.getOwnPropertyDescriptor(Nv.prototype, "availableCrops"), Nv.prototype), og(Nv.prototype, "availableVarieties", [a.computed], Object.getOwnPropertyDescriptor(Nv.prototype, "availableVarieties"), Nv.prototype), og(Nv.prototype, "cropNames", [a.computed], Object.getOwnPropertyDescriptor(Nv.prototype, "cropNames"), Nv.prototype), og(Nv.prototype, "cropOptions", [a.computed], Object.getOwnPropertyDescriptor(Nv.prototype, "cropOptions"), Nv.prototype), og(Nv.prototype, "filtersApplied", [a.computed], Object.getOwnPropertyDescriptor(Nv.prototype, "filtersApplied"), Nv.prototype), og(Nv.prototype, "filteredFields", [a.computed], Object.getOwnPropertyDescriptor(Nv.prototype, "filteredFields"), Nv.prototype), og(Nv.prototype, "includeVarieties", [a.computed], Object.getOwnPropertyDescriptor(Nv.prototype, "includeVarieties"), Nv.prototype), og(Nv.prototype, "indexedFields", [a.computed], Object.getOwnPropertyDescriptor(Nv.prototype, "indexedFields"), Nv.prototype), og(Nv.prototype, "initialCropsToFilter", [a.computed], Object.getOwnPropertyDescriptor(Nv.prototype, "initialCropsToFilter"), Nv.prototype), og(Nv.prototype, "isFilteringConventional", [a.computed], Object.getOwnPropertyDescriptor(Nv.prototype, "isFilteringConventional"), Nv.prototype), og(Nv.prototype, "isFilteringOrganic", [a.computed], Object.getOwnPropertyDescriptor(Nv.prototype, "isFilteringOrganic"), Nv.prototype), og(Nv.prototype, "varietyOptions", [a.computed], Object.getOwnPropertyDescriptor(Nv.prototype, "varietyOptions"), Nv.prototype), og(Nv.prototype, "t", [a.computed], Object.getOwnPropertyDescriptor(Nv.prototype, "t"), Nv.prototype), og(Nv.prototype, "unlistedCrops", [a.computed], Object.getOwnPropertyDescriptor(Nv.prototype, "unlistedCrops"), Nv.prototype), og(Nv.prototype, "fieldsWithCheckedState", [a.computed], Object.getOwnPropertyDescriptor(Nv.prototype, "fieldsWithCheckedState"), Nv.prototype), og(Nv.prototype, "checkedFields", [a.computed], Object.getOwnPropertyDescriptor(Nv.prototype, "checkedFields"), Nv.prototype), og(Nv.prototype, "acresSelected", [a.computed], Object.getOwnPropertyDescriptor(Nv.prototype, "acresSelected"), Nv.prototype), og(Nv.prototype, "selectedCropNames", [a.computed], Object.getOwnPropertyDescriptor(Nv.prototype, "selectedCropNames"), Nv.prototype), og(Nv.prototype, "selectedVarieties", [a.computed], Object.getOwnPropertyDescriptor(Nv.prototype, "selectedVarieties"), Nv.prototype), og(Nv.prototype, "isScrollable", [a.computed], Object.getOwnPropertyDescriptor(Nv.prototype, "isScrollable"), Nv.prototype), og(Nv.prototype, "initialize", [a.action], Object.getOwnPropertyDescriptor(Nv.prototype, "initialize"), Nv.prototype), og(Nv.prototype, "initOrganicRadioModel", [a.action], Object.getOwnPropertyDescriptor(Nv.prototype, "initOrganicRadioModel"), Nv.prototype), Uv = og(Nv.prototype, "onCheckOrganicRadioBtn", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            e.organicFilter = t;
          };
        }
      }), Vv = og(Nv.prototype, "onChangeCropFilter", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            e.cropFilter = t;
          };
        }
      }), Bv = og(Nv.prototype, "onChangeVarietyFilter", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            e.varietyFilter = t;
          };
        }
      }), og(Nv.prototype, "onCheckAll", [a.action], Object.getOwnPropertyDescriptor(Nv.prototype, "onCheckAll"), Nv.prototype), qv = og(Nv.prototype, "onRegisterCropSelectModel", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            e.cropSelectModel = t;
          };
        }
      }), Wv = og(Nv.prototype, "onRegisterVarietySelectModel", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            e.varietySelectModel = t;
          };
        }
      }), og(Nv.prototype, "reset", [a.action], Object.getOwnPropertyDescriptor(Nv.prototype, "reset"), Nv.prototype), og(Nv.prototype, "update", [a.action], Object.getOwnPropertyDescriptor(Nv.prototype, "update"), Nv.prototype), Nv);
    function Lg(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Ug(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Lg(Object(r), !0).forEach(function (t) {
          Vg(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Lg(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function Vg(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function Bg(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function qg(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function Wg(e, t) {
      return (Wg = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function Hg(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = $g(e);
        if (t) {
          var o = $g(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return Gg(this, r);
      };
    }
    function Gg(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return Jg(e);
    }
    function Jg(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function $g(e) {
      return ($g = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function Kg(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var Zg = Object(c.observer)((ag = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && Wg(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = Hg(a);
        function a(e) {
          var t;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, a), (t = o.call(this, e)).satelliteAttribution = "Esri, DigitalGlobe, GeoEye, Earthstar Geographics, CNES/Airbus DS, USDA, USGS, AeroGRID, IGN, and the GIS User Community", t.streetsAttribution = "OpenStreetMap contributors", t.defaultCenter = [46.601557, -120.5108421], t.geoJSONParser = void 0, t.map = void 0, t.maxZoom = 19, t.polyline = void 0, t.defaultZoom = 14, t.displayOnlyColor = "#6c757d", t.displayOnlyOpacity = "0.8", Bg(t, "area", cg, Jg(t)), Bg(t, "circles", lg, Jg(t)), Bg(t, "isDrawingCircle", ug, Jg(t)), Bg(t, "mapState", sg, Jg(t)), Bg(t, "polygons", pg, Jg(t)), Bg(t, "rowSpacing", fg, Jg(t)), Bg(t, "rowSpacingUnit", dg, Jg(t)), Bg(t, "plantSpacing", yg, Jg(t)), Bg(t, "plantSpacingUnit", bg, Jg(t)), Bg(t, "treeDensity", hg, Jg(t)), Bg(t, "treeDensityUnit", mg, Jg(t)), Bg(t, "irrigationRate", vg, Jg(t)), Bg(t, "irrigationRateUnit", gg, Jg(t)), Bg(t, "addPolylinePoint", wg, Jg(t)), Bg(t, "applyComputedAreaOverride", Og, Jg(t)), Bg(t, "clearShapes", _g, Jg(t)), Bg(t, "drawCircle", jg, Jg(t)), Bg(t, "drawPolygon", Pg, Jg(t)), Bg(t, "emitPoint", Eg, Jg(t)), Bg(t, "emitPolygon", kg, Jg(t)), Bg(t, "emitGrayPoint", xg, Jg(t)), Bg(t, "emitGrayPolygon", Sg, Jg(t)), Bg(t, "finishPolygon", Cg, Jg(t)), Bg(t, "navigateMap", Rg, Jg(t)), Bg(t, "onDrawCircleEnd", Ng, Jg(t)), Bg(t, "onEditPolygon", zg, Jg(t)), Bg(t, "onRemoveCircle", Dg, Jg(t)), Bg(t, "onRemovePolygon", Tg, Jg(t)), Bg(t, "resetMap", Mg, Jg(t)), Bg(t, "startCircle", Fg, Jg(t)), Bg(t, "updateArea", Ig, Jg(t));
          var r = e.area,
            n = e.rowSpacing,
            c = e.plantSpacing,
            l = e.treeDensity,
            u = e.irrigationRate;
          if (n) {
            var s = Un()(n);
            t.rowSpacing = s.scalar, t.rowSpacingUnit = s.units();
          }
          if (c) {
            var p = Un()(c);
            t.plantSpacing = p.scalar, t.plantSpacingUnit = p.units();
          }
          if (l) {
            var f = Un()(l);
            t.treeDensity = f.scalar, t.treeDensityUnit = f.units();
          }
          if (u) {
            var d = Un()(u);
            t.irrigationRate = d.scalar, t.irrigationRateUnit = d.units();
          }
          if (r && (t.area = Un()(r).to("acres").scalar), !("neighboringFields" in e)) throw new Error("FieldVisualEditor requires neighboringFields");
          return e.neighboringFields.forEach(function (e) {
            if (!(e instanceof Jv)) throw new Error("FieldVisualEditor requires neighboringFields to be Field instances");
          }), t.geoJSONParser = new zb({
            emitPoint: t.emitPoint,
            emitPolygon: t.emitPolygon
          }), t._tooltipContainerRef = i.a.createRef(), t;
        }
        return t = a, (r = [{
          key: "center",
          get: function () {
            return this.geoJSONBounds ? this.geoJSONBounds.getCenter() : null;
          }
        }, {
          key: "circleArea",
          get: function () {
            return this.circles.reduce(function (e, t) {
              return e + t.area;
            }, 0);
          }
        }, {
          key: "computedArea",
          get: function () {
            return this.toAcres(this.polygonArea + this.circleArea);
          }
        }, {
          key: "geoJSON",
          get: function () {
            return {
              type: "FeatureCollection",
              features: this.polygons.map(function (e) {
                return e.geoJSON;
              }).concat(this.circles.map(function (e) {
                return e.geoJSON;
              }))
            };
          }
        }, {
          key: "geoJSONAsPolygonCollection",
          get: function () {
            return {
              type: "FeatureCollection",
              features: this.polygons.map(function (e) {
                return e.geoJSON;
              }).concat(this.circles.map(function (e) {
                return {
                  type: "Feature",
                  geometry: {
                    type: "Polygon",
                    coordinates: [[vd()([e.centerPoint.lng, e.centerPoint.lat], e.radius / 1e3, 180).geometry.coordinates, vd()([e.centerPoint.lng, e.centerPoint.lat], e.radius / 1e3, 90).geometry.coordinates, vd()([e.centerPoint.lng, e.centerPoint.lat], e.radius / 1e3, 0).geometry.coordinates, vd()([e.centerPoint.lng, e.centerPoint.lat], e.radius / 1e3, -90).geometry.coordinates, vd()([e.centerPoint.lng, e.centerPoint.lat], e.radius / 1e3, -180).geometry.coordinates]]
                  }
                };
              }))
            };
          }
        }, {
          key: "geoJSONBounds",
          get: function () {
            var e = this.geoJSONAsPolygonCollection,
              t = hd()(e);
            return t.find(function (e) {
              return e === 1 / 0 || e === -1 / 0;
            }) ? null : wd.a.latLngBounds([{
              lat: t[1],
              lng: t[0]
            }, {
              lat: t[3],
              lng: t[2]
            }]);
          }
        }, {
          key: "geoJSONString",
          get: function () {
            return JSON.stringify(this.geoJSON);
          }
        }, {
          key: "latitude",
          get: function () {
            return this.center ? this.center.lat : "";
          }
        }, {
          key: "longitude",
          get: function () {
            return this.center ? this.center.lng : "";
          }
        }, {
          key: "polygonArea",
          get: function () {
            return this.polygons.reduce(function (e, t) {
              return e + t.area;
            }, 0);
          }
        }, {
          key: "componentDidMount",
          value: function () {
            var e = this,
              t = this.props,
              r = t.id,
              n = t.geoJson,
              o = t.neighboringFields,
              i = this.defaultCenter;
            this.map = wd.a.map(r, {
              scrollWheelZoom: !1,
              zoomDelta: .75,
              zoomSnap: .75
            }).setView(i, this.defaultZoom), this.map.attributionControl.setPrefix("Leaflet"), n && this.geoJSONParser.parse(JSON.parse(n));
            var a = new zb({
              emitPoint: this.emitGrayPoint,
              emitPolygon: this.emitGrayPolygon
            });
            o.forEach(function (e) {
              return e.geoJson && a.parse(e.geoJson);
            }), this.zoomMap();
            var c = wd.a.tileLayer("http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}", {
                attribution: "&copy; ".concat(this.satelliteAttribution),
                maxZoom: this.maxZoom
              }),
              l = wd.a.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
                attribution: "&copy; ".concat(this.streetsAttribution),
                maxZoom: this.maxZoom
              }),
              u = wd.a.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
                attribution: "&copy; ".concat(this.streetsAttribution),
                maxZoom: this.maxZoom,
                opacity: .5
              }),
              s = wd.a.layerGroup([c, u]);
            s.addTo(this.map), wd.a.control.layers({
              Satellite: c,
              Streets: l,
              Both: s
            }).addTo(this.map), wd.a.control.scale().addTo(this.map), this.map.on("click", function (t) {
              if ("navigate" !== e.mapState && ("drawPoly" === e.mapState && e.addPolylinePoint(t), "drawCircle" === e.mapState)) {
                if (e.isDrawingCircle) return;
                e.startCircle(t.latlng);
              }
            });
          }
        }, {
          key: "clearCircles",
          value: function () {
            this.circles.forEach(function (e) {
              e && e.remove();
            }), this.circles = [];
          }
        }, {
          key: "clearPolygons",
          value: function () {
            this.polygons.forEach(function (e) {
              e && e.remove();
            }), this.polygons = [];
          }
        }, {
          key: "clearPolyline",
          value: function () {
            this.polyline && (this.polyline.off("clickStartingPoint", this.finishPolygon), this.polyline.remove()), this.polyline = null;
          }
        }, {
          key: "createCircle",
          value: function (e, t) {
            var r = this,
              n = document.createElement("div"),
              o = _d()();
            bl.a.render(i.a.createElement(pb, {
              onClick: function () {
                return r.onRemoveCircle(o);
              }
            }), n);
            var a = new sy(Ug({
              id: o,
              popup: n,
              map: this.map,
              isResizingCircle: this.isDrawingCircle
            }, e || {}));
            return t || this.circles.push(a), a;
          }
        }, {
          key: "createPolygon",
          value: function (e, t) {
            var r = this,
              n = document.createElement("div"),
              o = _d()(),
              a = new Pb(Ug({
                id: o,
                map: this.map
              }, e || {}));
            t || this.polygons.push(a), bl.a.render(i.a.createElement("div", {
              className: "btn-group",
              role: "group"
            }, i.a.createElement(c.Observer, null, function () {
              return i.a.createElement(Vb, {
                onClick: function () {
                  return r.onEditPolygon(o);
                },
                isEditing: a.isEditingPolygon
              });
            }), i.a.createElement(pb, {
              onClick: function () {
                return r.onRemovePolygon(o);
              }
            })), n), !1 !== e.popup && a.setPopup(n);
          }
        }, {
          key: "findLocation",
          value: function (e) {
            return fetch("https://nominatim.openstreetmap.org/search?format=json&q=".concat(e)).then(function (e) {
              return e.json();
            });
          }
        }, {
          key: "isEditingPolygon",
          value: function (e) {
            var t = this.polygons.find(function (t) {
              return t.id === e;
            });
            return !!t && t.isEditingPolygon;
          }
        }, {
          key: "setView",
          value: function (e, t) {
            if (t) return this.map.fitBounds(t, {
              maxZoom: this.maxZoom
            });
            this.map.setView(e, this.defaultZoom);
          }
        }, {
          key: "toAcres",
          value: function (e) {
            return Un()(e, "m^2").to("acres").toPrec(.01).scalar;
          }
        }, {
          key: "zoomMap",
          value: function () {
            var e = this,
              t = this.props,
              r = t.address,
              n = t.latitude,
              o = t.longitude,
              i = t.neighboringFields,
              a = this.defaultCenter,
              c = this.geoJSONBounds,
              l = i.map(function (e) {
                return e.latitude && e.longitude ? [e.latitude, e.longitude] : null;
              }).filter(function (e) {
                return !!e;
              });
            null != o && null != n ? this.setView([n, o], c) : l && l.length ? this.setView(Ge(l.map(function (e) {
              return e.map(function (e) {
                return Number(e);
              });
            })), c) : r ? this.findLocation(r).then(function (t) {
              return Array.isArray(t) && t.length > 0 ? e.setView([t[0].lat, t[0].lon], c) : e.setView(a, c);
            }).catch(function () {
              return e.setView(a, c);
            }) : this.setView(a, c);
          }
        }, {
          key: "render",
          value: function () {
            var e = this.props,
              t = e.id,
              r = e.t,
              n = {
                container: this._tooltipContainerRef,
                placement: "top",
                delay: {
                  show: 250,
                  hide: 400
                }
              };
            return i.a.createElement(j, {
              i18n: Re
            }, i.a.createElement("label", null, "Location"), i.a.createElement("div", {
              className: "row no-gutters",
              ref: this._tooltipContainerRef
            }, i.a.createElement("div", {
              className: "col-md-auto pl-0 pr-0 ml-0 mr-0"
            }, i.a.createElement("div", {
              className: "d-flex flex-column justify-content-start align-items-center"
            }, i.a.createElement(Fd, Object.assign({}, n, {
              overlay: i.a.createElement(Kd, null, "Navigate the map (enable panning)")
            }), i.a.createElement("button", {
              type: "button",
              className: "btn btn-secondary m-2".concat("navigate" === this.mapState ? " active" : ""),
              onClick: this.navigateMap
            }, i.a.createElement(Ot.FontAwesomeIcon, {
              icon: _t.faMap
            }))), i.a.createElement(Fd, Object.assign({}, n, {
              overlay: i.a.createElement(Kd, null, "Draw polygon region")
            }), i.a.createElement("button", {
              type: "button",
              className: "btn btn-secondary m-2".concat("drawPoly" === this.mapState ? " active" : ""),
              onClick: this.drawPolygon
            }, i.a.createElement(Ot.FontAwesomeIcon, {
              icon: _t.faDrawPolygon
            }))), i.a.createElement(Fd, Object.assign({}, n, {
              overlay: i.a.createElement(Kd, null, "Draw circular region")
            }), i.a.createElement("button", {
              type: "button",
              className: "btn btn-secondary m-2".concat("drawCircle" === this.mapState ? " active" : ""),
              onClick: this.drawCircle
            }, i.a.createElement(Ot.FontAwesomeIcon, {
              icon: _t.faDotCircle
            }))), i.a.createElement(Fd, Object.assign({}, n, {
              overlay: i.a.createElement(Kd, null, "Clear all regions from the map")
            }), i.a.createElement("button", {
              type: "button",
              className: "btn btn-secondary m-2",
              onClick: this.resetMap
            }, i.a.createElement(Ot.FontAwesomeIcon, {
              icon: _t.faTimes
            }))))), i.a.createElement("div", {
              className: "col pl-0 field-visual-editor-col".concat("drawCircle" === this.mapState || "drawPoly" === this.mapState ? " draw-shape" : "")
            }, i.a.createElement("div", {
              className: "field-map",
              id: t
            }))), i.a.createElement("div", {
              className: "row form-group mt-3"
            }, i.a.createElement("div", {
              className: "col-md-6"
            }, i.a.createElement("label", {
              htmlFor: "field_area"
            }, r("if2_fields.field_visual_editor.acreage")), i.a.createElement("input", {
              className: "form-control",
              value: this.area,
              placeholder: r("if2_fields.field_visual_editor.field_block_acreage"),
              onChange: this.updateArea
            }), i.a.createElement("input", {
              type: "hidden",
              value: "".concat(this.area, " acres"),
              id: "field_area",
              name: "field[area]"
            })), i.a.createElement("div", {
              className: "col-md-6"
            }, i.a.createElement("label", {
              htmlFor: "field_area"
            }, r("if2_fields.field_visual_editor.computed_acreage")), i.a.createElement("div", {
              className: "input-group"
            }, i.a.createElement("input", {
              className: "form-control",
              readOnly: !0,
              value: this.computedArea
            }), i.a.createElement("div", {
              className: "input-group-append"
            }, i.a.createElement("button", {
              className: "btn btn-outline-primary",
              type: "button",
              onClick: this.applyComputedAreaOverride
            }, r("if2_fields.apply")))))), i.a.createElement("label", null, r("if2_fields.row_spacing")), i.a.createElement("div", {
              className: "row form-group"
            }, i.a.createElement(eo, {
              name: "field[row_spacing]",
              placeholder: r("if2_fields.field_visual_editor.field_block_row_spacing"),
              unitList: ["ft", "m", "in", "cm"],
              currentValue: this.rowSpacing,
              currentUnit: this.rowSpacingUnit
            })), i.a.createElement("label", null, r("if2_fields.plant_spacing")), i.a.createElement("div", {
              className: "row form-group"
            }, i.a.createElement(eo, {
              name: "field[plant_spacing]",
              placeholder: r("if2_fields.field_visual_editor.field_block_plant_spacing"),
              unitList: ["ft", "m", "in", "cm"],
              currentValue: this.plantSpacing,
              currentUnit: this.plantSpacingUnit
            })), i.a.createElement("label", null, r("if2_fields.tree_density")), i.a.createElement("div", {
              className: "row form-group"
            }, i.a.createElement(eo, {
              name: "field[tree_density]",
              placeholder: r("if2_fields.field_visual_editor.field_block_tree_density"),
              unitList: ["1/acre", "1/hectare"],
              currentValue: this.treeDensity,
              currentUnit: this.treeDensityUnit
            })), i.a.createElement("label", null, r("if2_fields.irrigation_rate")), i.a.createElement("div", {
              className: "row form-group"
            }, i.a.createElement(eo, {
              name: "field[irrigation_rate]",
              placeholder: r("if2_fields.field_visual_editor.field_block_irrigation_rate"),
              unitList: ["gal/min", "l/min"],
              currentValue: this.irrigationRate,
              currentUnit: this.irrigationRateUnit
            })), i.a.createElement("input", {
              type: "hidden",
              name: "field[latitude]",
              value: this.latitude,
              onChange: function () {}
            }), i.a.createElement("input", {
              type: "hidden",
              name: "field[longitude]",
              value: this.longitude,
              onChange: function () {}
            }), i.a.createElement("input", {
              type: "hidden",
              name: "field[geo_json]",
              value: this.geoJSONString,
              onChange: function () {}
            }));
          }
        }]) && qg(t.prototype, r), n && qg(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(i.a.Component), cg = Kg(ag.prototype, "area", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return "";
        }
      }), lg = Kg(ag.prototype, "circles", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return [];
        }
      }), ug = Kg(ag.prototype, "isDrawingCircle", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return !1;
        }
      }), sg = Kg(ag.prototype, "mapState", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return "navigate";
        }
      }), pg = Kg(ag.prototype, "polygons", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return [];
        }
      }), fg = Kg(ag.prototype, "rowSpacing", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return "";
        }
      }), dg = Kg(ag.prototype, "rowSpacingUnit", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return "ft";
        }
      }), yg = Kg(ag.prototype, "plantSpacing", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return "";
        }
      }), bg = Kg(ag.prototype, "plantSpacingUnit", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return "ft";
        }
      }), hg = Kg(ag.prototype, "treeDensity", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return "";
        }
      }), mg = Kg(ag.prototype, "treeDensityUnit", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return "1/acre";
        }
      }), vg = Kg(ag.prototype, "irrigationRate", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return "";
        }
      }), gg = Kg(ag.prototype, "irrigationRateUnit", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return "gal/min";
        }
      }), Kg(ag.prototype, "center", [a.computed], Object.getOwnPropertyDescriptor(ag.prototype, "center"), ag.prototype), Kg(ag.prototype, "circleArea", [a.computed], Object.getOwnPropertyDescriptor(ag.prototype, "circleArea"), ag.prototype), Kg(ag.prototype, "computedArea", [a.computed], Object.getOwnPropertyDescriptor(ag.prototype, "computedArea"), ag.prototype), Kg(ag.prototype, "geoJSON", [a.computed], Object.getOwnPropertyDescriptor(ag.prototype, "geoJSON"), ag.prototype), Kg(ag.prototype, "geoJSONAsPolygonCollection", [a.computed], Object.getOwnPropertyDescriptor(ag.prototype, "geoJSONAsPolygonCollection"), ag.prototype), Kg(ag.prototype, "geoJSONBounds", [a.computed], Object.getOwnPropertyDescriptor(ag.prototype, "geoJSONBounds"), ag.prototype), Kg(ag.prototype, "geoJSONString", [a.computed], Object.getOwnPropertyDescriptor(ag.prototype, "geoJSONString"), ag.prototype), Kg(ag.prototype, "latitude", [a.computed], Object.getOwnPropertyDescriptor(ag.prototype, "latitude"), ag.prototype), Kg(ag.prototype, "longitude", [a.computed], Object.getOwnPropertyDescriptor(ag.prototype, "longitude"), ag.prototype), Kg(ag.prototype, "polygonArea", [a.computed], Object.getOwnPropertyDescriptor(ag.prototype, "polygonArea"), ag.prototype), wg = Kg(ag.prototype, "addPolylinePoint", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            e.polyline.addPoint(t.latlng);
          };
        }
      }), Og = Kg(ag.prototype, "applyComputedAreaOverride", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function () {
            e.area = e.computedArea;
          };
        }
      }), _g = Kg(ag.prototype, "clearShapes", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function () {
            e.clearPolyline(), e.clearPolygons(), e.clearCircles();
          };
        }
      }), jg = Kg(ag.prototype, "drawCircle", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function () {
            e.mapState = "drawCircle", e.map.dragging.disable();
          };
        }
      }), Pg = Kg(ag.prototype, "drawPolygon", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function () {
            e.mapState = "drawPoly", e.map.dragging.disable(), e.polyline = new Sy({
              map: e.map
            }), e.polyline.on("clickStartingPoint", e.finishPolygon);
          };
        }
      }), Eg = Kg(ag.prototype, "emitPoint", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t, r) {
            if (r && "circle" === r.pointType) return e.createCircle({
              centerPoint: t,
              radius: r.radius
            });
            wd.a.marker(t).addTo(e.map);
          };
        }
      }), kg = Kg(ag.prototype, "emitPolygon", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            e.createPolygon({
              points: t
            });
          };
        }
      }), xg = Kg(ag.prototype, "emitGrayPoint", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t, r) {
            if (r && "circle" === r.pointType) return e.createCircle({
              centerPoint: t,
              color: e.displayOnlyColor,
              opacity: e.displayOnlyOpacity,
              radius: r.radius,
              popup: !1
            }, !0);
            wd.a.marker(t).addTo(e.map);
          };
        }
      }), Sg = Kg(ag.prototype, "emitGrayPolygon", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            e.createPolygon({
              points: t,
              color: e.displayOnlyColor,
              opacity: e.displayOnlyOpacity,
              popup: !1
            }, !0);
          };
        }
      }), Cg = Kg(ag.prototype, "finishPolygon", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function () {
            var t = e.polyline.points;
            t.push(Ug({}, e.polyline.points[0])), e.createPolygon({
              points: t
            }), e.clearPolyline(), e.navigateMap();
          };
        }
      }), Rg = Kg(ag.prototype, "navigateMap", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function () {
            e.mapState = "navigate", e.map.dragging.enable();
          };
        }
      }), Ng = Kg(ag.prototype, "onDrawCircleEnd", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            e.isDrawingCircle = !1, t.clearCenterMarker(), e.navigateMap();
          };
        }
      }), zg = Kg(ag.prototype, "onEditPolygon", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            var r = e.polygons.find(function (e) {
              return e.id === t;
            });
            r && (r.isEditingPolygon ? r.stopEditing() : r.edit());
          };
        }
      }), Dg = Kg(ag.prototype, "onRemoveCircle", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            var r = e.circles.findIndex(function (e) {
              return e.id === t;
            });
            r < 0 || (e.circles[r].remove(), e.circles.splice(r, 1));
          };
        }
      }), Tg = Kg(ag.prototype, "onRemovePolygon", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            var r = e.polygons.findIndex(function (e) {
              return e.id === t;
            });
            r < 0 || (e.polygons[r].remove(), e.polygons.splice(r, 1));
          };
        }
      }), Mg = Kg(ag.prototype, "resetMap", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function () {
            e.clearShapes(), e.navigateMap();
          };
        }
      }), Fg = Kg(ag.prototype, "startCircle", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            e.isDrawingCircle = !0, e.createCircle({
              centerPoint: t,
              radius: 0
            }).on("drawCircleEnd", e.onDrawCircleEnd);
          };
        }
      }), Ig = Kg(ag.prototype, "updateArea", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            e.area = t.target.value;
          };
        }
      }), ig = ag)) || ig,
      Yg = U()(Zg);
    var Qg,
      Xg,
      ew,
      tw = (Qg = new yd.SchemaValidator(), (Xg = r(103)).keys().forEach(function (e) {
        Qg.addSchema(Xg(e));
      }), Qg);
    function rw(e) {
      tw.validate("https://schemas.miriamtech.com/if2/fields/field", e);
    }
    function nw(e) {
      return tw.sanitizeData("https://schemas.miriamtech.com/if2/fields/field", e);
    }
    function ow(e) {
      tw.validate("https://schemas.miriamtech.com/if2/fields/field-import", e);
    }
    function iw(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function aw(e, t) {
      return (aw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function cw(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = uw(e);
        if (t) {
          var o = uw(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return lw(this, r);
      };
    }
    function lw(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function uw(e) {
      return (uw = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var sw = Object(c.observer)(ew = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && aw(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = cw(a);
        function a(e) {
          var t;
          if (function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, a), t = o.call(this, e), !("neighboringFields" in e)) throw new Error("RailsFieldVisualEditor requires neighboringFields");
          try {
            t.neighboringFields = e.neighboringFields.map(function (e) {
              return new Jv(nw(e));
            });
          } catch (e) {
            if (e instanceof yd.DataDoesNotMatchSchemaError) {
              var r = e.errors.map(function (e) {
                return e.stack;
              });
              throw new Error("Invalid neighboring field supplied: ".concat(r.join(", ")));
            }
            throw e;
          }
          return t;
        }
        return t = a, (r = [{
          key: "render",
          value: function () {
            var e = this.props,
              t = e.area,
              r = e.rowSpacing,
              n = e.plantSpacing,
              o = e.treeDensity,
              a = e.irrigationRate,
              c = e.geoJson,
              l = e.longitude,
              u = e.latitude,
              s = e.address;
            return i.a.createElement(Yg, {
              id: "field-visual-editor",
              area: t,
              rowSpacing: r,
              plantSpacing: n,
              treeDensity: o,
              irrigationRate: a,
              geoJson: c,
              longitude: l,
              latitude: u,
              neighboringFields: this.neighboringFields,
              address: s
            });
          }
        }]) && iw(t.prototype, r), n && iw(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(i.a.Component)) || ew,
      pw = r(84),
      fw = r.n(pw),
      dw = r(85),
      yw = r(86),
      bw = r(37),
      hw = r(87),
      mw = r.n(hw),
      vw = r(88),
      gw = r(89);
    function ww(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function Ow(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function _w(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    var jw,
      Pw,
      Ew,
      kw,
      xw,
      Sw,
      Cw,
      Rw = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this.accountId = void 0, this.apiPath = "/if2/api/fields/", this.apiFieldsQueryPath = "".concat(this.apiPath, "query");
          var r = function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = null != arguments[t] ? arguments[t] : {};
              t % 2 ? ww(Object(r), !0).forEach(function (t) {
                Ow(e, t, r[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ww(Object(r)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
              });
            }
            return e;
          }({
            accountId: ""
          }, t || {}).accountId;
          this.accountId = r;
        }
        var t, r, n;
        return t = e, (r = [{
          key: "csrf",
          value: function () {
            return document.querySelector("[name='csrf-token']").content;
          }
        }, {
          key: "apiAccountFieldsPath",
          value: function () {
            return "/if2/api/accounts/".concat(this.accountId, "/fields/hierarchy");
          }
        }, {
          key: "fieldPath",
          value: function (e) {
            return "/if2/fields/".concat(e);
          }
        }, {
          key: "findAll",
          value: function () {
            return fetch(this.apiAccountFieldsPath()).then(function (e) {
              return e.json();
            });
          }
        }, {
          key: "fetchAll",
          value: function () {
            return fetch(this.apiAccountFieldsPath());
          }
        }, {
          key: "fetchAllForAccounts",
          value: function (e) {
            var t = this.csrf();
            return fetch(this.apiFieldsQueryPath, {
              method: "POST",
              headers: {
                "X-CSRF-Token": t,
                "Content-Type": "application/json"
              },
              body: JSON.stringify({
                accounts: e
              })
            });
          }
        }]) && _w(t.prototype, r), n && _w(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), e;
      }();
    function Nw() {
      return (Nw = Object.assign ? Object.assign.bind() : function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
      }).apply(this, arguments);
    }
    var zw,
      Dw,
      Tw,
      Mw,
      Fw,
      Iw,
      Aw,
      Lw,
      Uw,
      Vw = function (e) {
        return o.createElement("svg", Nw({
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 535.67 537.13"
        }, e), jw || (jw = o.createElement("path", {
          d: "M485.64 93.67v6.35L286.35 298.6l-41.6 41.45L46.96 537.13h-4.78c-21.36 0-39.02-15.88-41.79-36.49L203.3 298.45 244.9 257 450.55 52.09c19.92 3.36 35.09 20.7 35.09 41.58z",
          fill: "#fcda43"
        })), Pw || (Pw = o.createElement("path", {
          fill: "#4385f2",
          d: "M441.12 537.13H46.96l197.79-197.08 196.37 197.08z"
        })), Ew || (Ew = o.createElement("path", {
          d: "M485.49 498.47c-1.78 21.65-19.91 38.66-42.03 38.66h-2.34L244.75 340.05l41.6-41.45 199.14 199.87z",
          fill: "#eeefef"
        })), kw || (kw = o.createElement("path", {
          d: "M485.64 100.02v394.93c0 1.18-.05 2.36-.15 3.52L286.35 298.6l199.29-198.58z",
          fill: "#e7e7e7"
        })), xw || (xw = o.createElement("path", {
          d: "M450.55 52.09L244.9 257l-41.6 41.45L.39 500.64a41.09 41.09 0 01-.39-5.69V93.67c0-22.63 17.81-41.08 40.17-42.14.67-.02 1.34-.04 2.01-.04h401.28c2.42 0 4.78.2 7.09.6z",
          fill: "#19a05e"
        })), Sw || (Sw = o.createElement("path", {
          d: "M111.84 146.92c.75.98 46.11 2.23 60.31 2.59 2.42.06 4.41 1.96 4.56 4.37 3.54 56.64-42.78 90.38-96.56 70.96-55.76-20.94-56.83-109.01.06-129.43 26.63-9.75 52.04-6.64 73.44 10.73 1.42 1.03 1.56 3.08.31 4.31l-17 16.62c-1.03 1.01-2.66 1.05-3.76.12-7.99-6.58-12.46-8.16-22.58-8.81-37.01-.98-56.34 42.73-32.22 70.45 18.51 21.04 58.49 17.07 67.52-11.31.39-1.09-.44-2.24-1.6-2.24l-32.95-.06c-1.9 0-3.42-1.56-3.38-3.46l.43-21.51a3.385 3.385 0 013.42-3.32z",
          fill: "#fff"
        })), Cw || (Cw = o.createElement("g", null, o.createElement("path", {
          d: "M305.78 50.92c10.71-13.08 22.82-24.52 37.45-33.25 69.41-41.42 161.63-6.76 186.09 70.05 11.12 34.93 7.25 68.57-8.53 101.25-9.44 19.54-21.64 37.37-33.74 55.27-1.38 2.04-3.19 3.85-3.74 6.38-7.02 8.42-12.56 17.86-18.51 27.02-26.33 40.52-44.77 83.96-48.98 132.66-.39 4.49-3.66 7.09-8.14 7.02-1.29-.02-2.55-1.02-3.85-.09-2.27-1.08-2.58-3.56-3.83-5.36.12-.25.08-.48-.11-.68-.12-3.14 0-6.32-.41-9.43-4.3-32.87-14.48-63.88-29.97-93.13-11.03-20.83-23.57-40.74-37.67-59.65-6.27-9.46-12.63-18.87-18.78-28.41-4.87-7.57-9.48-15.31-14.21-22.98a.932.932 0 00-.53-.22c-1.47-6.06-4.99-11.26-7.15-17.07-4.14-11.12-8.14-22.18-9.46-34.04-.39-3.37 1.37-7.11-1.7-10.03-.05-2.98-.1-5.97-.14-8.95-.4-5.86 1.9-11.4 2-17.21.13-7.81 2.87-15.09 5.02-22.44 3.29-11.27 8.99-21.45 15.04-31.43 2.71-.7 2.21-3.77 3.86-5.25zm57.98 76.5c-1.3 25.29 20.8 44.79 44.17 44.82 24.6.02 45-20.07 44.86-44.53-.14-25.64-19.29-44.57-44.31-45.16-25.06-.59-46.25 21.44-44.73 44.87z",
          fill: "#d9463a"
        }), o.createElement("path", {
          d: "M363.76 127.42c-1.52-23.43 19.67-45.46 44.73-44.87 25.02.59 44.17 19.52 44.31 45.16.13 24.46-20.26 44.55-44.86 44.53-23.38-.02-45.47-19.53-44.17-44.82z",
          fill: "#7d2521"
        }))));
      };
    function Bw(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function qw(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Bw(Object(r), !0).forEach(function (t) {
          Ww(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Bw(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function Ww(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function Hw(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function Gw(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function Jw(e, t) {
      return (Jw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function $w(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = Yw(e);
        if (t) {
          var o = Yw(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return Kw(this, r);
      };
    }
    function Kw(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return Zw(e);
    }
    function Zw(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function Yw(e) {
      return (Yw = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function Qw(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var Xw,
      eO = ["#1f78b4", "#33a02c", "#e31a1c", "#ff7f00", "#6a3d9a", "#b15928", "#a6cee3", "#b2df8a", "#fb9a99", "#fdbf6f", "#cab2d6", "#ffff99"],
      tO = Object(c.observer)((Uw = Lw = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && Jw(e, t);
        }(c, e);
        var t,
          r,
          n,
          o = $w(c);
        function c(e) {
          var t;
          if (function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, c), (t = o.call(this, e)).map = void 0, t.fieldsApi = void 0, t.defaultLatLon = [46.601557, -120.5108421], t.geoJSONLayer = void 0, t.satelliteLayer = void 0, t.streetsLayer = void 0, t.bothLayer = void 0, t.streetsAttribution = "OpenStreetMap contributors", t.satelliteAttribution = "Esri, DigitalGlobe, GeoEye, Earthstar Geographics, CNES/Airbus DS, USDA, USGS, AeroGRID, IGN, and the GIS User Community", t.colorScale = Object(dw.scaleOrdinal)(eO), Hw(t, "pendingZooms", Tw, Zw(t)), Hw(t, "pendingMoves", Mw, Zw(t)), Hw(t, "pendingStreetsLayerLoads", Fw, Zw(t)), Hw(t, "zoom", Iw, Zw(t)), Hw(t, "highContrastLabels", Aw, Zw(t)), t.onBaseLayerChange = function (e) {
            return Object(a.runInAction)(function () {
              t.highContrastLabels = /satellite/i.test(e.name);
            });
          }, t.onMapMoveStart = function () {
            return Object(a.runInAction)(function () {
              t.pendingMoves += 1;
            });
          }, t.onMapMoveEnd = function () {
            return Object(a.runInAction)(function () {
              t.pendingMoves -= 1;
            });
          }, t.onMapZoomStart = function () {
            return Object(a.runInAction)(function () {
              t.pendingZooms += 1;
            });
          }, t.onMapZoomEnd = function () {
            return Object(a.runInAction)(function () {
              t.pendingZooms -= 1;
            });
          }, t.onStreetsLayerLoad = function () {
            return Object(a.runInAction)(function () {
              t.pendingStreetsLayerLoads -= 1;
            });
          }, t.onStreetsLayerLoading = function () {
            return Object(a.runInAction)(function () {
              t.pendingStreetsLayerLoads += 1;
            });
          }, t.rerenderMap = function () {
            t.map.invalidateSize();
            var e = [t.streetsLayer];
            return Promise.all(e.map(function (e) {
              return t.rerenderTileLayer(e);
            })).then(function () {
              return Object(a.when)(function () {
                return !t.mapViewIsChanging;
              });
            });
          }, t.rerenderTileLayer = function (e) {
            var r = t.props.rerenderTimeout,
              n = t.geoJSONLayer && t.geoJSONLayer.getBounds();
            return new Promise(function (o) {
              var i,
                a = function t() {
                  i && clearTimeout(i), e.off("load", t), o();
                };
              i = setTimeout(a, r), e.on("load", a), t.setView(n), e.remove(), e.addTo(t.map);
            });
          }, !("fields" in e)) throw new Error("FieldMapViewer requires fields");
          e.fields.forEach(function (e) {
            if (!(e instanceof Jv)) throw new Error("FieldMapViewer requires fields to be Field instances");
          });
          var r = t.props.fieldsApiPath,
            n = {};
          return r && (n.apiPath = r), t.fieldsApi = new Rw(n), t;
        }
        return t = c, (r = [{
          key: "featureCollection",
          get: function () {
            var e = this;
            return {
              type: "FeatureCollection",
              features: this.props.fields.filter(function (e) {
                return e.geoJson;
              }).map(function (t) {
                return e.presentGeoJson(t);
              })
            };
          }
        }, {
          key: "center",
          get: function () {
            var e = this.props.fields.filter(function (e) {
              return null != e.latitude && null != e.longitude;
            }).map(function (e) {
              return [Number(e.latitude), Number(e.longitude)];
            });
            return Ge(e);
          }
        }, {
          key: "mapViewIsChanging",
          get: function () {
            return this.pendingZooms > 0 || this.pendingMoves > 0 || this.pendingStreetsLayerLoads > 0;
          }
        }, {
          key: "componentDidMount",
          value: function () {
            var e = this.props,
              t = e.id,
              r = e.onRegisterMapRerenderer;
            this.initMap(), r(t, this.rerenderMap), this.map.whenReady(this.map.invalidateSize);
          }
        }, {
          key: "componentWillUnmount",
          value: function () {
            var e = this.props,
              t = e.id;
            (0, e.onUnregisterMapRerenderer)(t), this.map.off("movestart", this.onMapMoveStart), this.map.off("moveend", this.onMapMoveEnd), this.map.off("zoomstart", this.onMapZoomStart), this.map.off("zoomend", this.onMapZoomEnd), this.streetsLayer.off("load", this.onStreetsLayerLoad), this.streetsLayer.off("loading", this.onStreetsLayerLoading);
          }
        }, {
          key: "addLabel",
          value: function (e, t) {
            var r,
              n,
              o,
              i,
              a = ["field-name-label-text"];
            if ("Point" === (null == e || null === (r = e.geometry) || void 0 === r ? void 0 : r.type)) n = null == t ? void 0 : t.getLatLng(), a.push("center-label");else {
              var c = t.getBounds().getNorthWest(),
                l = Object(vw.coordAll)(e),
                u = Object(bw.featureCollection)(l.map(function (e) {
                  return Object(bw.point)(e);
                })),
                s = mw()(Object(bw.point)([c.lng, c.lat]), u).geometry.coordinates;
              n = wd.a.latLng([s[1], s[0]]);
            }
            n && wd.a.marker(n, {
              icon: wd.a.divIcon({
                className: "field-name-label".concat(e.properties.data.inactive ? " inactive" : ""),
                html: '<div class="'.concat(a.join(" "), '">').concat((null == e || null === (o = e.properties) || void 0 === o || null === (i = o.data) || void 0 === i ? void 0 : i.name) || "", "</div>"),
                iconSize: [null, null]
              })
            }).addTo(this.map);
          }
        }, {
          key: "createMap",
          value: function () {
            var e = this.props.id;
            this.map = wd.a.map(e, {
              scrollWheelZoom: !1,
              fadeAnimation: !1,
              zoomDelta: .75,
              zoomSnap: .75
            }), this.map.on("baselayerchange", this.onBaseLayerChange), this.map.on("movestart", this.onMapMoveStart), this.map.on("moveend", this.onMapMoveEnd), this.map.on("zoomstart", this.onMapZoomStart), this.map.on("zoomend", this.onMapZoomEnd), this.map.setView(this.center || this.defaultLatLon, this.zoom), this.map.attributionControl.setPrefix("Leaflet");
          }
        }, {
          key: "createGeoJSONLayer",
          value: function () {
            var e = this;
            this.geoJSONLayer = wd.a.geoJSON(this.featureCollection, {
              pointToLayer: function (e, t) {
                return "circle" === e.properties.pointType ? wd.a.circle(t, {
                  radius: e.properties.radius,
                  color: e.properties.color
                }) : wd.a.marker(t);
              },
              style: function (e) {
                return {
                  color: e.properties.color,
                  fill: !0,
                  fillColor: e.properties.color,
                  fillOpacity: .2,
                  className: e.properties.data.inactive ? "inactive" : "active"
                };
              },
              onEachFeature: function (t, r) {
                var n = e.props,
                  o = n.hasInteractiveFields,
                  i = n.showLabels,
                  a = t.properties.data;
                i && e.addLabel(t, r), o && (r.bindTooltip('<div class="field-map-tooltip"><label>'.concat(a.name, "</label><p>").concat(a.varieties && a.varieties.length ? "".concat(a.varieties.map(function (e) {
                  return e.name;
                }).join(", "), " ") : a.crop.name ? "".concat(a.crop.name, " ") : "").concat(a.area ? "(".concat(a.area.displayValue, ")") : "", "<p></div>")).addTo(e.map), r.on("mouseover", function () {
                  return r.setStyle(qw(qw({}, r.options), {}, {
                    fillOpacity: .5
                  }));
                }), r.on("mouseout", function () {
                  return r.setStyle(qw(qw({}, r.options), {}, {
                    fillOpacity: .2
                  }));
                }), r.on("click", function () {
                  return e.onClickField(a);
                }));
              }
            }), this.geoJSONLayer.addTo(this.map);
          }
        }, {
          key: "createTileLayer",
          value: function () {
            this.satelliteLayer = this.createSatelliteLayer(), this.streetsLayer = wd.a.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
              attribution: "&copy; ".concat(this.streetsAttribution),
              maxZoom: 19
            }), this.streetsLayer.on("load", this.onStreetsLayerLoad), this.streetsLayer.on("loading", this.onStreetsLayerLoading), this.streetsLayerTransparent = wd.a.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
              attribution: "&copy; ".concat(this.streetsAttribution),
              maxZoom: 19,
              opacity: .5
            }), this.bothLayer = wd.a.layerGroup([this.createSatelliteLayer(), this.streetsLayerTransparent]), this.layerControl = wd.a.control.layers({
              Satellite: this.satelliteLayer,
              Streets: this.streetsLayer,
              Both: this.bothLayer
            }).addTo(this.map);
          }
        }, {
          key: "createSatelliteLayer",
          value: function () {
            return wd.a.tileLayer("https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}", {
              attribution: "&copy; ".concat(this.satelliteAttribution),
              maxZoom: 19
            });
          }
        }, {
          key: "setView",
          value: function (e) {
            var t = this,
              r = this.props.address;
            e && e.isValid() ? this.map.fitBounds(e) : this.center ? this.map.setView(this.center, this.zoom) : r ? fetch("https://nominatim.openstreetmap.org/search?format=json&q=".concat(r)).then(function (e) {
              return e.json();
            }).then(function (e) {
              if (!(Array.isArray(e) && e.length > 0)) throw new Error("Unable to lookup address: ".concat(r));
              t.map.setView([e[0].lat, e[0].lon], t.zoom);
            }).catch(function () {
              t.map.setView(t.defaultLatLon, t.zoom);
            }) : this.map.setView(this.defaultLatLon, this.zoom);
          }
        }, {
          key: "initMap",
          value: function () {
            this.createMap(), this.createTileLayer(), wd.a.control.scale().addTo(this.map), this.rerenderMap(), this.centerMap();
          }
        }, {
          key: "centerMap",
          value: function () {
            var e;
            this.featureCollection.features.length && (this.createGeoJSONLayer(), e = this.geoJSONLayer.getBounds()), this.setView(e), this.addGoogleMapsLink();
          }
        }, {
          key: "addGoogleMapsLink",
          value: function () {
            var e = wd.a.control({
                position: "bottomright"
              }),
              t = this.map.getCenter(),
              r = this.zoom,
              n = this.props.fields,
              o = "/maps",
              a = "?api=1";
            n.length > 1 ? (o += "/@", a += "&map_action=map&center=".concat(t.lat, "%2C").concat(t.lng)) : (o += "/search/", a += "&query=".concat(t.lat, "%2C").concat(t.lng)), a += "&zoom=".concat(r), e.onAdd = function () {
              var e = wd.a.DomUtil.create("div", "info legend");
              return e.innerHTML = Object(gw.renderToString)(i.a.createElement("a", {
                href: "https://www.google.com".concat(o).concat(a),
                rel: "noreferrer",
                target: "_blank"
              }, i.a.createElement(Vw, {
                width: "32px",
                height: "32px"
              }))), e;
            }, e.addTo(this.map);
          }
        }, {
          key: "color",
          value: function (e) {
            return e.crop ? Object(yw.hsl)(e.crop.hue, 1, .5) : e.crop && e.crop.name ? this.colorScale(e.crop.name) : this.colorScale(e.name);
          }
        }, {
          key: "onClickField",
          value: function (e) {
            this.props.hasInteractiveFields && window.location.assign(this.fieldsApi.fieldPath(e.serial));
          }
        }, {
          key: "presentGeoJson",
          value: function (e) {
            var t = this,
              r = fw()(e.geoJson.toJS());
            return ("Feature" === r.type ? [r] : "FeatureCollection" === r.type ? r.features : []).forEach(function (r) {
              r.properties.color = t.color(e), r.properties.data = e;
            }), r;
          }
        }, {
          key: "render",
          value: function () {
            var e = this.props.id;
            return i.a.createElement("div", {
              className: "field-map-container".concat(this.highContrastLabels ? "-high-contrast-labels" : "")
            }, i.a.createElement("div", {
              className: "field-map",
              id: e
            }));
          }
        }]) && Gw(t.prototype, r), n && Gw(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), c;
      }(i.a.Component), Lw.defaultProps = {
        onRegisterMapRerenderer: function () {},
        onUnregisterMapRerenderer: function () {},
        rerenderTimeout: 3e5
      }, Tw = Qw((Dw = Uw).prototype, "pendingZooms", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return 0;
        }
      }), Mw = Qw(Dw.prototype, "pendingMoves", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return 0;
        }
      }), Fw = Qw(Dw.prototype, "pendingStreetsLayerLoads", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return 0;
        }
      }), Iw = Qw(Dw.prototype, "zoom", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return 14;
        }
      }), Aw = Qw(Dw.prototype, "highContrastLabels", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return !1;
        }
      }), Qw(Dw.prototype, "featureCollection", [a.computed], Object.getOwnPropertyDescriptor(Dw.prototype, "featureCollection"), Dw.prototype), Qw(Dw.prototype, "center", [a.computed], Object.getOwnPropertyDescriptor(Dw.prototype, "center"), Dw.prototype), Qw(Dw.prototype, "mapViewIsChanging", [a.computed], Object.getOwnPropertyDescriptor(Dw.prototype, "mapViewIsChanging"), Dw.prototype), zw = Dw)) || zw,
      rO = r(90);
    function nO(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function oO(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function iO(e, t) {
      return (iO = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function aO(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = lO(e);
        if (t) {
          var o = lO(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return cO(this, r);
      };
    }
    function cO(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function lO(e) {
      return (lO = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var uO,
      sO = Object(c.observer)(Xw = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && iO(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = aO(a);
        function a() {
          var e;
          nO(this, a);
          for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];
          return (e = o.call.apply(o, [this].concat(r))).onCheckAll = function (t) {
            return e.props.fieldSelectModel.onCheckAll(t);
          }, e;
        }
        return t = a, (r = [{
          key: "render",
          value: function () {
            var e = this.props,
              t = e.fieldSelectModel,
              r = e.t;
            return i.a.createElement("tr", {
              className: "fsl_table-head-row"
            }, i.a.createElement("th", {
              className: "checkbox-cell"
            }, i.a.createElement(Vn.Checkbox, {
              isChecked: t.allChecked,
              onChange: this.onCheckAll
            })), i.a.createElement("th", {
              className: "field-name-cell"
            }, i.a.createElement("div", {
              className: "field-name"
            }, r("if2_fields.name"))), i.a.createElement("th", {
              className: "field-icons-cell"
            }, " "), i.a.createElement("th", null, i.a.createElement("div", {
              className: "crop-name"
            }, t.includeVarieties ? r("if2_fields.crop_and_variety") : r("if2_fields.crop"))), i.a.createElement("th", null, i.a.createElement("div", {
              className: "field-area"
            }, r("if2_fields.acres"))));
          }
        }]) && oO(t.prototype, r), n && oO(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component)) || Xw,
      pO = U()(sO);
    function fO(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function dO(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function yO(e, t) {
      return (yO = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function bO(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = mO(e);
        if (t) {
          var o = mO(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return hO(this, r);
      };
    }
    function hO(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function mO(e) {
      return (mO = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var vO,
      gO,
      wO,
      OO,
      _O = Object(c.observer)(uO = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && yO(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = bO(a);
        function a() {
          return fO(this, a), o.apply(this, arguments);
        }
        return t = a, (r = [{
          key: "render",
          value: function () {
            var e = this.props.model;
            return i.a.createElement("tr", {
              className: "fsl_table-body-row no-match"
            }, i.a.createElement("td", null, e.noMatchText()));
          }
        }]) && dO(t.prototype, r), n && dO(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component)) || uO,
      jO = r(51),
      PO = r.n(jO);
    function EO(e, t, r, n, o, i, a) {
      try {
        var c = e[i](a),
          l = c.value;
      } catch (e) {
        return void r(e);
      }
      c.done ? t(l) : Promise.resolve(l).then(n, o);
    }
    function kO(e) {
      return function () {
        var t = this,
          r = arguments;
        return new Promise(function (n, o) {
          var i = e.apply(t, r);
          function a(e) {
            EO(i, n, o, a, c, "next", e);
          }
          function c(e) {
            EO(i, n, o, a, c, "throw", e);
          }
          a(void 0);
        });
      };
    }
    function xO(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function SO(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function CO(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var RO,
      NO = (gO = CO((vO = function () {
        function e(t) {
          var r = this;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), xO(this, "props", gO, this), xO(this, "warnings", wO, this), xO(this, "onToggleChecked", OO, this), this.props = t || {}, this.warningsDisposer = Object(a.autorun)(kO(PO.a.mark(function e() {
            return PO.a.wrap(function (e) {
              for (;;) switch (e.prev = e.next) {
                case 0:
                  return e.next = 2, r.getWarnings();
                case 2:
                  r.warnings = e.sent;
                case 3:
                case "end":
                  return e.stop();
              }
            }, e);
          })));
        }
        var t, r, n;
        return t = e, (r = [{
          key: "sortedVarietyNames",
          get: function () {
            var e = this.props.field;
            return e ? (e.varieties || []).map(function (e) {
              return e.name;
            }).sort(Vn.naturalSort) : [];
          }
        }, {
          key: "field",
          get: function () {
            return this.props.field;
          }
        }, {
          key: "fieldSelectModel",
          get: function () {
            return this.props.fieldSelectModel;
          }
        }, {
          key: "destroy",
          value: function () {
            this.warningsDisposer();
          }
        }, {
          key: "update",
          value: function (e) {
            var t = this;
            Object.keys(e).forEach(function (r) {
              t.props[r] = e[r];
            });
          }
        }, {
          key: "getWarnings",
          value: function () {
            return this.fieldSelectModel.warningsForField(this.field);
          }
        }]) && SO(t.prototype, r), n && SO(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), e;
      }()).prototype, "props", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), wO = CO(vO.prototype, "warnings", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return [];
        }
      }), CO(vO.prototype, "sortedVarietyNames", [a.computed], Object.getOwnPropertyDescriptor(vO.prototype, "sortedVarietyNames"), vO.prototype), CO(vO.prototype, "field", [a.computed], Object.getOwnPropertyDescriptor(vO.prototype, "field"), vO.prototype), CO(vO.prototype, "fieldSelectModel", [a.computed], Object.getOwnPropertyDescriptor(vO.prototype, "fieldSelectModel"), vO.prototype), OO = CO(vO.prototype, "onToggleChecked", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function (t) {
            e.fieldSelectModel.setCheck(e.field.id, t);
          };
        }
      }), CO(vO.prototype, "update", [a.action], Object.getOwnPropertyDescriptor(vO.prototype, "update"), vO.prototype), vO);
    function zO(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function DO(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function TO(e, t) {
      return (TO = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function MO(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = IO(e);
        if (t) {
          var o = IO(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return FO(this, r);
      };
    }
    function FO(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function IO(e) {
      return (IO = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var AO,
      LO,
      UO = Object(c.observer)(RO = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && TO(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = MO(a);
        function a() {
          return zO(this, a), o.apply(this, arguments);
        }
        return t = a, (r = [{
          key: "render",
          value: function () {
            var e = this.props.rowModel;
            return i.a.createElement("td", {
              className: "name-col"
            }, i.a.createElement("div", {
              className: "field-name"
            }, null == e ? void 0 : e.field.name));
          }
        }]) && DO(t.prototype, r), n && DO(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component)) || RO;
    function VO(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function BO(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function qO(e, t) {
      return (qO = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function WO(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = GO(e);
        if (t) {
          var o = GO(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return HO(this, r);
      };
    }
    function HO(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function GO(e) {
      return (GO = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var JO,
      $O,
      KO = Object(c.observer)((function (e, t, r, n, o) {
        var i = {};
        Object.keys(n).forEach(function (e) {
          i[e] = n[e];
        }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
          return n(e, t, r) || r;
        }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null);
      }((LO = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && qO(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = WO(a);
        function a() {
          return VO(this, a), o.apply(this, arguments);
        }
        return t = a, (r = [{
          key: "warningsTooltip",
          get: function () {
            return this.props.rowModel.warnings.slice().sort().join("\n");
          }
        }, {
          key: "componentWillUnmount",
          value: function () {
            this.props.rowModel.destroy();
          }
        }, {
          key: "render",
          value: function () {
            var e;
            return null !== (e = this.props.rowModel.warnings) && void 0 !== e && e.length ? i.a.createElement(Ot.FontAwesomeIcon, {
              icon: _t.faExclamationTriangle,
              className: "text-warning",
              title: this.warningsTooltip
            }) : null;
          }
        }]) && BO(t.prototype, r), n && BO(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component)).prototype, "warningsTooltip", [a.computed], Object.getOwnPropertyDescriptor(LO.prototype, "warningsTooltip"), LO.prototype), AO = LO)) || AO;
    function ZO() {
      return (ZO = Object.assign ? Object.assign.bind() : function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
      }).apply(this, arguments);
    }
    var YO,
      QO = function (e) {
        return o.createElement("svg", ZO({
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 39.58 33.77"
        }, e), JO || (JO = o.createElement("defs", null, o.createElement("style", null, ".organic_svg__cls-1{fill:#30a649}"))), $O || ($O = o.createElement("g", {
          id: "organic_svg__Layer_2",
          "data-name": "Layer 2"
        }, o.createElement("g", {
          id: "organic_svg__Capa_1",
          "data-name": "Capa 1"
        }, o.createElement("path", {
          className: "organic_svg__cls-1",
          d: "M39.56 21.76a13.19 13.19 0 01-7.93 11.45 14.83 14.83 0 01-4.92-.21 44.11 44.11 0 005.12-17.28.29.29 0 00-.3-.29.3.3 0 00-.28.26 48.12 48.12 0 01-4 13.33 13.77 13.77 0 00-2.47-11.32c-.2-.29-.41-.58-.64-.86l-.41-.48c-.34-.38-.7-.75-1.08-1.1s-.75-.66-1.15-1c2.42-4.1 6.74-7.54 6.63-14.12-.03-1.96 12 11.5 11.43 21.62z"
        }), o.createElement("path", {
          className: "organic_svg__cls-1",
          d: "M25.76 30.44a8.67 8.67 0 01-.76 1.18 8.34 8.34 0 01-1.64 1.5s-.52-1.45-.72-1.92a45.44 45.44 0 00-9-13.32.34.34 0 00-.21-.08.3.3 0 00-.2.08.29.29 0 000 .38c3.26 4.08 7 10.3 8.62 15.29a13 13 0 01-2.43.22 16.35 16.35 0 01-12.2-5.53C3.15 23.12 6.31 15.5.09 9.41c-.35-.33.39-.52 1.81-.52 4.05 0 13.61 1.57 19.34 5.9a14 14 0 012.12 1.93 13.18 13.18 0 012.4 13.72zM21.5 14.33c.4.31.78.62 1.15.95-.37-.28-.75-.65-1.15-.95z"
        })))));
      };
    function XO() {
      return (XO = Object.assign ? Object.assign.bind() : function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
      }).apply(this, arguments);
    }
    var e_,
      t_,
      r_ = function (e) {
        return o.createElement("svg", XO({
          xmlns: "http://www.w3.org/2000/svg",
          width: 22.443,
          height: 27.79
        }, e), YO || (YO = o.createElement("g", {
          "data-name": "Group 346",
          fill: "#541d09"
        }, o.createElement("path", {
          "data-name": "Path 125",
          d: "M7.503 9.94c.11-1.77-.13-6.43-7.48-6.81 0 0-.73 7.46 5.99 8.4a7.976 7.976 0 00-2.47-5.71 8.068 8.068 0 013.96 4.12zm2.98 8.93c2.31-3.89 7.08-4.38 7.08-4.38-4.1 2.15-5.87 4.88-6.13 6.56 10.51 1.71 11.01-9.21 11.01-9.21-9.97-1.78-11.57 4.62-11.96 7.03z"
        }), o.createElement("path", {
          "data-name": "Path 126",
          d: "M12.223 27.27c0 .28-1.54.52-3.45.52s-3.45-.24-3.45-.52c0-.18.67-.35 1.67-.44A33.121 33.121 0 0114.503 0c-7.03 12.86-4.86 23.68-3.97 26.83 1.01.09 1.69.25 1.69.44z"
        }))));
      };
    function n_() {
      return (n_ = Object.assign ? Object.assign.bind() : function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
      }).apply(this, arguments);
    }
    var o_,
      i_,
      a_,
      c_,
      l_ = function (e) {
        return o.createElement("svg", n_({
          xmlns: "http://www.w3.org/2000/svg",
          xmlnsXlink: "http://www.w3.org/1999/xlink",
          viewBox: "0 0 39.58 33.77"
        }, e), e_ || (e_ = o.createElement("defs", null, o.createElement("linearGradient", {
          id: "transitional_svg__b"
        }, o.createElement("stop", {
          offset: 0,
          stopColor: "#ffc400"
        }), o.createElement("stop", {
          offset: 1,
          stopColor: "#30a649"
        })), o.createElement("linearGradient", {
          id: "transitional_svg__a"
        }, o.createElement("stop", {
          offset: 0,
          stopColor: "#ffc400"
        }), o.createElement("stop", {
          offset: 1,
          stopColor: "#ffc400",
          stopOpacity: 0
        })), o.createElement("linearGradient", {
          xlinkHref: "#transitional_svg__b",
          id: "transitional_svg__c",
          x1: 20.323,
          y1: 16.859,
          x2: 39.58,
          y2: 16.859,
          gradientUnits: "userSpaceOnUse"
        }))), t_ || (t_ = o.createElement("g", {
          "data-name": "Layer 2"
        }, o.createElement("g", {
          "data-name": "Capa 1"
        }, o.createElement("path", {
          d: "M25.76 30.44a8.67 8.67 0 01-.76 1.18 8.34 8.34 0 01-1.64 1.5s-.52-1.45-.72-1.92a45.44 45.44 0 00-9-13.32.34.34 0 00-.21-.08.3.3 0 00-.2.08.29.29 0 000 .38c3.26 4.08 7 10.3 8.62 15.29a13 13 0 01-2.43.22 16.35 16.35 0 01-12.2-5.53C3.15 23.12 6.31 15.5.09 9.41c-.35-.33.39-.52 1.81-.52 4.05 0 13.61 1.57 19.34 5.9a14 14 0 012.12 1.93 13.18 13.18 0 012.4 13.72zm13.8-8.68a13.19 13.19 0 01-7.93 11.45 14.83 14.83 0 01-4.92-.21 44.11 44.11 0 005.12-17.28.29.29 0 00-.3-.29.3.3 0 00-.28.26 48.12 48.12 0 01-4 13.33 13.77 13.77 0 00-2.47-11.32c-.2-.29-.41-.58-.64-.86l-.41-.48c-.34-.38-.7-.75-1.08-1.1-.38-.35-.75-.66-1.15-1 2.42-4.1 6.74-7.54 6.63-14.12-.03-1.96 12 11.5 11.43 21.62z",
          fill: "url(#transitional_svg__c)"
        }), o.createElement("path", {
          d: "M21.5 14.33c.4.31.78.62 1.15.95-.37-.28-.75-.65-1.15-.95z",
          fill: "#30a649"
        })))));
      };
    function u_(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function s_(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function p_(e, t) {
      return (p_ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function f_(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = y_(e);
        if (t) {
          var o = y_(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return d_(this, r);
      };
    }
    function d_(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function y_(e) {
      return (y_ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var b_ = Object(c.observer)((c_ = a_ = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && p_(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = f_(a);
        function a() {
          return u_(this, a), o.apply(this, arguments);
        }
        return t = a, (r = [{
          key: "className",
          get: function () {
            var e = this.props.className;
            return ["fsl_table-body-row"].concat(e || []).join(" ");
          }
        }, {
          key: "render",
          value: function () {
            var e,
              t,
              r,
              n,
              o,
              a,
              c,
              l,
              u,
              s = this.props,
              p = s.rowModel,
              f = s.FieldNameColumnComponent;
            return i.a.createElement("tr", {
              className: this.className
            }, i.a.createElement("td", {
              className: "checkbox-cell"
            }, i.a.createElement(Vn.Checkbox, {
              isChecked: null == p || null === (e = p.fieldSelectModel) || void 0 === e ? void 0 : e.isChecked(null == p ? void 0 : p.field.id),
              onChange: null == p ? void 0 : p.onToggleChecked,
              testId: "add-field-".concat(null == p ? void 0 : p.field.id)
            })), i.a.createElement(f, {
              rowModel: p
            }), i.a.createElement("td", {
              className: "field-icons-cell"
            }, i.a.createElement("span", {
              className: "field-icons"
            }, i.a.createElement(KO, {
              rowModel: p
            }), null != p && null !== (t = p.field) && void 0 !== t && t.organic ? i.a.createElement(QO, {
              width: "1rem",
              height: "1rem"
            }) : null != p && null !== (r = p.field) && void 0 !== r && r.transitional ? i.a.createElement(l_, {
              width: "1rem",
              height: "1rem"
            }) : null, null != p && null !== (n = p.field) && void 0 !== n && n.nonBearing ? i.a.createElement(r_, {
              width: "1rem",
              height: "1rem"
            }) : null)), i.a.createElement("td", null, i.a.createElement("div", {
              className: "crop-name"
            }, null == p || null === (o = p.field) || void 0 === o || null === (a = o.crop) || void 0 === a ? void 0 : a.name), null != p && null !== (c = p.fieldSelectModel) && void 0 !== c && c.includeVarieties ? null == p ? void 0 : p.sortedVarietyNames.map(function (e) {
              return i.a.createElement("div", {
                className: "variety-name",
                key: e
              }, e);
            }) : null), i.a.createElement("td", null, i.a.createElement("div", {
              className: "field-area"
            }, (null == p || null === (l = p.field) || void 0 === l || null === (u = l.area) || void 0 === u ? void 0 : u.displayValue) || "")));
          }
        }]) && s_(t.prototype, r), n && s_(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component), a_.defaultProps = {
        FieldNameColumnComponent: UO
      }, function (e, t, r, n, o) {
        var i = {};
        Object.keys(n).forEach(function (e) {
          i[e] = n[e];
        }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
          return n(e, t, r) || r;
        }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null);
      }((i_ = c_).prototype, "className", [a.computed], Object.getOwnPropertyDescriptor(i_.prototype, "className"), i_.prototype), o_ = i_)) || o_,
      h_ = U()(b_);
    function m_(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function v_(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function g_(e, t) {
      return (g_ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function w_(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = __(e);
        if (t) {
          var o = __(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return O_(this, r);
      };
    }
    function O_(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function __(e) {
      return (__ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var j_,
      P_,
      E_,
      k_,
      x_,
      S_ = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && g_(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = w_(a);
        function a() {
          return m_(this, a), o.apply(this, arguments);
        }
        return t = a, (r = [{
          key: "render",
          value: function () {
            var e = this.props,
              t = e.style,
              r = e.className;
            return i.a.createElement("tr", {
              className: r,
              style: t
            }, i.a.createElement("td", null));
          }
        }]) && v_(t.prototype, r), n && v_(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component);
    function C_(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function R_(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function N_(e, t) {
      return (N_ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function z_(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = M_(e);
        if (t) {
          var o = M_(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return D_(this, r);
      };
    }
    function D_(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return T_(e);
    }
    function T_(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function M_(e) {
      return (M_ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function F_(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var I_,
      A_,
      L_,
      U_ = Object(c.observer)((P_ = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && N_(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = z_(a);
        function a(e) {
          var t;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, a), C_(t = o.call(this, e), "rowModel", E_, T_(t)), C_(t, "shouldRender", k_, T_(t)), C_(t, "rowModelDisposer", x_, T_(t));
          var r = t.props,
            n = r.field,
            i = r.fieldSelectModel,
            c = r.shouldDelay,
            l = i.tableRowMap.get(n.id);
          return l ? (t.rowModel = l, t.shouldRender = !0, D_(t)) : c ? (t.timeout = setTimeout(function () {
            return t.init();
          }, 10), D_(t)) : (t.init(), t);
        }
        return t = a, (r = [{
          key: "componentWillUnmount",
          value: function () {
            clearTimeout(this.timeout);
          }
        }, {
          key: "init",
          value: function () {
            var e = this.props,
              t = e.field,
              r = e.fieldSelectModel;
            this.rowModel = new NO({
              field: t,
              fieldSelectModel: r
            }), r.tableRowMap.set(t.id, this.rowModel), this.shouldRender = !0;
          }
        }, {
          key: "render",
          value: function () {
            return this.shouldRender ? i.a.createElement(h_, Object.assign({}, this.props, {
              rowModel: this.rowModel
            })) : i.a.createElement(S_, this.props);
          }
        }]) && R_(t.prototype, r), n && R_(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component), E_ = F_(P_.prototype, "rowModel", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), k_ = F_(P_.prototype, "shouldRender", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return !1;
        }
      }), x_ = F_(P_.prototype, "rowModelDisposer", [c.disposeOnUnmount], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return Object(a.autorun)(function () {
            var t = e.props,
              r = t.field,
              n = t.fieldSelectModel;
            e.rowModel && e.rowModel.update({
              field: r,
              fieldSelectModel: n
            });
          });
        }
      }), F_(P_.prototype, "init", [a.action], Object.getOwnPropertyDescriptor(P_.prototype, "init"), P_.prototype), j_ = P_)) || j_,
      V_ = ["fieldSelectModel"];
    function B_(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function q_(e, t) {
      if (null == e) return {};
      var r,
        n,
        o = function (e, t) {
          if (null == e) return {};
          var r,
            n,
            o = {},
            i = Object.keys(e);
          for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) >= 0 || (o[r] = e[r]);
          return o;
        }(e, t);
      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (o[r] = e[r]);
      }
      return o;
    }
    function W_(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function H_(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function G_(e, t) {
      return (G_ = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function J_(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = Z_(e);
        if (t) {
          var o = Z_(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return $_(this, r);
      };
    }
    function $_(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return K_(e);
    }
    function K_(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function Z_(e) {
      return (Z_ = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function Y_(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var Q_,
      X_ = Object(c.observer)((Y_((A_ = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && G_(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = J_(a);
        function a() {
          var e;
          W_(this, a);
          for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];
          return (e = o.call.apply(o, [this].concat(r))).HeaderContent = function () {
            var t = e.props.fieldSelectModel;
            return i.a.createElement(pO, {
              fieldSelectModel: t
            });
          }, e.Row = function (e) {
            var t = e.context,
              r = t.fieldSelectModel,
              n = q_(t, V_);
            return i.a.createElement(U_, Object.assign({}, n, {
              field: e.item,
              fieldSelectModel: r,
              className: e["data-item-index"] % 2 ? "dark" : "light"
            }));
          }, B_(e, "itemKey", L_, K_(e)), e;
        }
        return t = a, (r = [{
          key: "FooterContent",
          get: function () {
            var e = this.props.fieldSelectModel,
              t = e.filteredFields.length;
            return function () {
              return 0 === t ? i.a.createElement(_O, {
                model: e
              }) : null;
            };
          }
        }, {
          key: "render",
          value: function () {
            var e = this.props,
              t = e.fieldSelectModel,
              r = e.tableOptions;
            return i.a.createElement(j, {
              i18n: Re
            }, i.a.createElement("div", {
              className: "if2-fields"
            }, i.a.createElement("div", {
              className: "field-select-list"
            }, i.a.createElement(rO.TableVirtuoso, Object.assign({
              components: {
                TableRow: this.Row
              },
              computeItemKey: this.itemKey,
              context: this.props,
              data: t.filteredFields,
              defaultItemHeight: t.constructor.itemSize,
              fixedHeaderContent: this.HeaderContent,
              fixedFooterContent: this.FooterContent
            }, r)))));
          }
        }]) && H_(t.prototype, r), n && H_(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component)).prototype, "FooterContent", [a.computed], Object.getOwnPropertyDescriptor(A_.prototype, "FooterContent"), A_.prototype), L_ = Y_(A_.prototype, "itemKey", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return function (e, t) {
            return t.id;
          };
        }
      }), I_ = A_)) || I_;
    function ej(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function tj(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function rj(e, t) {
      return (rj = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function nj(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = ij(e);
        if (t) {
          var o = ij(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return oj(this, r);
      };
    }
    function oj(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function ij(e) {
      return (ij = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var aj,
      cj = Object(c.observer)(Q_ = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && rj(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = nj(a);
        function a() {
          return ej(this, a), o.apply(this, arguments);
        }
        return t = a, (r = [{
          key: "render",
          value: function () {
            var e = this.props,
              t = e.fieldSelectModel,
              r = e.t;
            return i.a.createElement(j, {
              i18n: Re
            }, i.a.createElement("div", {
              className: "if2-fields"
            }, i.a.createElement("div", {
              className: "field-select-controls row"
            }, i.a.createElement("div", {
              className: "col search-col"
            }, i.a.createElement(Vn.SearchBox, {
              placeholder: r("if2_fields.search_by_name_crop_variety"),
              onChange: t.searchModel.onChangeText,
              searchText: t.searchModel.text,
              onClearSearch: t.searchModel.clearText
            })), i.a.createElement("div", {
              className: "col organic-radio-col"
            }, i.a.createElement("div", {
              className: "organic-radio-btn-group"
            }, i.a.createElement(Vn.RadioBtnGroup, {
              model: t.organicRadioBtnGroupModel
            }))), i.a.createElement("div", {
              className: "col crop-filter-col"
            }, i.a.createElement(Vn.MultiSelectDropdown, {
              options: t.cropOptions,
              placeholder: r("if2_fields.crop_filter"),
              className: "text-center",
              showFilterBadge: !0,
              onChange: t.onChangeCropFilter,
              onRegisterModel: t.onRegisterCropSelectModel
            })), t.includeVarieties ? i.a.createElement("div", {
              className: "col variety-filter-col"
            }, i.a.createElement(Vn.MultiSelectDropdown, {
              options: t.varietyOptions,
              placeholder: r("if2_fields.variety_filter"),
              className: "text-center",
              showFilterBadge: !0,
              onChange: t.onChangeVarietyFilter,
              onRegisterModel: t.onRegisterVarietySelectModel
            })) : null)));
          }
        }]) && tj(t.prototype, r), n && tj(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component)) || Q_,
      lj = U()(cj),
      uj = r(36);
    function sj(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function pj(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function fj(e, t) {
      return (fj = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function dj(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = bj(e);
        if (t) {
          var o = bj(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return yj(this, r);
      };
    }
    function yj(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function bj(e) {
      return (bj = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var hj,
      mj = Object(c.observer)(aj = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && fj(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = dj(a);
        function a() {
          var e;
          sj(this, a);
          for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];
          return (e = o.call.apply(o, [this].concat(r))).id = Object(uj.v4)(), e;
        }
        return t = a, (r = [{
          key: "render",
          value: function () {
            var e = this.props,
              t = e.acres,
              r = e.numFields,
              n = e.t;
            return i.a.createElement("div", {
              className: "if2-fields"
            }, i.a.createElement("div", {
              className: "field-summary-line"
            }, i.a.createElement("label", {
              className: "field-summary-label",
              htmlFor: this.id
            }, n("if2_fields.blocks"), ":"), " ", i.a.createElement("output", {
              className: "field-summary-value",
              id: this.id
            }, i.a.createElement("span", {
              className: "field-summary-num-fields"
            }, r || ""), Ue.Quantity.isQuantityTruthy(t) ? i.a.createElement(i.a.Fragment, null, ",", " ", i.a.createElement("span", {
              className: "field-summary-acres"
            }, t.displayValue)) : null, " ")));
          }
        }]) && pj(t.prototype, r), n && pj(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component)) || aj,
      vj = U()(mj);
    function gj(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function wj(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function Oj(e, t) {
      return (Oj = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function _j(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = Pj(e);
        if (t) {
          var o = Pj(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return jj(this, r);
      };
    }
    function jj(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function Pj(e) {
      return (Pj = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var Ej,
      kj = Object(c.observer)(hj = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && Oj(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = _j(a);
        function a() {
          return gj(this, a), o.apply(this, arguments);
        }
        return t = a, (r = [{
          key: "render",
          value: function () {
            var e = this.props.model;
            return i.a.createElement(i.a.Fragment, null, i.a.createElement("span", {
              className: "item-summary-name"
            }, e.name), e.isLast ? null : ", ");
          }
        }]) && wj(t.prototype, r), n && wj(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component)) || hj;
    function xj(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function Sj(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function Cj(e, t) {
      return (Cj = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function Rj(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = zj(e);
        if (t) {
          var o = zj(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return Nj(this, r);
      };
    }
    function Nj(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function zj(e) {
      return (zj = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var Dj,
      Tj,
      Mj = Object(c.observer)(Ej = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && Cj(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = Rj(a);
        function a() {
          return xj(this, a), o.apply(this, arguments);
        }
        return t = a, (r = [{
          key: "render",
          value: function () {
            var e = this.props.model;
            return i.a.createElement("div", {
              className: "item-summary-line"
            }, i.a.createElement("label", {
              className: "item-summary-label",
              htmlFor: e.id
            }, e.label, ":"), " ", i.a.createElement("output", {
              className: "item-summary-value",
              id: e.id
            }, e.itemSummaries.map(function (e) {
              return i.a.createElement(kj, {
                model: e,
                key: e.name
              });
            })));
          }
        }]) && Sj(t.prototype, r), n && Sj(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component)) || Ej;
    function Fj(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function Ij(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var Aj,
      Lj,
      Uj,
      Vj,
      Bj,
      qj,
      Wj = (Tj = Ij((Dj = function () {
        function e(t) {
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, e), this.id = Object(uj.v4)(), function (e, t, r, n) {
            r && Object.defineProperty(e, t, {
              enumerable: r.enumerable,
              configurable: r.configurable,
              writable: r.writable,
              value: r.initializer ? r.initializer.call(n) : void 0
            });
          }(this, "props", Tj, this), this.props = t || {};
        }
        var t, r, n;
        return t = e, (r = [{
          key: "items",
          get: function () {
            return this.props.items || [];
          }
        }, {
          key: "itemSummaries",
          get: function () {
            return this.items.map(function (e, t, r) {
              return {
                name: e,
                isLast: t + 1 === r.length
              };
            });
          }
        }, {
          key: "label",
          get: function () {
            return this.props.label || "";
          }
        }, {
          key: "update",
          value: function (e) {
            var t = this;
            Object.keys(e).forEach(function (r) {
              t.props[r] = e[r];
            });
          }
        }]) && Fj(t.prototype, r), n && Fj(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), e;
      }()).prototype, "props", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), Ij(Dj.prototype, "items", [a.computed], Object.getOwnPropertyDescriptor(Dj.prototype, "items"), Dj.prototype), Ij(Dj.prototype, "itemSummaries", [a.computed], Object.getOwnPropertyDescriptor(Dj.prototype, "itemSummaries"), Dj.prototype), Ij(Dj.prototype, "label", [a.computed], Object.getOwnPropertyDescriptor(Dj.prototype, "label"), Dj.prototype), Ij(Dj.prototype, "update", [a.action], Object.getOwnPropertyDescriptor(Dj.prototype, "update"), Dj.prototype), Dj);
    function Hj(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function Gj(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function Jj(e, t) {
      return (Jj = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function $j(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = Yj(e);
        if (t) {
          var o = Yj(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return Kj(this, r);
      };
    }
    function Kj(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return Zj(e);
    }
    function Zj(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function Yj(e) {
      return (Yj = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function Qj(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var Xj,
      eP,
      tP = Object(c.observer)((qj = Bj = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && Jj(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = $j(a);
        function a(e) {
          var t;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, a), Hj(t = o.call(this, e), "model", Uj, Zj(t)), Hj(t, "modelDisposer", Vj, Zj(t)), t.model = t.constructor.createViewModel(t.props), t;
        }
        return t = a, (r = [{
          key: "render",
          value: function () {
            return i.a.createElement(Mj, {
              model: this.model
            });
          }
        }]) && Gj(t.prototype, r), n && Gj(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component), Bj.createViewModel = function (e) {
        return new Wj(e);
      }, Uj = Qj((Lj = qj).prototype, "model", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: null
      }), Vj = Qj(Lj.prototype, "modelDisposer", [c.disposeOnUnmount], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return Object(a.autorun)(function () {
            e.model && e.model.update(e.props);
          });
        }
      }), Aj = Lj)) || Aj;
    function rP(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function nP(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function oP(e, t) {
      return (oP = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function iP(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = cP(e);
        if (t) {
          var o = cP(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return aP(this, r);
      };
    }
    function aP(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function cP(e) {
      return (cP = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function lP(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var uP,
      sP = Object(c.observer)((lP((eP = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && oP(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = iP(a);
        function a() {
          return rP(this, a), o.apply(this, arguments);
        }
        return t = a, (r = [{
          key: "fieldSummaryColClasses",
          get: function () {
            return this.props.model.includeVarieties ? "col-md-3" : "col-md-4";
          }
        }, {
          key: "cropSummaryColClasses",
          get: function () {
            return this.props.model.includeVarieties ? "col-md-9" : "col-md-8";
          }
        }, {
          key: "render",
          value: function () {
            var e = this.props,
              t = e.model,
              r = e.t;
            return i.a.createElement("div", {
              className: "row selection-summary my-3"
            }, i.a.createElement("div", {
              className: this.fieldSummaryColClasses
            }, i.a.createElement(vj, {
              acres: t.acresSelected,
              numFields: t.numChecked
            })), i.a.createElement("div", {
              className: this.cropSummaryColClasses
            }, i.a.createElement(tP, {
              items: t.selectedCropNames,
              label: r("if2_fields.crops")
            }), t.includeVarieties ? i.a.createElement(tP, {
              items: t.selectedVarieties,
              label: r("if2_fields.varieties")
            }) : null));
          }
        }]) && nP(t.prototype, r), n && nP(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component)).prototype, "fieldSummaryColClasses", [a.computed], Object.getOwnPropertyDescriptor(eP.prototype, "fieldSummaryColClasses"), eP.prototype), lP(eP.prototype, "cropSummaryColClasses", [a.computed], Object.getOwnPropertyDescriptor(eP.prototype, "cropSummaryColClasses"), eP.prototype), Xj = eP)) || Xj,
      pP = U()(sP);
    function fP(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function dP(e, t) {
      return (dP = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function yP(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = hP(e);
        if (t) {
          var o = hP(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return bP(this, r);
      };
    }
    function bP(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function hP(e) {
      return (hP = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var mP,
      vP,
      gP,
      wP,
      OP = Object(c.observer)(uP = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && dP(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = yP(a);
        function a(e) {
          var t;
          if (function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, a), t = o.call(this, e), !("fields" in e)) throw new Error("RailsFieldMapViewer requires fields");
          try {
            t.fields = e.fields.map(function (e) {
              return new Jv(nw(e));
            });
          } catch (e) {
            if (e instanceof yd.DataDoesNotMatchSchemaError) {
              var r = e.errors.map(function (e) {
                return e.stack;
              });
              throw new Error("Invalid field supplied: ".concat(r.join(", ")));
            }
            throw e;
          }
          return t;
        }
        return t = a, (r = [{
          key: "render",
          value: function () {
            var e = this.props,
              t = e.hasInteractiveFields,
              r = e.showLabels,
              n = e.address;
            return i.a.createElement(tO, {
              id: "field-map-viewer",
              fields: this.fields,
              hasInteractiveFields: t,
              showLabels: r,
              address: n
            });
          }
        }]) && fP(t.prototype, r), n && fP(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(i.a.Component)) || uP;
    function _P(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function jP(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function PP(e, t) {
      return (PP = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function EP(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = SP(e);
        if (t) {
          var o = SP(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return kP(this, r);
      };
    }
    function kP(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return xP(e);
    }
    function xP(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function SP(e) {
      return (SP = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function CP(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var RP,
      NP,
      zP,
      DP,
      TP,
      MP = Object(c.observer)((vP = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && PP(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = EP(a);
        function a(e) {
          var t;
          !function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, a), _P(t = o.call(this, e), "_value", gP, xP(t)), _P(t, "_unit", wP, xP(t));
          var r = e.value;
          if (r) {
            var n = Un()(r);
            t._value = n.scalar, t._unit = n.units();
          }
          return t;
        }
        return t = a, (r = [{
          key: "_modelName",
          get: function () {
            var e = this.props.modelName;
            if (!e) throw new Error("RailsUnitSelector needs a 'modelName' property");
            return e;
          }
        }, {
          key: "_attributeName",
          get: function () {
            var e = this.props.attributeName;
            if (!e) throw new Error("RailsUnitSelector needs an 'attributeName' property");
            return e;
          }
        }, {
          key: "_placeholder",
          get: function () {
            return this.props.placeholder || "";
          }
        }, {
          key: "_supportedUnits",
          get: function () {
            var e = this.props.supportedUnits;
            if (!e) throw new Error("RailsUnitSelector needs a 'supportedUnits' property");
            return e;
          }
        }, {
          key: "render",
          value: function () {
            return i.a.createElement(i.a.Fragment, null, i.a.createElement("div", {
              className: "row form-group"
            }, i.a.createElement(eo, {
              name: "".concat(this._modelName, "[").concat(this._attributeName, "]"),
              placeholder: this._placeholder,
              unitList: this._supportedUnits,
              currentValue: this._value,
              currentUnit: this._unit,
              valueColumnClassName: "col-6",
              unitColumnClassName: "col-6"
            })));
          }
        }]) && jP(t.prototype, r), n && jP(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(i.a.Component), gP = CP(vP.prototype, "_value", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return "";
        }
      }), wP = CP(vP.prototype, "_unit", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return "";
        }
      }), CP(vP.prototype, "_modelName", [a.computed], Object.getOwnPropertyDescriptor(vP.prototype, "_modelName"), vP.prototype), CP(vP.prototype, "_attributeName", [a.computed], Object.getOwnPropertyDescriptor(vP.prototype, "_attributeName"), vP.prototype), CP(vP.prototype, "_placeholder", [a.computed], Object.getOwnPropertyDescriptor(vP.prototype, "_placeholder"), vP.prototype), CP(vP.prototype, "_supportedUnits", [a.computed], Object.getOwnPropertyDescriptor(vP.prototype, "_supportedUnits"), vP.prototype), mP = vP)) || mP,
      FP = r(52),
      IP = r.n(FP),
      AP = r(91);
    function LP(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function UP(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function VP(e, t) {
      return (VP = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function BP(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = HP(e);
        if (t) {
          var o = HP(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return qP(this, r);
      };
    }
    function qP(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return WP(e);
    }
    function WP(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function HP(e) {
      return (HP = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function GP(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var JP,
      $P,
      KP = Object(c.observer)((NP = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && VP(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = BP(a);
        function a(e) {
          var t;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, a), LP(t = o.call(this, e), "_copied", zP, WP(t)), LP(t, "_handleCopied", DP, WP(t)), LP(t, "_resetCopied", TP, WP(t)), t._id = Object(Jt.uniqueId)("copy-to-clipboard-"), t;
        }
        return t = a, (r = [{
          key: "_text",
          get: function () {
            var e = this.props.text;
            if (!e) throw new Error("CopyToClipboard needs a 'text' property");
            return e;
          }
        }, {
          key: "render",
          value: function () {
            var e = this.props.t;
            return i.a.createElement(j, {
              i18n: Re
            }, this._text, " ", i.a.createElement("span", {
              className: "d-print-none"
            }, this._copied ? i.a.createElement(i.a.Fragment, null, i.a.createElement(ba.ReactInterval, {
              enabled: !0,
              timeout: 1e3,
              callback: this._resetCopied
            }), i.a.createElement(Ot.FontAwesomeIcon, {
              icon: _t.faClipboardCheck,
              "data-tip": e("if2_fields.copied_to_clipboard"),
              "data-place": "right",
              "data-effect": "solid",
              "data-for": this._id
            }), i.a.createElement(IP.a, {
              id: this._id
            })) : i.a.createElement(i.a.Fragment, null, i.a.createElement(AP.CopyToClipboard, {
              text: this._text,
              onCopy: this._handleCopied
            }, i.a.createElement(Ot.FontAwesomeIcon, {
              icon: jt.faCopy,
              "data-tip": e("if2_fields.copy_to_clipboard"),
              "data-place": "right",
              "data-effect": "solid",
              "data-for": this._id
            })), i.a.createElement(IP.a, {
              id: this._id
            }))));
          }
        }]) && UP(t.prototype, r), n && UP(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(i.a.Component), zP = GP(NP.prototype, "_copied", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return !1;
        }
      }), GP(NP.prototype, "_text", [a.computed], Object.getOwnPropertyDescriptor(NP.prototype, "_text"), NP.prototype), DP = GP(NP.prototype, "_handleCopied", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function () {
            e._copied = !0;
          };
        }
      }), TP = GP(NP.prototype, "_resetCopied", [a.action], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          var e = this;
          return function () {
            e._copied = !1;
          };
        }
      }), RP = NP)) || RP,
      ZP = U()(KP);
    function YP(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function QP(e, t) {
      return (QP = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function XP(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = tE(e);
        if (t) {
          var o = tE(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return eE(this, r);
      };
    }
    function eE(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return function (e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
      }(e);
    }
    function tE(e) {
      return (tE = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    var rE,
      nE,
      oE,
      iE = Object(c.observer)((function (e, t, r, n, o) {
        var i = {};
        Object.keys(n).forEach(function (e) {
          i[e] = n[e];
        }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
          return n(e, t, r) || r;
        }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null);
      }(($P = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && QP(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = XP(a);
        function a(e) {
          var t;
          return function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this, a), (t = o.call(this, e))._id = Object(Jt.uniqueId)("field-path-"), t;
        }
        return t = a, (r = [{
          key: "_accounts",
          get: function () {
            var e = this.props.accounts;
            if (!e) throw new Error("FieldPath needs an 'accounts' property");
            return e.map(function (e) {
              if (!("fields_url" in e)) throw new Error("FieldPath requires each account to have a 'fields_url' property");
              var t = new rh(e);
              return t.fields_url = e.fields_url, t;
            });
          }
        }, {
          key: "render",
          value: function () {
            var e = this;
            return this._accounts.length > 0 ? i.a.createElement("ol", {
              className: "path"
            }, this._accounts.map(function (t, r) {
              return i.a.createElement(i.a.Fragment, {
                key: "".concat(e._id, "-item-").concat(t.serial)
              }, i.a.createElement("li", {
                className: "path-item"
              }, i.a.createElement("a", {
                href: t.fields_url
              }, t.name)), r !== e._accounts.length - 1 ? i.a.createElement("span", {
                style: {
                  padding: "0 6px"
                }
              }, i.a.createElement(Ot.FontAwesomeIcon, {
                icon: _t.faArrowRight,
                color: "rgb(222, 226, 230)"
              })) : null);
            })) : null;
          }
        }]) && YP(t.prototype, r), n && YP(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(i.a.Component)).prototype, "_accounts", [a.computed], Object.getOwnPropertyDescriptor($P.prototype, "_accounts"), $P.prototype), JP = $P)) || JP;
    function aE(e, t, r, n) {
      r && Object.defineProperty(e, t, {
        enumerable: r.enumerable,
        configurable: r.configurable,
        writable: r.writable,
        value: r.initializer ? r.initializer.call(n) : void 0
      });
    }
    function cE(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function lE(e, t) {
      for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }
    function uE(e, t) {
      return (uE = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
        return e.__proto__ = t, e;
      })(e, t);
    }
    function sE(e) {
      var t = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }();
      return function () {
        var r,
          n = dE(e);
        if (t) {
          var o = dE(this).constructor;
          r = Reflect.construct(n, arguments, o);
        } else r = n.apply(this, arguments);
        return pE(this, r);
      };
    }
    function pE(e, t) {
      if (t && ("object" == typeof t || "function" == typeof t)) return t;
      if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
      return fE(e);
    }
    function fE(e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }
    function dE(e) {
      return (dE = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
        return e.__proto__ || Object.getPrototypeOf(e);
      })(e);
    }
    function yE(e, t, r, n, o) {
      var i = {};
      return Object.keys(n).forEach(function (e) {
        i[e] = n[e];
      }), i.enumerable = !!i.enumerable, i.configurable = !!i.configurable, ("value" in i || i.initializer) && (i.writable = !0), i = r.slice().reverse().reduce(function (r, n) {
        return n(e, t, r) || r;
      }, i), o && void 0 !== i.initializer && (i.value = i.initializer ? i.initializer.call(o) : void 0, i.initializer = void 0), void 0 === i.initializer && (Object.defineProperty(e, t, i), i = null), i;
    }
    var bE = Object(c.observer)((nE = function (e) {
        !function (e, t) {
          if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
          e.prototype = Object.create(t && t.prototype, {
            constructor: {
              value: e,
              writable: !0,
              configurable: !0
            }
          }), Object.defineProperty(e, "prototype", {
            writable: !1
          }), t && uE(e, t);
        }(a, e);
        var t,
          r,
          n,
          o = sE(a);
        function a() {
          var e;
          cE(this, a);
          for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++) r[n] = arguments[n];
          return aE(e = o.call.apply(o, [this].concat(r)), "_importFieldsModalActivated", oE, fE(e)), e;
        }
        return t = a, (r = [{
          key: "_exportKmlUrl",
          get: function () {
            var e = this.props.exportKmlUrl;
            if (!e) throw new Error("ExportFieldsButton requires an exportKmlUrl");
            return e;
          }
        }, {
          key: "render",
          value: function () {
            var e = this.props.t;
            return i.a.createElement(j, {
              i18n: Re
            }, i.a.createElement(ju, null, i.a.createElement(ju.Toggle, {
              variant: "secondary"
            }, e("if2_fields.export.fields")), i.a.createElement(ju.Menu, null, i.a.createElement(ju.Item, {
              href: this._exportKmlUrl
            }, e("if2_fields.export.to_kml")))));
          }
        }]) && lE(t.prototype, r), n && lE(t, n), Object.defineProperty(t, "prototype", {
          writable: !1
        }), a;
      }(o.Component), oE = yE(nE.prototype, "_importFieldsModalActivated", [a.observable], {
        configurable: !0,
        enumerable: !0,
        writable: !0,
        initializer: function () {
          return !1;
        }
      }), yE(nE.prototype, "_exportKmlUrl", [a.computed], Object.getOwnPropertyDescriptor(nE.prototype, "_exportKmlUrl"), nE.prototype), rE = nE)) || rE,
      hE = U()(bE);
    "undefined" != typeof window ? window.IF2Fields = n : console.warn("Unable to register React components for IF2Fields");
  }]);
});